var _CUSTOM_COD_FORM_PROVINCES = {
  data: {
  "MÉXICO": {
    "ACAMBAY DE RUIZ CASTANEDA": {
      "50300": true,
      "50303": true,
      "50304": true,
      "50305": true,
      "50306": true,
      "50310": true,
      "50313": true,
      "50314": true,
      "50315": true,
      "50323": true,
      "50324": true,
      "50325": true,
      "50326": true,
      "50330": true,
      "50333": true,
      "50334": true,
      "50335": true,
      "50336": true,
      "50337": true,
      "50340": true,
      "50343": true,
      "50344": true,
      "50345": true,
      "50350": true
    },
    "ACOLMAN": {
      "55870": true,
      "55875": true,
      "55880": true,
      "55882": true,
      "55883": true,
      "55884": true,
      "55885": true,
      "55886": true,
      "55887": true,
      "55888": true,
      "55890": true,
      "55893": true,
      "55894": true,
      "55895": true,
      "55896": true,
      "55899": true
    },
    "ACULCO": {
      "50360": true,
      "50370": true,
      "50373": true,
      "50374": true,
      "50375": true,
      "50376": true,
      "50380": true,
      "50383": true,
      "50384": true,
      "50385": true,
      "50386": true,
      "50393": true,
      "50394": true,
      "50395": true,
      "50396": true,
      "50397": true
    },
    "ALMOLOYA DE ALQUISIRAS": {
      "51860": true,
      "51863": true,
      "51864": true,
      "51865": true,
      "51866": true,
      "51867": true,
      "51870": true,
      "51874": true,
      "51875": true
    },
    "ALMOLOYA DE JUÁREZ": {
      "50900": true,
      "50903": true,
      "50904": true,
      "50906": true,
      "50907": true,
      "50910": true,
      "50920": true,
      "50924": true,
      "50925": true,
      "50926": true,
      "50927": true,
      "50930": true,
      "50933": true,
      "50934": true,
      "50935": true,
      "50940": true,
      "50943": true,
      "50944": true,
      "50945": true,
      "50946": true
    },
    "ALMOLOYA DEL RIO": {
      "52540": true,
      "52542": true,
      "52543": true,
      "52544": true
    },
    "AMANALCO": {
      "51260": true,
      "51265": true,
      "51266": true,
      "51267": true,
      "51268": true,
      "51270": true,
      "51273": true,
      "51274": true,
      "51280": true,
      "51285": true,
      "51287": true
    },
    "AMATEPEC": {
      "51500": true,
      "51510": true,
      "51514": true,
      "51518": true,
      "51523": true,
      "51524": true,
      "51525": true,
      "51526": true,
      "51527": true,
      "51530": true,
      "51533": true,
      "51534": true,
      "51535": true,
      "51536": true,
      "51537": true,
      "51540": true
    },
    "AMECAMECA": {
      "56900": true,
      "56903": true,
      "56904": true,
      "56905": true,
      "56913": true,
      "56914": true,
      "56920": true,
      "56924": true,
      "56930": true,
      "56933": true,
      "56935": true,
      "56940": true,
      "56945": true,
      "56950": true,
      "56953": true,
      "56954": true,
      "56955": true,
      "56956": true,
      "56960": true,
      "56963": true,
      "56965": true
    },
    "APAXCO": {
      "55660": true,
      "55663": true,
      "55664": true,
      "55665": true,
      "55666": true,
      "55667": true
    },
    "ATENCO": {
      "56300": true,
      "56303": true,
      "56304": true,
      "56305": true,
      "56310": true,
      "56314": true,
      "56315": true
    },
    "ATIZAPAN": {
      "52500": true,
      "52503": true,
      "52504": true,
      "52505": true,
      "52506": true
    },
    "ATIZAPÁN DE ZARAGOZA": {
      "52500": true,
      "52503": true,
      "52504": true,
      "52505": true,
      "52506": true,
      "52900": true,
      "52910": true,
      "52915": true,
      "52916": true,
      "52918": true,
      "52919": true,
      "52920": true,
      "52923": true,
      "52924": true,
      "52925": true,
      "52926": true,
      "52927": true,
      "52928": true,
      "52929": true,
      "52930": true,
      "52934": true,
      "52936": true,
      "52937": true,
      "52938": true,
      "52940": true,
      "52945": true,
      "52946": true,
      "52947": true,
      "52948": true,
      "52949": true,
      "52950": true,
      "52953": true,
      "52957": true,
      "52959": true,
      "52960": true,
      "52965": true,
      "52966": true,
      "52967": true,
      "52968": true,
      "52970": true,
      "52975": true,
      "52976": true,
      "52977": true,
      "52978": true,
      "52979": true,
      "52980": true,
      "52985": true,
      "52986": true,
      "52987": true,
      "52988": true,
      "52989": true,
      "52990": true,
      "52994": true,
      "52995": true,
      "52996": true,
      "52997": true,
      "52998": true
    },
    "ATLACOMULCO": {
      "50450": true,
      "50453": true,
      "50454": true,
      "50455": true,
      "50456": true,
      "50457": true,
      "50458": true,
      "50460": true,
      "50463": true,
      "50464": true,
      "50465": true,
      "50466": true,
      "50470": true,
      "50473": true,
      "50474": true,
      "50475": true,
      "50476": true,
      "50480": true,
      "50483": true,
      "50484": true,
      "50485": true,
      "50486": true,
      "50487": true,
      "50490": true,
      "50493": true,
      "50494": true,
      "50495": true,
      "50496": true,
      "50497": true
    },
    "ATLAUTLA": {
      "56970": true,
      "56975": true,
      "56976": true,
      "56980": true,
      "56982": true,
      "56983": true,
      "56984": true
    },
    "AXAPUSCO": {
      "55940": true,
      "55943": true,
      "55950": true,
      "55952": true,
      "55954": true,
      "55955": true,
      "55956": true,
      "55963": true,
      "55965": true,
      "55966": true
    },
    "AYAPANGO": {
      "56760": true,
      "56763": true,
      "56765": true,
      "56766": true,
      "56770": true,
      "56776": true
    },
    "CALIMAYA": {
      "52200": true,
      "52203": true,
      "52204": true,
      "52205": true,
      "52210": true,
      "52213": true,
      "52214": true,
      "52215": true,
      "52220": true,
      "52223": true,
      "52224": true,
      "52225": true,
      "52226": true,
      "52227": true,
      "52230": true,
      "52233": true,
      "52234": true,
      "52235": true,
      "52236": true
    },
    "CAPULHUAC": {
      "52700": true,
      "52710": true,
      "52713": true,
      "52714": true,
      "52720": true,
      "52723": true,
      "52730": true,
      "52733": true
    },
    "CHALCO": {
      "56600": true,
      "56604": true,
      "56605": true,
      "56606": true,
      "56607": true,
      "56608": true,
      "56609": true,
      "56620": true,
      "56623": true,
      "56624": true,
      "56625": true,
      "56640": true,
      "56641": true,
      "56642": true,
      "56643": true,
      "56644": true,
      "56646": true,
      "56647": true
    },
    "CHAPA DE MOTA": {
      "54350": true,
      "54360": true,
      "54363": true,
      "54364": true,
      "54365": true,
      "54366": true,
      "54367": true,
      "54373": true,
      "54374": true,
      "54375": true,
      "54380": true,
      "54383": true,
      "54384": true,
      "54385": true,
      "54386": true,
      "54387": true
    },
    "CHAPULTEPEC": {
      "52240": true,
      "52243": true,
      "52244": true,
      "52250": true,
      "52254": true
    },
    "CHIAUTLA": {
      "56030": true,
      "56033": true,
      "56034": true,
      "56035": true,
      "56036": true,
      "56037": true,
      "56038": true,
      "56040": true
    },
    "CHICOLOAPAN": {
      "56370": true,
      "56373": true,
      "56375": true,
      "56376": true,
      "56377": true,
      "56380": true,
      "56383": true,
      "56384": true,
      "56386": true,
      "56390": true,
      "56395": true,
      "56396": true
    },
    "CHICONCUAC": {
      "56270": true,
      "56272": true,
      "56273": true,
      "56274": true,
      "56280": true
    },
    "CHIMALHUACAN": {
      "56330": true,
      "56334": true,
      "56335": true,
      "56337": true,
      "56338": true,
      "56340": true,
      "56343": true,
      "56344": true,
      "56346": true,
      "56350": true,
      "56353": true,
      "56356": true,
      "56360": true,
      "56363": true,
      "56366": true
    },
    "CHIMALHUACÁN": {
      "56330": true,
      "56334": true,
      "56335": true,
      "56337": true,
      "56338": true,
      "56340": true,
      "56343": true,
      "56344": true,
      "56346": true,
      "56350": true,
      "56353": true,
      "56356": true,
      "56360": true,
      "56363": true,
      "56366": true
    },
    "COACALCO DE BERRIOZÁBAL": {
      "55700": true,
      "55705": true,
      "55707": true,
      "55708": true,
      "55709": true,
      "55710": true,
      "55712": true,
      "55713": true,
      "55714": true,
      "55715": true,
      "55716": true,
      "55717": true,
      "55718": true,
      "55719": true,
      "55720": true,
      "55726": true,
      "55728": true,
      "55729": true,
      "55730": true,
      "55736": true,
      "55737": true,
      "55738": true,
      "55739": true
    },
    "COATEPEC HARINAS": {
      "51700": true,
      "51704": true,
      "51705": true,
      "51713": true,
      "51714": true,
      "51715": true,
      "51716": true,
      "51720": true,
      "51723": true,
      "51724": true,
      "51726": true,
      "51727": true,
      "51730": true,
      "51733": true,
      "51734": true,
      "51735": true,
      "51750": true,
      "51753": true,
      "51754": true
    },
    "COCOTITLAN": {
      "56680": true,
      "56683": true,
      "56684": true
    },
    "COYOTEPEC": {
      "54660": true,
      "54665": true,
      "54666": true,
      "54667": true,
      "54668": true
    },
    "CUAUTITLÁN": {
      "54800": true,
      "54803": true,
      "54804": true,
      "54805": true,
      "54807": true,
      "54830": true,
      "54831": true,
      "54834": true,
      "54835": true,
      "54836": true,
      "54840": true,
      "54850": true,
      "54855": true,
      "54857": true,
      "54858": true,
      "54860": true,
      "54870": true,
      "54875": true,
      "54877": true,
      "54878": true,
      "54879": true
    },
    "CUAUTITLÁN IZCALLI": {
      "54700": true,
      "54710": true,
      "54712": true,
      "54713": true,
      "54714": true,
      "54715": true,
      "54716": true,
      "54719": true,
      "54720": true,
      "54725": true,
      "54729": true,
      "54730": true,
      "54740": true,
      "54743": true,
      "54744": true,
      "54745": true,
      "54750": true,
      "54753": true,
      "54759": true,
      "54760": true,
      "54763": true,
      "54764": true,
      "54765": true,
      "54766": true,
      "54767": true,
      "54769": true
    },
    "DONATO GUERRA": {
      "51030": true,
      "51034": true,
      "51035": true,
      "51036": true,
      "51040": true,
      "51043": true,
      "51044": true,
      "51045": true,
      "51046": true,
      "51050": true
    },
    "ECATEPEC DE MORELOS": {
      "55000": true,
      "55010": true,
      "55014": true,
      "55016": true,
      "55017": true,
      "55018": true,
      "55020": true,
      "55023": true,
      "55024": true,
      "55025": true,
      "55027": true,
      "55028": true,
      "55029": true,
      "55030": true,
      "55036": true,
      "55037": true,
      "55038": true,
      "55039": true,
      "55040": true,
      "55050": true,
      "55055": true,
      "55056": true,
      "55059": true,
      "55060": true,
      "55063": true,
      "55064": true,
      "55065": true,
      "55066": true,
      "55067": true,
      "55068": true,
      "55069": true,
      "55070": true,
      "55074": true,
      "55075": true,
      "55076": true,
      "55080": true,
      "55084": true,
      "55085": true,
      "55087": true,
      "55090": true,
      "55094": true,
      "55095": true,
      "55100": true,
      "55104": true,
      "55105": true,
      "55107": true,
      "55114": true,
      "55115": true,
      "55117": true,
      "55118": true,
      "55119": true,
      "55120": true,
      "55125": true,
      "55126": true,
      "55127": true,
      "55128": true,
      "55129": true,
      "55130": true,
      "55135": true,
      "55137": true,
      "55138": true,
      "55139": true,
      "55140": true,
      "55146": true,
      "55147": true,
      "55148": true,
      "55149": true,
      "55158": true,
      "55170": true,
      "55176": true,
      "55180": true,
      "55187": true,
      "55188": true,
      "55189": true,
      "55190": true,
      "55200": true,
      "55210": true,
      "55218": true,
      "55220": true,
      "55230": true,
      "55234": true,
      "55235": true,
      "55236": true,
      "55237": true,
      "55238": true,
      "55240": true,
      "55242": true,
      "55243": true,
      "55244": true,
      "55245": true,
      "55246": true,
      "55247": true,
      "55248": true,
      "55249": true,
      "55260": true,
      "55264": true,
      "55266": true,
      "55267": true,
      "55268": true,
      "55269": true,
      "55270": true,
      "55280": true,
      "55284": true,
      "55287": true,
      "55288": true,
      "55289": true,
      "55290": true,
      "55294": true,
      "55295": true,
      "55296": true,
      "55297": true,
      "55298": true,
      "55299": true,
      "55300": true,
      "55308": true,
      "55310": true,
      "55316": true,
      "55317": true,
      "55320": true,
      "55330": true,
      "55338": true,
      "55339": true,
      "55340": true,
      "55347": true,
      "55348": true,
      "55349": true,
      "55360": true,
      "55369": true,
      "55390": true,
      "55400": true,
      "55404": true,
      "55405": true,
      "55407": true,
      "55410": true,
      "55414": true,
      "55415": true,
      "55416": true,
      "55417": true,
      "55418": true,
      "55419": true,
      "55420": true,
      "55425": true,
      "55429": true,
      "55430": true,
      "55450": true,
      "55458": true,
      "55459": true,
      "55490": true,
      "55498": true,
      "55500": true,
      "55506": true,
      "55507": true,
      "55508": true,
      "55509": true,
      "55510": true,
      "55515": true,
      "55516": true,
      "55517": true,
      "55518": true,
      "55519": true,
      "55520": true,
      "55530": true,
      "55540": true,
      "55547": true,
      "55548": true,
      "55549": true
    },
    "ECATZINGO": {
      "56990": true,
      "56993": true,
      "56996": true
    },
    "EL ORO": {
      "50600": true,
      "50601": true,
      "50603": true,
      "50604": true,
      "50610": true,
      "50613": true,
      "50614": true,
      "50615": true,
      "50616": true,
      "50617": true,
      "50625": true,
      "50626": true,
      "50627": true,
      "50630": true,
      "50633": true,
      "50634": true,
      "50635": true,
      "50636": true,
      "50637": true
    },
    "HUEHUETOCA": {
      "54680": true,
      "54683": true,
      "54684": true,
      "54685": true,
      "54687": true,
      "54693": true,
      "54694": true,
      "54696": true,
      "54697": true
    },
    "HUEYPOXTLA": {
      "55670": true,
      "55679": true,
      "55680": true,
      "55683": true,
      "55690": true,
      "55694": true,
      "55697": true
    },
    "HUIXQUILUCAN": {
      "52760": true,
      "52763": true,
      "52764": true,
      "52765": true,
      "52766": true,
      "52767": true,
      "52768": true,
      "52769": true,
      "52770": true,
      "52773": true,
      "52774": true,
      "52775": true,
      "52776": true,
      "52777": true,
      "52778": true,
      "52779": true,
      "52780": true,
      "52783": true,
      "52784": true,
      "52785": true,
      "52786": true,
      "52787": true,
      "52788": true,
      "52789": true,
      "52790": true,
      "52793": true,
      "52794": true,
      "52795": true,
      "52796": true,
      "52797": true,
      "52798": true,
      "52799": true
    },
    "ISIDRO FABELA": {
      "54480": true,
      "54483": true,
      "54484": true,
      "54485": true,
      "54486": true,
      "54487": true,
      "54488": true,
      "54489": true,
      "54490": true,
      "54493": true,
      "54494": true,
      "54495": true,
      "54530": true
    },
    "IXTAPALUCA": {
      "56530": true,
      "56535": true,
      "56536": true,
      "56537": true,
      "56538": true,
      "56539": true,
      "56540": true,
      "56550": true,
      "56553": true,
      "56555": true,
      "56556": true,
      "56558": true,
      "56560": true,
      "56563": true,
      "56564": true,
      "56565": true,
      "56566": true,
      "56567": true,
      "56568": true,
      "56569": true,
      "56570": true,
      "56576": true,
      "56577": true,
      "56579": true,
      "56580": true,
      "56584": true,
      "56585": true,
      "56586": true,
      "56587": true,
      "56588": true,
      "56589": true,
      "56590": true,
      "56599": true
    },
    "IXTAPAN DE LA SAL": {
      "51900": true,
      "51904": true,
      "51905": true,
      "51906": true,
      "51907": true,
      "51910": true,
      "51915": true,
      "51916": true,
      "51917": true,
      "51920": true,
      "51923": true,
      "51924": true,
      "51930": true,
      "51933": true,
      "51936": true,
      "51937": true
    },
    "IXTAPAN DEL ORO": {
      "51070": true,
      "51074": true,
      "51075": true,
      "51076": true,
      "51077": true,
      "51080": true,
      "51083": true,
      "51084": true,
      "51085": true,
      "51089": true,
      "51100": true
    },
    "IXTLAHUACA": {
      "50740": true,
      "50743": true,
      "50744": true,
      "50755": true,
      "50760": true,
      "50764": true,
      "50770": true,
      "50773": true,
      "50774": true,
      "50775": true,
      "50780": true,
      "50783": true,
      "50785": true
    },
    "JALTENCO": {
      "55780": true,
      "55783": true,
      "55784": true
    },
    "JILOTEPEC": {
      "54240": true,
      "54246": true,
      "54250": true,
      "54253": true,
      "54254": true,
      "54255": true,
      "54256": true,
      "54257": true,
      "54260": true,
      "54263": true,
      "54265": true,
      "54270": true,
      "54275": true,
      "54276": true
    },
    "JILOTZINGO": {
      "54570": true,
      "54571": true,
      "54573": true,
      "54574": true,
      "54575": true
    },
    "JIQUIPILCO": {
      "50800": true,
      "50810": true,
      "50813": true,
      "50814": true,
      "50815": true,
      "50816": true,
      "50820": true,
      "50823": true,
      "50824": true,
      "50825": true,
      "50826": true,
      "50830": true,
      "50833": true,
      "50834": true,
      "50835": true,
      "50836": true,
      "50840": true,
      "50843": true,
      "50844": true,
      "50845": true,
      "50846": true,
      "50847": true,
      "50848": true
    },
    "JOCOTITLAN": {
      "50700": true,
      "50710": true,
      "50713": true,
      "50714": true,
      "50720": true,
      "50724": true,
      "50725": true,
      "50726": true,
      "50727": true,
      "50733": true,
      "50734": true,
      "50736": true,
      "50737": true
    },
    "JOQUICINGO": {
      "52370": true,
      "52374": true,
      "52376": true,
      "52380": true,
      "52387": true,
      "52390": true
    },
    "JUCHITEPEC": {
      "56860": true,
      "56863": true,
      "56864": true,
      "56866": true,
      "56867": true,
      "56870": true
    },
    "LA PAZ": {
      "56400": true,
      "56410": true,
      "56420": true,
      "56428": true,
      "56429": true,
      "56430": true,
      "56440": true,
      "56490": true,
      "56495": true,
      "56500": true,
      "56505": true,
      "56507": true,
      "56508": true,
      "56509": true,
      "56510": true,
      "56512": true,
      "56513": true,
      "56514": true,
      "56515": true,
      "56516": true,
      "56520": true,
      "56524": true,
      "56525": true,
      "56526": true,
      "56527": true,
      "56528": true,
      "56529": true
    },
    "LERMA": {
      "52000": true,
      "52004": true,
      "52005": true,
      "52006": true,
      "52010": true,
      "52020": true,
      "52030": true,
      "52040": true,
      "52043": true,
      "52044": true,
      "52045": true,
      "52046": true,
      "52047": true,
      "52050": true,
      "52054": true,
      "52055": true,
      "52059": true
    },
    "LUVIANOS": {
      "51440": true,
      "51442": true,
      "51443": true,
      "51445": true,
      "51446": true,
      "51462": true,
      "51463": true,
      "51464": true,
      "51465": true,
      "51466": true
    },
    "MALINALCO": {
      "52440": true,
      "52443": true,
      "52444": true,
      "52460": true,
      "52463": true,
      "52464": true,
      "52465": true,
      "52466": true,
      "52467": true,
      "52473": true
    },
    "MELCHOR OCAMPO": {
      "54880": true,
      "54882": true,
      "54883": true,
      "54884": true,
      "54890": true,
      "54893": true,
      "54894": true
    },
    "METEPEC": {
      "52140": true,
      "52143": true,
      "52144": true,
      "52145": true,
      "52146": true,
      "52147": true,
      "52148": true,
      "52149": true,
      "52150": true,
      "52154": true,
      "52155": true,
      "52156": true,
      "52157": true,
      "52158": true,
      "52159": true,
      "52160": true,
      "52161": true,
      "52164": true,
      "52165": true,
      "52166": true,
      "52167": true,
      "52168": true,
      "52169": true,
      "52170": true,
      "52172": true,
      "52175": true,
      "52176": true,
      "52177": true,
      "52178": true,
      "52179": true
    },
    "MEXICALTZINGO": {
      "52180": true,
      "52182": true,
      "52183": true,
      "52185": true,
      "52189": true
    },
    "MORELOS": {
      "50550": true,
      "50553": true,
      "50554": true,
      "50559": true,
      "50560": true,
      "50563": true,
      "50564": true,
      "50565": true,
      "50566": true,
      "50567": true,
      "50570": true,
      "50573": true,
      "50574": true,
      "50575": true,
      "50583": true,
      "50584": true,
      "50590": true,
      "50596": true,
      "50597": true
    },
    "NAUCALPAN DE JUÁREZ": {
      "53000": true,
      "53010": true,
      "53030": true,
      "53040": true,
      "53050": true,
      "53060": true,
      "53070": true,
      "53100": true,
      "53110": true,
      "53115": true,
      "53116": true,
      "53117": true,
      "53119": true,
      "53120": true,
      "53124": true,
      "53125": true,
      "53126": true,
      "53127": true,
      "53128": true,
      "53129": true,
      "53130": true,
      "53138": true,
      "53140": true,
      "53150": true,
      "53160": true,
      "53170": true,
      "53177": true,
      "53178": true,
      "53179": true,
      "53200": true,
      "53215": true,
      "53216": true,
      "53217": true,
      "53218": true,
      "53219": true,
      "53220": true,
      "53224": true,
      "53227": true,
      "53228": true,
      "53229": true,
      "53230": true,
      "53237": true,
      "53239": true,
      "53240": true,
      "53247": true,
      "53248": true,
      "53250": true,
      "53260": true,
      "53270": true,
      "53278": true,
      "53279": true,
      "53280": true,
      "53283": true,
      "53290": true,
      "53296": true,
      "53297": true,
      "53298": true,
      "53300": true,
      "53309": true,
      "53310": true,
      "53320": true,
      "53329": true,
      "53330": true,
      "53338": true,
      "53339": true,
      "53340": true,
      "53348": true,
      "53350": true,
      "53370": true,
      "53378": true,
      "53390": true,
      "53398": true,
      "53400": true,
      "53410": true,
      "53420": true,
      "53425": true,
      "53426": true,
      "53427": true,
      "53428": true,
      "53430": true,
      "53440": true,
      "53450": true,
      "53458": true,
      "53459": true,
      "53460": true,
      "53470": true,
      "53489": true,
      "53490": true,
      "53500": true,
      "53519": true,
      "53520": true,
      "53529": true,
      "53530": true,
      "53533": true,
      "53550": true,
      "53560": true,
      "53569": true,
      "53570": true,
      "53580": true,
      "53598": true,
      "53640": true,
      "53650": true,
      "53658": true,
      "53659": true,
      "53660": true,
      "53664": true,
      "53670": true,
      "53680": true,
      "53687": true,
      "53688": true,
      "53689": true,
      "53690": true,
      "53694": true,
      "53695": true,
      "53696": true,
      "53697": true,
      "53698": true,
      "53700": true,
      "53708": true,
      "53710": true,
      "53713": true,
      "53714": true,
      "53716": true,
      "53717": true,
      "53718": true,
      "53719": true,
      "53730": true,
      "53760": true,
      "53770": true,
      "53780": true,
      "53787": true,
      "53788": true,
      "53790": true,
      "53798": true,
      "53799": true,
      "53800": true,
      "53809": true,
      "53810": true,
      "53819": true,
      "53820": true,
      "53830": true,
      "53839": true,
      "53840": true,
      "53900": true,
      "53909": true,
      "53910": true,
      "53930": true,
      "53940": true,
      "53950": true,
      "53960": true,
      "53970": true
    },
    "NEXTLALPAN": {
      "55790": true,
      "55793": true,
      "55794": true,
      "55795": true,
      "55796": true,
      "55797": true,
      "55799": true
    },
    "NEZAHUALCÓYOTL": {
      "57000": true,
      "57100": true,
      "57103": true,
      "57120": true,
      "57129": true,
      "57130": true,
      "57138": true,
      "57139": true,
      "57140": true,
      "57150": true,
      "57158": true,
      "57170": true,
      "57171": true,
      "57178": true,
      "57179": true,
      "57180": true,
      "57185": true,
      "57188": true,
      "57189": true,
      "57200": true,
      "57205": true,
      "57210": true,
      "57300": true,
      "57310": true,
      "57400": true,
      "57410": true,
      "57420": true,
      "57430": true,
      "57440": true,
      "57450": true,
      "57460": true,
      "57500": true,
      "57510": true,
      "57520": true,
      "57530": true,
      "57600": true,
      "57610": true,
      "57620": true,
      "57630": true,
      "57700": true,
      "57708": true,
      "57709": true,
      "57710": true,
      "57718": true,
      "57719": true,
      "57720": true,
      "57730": true,
      "57739": true,
      "57740": true,
      "57750": true,
      "57760": true,
      "57800": true,
      "57809": true,
      "57810": true,
      "57819": true,
      "57820": true,
      "57830": true,
      "57840": true,
      "57849": true,
      "57900": true,
      "57910": true,
      "57920": true,
      "57930": true,
      "57940": true,
      "57950": true
    },
    "NICOLÁS ROMERO": {
      "54400": true,
      "54402": true,
      "54405": true,
      "54407": true,
      "54408": true,
      "54409": true,
      "54410": true,
      "54413": true,
      "54414": true,
      "54416": true,
      "54417": true,
      "54420": true,
      "54424": true,
      "54425": true,
      "54426": true,
      "54430": true,
      "54434": true,
      "54435": true,
      "54439": true,
      "54440": true,
      "54447": true,
      "54448": true,
      "54449": true,
      "54455": true,
      "54457": true,
      "54459": true,
      "54460": true,
      "54463": true,
      "54464": true,
      "54466": true,
      "54467": true,
      "54469": true,
      "54470": true,
      "54473": true,
      "54474": true,
      "54475": true,
      "54476": true,
      "54477": true,
      "54539": true
    },
    "NOPALTEPEC": {
      "55970": true,
      "55973": true,
      "55975": true,
      "55976": true,
      "55977": true,
      "55978": true
    },
    "OCOYOACAC": {
      "52740": true,
      "52743": true,
      "52750": true,
      "52753": true,
      "52754": true,
      "52755": true,
      "52756": true,
      "52757": true
    },
    "OCUILAN": {
      "52480": true,
      "52483": true,
      "52484": true,
      "52486": true,
      "52490": true,
      "52494": true,
      "52495": true,
      "52496": true,
      "52497": true
    },
    "OTUMBA": {
      "55900": true,
      "55913": true,
      "55914": true,
      "55920": true,
      "55923": true,
      "55924": true,
      "55925": true,
      "55926": true,
      "55927": true,
      "55930": true,
      "55934": true,
      "55935": true,
      "55936": true,
      "55937": true
    },
    "OTZOLOTEPEC": {
      "52080": true,
      "52082": true,
      "52083": true,
      "52084": true,
      "52085": true,
      "52088": true,
      "52089": true,
      "52090": true,
      "52094": true,
      "52095": true,
      "52096": true
    },
    "OZUMBA": {
      "56800": true,
      "56806": true,
      "56810": true,
      "56813": true,
      "56814": true,
      "56816": true,
      "56820": true
    },
    "PAPALOTLA": {
      "56050": true,
      "56053": true,
      "56054": true,
      "56055": true,
      "56056": true,
      "56057": true
    },
    "RAYON": {
      "52360": true,
      "52362": true,
      "52363": true,
      "52364": true,
      "52365": true,
      "52366": true,
      "52367": true
    },
    "SAN ANTONIO LA ISLA": {
      "52280": true,
      "52282": true,
      "52286": true,
      "52290": true
    },
    "SAN FELIPE DEL PROGRESO": {
      "50640": true,
      "50653": true,
      "50654": true,
      "50655": true,
      "50656": true,
      "50680": true,
      "50683": true,
      "50684": true,
      "50686": true,
      "50687": true,
      "50693": true,
      "50694": true,
      "50695": true,
      "50696": true,
      "50697": true
    },
    "SAN JOSE DEL RINCON": {
      "50660": true,
      "50663": true,
      "50664": true,
      "50665": true,
      "50666": true,
      "50667": true,
      "50668": true,
      "50670": true,
      "50673": true,
      "50674": true,
      "50676": true,
      "50677": true,
      "50678": true
    },
    "SAN MARTIN DE LAS PIRAMIDES": {
      "55850": true,
      "55852": true,
      "55853": true,
      "55854": true,
      "55855": true,
      "55856": true,
      "55859": true
    },
    "SAN MATEO ATENCO": {
      "52100": true,
      "52104": true,
      "52105": true,
      "52106": true,
      "52107": true,
      "52110": true,
      "52120": true
    },
    "SAN SIMON DE GUERRERO": {
      "51470": true,
      "51476": true,
      "51479": true,
      "51480": true,
      "51483": true,
      "51484": true,
      "51485": true
    },
    "SOYANIQUILPAN DE JUAREZ": {
      "54280": true,
      "54283": true,
      "54284": true,
      "54285": true,
      "54290": true,
      "54293": true,
      "54294": true,
      "54295": true,
      "54296": true,
      "54297": true
    },
    "SULTEPEC": {
      "51600": true,
      "51603": true,
      "51604": true,
      "51605": true,
      "51606": true,
      "51607": true,
      "51610": true,
      "51620": true,
      "51633": true,
      "51635": true,
      "51637": true
    },
    "TECAMAC": {
      "55740": true,
      "55743": true,
      "55744": true,
      "55745": true,
      "55746": true,
      "55747": true,
      "55748": true,
      "55749": true,
      "55750": true,
      "55752": true,
      "55754": true,
      "55755": true,
      "55757": true,
      "55758": true,
      "55760": true,
      "55763": true,
      "55764": true,
      "55765": true,
      "55766": true,
      "55767": true,
      "55768": true,
      "55770": true,
      "55773": true,
      "55776": true,
      "55778": true
    },
    "TECÁMAC": {
      "55740": true,
      "55743": true,
      "55744": true,
      "55745": true,
      "55746": true,
      "55747": true,
      "55748": true,
      "55749": true,
      "55750": true,
      "55752": true,
      "55754": true,
      "55755": true,
      "55757": true,
      "55758": true,
      "55760": true,
      "55763": true,
      "55764": true,
      "55765": true,
      "55766": true,
      "55767": true,
      "55768": true,
      "55770": true,
      "55773": true,
      "55776": true,
      "55778": true
    },
    "TEJUPILCO": {
      "51400": true,
      "51410": true,
      "51412": true,
      "51413": true,
      "51414": true,
      "51415": true,
      "51416": true,
      "51417": true,
      "51418": true,
      "51422": true,
      "51423": true,
      "51424": true,
      "51425": true,
      "51426": true,
      "51427": true,
      "51428": true
    },
    "TEMAMATLA": {
      "56650": true,
      "56653": true,
      "56654": true,
      "56655": true,
      "56656": true,
      "56657": true
    },
    "TEMASCALAPA": {
      "55980": true,
      "55983": true,
      "55984": true,
      "55985": true,
      "55988": true,
      "55989": true,
      "55990": true,
      "55993": true,
      "55994": true,
      "55995": true,
      "55996": true,
      "55997": true,
      "55998": true
    },
    "TEMASCALCINGO": {
      "50400": true,
      "50410": true,
      "50413": true,
      "50414": true,
      "50415": true,
      "50420": true,
      "50423": true,
      "50424": true,
      "50425": true,
      "50430": true,
      "50433": true,
      "50434": true,
      "50435": true,
      "50440": true,
      "50443": true,
      "50444": true,
      "50445": true,
      "50446": true
    },
    "TEMASCALTEPEC": {
      "51300": true,
      "51303": true,
      "51304": true,
      "51305": true,
      "51320": true,
      "51324": true,
      "51325": true,
      "51326": true,
      "51340": true,
      "51344": true,
      "51346": true
    },
    "TEMOAYA": {
      "50850": true,
      "50860": true,
      "50863": true,
      "50864": true,
      "50865": true,
      "50866": true,
      "50867": true,
      "50868": true,
      "50869": true,
      "50870": true,
      "50874": true,
      "50880": true,
      "50883": true,
      "50884": true,
      "50885": true,
      "50886": true,
      "50890": true,
      "50893": true,
      "50894": true,
      "50895": true,
      "50896": true
    },
    "TENANCINGO": {
      "52400": true,
      "52403": true,
      "52410": true,
      "52413": true,
      "52414": true,
      "52415": true,
      "52416": true,
      "52420": true,
      "52423": true,
      "52424": true,
      "52425": true,
      "52426": true,
      "52427": true,
      "52430": true,
      "52433": true,
      "52435": true,
      "52436": true,
      "52437": true
    },
    "TENANGO DEL AIRE": {
      "56780": true,
      "56783": true,
      "56784": true,
      "56785": true
    },
    "TENANGO DEL VALLE": {
      "52300": true,
      "52303": true,
      "52304": true,
      "52305": true,
      "52307": true,
      "52310": true,
      "52315": true,
      "52316": true,
      "52317": true,
      "52320": true,
      "52330": true,
      "52333": true,
      "52334": true,
      "52336": true,
      "52337": true,
      "52340": true,
      "52343": true,
      "52345": true,
      "52346": true,
      "52347": true,
      "52350": true,
      "52353": true,
      "52354": true,
      "52355": true,
      "52356": true,
      "52357": true
    },
    "TEOLOYUCAN": {
      "54770": true,
      "54783": true,
      "54784": true,
      "54785": true,
      "54786": true
    },
    "TEOTIHUACAN": {
      "55800": true,
      "55803": true,
      "55804": true,
      "55805": true,
      "55806": true,
      "55807": true,
      "55810": true,
      "55816": true,
      "55817": true,
      "55820": true,
      "55823": true,
      "55824": true,
      "55825": true,
      "55826": true,
      "55829": true,
      "55830": true,
      "55833": true,
      "55834": true,
      "55835": true,
      "55836": true,
      "55837": true,
      "55838": true,
      "55840": true,
      "55843": true,
      "55844": true,
      "55845": true,
      "55846": true,
      "55847": true
    },
    "TEPETLAOXTOC": {
      "56070": true,
      "56074": true,
      "56075": true,
      "56077": true,
      "56078": true,
      "56080": true,
      "56085": true,
      "56086": true,
      "56087": true
    },
    "TEPETLIXPA": {
      "56880": true,
      "56884": true,
      "56885": true,
      "56890": true,
      "56893": true,
      "56894": true
    },
    "TEPOTZOTLAN": {
      "54600": true,
      "54602": true,
      "54603": true,
      "54604": true,
      "54605": true,
      "54607": true,
      "54608": true,
      "54610": true,
      "54614": true,
      "54615": true,
      "54616": true,
      "54650": true,
      "54655": true,
      "54658": true
    },
    "TEPOTZOTLÁN": {
      "54600": true,
      "54602": true,
      "54603": true,
      "54604": true,
      "54605": true,
      "54607": true,
      "54608": true,
      "54610": true,
      "54614": true,
      "54615": true,
      "54616": true,
      "54650": true
    },
    "TEQUIXQUIAC": {
      "55650": true,
      "55653": true,
      "55654": true,
      "55655": true,
      "55656": true,
      "55657": true
    },
    "TEXCALTITLAN": {
      "51670": true,
      "51673": true,
      "51674": true,
      "51675": true,
      "51676": true,
      "51680": true,
      "51693": true,
      "51694": true,
      "51695": true,
      "51696": true,
      "51697": true
    },
    "TEXCALYACAC": {
      "52570": true,
      "52574": true
    },
    "TEXCOCO": {
      "56100": true,
      "56105": true,
      "56106": true,
      "56110": true,
      "56120": true,
      "56130": true,
      "56140": true,
      "56150": true,
      "56160": true,
      "56170": true,
      "56200": true,
      "56203": true,
      "56204": true,
      "56205": true,
      "56207": true,
      "56208": true,
      "56210": true,
      "56213": true,
      "56214": true,
      "56215": true,
      "56216": true,
      "56217": true,
      "56220": true,
      "56223": true,
      "56224": true,
      "56225": true,
      "56226": true,
      "56227": true,
      "56230": true,
      "56233": true,
      "56235": true,
      "56236": true,
      "56237": true,
      "56240": true,
      "56242": true,
      "56243": true,
      "56244": true,
      "56245": true,
      "56246": true,
      "56247": true,
      "56250": true,
      "56253": true,
      "56254": true,
      "56255": true,
      "56256": true,
      "56257": true,
      "56260": true,
      "56263": true,
      "56264": true,
      "56265": true,
      "56266": true,
      "56267": true,
      "56268": true
    },
    "TEZOYUCA": {
      "56000": true,
      "56003": true,
      "56004": true,
      "56005": true,
      "56006": true,
      "56007": true,
      "56010": true,
      "56020": true,
      "56023": true,
      "56024": true
    },
    "TIANGUISTENCO": {
      "52600": true,
      "52603": true,
      "52604": true,
      "52605": true,
      "52607": true,
      "52613": true,
      "52614": true,
      "52640": true,
      "52644": true,
      "52645": true,
      "52646": true,
      "52650": true,
      "52653": true,
      "52654": true,
      "52656": true,
      "52660": true,
      "52664": true,
      "52665": true,
      "52666": true,
      "52667": true
    },
    "TIMILPAN": {
      "50500": true,
      "50503": true,
      "50504": true,
      "50505": true,
      "50507": true,
      "50508": true,
      "50509": true,
      "50510": true,
      "50520": true,
      "50523": true,
      "50524": true,
      "50525": true,
      "50526": true,
      "50527": true,
      "50528": true,
      "50540": true
    },
    "TLALMANALCO": {
      "56700": true,
      "56703": true,
      "56704": true,
      "56710": true,
      "56713": true,
      "56714": true,
      "56715": true,
      "56716": true,
      "56720": true,
      "56723": true,
      "56730": true,
      "56735": true,
      "56740": true,
      "56743": true,
      "56744": true,
      "56745": true,
      "56746": true,
      "56747": true
    },
    "TLANEPANTLA": {
      "54000": true,
      "54009": true,
      "54010": true,
      "54015": true,
      "54016": true,
      "54017": true,
      "54020": true,
      "54021": true,
      "54022": true,
      "54023": true,
      "54025": true,
      "54026": true,
      "54028": true,
      "54030": true,
      "54033": true,
      "54037": true,
      "54038": true,
      "54040": true,
      "54049": true,
      "54050": true,
      "54054": true,
      "54055": true,
      "54057": true,
      "54059": true,
      "54060": true,
      "54063": true,
      "54067": true,
      "54068": true,
      "54069": true,
      "54070": true,
      "54073": true,
      "54075": true,
      "54076": true,
      "54080": true,
      "54090": true,
      "54092": true,
      "54093": true,
      "54094": true,
      "54098": true,
      "54100": true,
      "54108": true,
      "54109": true,
      "54110": true,
      "54118": true,
      "54119": true,
      "54120": true,
      "54124": true,
      "54126": true,
      "54127": true,
      "54128": true,
      "54130": true,
      "54134": true,
      "54135": true,
      "54136": true,
      "54140": true,
      "54142": true,
      "54143": true,
      "54145": true,
      "54146": true,
      "54147": true,
      "54149": true,
      "54150": true,
      "54152": true,
      "54158": true,
      "54160": true,
      "54162": true,
      "54168": true,
      "54170": true,
      "54172": true,
      "54173": true,
      "54180": true,
      "54187": true,
      "54189": true,
      "54190": true,
      "54193": true,
      "54195": true,
      "54196": true,
      "54197": true,
      "54198": true
    },
    "TLATLAYA": {
      "51550": true,
      "51553": true,
      "51554": true,
      "51555": true,
      "51556": true,
      "51557": true,
      "51558": true,
      "51559": true,
      "51564": true,
      "51566": true,
      "51568": true,
      "51569": true,
      "51570": true,
      "51572": true,
      "51573": true,
      "51574": true,
      "51576": true,
      "51577": true,
      "51578": true,
      "51579": true,
      "51580": true,
      "51583": true,
      "51584": true,
      "51585": true,
      "51587": true,
      "51588": true
    },
    "TOLUCA": {
      "50000": true,
      "50010": true,
      "50016": true,
      "50017": true,
      "50018": true,
      "50019": true,
      "50020": true,
      "50026": true,
      "50030": true,
      "50039": true,
      "50040": true,
      "50050": true,
      "50060": true,
      "50069": true,
      "50070": true,
      "50071": true,
      "50075": true,
      "50076": true,
      "50080": true,
      "50090": true,
      "50100": true,
      "50103": true,
      "50110": true,
      "50115": true,
      "50120": true,
      "50122": true,
      "50123": true,
      "50130": true,
      "50140": true,
      "50150": true,
      "50160": true,
      "50168": true,
      "50170": true,
      "50180": true,
      "50190": true,
      "50200": true,
      "50203": true,
      "50205": true,
      "50206": true,
      "50209": true,
      "50210": true,
      "50214": true,
      "50220": true,
      "50223": true,
      "50225": true,
      "50226": true,
      "50227": true,
      "50228": true,
      "50230": true,
      "50233": true,
      "50235": true,
      "50236": true,
      "50240": true,
      "50245": true,
      "50246": true,
      "50250": true,
      "50253": true,
      "50254": true,
      "50255": true,
      "50256": true,
      "50257": true,
      "50258": true,
      "50260": true,
      "50263": true,
      "50264": true,
      "50265": true,
      "50266": true,
      "50270": true,
      "50273": true,
      "50274": true,
      "50280": true,
      "50283": true,
      "50284": true,
      "50285": true,
      "50286": true,
      "50290": true,
      "50293": true,
      "50294": true,
      "50295": true
    },
    "TONANITLA": {
      "55785": true,
      "55786": true,
      "55787": true
    },
    "TONATICO": {
      "51950": true,
      "51953": true,
      "51954": true,
      "51955": true,
      "51956": true,
      "51959": true,
      "51960": true,
      "51963": true,
      "51964": true,
      "51970": true,
      "51973": true,
      "51974": true,
      "51977": true
    },
    "TULTEPEC": {
      "54960": true,
      "54962": true,
      "54963": true,
      "54964": true,
      "54965": true,
      "54966": true,
      "54967": true,
      "54970": true,
      "54972": true,
      "54974": true,
      "54975": true,
      "54976": true,
      "54977": true,
      "54980": true,
      "54983": true,
      "54984": true,
      "54985": true,
      "54986": true,
      "54987": true,
      "54990": true
    },
    "TULTITLÁN": {
      "54900": true,
      "54910": true,
      "54913": true,
      "54914": true,
      "54915": true,
      "54916": true,
      "54918": true,
      "54920": true,
      "54924": true,
      "54925": true,
      "54926": true,
      "54927": true,
      "54929": true,
      "54930": true,
      "54932": true,
      "54933": true,
      "54934": true,
      "54935": true,
      "54938": true,
      "54939": true,
      "54940": true,
      "54942": true,
      "54943": true,
      "54944": true,
      "54945": true,
      "54946": true,
      "54947": true,
      "54948": true,
      "54949": true,
      "54950": true,
      "54954": true,
      "54955": true,
      "54957": true,
      "54958": true,
      "54959": true
    },
    "VALLE DE BRAVO": {
      "51200": true,
      "51206": true,
      "51207": true,
      "51208": true,
      "51209": true,
      "51210": true,
      "51216": true,
      "51217": true,
      "51218": true,
      "51219": true,
      "51220": true,
      "51225": true,
      "51226": true,
      "51229": true,
      "51230": true,
      "51236": true,
      "51237": true,
      "51238": true,
      "51239": true,
      "51240": true,
      "51245": true,
      "51246": true,
      "51247": true,
      "51248": true
    },
    "VALLE DE CHALCO SOLIDARIDAD": {
      "56610": true,
      "56613": true,
      "56614": true,
      "56615": true,
      "56616": true,
      "56617": true,
      "56618": true,
      "56619": true
    },
    "VILLA DE ALLENDE": {
      "51000": true,
      "51004": true,
      "51005": true,
      "51006": true,
      "51007": true,
      "51008": true,
      "51009": true,
      "51010": true,
      "51013": true,
      "51014": true,
      "51015": true,
      "51016": true,
      "51017": true,
      "51019": true,
      "51020": true,
      "51024": true,
      "51025": true,
      "51026": true,
      "51027": true,
      "51028": true,
      "51029": true
    },
    "VILLA DEL CARBON": {
      "54300": true,
      "54310": true,
      "54313": true,
      "54314": true,
      "54315": true,
      "54320": true,
      "54324": true,
      "54325": true,
      "54326": true,
      "54327": true,
      "54330": true,
      "54333": true,
      "54334": true,
      "54335": true,
      "54337": true,
      "54345": true,
      "54346": true
    },
    "VILLA GUERRERO": {
      "51760": true,
      "51765": true,
      "51766": true,
      "51767": true,
      "51773": true,
      "51775": true,
      "51776": true,
      "51777": true,
      "51783": true,
      "51784": true,
      "51786": true
    },
    "VILLA VICTORIA": {
      "50960": true,
      "50963": true,
      "50964": true,
      "50965": true,
      "50966": true,
      "50967": true,
      "50970": true,
      "50973": true,
      "50974": true,
      "50975": true,
      "50980": true,
      "50983": true,
      "50984": true,
      "50985": true,
      "50986": true,
      "50987": true,
      "50990": true,
      "50993": true,
      "50994": true,
      "50995": true,
      "50996": true,
      "50997": true
    },
    "XALATLACO": {
      "52680": true,
      "52683": true,
      "52684": true,
      "52685": true,
      "52686": true,
      "52688": true,
      "52689": true,
      "52693": true
    },
    "XONACATLAN": {
      "52060": true,
      "52064": true,
      "52065": true,
      "52067": true,
      "52070": true,
      "52073": true,
      "52074": true,
      "52075": true,
      "52076": true
    },
    "ZINACANTEPEC": {
      "51350": true,
      "51353": true,
      "51354": true,
      "51355": true,
      "51356": true,
      "51357": true,
      "51360": true,
      "51364": true,
      "51366": true,
      "51367": true,
      "51370": true,
      "51373": true,
      "51374": true,
      "51375": true,
      "51380": true,
      "51383": true,
      "51384": true,
      "51385": true,
      "51386": true,
      "51390": true,
      "51393": true
    },
    "ZUMPAHUACAN": {
      "51980": true,
      "51984": true,
      "51985": true,
      "51986": true,
      "51987": true,
      "51988": true,
      "51989": true,
      "51990": true,
      "51994": true,
      "51995": true,
      "51997": true
    },
    "ZUMPANGO": {
      "55600": true,
      "55604": true,
      "55605": true,
      "55606": true,
      "55607": true,
      "55609": true,
      "55610": true,
      "55613": true,
      "55614": true,
      "55619": true,
      "55620": true,
      "55627": true,
      "55628": true,
      "55629": true,
      "55630": true,
      "55634": true,
      "55635": true,
      "55636": true,
      "55637": true,
      "55640": true
    }
  },
  "CIUDAD DE MÉXICO": {
    "AZCAPOTZALCO": {
      "02000": true,
      "02010": true,
      "02020": true,
      "02040": true,
      "02050": true,
      "02060": true,
      "02070": true,
      "02080": true,
      "02090": true,
      "02099": true,
      "02100": true,
      "02120": true,
      "02128": true,
      "02129": true,
      "02130": true,
      "02140": true,
      "02150": true,
      "02160": true,
      "02200": true,
      "02230": true,
      "02240": true,
      "02250": true,
      "02300": true,
      "02310": true,
      "02320": true,
      "02330": true,
      "02340": true,
      "02360": true,
      "02400": true,
      "02410": true,
      "02420": true,
      "02440": true,
      "02459": true,
      "02460": true,
      "02470": true,
      "02480": true,
      "02490": true,
      "02500": true,
      "02519": true,
      "02520": true,
      "02530": true,
      "02600": true,
      "02630": true,
      "02640": true,
      "02650": true,
      "02660": true,
      "02670": true,
      "02680": true,
      "02700": true,
      "02710": true,
      "02719": true,
      "02720": true,
      "02730": true,
      "02750": true,
      "02760": true,
      "02770": true,
      "02780": true,
      "02790": true,
      "02800": true,
      "02810": true,
      "02830": true,
      "02840": true,
      "02860": true,
      "02870": true,
      "02900": true,
      "02910": true,
      "02920": true,
      "02930": true,
      "02940": true,
      "02950": true,
      "02960": true,
      "02970": true,
      "02980": true,
      "02990": true
    },
    "BENITO JUÁREZ": {
      "03000": true,
      "03010": true,
      "03020": true,
      "03023": true,
      "03100": true,
      "03103": true,
      "03104": true,
      "03200": true,
      "03230": true,
      "03240": true,
      "03300": true,
      "03303": true,
      "03310": true,
      "03320": true,
      "03330": true,
      "03340": true,
      "03400": true,
      "03410": true,
      "03420": true,
      "03430": true,
      "03440": true,
      "03500": true,
      "03510": true,
      "03520": true,
      "03530": true,
      "03540": true,
      "03550": true,
      "03560": true,
      "03570": true,
      "03580": true,
      "03590": true,
      "03600": true,
      "03610": true,
      "03620": true,
      "03630": true,
      "03640": true,
      "03650": true,
      "03660": true,
      "03700": true,
      "03710": true,
      "03720": true,
      "03730": true,
      "03740": true,
      "03800": true,
      "03810": true,
      "03820": true,
      "03840": true,
      "03900": true,
      "03910": true,
      "03920": true,
      "03930": true,
      "03940": true,
      "04120": true,
      "04260": true,
      "04320": true,
      "04330": true,
      "04360": true,
      "04370": true,
      "04380": true,
      "04390": true,
      "04440": true
    },
    "COYOACÁN": {
      "04000": true,
      "04010": true,
      "04020": true,
      "04030": true,
      "04040": true,
      "04100": true,
      "04120": true,
      "04200": true,
      "04210": true,
      "04230": true,
      "04240": true,
      "04250": true,
      "04260": true,
      "04300": true,
      "04310": true,
      "04318": true,
      "04320": true,
      "04330": true,
      "04340": true,
      "04360": true,
      "04369": true,
      "04370": true,
      "04380": true,
      "04390": true,
      "04400": true,
      "04410": true,
      "04420": true,
      "04440": true,
      "04450": true,
      "04460": true,
      "04470": true,
      "04480": true,
      "04489": true,
      "04490": true,
      "04500": true,
      "04510": true,
      "04519": true,
      "04530": true,
      "04600": true,
      "04610": true,
      "04620": true,
      "04630": true,
      "04640": true,
      "04650": true,
      "04660": true,
      "04700": true,
      "04710": true,
      "04730": true,
      "04739": true,
      "04800": true,
      "04810": true,
      "04815": true,
      "04830": true,
      "04840": true,
      "04870": true,
      "04890": true,
      "04899": true,
      "04909": true,
      "04910": true,
      "04918": true,
      "04919": true,
      "04920": true,
      "04929": true,
      "04930": true,
      "04938": true,
      "04939": true,
      "04940": true,
      "04950": true,
      "04960": true,
      "04970": true,
      "04980": true
    },
    "CUAJIMALPA DE MORELOS": {
      "05000": true,
      "05010": true,
      "05020": true,
      "05030": true,
      "05050": true,
      "05100": true,
      "05110": true,
      "05118": true,
      "05119": true,
      "05120": true,
      "05129": true,
      "05200": true,
      "05219": true,
      "05220": true,
      "05230": true,
      "05240": true,
      "05260": true,
      "05269": true,
      "05270": true,
      "05280": true,
      "05310": true,
      "05320": true,
      "05330": true,
      "05348": true,
      "05360": true,
      "05370": true,
      "05379": true,
      "05400": true,
      "05410": true,
      "05500": true,
      "05520": true,
      "05530": true,
      "05600": true,
      "05610": true,
      "05700": true,
      "05710": true,
      "05730": true,
      "05750": true,
      "05760": true,
      "05780": true,
      "05790": true
    },
    "CUAUHTÉMOC": {
      "06000": true,
      "06010": true,
      "06020": true,
      "06030": true,
      "06040": true,
      "06050": true,
      "06060": true,
      "06070": true,
      "06080": true,
      "06090": true,
      "06100": true,
      "06140": true,
      "06170": true,
      "06200": true,
      "06220": true,
      "06240": true,
      "06250": true,
      "06270": true,
      "06280": true,
      "06300": true,
      "06350": true,
      "06400": true,
      "06430": true,
      "06450": true,
      "06470": true,
      "06500": true,
      "06600": true,
      "06700": true,
      "06720": true,
      "06760": true,
      "06780": true,
      "06800": true,
      "06820": true,
      "06840": true,
      "06850": true,
      "06860": true,
      "06870": true,
      "06880": true,
      "06890": true,
      "06900": true,
      "06920": true
    },
    "GUSTAVO A. MADERO": {
      "07000": true,
      "07010": true,
      "07020": true,
      "07040": true,
      "07050": true,
      "07058": true,
      "07060": true,
      "07069": true,
      "07070": true,
      "07080": true,
      "07089": true,
      "07090": true,
      "07100": true,
      "07109": true,
      "07110": true,
      "07119": true,
      "07130": true,
      "07140": true,
      "07144": true,
      "07149": true,
      "07150": true,
      "07160": true,
      "07164": true,
      "07170": true,
      "07180": true,
      "07183": true,
      "07187": true,
      "07188": true,
      "07189": true,
      "07190": true,
      "07199": true,
      "07200": true,
      "07207": true,
      "07209": true,
      "07210": true,
      "07214": true,
      "07220": true,
      "07224": true,
      "07230": true,
      "07239": true,
      "07240": true,
      "07250": true,
      "07259": true,
      "07268": true,
      "07270": true,
      "07279": true,
      "07280": true,
      "07290": true,
      "07300": true,
      "07310": true,
      "07320": true,
      "07330": true,
      "07340": true,
      "07350": true,
      "07359": true,
      "07360": true,
      "07369": true,
      "07370": true,
      "07380": true,
      "07400": true,
      "07410": true,
      "07420": true,
      "07430": true,
      "07440": true,
      "07450": true,
      "07455": true,
      "07456": true,
      "07458": true,
      "07460": true,
      "07469": true,
      "07470": true,
      "07480": true,
      "07500": true,
      "07509": true,
      "07510": true,
      "07520": true,
      "07530": true,
      "07540": true,
      "07550": true,
      "07560": true,
      "07570": true,
      "07580": true,
      "07600": true,
      "07620": true,
      "07630": true,
      "07640": true,
      "07650": true,
      "07670": true,
      "07680": true,
      "07700": true,
      "07707": true,
      "07708": true,
      "07720": true,
      "07730": true,
      "07739": true,
      "07740": true,
      "07750": true,
      "07754": true,
      "07755": true,
      "07760": true,
      "07770": true,
      "07780": true,
      "07790": true,
      "07800": true,
      "07810": true,
      "07820": true,
      "07830": true,
      "07838": true,
      "07839": true,
      "07840": true,
      "07850": true,
      "07858": true,
      "07859": true,
      "07860": true,
      "07869": true,
      "07870": true,
      "07880": true,
      "07889": true,
      "07890": true,
      "07899": true,
      "07900": true,
      "07910": true,
      "07918": true,
      "07919": true,
      "07920": true,
      "07930": true,
      "07939": true,
      "07940": true,
      "07950": true,
      "07960": true,
      "07969": true,
      "07970": true,
      "07979": true,
      "07980": true,
      "07990": true
    },
    "IZTACALCO": {
      "08000": true,
      "08010": true,
      "08020": true,
      "08030": true,
      "08040": true,
      "08100": true,
      "08200": true,
      "08210": true,
      "08220": true,
      "08230": true,
      "08240": true,
      "08300": true,
      "08310": true,
      "08320": true,
      "08400": true,
      "08420": true,
      "08500": true,
      "08510": true,
      "08600": true,
      "08610": true,
      "08620": true,
      "08650": true,
      "08700": true,
      "08710": true,
      "08720": true,
      "08730": true,
      "08760": true,
      "08770": true,
      "08800": true,
      "08810": true,
      "08830": true,
      "08840": true,
      "08900": true,
      "08910": true,
      "08920": true,
      "08930": true
    },
    "IZTAPALAPA": {
      "09000": true,
      "09010": true,
      "09020": true,
      "09030": true,
      "09040": true,
      "09060": true,
      "09070": true,
      "09080": true,
      "09089": true,
      "09090": true,
      "09099": true,
      "09100": true,
      "09130": true,
      "09140": true,
      "09180": true,
      "09200": true,
      "09208": true,
      "09209": true,
      "09210": true,
      "09220": true,
      "09230": true,
      "09239": true,
      "09240": true,
      "09250": true,
      "09260": true,
      "09270": true,
      "09280": true,
      "09290": true,
      "09300": true,
      "09310": true,
      "09319": true,
      "09320": true,
      "09350": true,
      "09359": true,
      "09360": true,
      "09400": true,
      "09410": true,
      "09420": true,
      "09429": true,
      "09430": true,
      "09438": true,
      "09440": true,
      "09450": true,
      "09460": true,
      "09470": true,
      "09479": true,
      "09480": true,
      "09500": true,
      "09510": true,
      "09520": true,
      "09530": true,
      "09550": true,
      "09560": true,
      "09570": true,
      "09578": true,
      "09600": true,
      "09608": true,
      "09609": true,
      "09620": true,
      "09630": true,
      "09637": true,
      "09638": true,
      "09640": true,
      "09648": true,
      "09660": true,
      "09670": true,
      "09680": true,
      "09689": true,
      "09690": true,
      "09696": true,
      "09698": true,
      "09700": true,
      "09704": true,
      "09705": true,
      "09706": true,
      "09708": true,
      "09709": true,
      "09710": true,
      "09720": true,
      "09730": true,
      "09740": true,
      "09750": true,
      "09760": true,
      "09769": true,
      "09770": true,
      "09780": true,
      "09790": true,
      "09800": true,
      "09810": true,
      "09819": true,
      "09820": true,
      "09828": true,
      "09829": true,
      "09830": true,
      "09837": true,
      "09838": true,
      "09839": true,
      "09840": true,
      "09849": true,
      "09850": true,
      "09856": true,
      "09858": true,
      "09859": true,
      "09860": true,
      "09868": true,
      "09870": true,
      "09880": true,
      "09890": true,
      "09897": true,
      "09900": true,
      "09910": true,
      "09920": true,
      "09930": true,
      "09940": true,
      "09960": true,
      "09969": true,
      "09970": true
    },
    "LA MAGDALENA CONTRERAS": {
      "10000": true,
      "10010": true,
      "10020": true,
      "10130": true,
      "10200": true,
      "10300": true,
      "10320": true,
      "10330": true,
      "10340": true,
      "10350": true,
      "10360": true,
      "10368": true,
      "10369": true,
      "10370": true,
      "10378": true,
      "10379": true,
      "10380": true,
      "10400": true,
      "10500": true,
      "10580": true,
      "10600": true,
      "10610": true,
      "10620": true,
      "10630": true,
      "10640": true,
      "10660": true,
      "10700": true,
      "10710": true,
      "10800": true,
      "10810": true,
      "10820": true,
      "10830": true,
      "10840": true,
      "10900": true,
      "10910": true,
      "10920": true,
      "10926": true
    },
    "MIGUEL HIDALGO": {
      "11000": true,
      "11040": true,
      "11100": true,
      "11200": true,
      "11210": true,
      "11220": true,
      "11230": true,
      "11240": true,
      "11250": true,
      "11260": true,
      "11270": true,
      "11280": true,
      "11289": true,
      "11290": true,
      "11300": true,
      "11310": true,
      "11320": true,
      "11330": true,
      "11340": true,
      "11350": true,
      "11360": true,
      "11370": true,
      "11400": true,
      "11410": true,
      "11420": true,
      "11430": true,
      "11440": true,
      "11450": true,
      "11460": true,
      "11470": true,
      "11480": true,
      "11489": true,
      "11490": true,
      "11500": true,
      "11510": true,
      "11520": true,
      "11529": true,
      "11530": true,
      "11540": true,
      "11550": true,
      "11560": true,
      "11570": true,
      "11580": true,
      "11590": true,
      "11600": true,
      "11610": true,
      "11619": true,
      "11650": true,
      "11700": true,
      "11800": true,
      "11810": true,
      "11820": true,
      "11830": true,
      "11840": true,
      "11850": true,
      "11860": true,
      "11870": true,
      "11910": true,
      "11920": true,
      "11930": true,
      "11950": true
    },
    "MILPA ALTA": {
      "12000": true,
      "12070": true,
      "12080": true,
      "12100": true,
      "12110": true,
      "12200": true,
      "12250": true,
      "12300": true,
      "12400": true,
      "12410": true,
      "12500": true,
      "12600": true,
      "12700": true,
      "12800": true,
      "12910": true,
      "12920": true,
      "12930": true,
      "12940": true,
      "12950": true
    },
    "TLALPAN": {
      "14000": true,
      "14010": true,
      "14020": true,
      "14030": true,
      "14039": true,
      "14040": true,
      "14049": true,
      "14050": true,
      "14060": true,
      "14070": true,
      "14080": true,
      "14090": true,
      "14100": true,
      "14108": true,
      "14110": true,
      "14120": true,
      "14140": true,
      "14150": true,
      "14160": true,
      "14200": true,
      "14208": true,
      "14209": true,
      "14210": true,
      "14219": true,
      "14220": true,
      "14230": true,
      "14239": true,
      "14240": true,
      "14248": true,
      "14250": true,
      "14260": true,
      "14266": true,
      "14267": true,
      "14268": true,
      "14269": true,
      "14270": true,
      "14275": true,
      "14300": true,
      "14308": true,
      "14310": true,
      "14320": true,
      "14325": true,
      "14326": true,
      "14330": true,
      "14340": true,
      "14350": true,
      "14357": true,
      "14360": true,
      "14370": true,
      "14376": true,
      "14377": true,
      "14380": true,
      "14386": true,
      "14387": true,
      "14388": true,
      "14389": true,
      "14390": true,
      "14400": true,
      "14406": true,
      "14408": true,
      "14409": true,
      "14410": true,
      "14420": true,
      "14426": true,
      "14427": true,
      "14429": true,
      "14430": true,
      "14438": true,
      "14439": true,
      "14440": true,
      "14449": true,
      "14456": true,
      "14460": true,
      "14470": true,
      "14476": true,
      "14479": true,
      "14480": true,
      "14490": true,
      "14500": true,
      "14600": true,
      "14608": true,
      "14609": true,
      "14610": true,
      "14620": true,
      "14629": true,
      "14630": true,
      "14640": true,
      "14643": true,
      "14646": true,
      "14647": true,
      "14650": true,
      "14653": true,
      "14654": true,
      "14655": true,
      "14657": true,
      "14658": true,
      "14659": true,
      "14700": true,
      "14710": true,
      "14720": true,
      "14730": true,
      "14734": true,
      "14735": true,
      "14737": true,
      "14738": true,
      "14739": true,
      "14740": true,
      "14748": true,
      "14749": true,
      "14760": true,
      "14900": true
    },
    "TLÁHUAC": {
      "13000": true,
      "13010": true,
      "13020": true,
      "13030": true,
      "13040": true,
      "13050": true,
      "13060": true,
      "13070": true,
      "13080": true,
      "13090": true,
      "13093": true,
      "13094": true,
      "13099": true,
      "13100": true,
      "13120": true,
      "13150": true,
      "13180": true,
      "13200": true,
      "13210": true,
      "13219": true,
      "13220": true,
      "13230": true,
      "13250": true,
      "13270": true,
      "13273": true,
      "13278": true,
      "13280": true,
      "13300": true,
      "13310": true,
      "13315": true,
      "13319": true,
      "13360": true,
      "13400": true,
      "13410": true,
      "13419": true,
      "13420": true,
      "13430": true,
      "13440": true,
      "13450": true,
      "13460": true,
      "13508": true,
      "13509": true,
      "13510": true,
      "13520": true,
      "13530": true,
      "13540": true,
      "13545": true,
      "13549": true,
      "13550": true,
      "13600": true,
      "13610": true,
      "13625": true,
      "13630": true,
      "13640": true,
      "13700": true
    },
    "VENUSTIANO CARRANZA": {
      "15000": true,
      "15010": true,
      "15020": true,
      "15100": true,
      "15200": true,
      "15210": true,
      "15220": true,
      "15230": true,
      "15240": true,
      "15250": true,
      "15260": true,
      "15270": true,
      "15280": true,
      "15290": true,
      "15300": true,
      "15309": true,
      "15310": true,
      "15320": true,
      "15330": true,
      "15339": true,
      "15340": true,
      "15350": true,
      "15370": true,
      "15380": true,
      "15390": true,
      "15400": true,
      "15410": true,
      "15420": true,
      "15430": true,
      "15440": true,
      "15450": true,
      "15460": true,
      "15470": true,
      "15500": true,
      "15510": true,
      "15520": true,
      "15530": true,
      "15540": true,
      "15600": true,
      "15610": true,
      "15620": true,
      "15630": true,
      "15640": true,
      "15650": true,
      "15660": true,
      "15670": true,
      "15680": true,
      "15700": true,
      "15710": true,
      "15730": true,
      "15740": true,
      "15750": true,
      "15800": true,
      "15810": true,
      "15820": true,
      "15830": true,
      "15840": true,
      "15850": true,
      "15860": true,
      "15870": true,
      "15900": true,
      "15960": true,
      "15970": true,
      "15980": true,
      "15990": true
    },
    "XOCHIMILCO": {
      "16000": true,
      "16010": true,
      "16020": true,
      "16029": true,
      "16030": true,
      "16034": true,
      "16035": true,
      "16036": true,
      "16038": true,
      "16040": true,
      "16050": true,
      "16059": true,
      "16060": true,
      "16070": true,
      "16080": true,
      "16083": true,
      "16090": true,
      "16100": true,
      "16200": true,
      "16210": true,
      "16240": true,
      "16300": true,
      "16310": true,
      "16320": true,
      "16340": true,
      "16400": true,
      "16410": true,
      "16420": true,
      "16428": true,
      "16429": true,
      "16430": true,
      "16440": true,
      "16443": true,
      "16450": true,
      "16457": true,
      "16459": true,
      "16500": true,
      "16513": true,
      "16514": true,
      "16520": true,
      "16530": true,
      "16533": true,
      "16550": true,
      "16600": true,
      "16604": true,
      "16605": true,
      "16606": true,
      "16607": true,
      "16609": true,
      "16610": true,
      "16614": true,
      "16615": true,
      "16616": true,
      "16617": true,
      "16620": true,
      "16629": true,
      "16630": true,
      "16640": true,
      "16710": true,
      "16720": true,
      "16739": true,
      "16740": true,
      "16749": true,
      "16750": true,
      "16770": true,
      "16776": true,
      "16780": true,
      "16797": true,
      "16799": true,
      "16800": true,
      "16810": true,
      "16813": true,
      "16840": true,
      "16850": true,
      "16860": true,
      "16880": true,
      "16900": true
    },
    "ÁLVARO OBREGÓN": {
      "01000": true,
      "01010": true,
      "01020": true,
      "01030": true,
      "01040": true,
      "01049": true,
      "01050": true,
      "01060": true,
      "01070": true,
      "01080": true,
      "01089": true,
      "01090": true,
      "01100": true,
      "01109": true,
      "01110": true,
      "01120": true,
      "01125": true,
      "01130": true,
      "01139": true,
      "01140": true,
      "01150": true,
      "01160": true,
      "01170": true,
      "01180": true,
      "01200": true,
      "01210": true,
      "01219": true,
      "01220": true,
      "01230": true,
      "01239": true,
      "01240": true,
      "01250": true,
      "01259": true,
      "01260": true,
      "01269": true,
      "01270": true,
      "01275": true,
      "01276": true,
      "01278": true,
      "01279": true,
      "01280": true,
      "01285": true,
      "01289": true,
      "01290": true,
      "01296": true,
      "01298": true,
      "01299": true,
      "01310": true,
      "01320": true,
      "01330": true,
      "01340": true,
      "01376": true,
      "01377": true,
      "01389": true,
      "01400": true,
      "01407": true,
      "01408": true,
      "01410": true,
      "01419": true,
      "01420": true,
      "01430": true,
      "01450": true,
      "01460": true,
      "01470": true,
      "01480": true,
      "01490": true,
      "01500": true,
      "01509": true,
      "01510": true,
      "01520": true,
      "01530": true,
      "01538": true,
      "01539": true,
      "01540": true,
      "01548": true,
      "01549": true,
      "01550": true,
      "01560": true,
      "01566": true,
      "01569": true,
      "01588": true,
      "01590": true,
      "01600": true,
      "01610": true,
      "01618": true,
      "01619": true,
      "01620": true,
      "01630": true,
      "01640": true,
      "01645": true,
      "01650": true,
      "01700": true,
      "01708": true,
      "01710": true,
      "01720": true,
      "01729": true,
      "01730": true,
      "01740": true,
      "01750": true,
      "01759": true,
      "01760": true,
      "01770": true,
      "01780": true,
      "01789": true,
      "01790": true,
      "01800": true,
      "01807": true,
      "01810": true,
      "01820": true,
      "01830": true,
      "01840": true,
      "01849": true,
      "01857": true,
      "01859": true,
      "01860": true,
      "01863": true,
      "01870": true,
      "01900": true,
      "01904": true
    }
  },
  "AGUASCALIENTES": {
    "AGUASCALIENTES": {
      "20000": true,
      "20010": true,
      "20016": true,
      "20018": true,
      "20020": true,
      "20029": true,
      "20030": true,
      "20040": true,
      "20049": true,
      "20050": true,
      "20059": true,
      "20060": true,
      "20064": true,
      "20070": true,
      "20078": true,
      "20080": true,
      "20089": true,
      "20100": true,
      "20110": true,
      "20115": true,
      "20116": true,
      "20118": true,
      "20119": true,
      "20120": true,
      "20123": true,
      "20124": true,
      "20126": true,
      "20127": true,
      "20128": true,
      "20129": true,
      "20130": true,
      "20135": true,
      "20136": true,
      "20137": true,
      "20138": true,
      "20140": true,
      "20146": true,
      "20149": true,
      "20150": true,
      "20157": true,
      "20158": true,
      "20159": true,
      "20160": true,
      "20164": true,
      "20169": true,
      "20170": true,
      "20172": true,
      "20174": true,
      "20175": true,
      "20177": true,
      "20179": true,
      "20180": true,
      "20190": true,
      "20196": true,
      "20198": true,
      "20199": true,
      "20200": true,
      "20205": true,
      "20206": true,
      "20207": true,
      "20208": true,
      "20210": true,
      "20217": true,
      "20218": true,
      "20219": true,
      "20220": true,
      "20229": true,
      "20230": true,
      "20234": true,
      "20235": true,
      "20236": true,
      "20237": true,
      "20238": true,
      "20239": true,
      "20240": true,
      "20247": true,
      "20248": true,
      "20249": true,
      "20250": true,
      "20255": true,
      "20256": true,
      "20257": true,
      "20259": true,
      "20260": true,
      "20263": true,
      "20264": true,
      "20265": true,
      "20266": true,
      "20267": true,
      "20268": true,
      "20269": true,
      "20270": true,
      "20276": true,
      "20277": true,
      "20278": true,
      "20280": true,
      "20283": true,
      "20284": true,
      "20285": true,
      "20286": true,
      "20287": true,
      "20288": true,
      "20289": true,
      "20290": true,
      "20296": true,
      "20297": true,
      "20298": true,
      "20299": true,
      "20310": true,
      "20313": true,
      "20314": true,
      "20316": true,
      "20320": true,
      "20323": true,
      "20324": true,
      "20326": true,
      "20328": true,
      "20329": true,
      "20340": true,
      "20341": true,
      "20342": true,
      "20343": true,
      "20344": true,
      "20345": true,
      "20346": true,
      "20347": true,
      "20348": true,
      "20349": true,
      "20363": true,
      "20364": true,
      "20366": true,
      "20367": true,
      "20369": true,
      "20370": true,
      "20371": true,
      "20372": true,
      "20373": true,
      "20374": true,
      "20375": true,
      "20376": true,
      "20377": true,
      "20378": true,
      "20384": true,
      "20386": true,
      "20388": true,
      "20389": true,
      "20392": true,
      "20393": true,
      "20394": true,
      "20395": true,
      "20396": true
    },
    "ASIENTOS": {
      "20700": true,
      "20704": true,
      "20705": true,
      "20706": true,
      "20708": true,
      "20709": true,
      "20710": true,
      "20712": true,
      "20713": true,
      "20714": true,
      "20715": true,
      "20720": true,
      "20721": true,
      "20722": true,
      "20723": true,
      "20724": true,
      "20727": true,
      "20729": true,
      "20730": true,
      "20734": true,
      "20736": true,
      "20737": true,
      "20739": true,
      "20740": true,
      "20741": true,
      "20742": true,
      "20744": true,
      "20746": true,
      "20748": true,
      "20749": true,
      "20750": true,
      "20768": true,
      "20770": true,
      "20773": true,
      "20780": true,
      "20782": true,
      "20785": true,
      "20790": true,
      "20795": true,
      "20796": true,
      "20799": true
    },
    "CALVILLO": {
      "20800": true,
      "20802": true,
      "20803": true,
      "20804": true,
      "20805": true,
      "20816": true,
      "20820": true,
      "20823": true,
      "20830": true,
      "20832": true,
      "20834": true,
      "20835": true,
      "20836": true,
      "20840": true,
      "20842": true,
      "20844": true,
      "20850": true,
      "20852": true,
      "20854": true,
      "20856": true,
      "20860": true,
      "20862": true,
      "20864": true,
      "20870": true,
      "20872": true,
      "20880": true,
      "20882": true
    },
    "COSIO": {
      "20460": true,
      "20462": true,
      "20466": true,
      "20467": true,
      "20468": true,
      "20469": true,
      "20470": true,
      "20472": true,
      "20476": true,
      "20478": true
    },
    "EL LLANO": {
      "20330": true,
      "20333": true,
      "20334": true,
      "20335": true,
      "20336": true,
      "20338": true,
      "20339": true
    },
    "JESÚS MARÍA": {
      "20900": true,
      "20901": true,
      "20903": true,
      "20904": true,
      "20905": true,
      "20907": true,
      "20908": true,
      "20909": true,
      "20910": true,
      "20913": true,
      "20914": true,
      "20915": true,
      "20916": true,
      "20917": true,
      "20920": true,
      "20922": true,
      "20923": true,
      "20924": true,
      "20925": true,
      "20926": true,
      "20927": true,
      "20928": true,
      "20933": true,
      "20934": true,
      "20947": true,
      "20953": true,
      "20954": true,
      "20955": true,
      "20956": true,
      "20957": true,
      "20970": true,
      "20974": true,
      "20983": true,
      "20984": true,
      "20990": true,
      "20994": true,
      "20995": true,
      "20996": true,
      "20997": true
    },
    "PABELLON DE ARTEAGA": {
      "20663": true,
      "20665": true,
      "20666": true,
      "20667": true,
      "20668": true,
      "20670": true,
      "20673": true,
      "20674": true,
      "20675": true,
      "20676": true,
      "20677": true,
      "20678": true,
      "20680": true,
      "20683": true,
      "20684": true,
      "20686": true,
      "20687": true
    },
    "RINCON DE ROMOS": {
      "20400": true,
      "20403": true,
      "20404": true,
      "20405": true,
      "20406": true,
      "20410": true,
      "20414": true,
      "20415": true,
      "20416": true,
      "20417": true,
      "20420": true,
      "20423": true,
      "20424": true,
      "20425": true,
      "20426": true,
      "20427": true,
      "20430": true,
      "20434": true,
      "20435": true,
      "20436": true,
      "20437": true,
      "20440": true,
      "20444": true,
      "20450": true
    },
    "SAN FRANCISCO DE LOS ROMO": {
      "20300": true,
      "20303": true,
      "20304": true,
      "20305": true,
      "20306": true,
      "20350": true,
      "20355": true,
      "20356": true,
      "20357": true,
      "20358": true
    },
    "SAN JOSE DE GRACIA": {
      "20500": true,
      "20503": true,
      "20504": true,
      "20508": true,
      "20510": true,
      "20516": true,
      "20540": true,
      "20545": true,
      "20563": true,
      "20564": true,
      "20567": true,
      "20576": true
    },
    "TEPEZALA": {
      "20600": true,
      "20602": true,
      "20603": true,
      "20607": true,
      "20610": true,
      "20614": true,
      "20615": true,
      "20616": true,
      "20620": true,
      "20622": true,
      "20634": true,
      "20635": true,
      "20637": true,
      "20650": true,
      "20656": true,
      "20657": true,
      "20658": true,
      "20659": true
    }
  },
  "BAJA CALIFORNIA": {
    "ENSENADA": {
      "22750": true,
      "22753": true,
      "22755": true,
      "22760": true,
      "22765": true,
      "22766": true,
      "22767": true,
      "22770": true,
      "22771": true,
      "22785": true,
      "22790": true,
      "22793": true,
      "22794": true,
      "22795": true,
      "22796": true,
      "22798": true,
      "22800": true,
      "22810": true,
      "22812": true,
      "22813": true,
      "22814": true,
      "22818": true,
      "22819": true,
      "22820": true,
      "22822": true,
      "22823": true,
      "22830": true,
      "22835": true,
      "22839": true,
      "22840": true,
      "22842": true,
      "22847": true,
      "22850": true,
      "22852": true,
      "22855": true,
      "22859": true,
      "22860": true,
      "22863": true,
      "22870": true,
      "22873": true,
      "22879": true,
      "22880": true,
      "22888": true,
      "22889": true,
      "22890": true,
      "22895": true,
      "22896": true,
      "22897": true,
      "22898": true,
      "22900": true,
      "22905": true,
      "22906": true,
      "22909": true
    },
    "MEXICALI": {
      "21000": true,
      "21010": true,
      "21020": true,
      "21030": true,
      "21038": true,
      "21039": true,
      "21040": true,
      "21050": true,
      "21060": true,
      "21070": true,
      "21079": true,
      "21080": true,
      "21090": true,
      "21100": true,
      "21110": true,
      "21120": true,
      "21130": true,
      "21135": true,
      "21137": true,
      "21138": true,
      "21139": true,
      "21140": true,
      "21147": true,
      "21150": true,
      "21160": true,
      "21165": true,
      "21170": true,
      "21178": true,
      "21179": true,
      "21180": true,
      "21185": true,
      "21188": true,
      "21190": true,
      "21200": true,
      "21210": true,
      "21215": true,
      "21216": true,
      "21217": true,
      "21218": true,
      "21219": true,
      "21220": true,
      "21224": true,
      "21225": true,
      "21226": true,
      "21229": true,
      "21230": true,
      "21239": true,
      "21240": true,
      "21250": true,
      "21254": true,
      "21255": true,
      "21257": true,
      "21258": true,
      "21259": true,
      "21260": true,
      "21270": true,
      "21279": true,
      "21280": true,
      "21285": true,
      "21289": true,
      "21290": true,
      "21297": true,
      "21298": true,
      "21299": true,
      "21300": true,
      "21307": true,
      "21309": true,
      "21310": true,
      "21320": true,
      "21323": true,
      "21324": true,
      "21326": true,
      "21327": true,
      "21330": true,
      "21337": true,
      "21339": true,
      "21340": true,
      "21350": true,
      "21353": true,
      "21354": true,
      "21355": true,
      "21356": true,
      "21360": true,
      "21370": true,
      "21376": true,
      "21378": true,
      "21379": true,
      "21380": true,
      "21383": true,
      "21384": true,
      "21385": true,
      "21386": true,
      "21387": true,
      "21389": true,
      "21390": true,
      "21394": true,
      "21395": true,
      "21396": true,
      "21397": true,
      "21398": true,
      "21399": true,
      "21600": true,
      "21606": true,
      "21607": true,
      "21609": true,
      "21610": true,
      "21611": true,
      "21613": true,
      "21614": true,
      "21615": true,
      "21620": true,
      "21627": true,
      "21628": true,
      "21700": true,
      "21703": true,
      "21704": true,
      "21705": true,
      "21706": true,
      "21710": true,
      "21713": true,
      "21720": true,
      "21722": true,
      "21723": true,
      "21725": true,
      "21730": true,
      "21731": true,
      "21735": true,
      "21738": true,
      "21740": true,
      "21742": true,
      "21743": true,
      "21800": true,
      "21801": true,
      "21802": true,
      "21810": true,
      "21813": true,
      "21820": true,
      "21821": true,
      "21830": true,
      "21831": true,
      "21832": true,
      "21833": true,
      "21840": true,
      "21841": true,
      "21843": true,
      "21850": true,
      "21853": true,
      "21854": true,
      "21855": true,
      "21900": true,
      "21902": true,
      "21904": true,
      "21905": true,
      "21910": true,
      "21911": true,
      "21912": true,
      "21913": true,
      "21920": true,
      "21921": true,
      "21925": true,
      "21930": true,
      "21950": true,
      "21951": true,
      "21960": true,
      "21961": true,
      "21963": true,
      "21964": true,
      "21965": true,
      "21966": true,
      "21970": true,
      "21980": true
    },
    "PLAYAS DE ROSARITO": {
      "22700": true,
      "22703": true,
      "22704": true,
      "22705": true,
      "22706": true,
      "22707": true,
      "22710": true,
      "22713": true,
      "22715": true,
      "22716": true,
      "22717": true,
      "22740": true,
      "22744": true,
      "22745": true,
      "22746": true
    },
    "SAN QUINTIN": {
      "22910": true,
      "22914": true,
      "22915": true,
      "22920": true,
      "22925": true,
      "22930": true,
      "22940": true,
      "22943": true,
      "22950": true,
      "22960": true,
      "22964": true,
      "22965": true,
      "22967": true,
      "22973": true,
      "22974": true,
      "22997": true
    },
    "TECATE": {
      "21400": true,
      "21410": true,
      "21420": true,
      "21430": true,
      "21432": true,
      "21433": true,
      "21440": true,
      "21442": true,
      "21447": true,
      "21448": true,
      "21449": true,
      "21450": true,
      "21452": true,
      "21453": true,
      "21460": true,
      "21462": true,
      "21470": true,
      "21472": true,
      "21477": true,
      "21478": true,
      "21480": true,
      "21482": true,
      "21483": true,
      "21484": true,
      "21485": true,
      "21490": true,
      "21496": true,
      "21500": true,
      "21503": true,
      "21505": true,
      "21506": true,
      "21507": true,
      "21520": true,
      "21530": true,
      "21536": true
    },
    "TIJUANA": {
      "22000": true,
      "22010": true,
      "22014": true,
      "22015": true,
      "22020": true,
      "22024": true,
      "22025": true,
      "22030": true,
      "22034": true,
      "22035": true,
      "22040": true,
      "22044": true,
      "22045": true,
      "22046": true,
      "22050": true,
      "22054": true,
      "22055": true,
      "22056": true,
      "22100": true,
      "22104": true,
      "22105": true,
      "22106": true,
      "22110": true,
      "22114": true,
      "22115": true,
      "22116": true,
      "22117": true,
      "22120": true,
      "22123": true,
      "22124": true,
      "22125": true,
      "22126": true,
      "22127": true,
      "22160": true,
      "22163": true,
      "22164": true,
      "22165": true,
      "22170": true,
      "22180": true,
      "22183": true,
      "22185": true,
      "22186": true,
      "22190": true,
      "22194": true,
      "22195": true,
      "22196": true,
      "22200": true,
      "22203": true,
      "22204": true,
      "22205": true,
      "22206": true,
      "22207": true,
      "22210": true,
      "22214": true,
      "22215": true,
      "22216": true,
      "22217": true,
      "22220": true,
      "22223": true,
      "22224": true,
      "22225": true,
      "22226": true,
      "22230": true,
      "22234": true,
      "22235": true,
      "22236": true,
      "22237": true,
      "22244": true,
      "22245": true,
      "22246": true,
      "22250": true,
      "22253": true,
      "22254": true,
      "22255": true,
      "22260": true,
      "22263": true,
      "22330": true,
      "22333": true,
      "22334": true,
      "22335": true,
      "22400": true,
      "22404": true,
      "22405": true,
      "22406": true,
      "22410": true,
      "22414": true,
      "22415": true,
      "22416": true,
      "22420": true,
      "22424": true,
      "22425": true,
      "22426": true,
      "22427": true,
      "22430": true,
      "22434": true,
      "22435": true,
      "22436": true,
      "22439": true,
      "22440": true,
      "22444": true,
      "22446": true,
      "22450": true,
      "22454": true,
      "22455": true,
      "22456": true,
      "22457": true,
      "22460": true,
      "22464": true,
      "22465": true,
      "22470": true,
      "22473": true,
      "22474": true,
      "22476": true,
      "22500": true,
      "22504": true,
      "22505": true,
      "22506": true,
      "22510": true,
      "22515": true,
      "22516": true,
      "22517": true,
      "22520": true,
      "22523": true,
      "22524": true,
      "22525": true,
      "22526": true,
      "22530": true,
      "22534": true,
      "22535": true,
      "22536": true,
      "22537": true,
      "22540": true,
      "22544": true,
      "22545": true,
      "22550": true,
      "22555": true,
      "22557": true,
      "22560": true,
      "22564": true,
      "22565": true,
      "22566": true,
      "22567": true,
      "22600": true,
      "22604": true,
      "22605": true,
      "22606": true,
      "22607": true,
      "22610": true,
      "22614": true,
      "22615": true,
      "22616": true,
      "22620": true,
      "22624": true,
      "22625": true,
      "22626": true,
      "22630": true,
      "22634": true,
      "22635": true,
      "22636": true,
      "22637": true,
      "22640": true,
      "22643": true,
      "22644": true,
      "22645": true,
      "22646": true,
      "22647": true,
      "22650": true,
      "22654": true,
      "22660": true,
      "22663": true,
      "22664": true,
      "22665": true,
      "22666": true,
      "22667": true
    }
  },
  "BAJA CALIFORNIA SUR": {
    "COMONDU": {
      "23600": true,
      "23610": true,
      "23620": true,
      "23630": true,
      "23640": true,
      "23641": true,
      "23643": true,
      "23650": true,
      "23653": true,
      "23658": true,
      "23660": true,
      "23670": true,
      "23676": true,
      "23677": true,
      "23678": true,
      "23680": true,
      "23683": true,
      "23690": true,
      "23695": true,
      "23696": true,
      "23697": true,
      "23700": true,
      "23710": true,
      "23721": true,
      "23736": true,
      "23737": true,
      "23740": true,
      "23748": true,
      "23749": true,
      "23750": true,
      "23760": true,
      "23770": true,
      "23771": true,
      "23774": true,
      "23775": true,
      "23805": true,
      "23810": true,
      "23813": true,
      "23824": true,
      "23837": true,
      "23845": true,
      "23873": true
    },
    "LA PAZ": {
      "23000": true,
      "23007": true,
      "23009": true,
      "23010": true,
      "23017": true,
      "23018": true,
      "23019": true,
      "23020": true,
      "23026": true,
      "23029": true,
      "23030": true,
      "23034": true,
      "23037": true,
      "23038": true,
      "23039": true,
      "23040": true,
      "23050": true,
      "23052": true,
      "23054": true,
      "23055": true,
      "23056": true,
      "23060": true,
      "23070": true,
      "23075": true,
      "23076": true,
      "23077": true,
      "23078": true,
      "23079": true,
      "23080": true,
      "23083": true,
      "23084": true,
      "23085": true,
      "23086": true,
      "23088": true,
      "23089": true,
      "23090": true,
      "23094": true,
      "23095": true,
      "23096": true,
      "23097": true,
      "23098": true,
      "23099": true,
      "23100": true,
      "23106": true,
      "23130": true,
      "23133": true,
      "23134": true,
      "23140": true,
      "23143": true,
      "23150": true,
      "23154": true,
      "23170": true,
      "23174": true,
      "23200": true,
      "23203": true,
      "23205": true,
      "23206": true,
      "23208": true,
      "23209": true,
      "23210": true,
      "23213": true,
      "23215": true,
      "23216": true,
      "23217": true,
      "23230": true,
      "23232": true,
      "23234": true,
      "23236": true,
      "23240": true,
      "23243": true,
      "23244": true,
      "23247": true,
      "23248": true,
      "23249": true,
      "23250": true,
      "23252": true,
      "23257": true,
      "23258": true,
      "23280": true,
      "23283": true,
      "23289": true,
      "23300": true,
      "23302": true,
      "23303": true,
      "23304": true,
      "23311": true,
      "23312": true,
      "23317": true,
      "23320": true,
      "23322": true,
      "23328": true,
      "23329": true,
      "23330": true,
      "23333": true,
      "23334": true,
      "23350": true,
      "23354": true,
      "23360": true,
      "23361": true,
      "23362": true,
      "23363": true,
      "23364": true,
      "23365": true,
      "23366": true,
      "23390": true,
      "23395": true
    },
    "LORETO": {
      "23880": true,
      "23883": true,
      "23884": true,
      "23885": true,
      "23886": true,
      "23889": true,
      "23894": true,
      "23895": true,
      "23897": true,
      "23898": true
    },
    "LOS CABOS": {
      "23400": true,
      "23403": true,
      "23405": true,
      "23406": true,
      "23407": true,
      "23420": true,
      "23425": true,
      "23426": true,
      "23427": true,
      "23428": true,
      "23429": true,
      "23434": true,
      "23435": true,
      "23436": true,
      "23437": true,
      "23440": true,
      "23443": true,
      "23444": true,
      "23445": true,
      "23450": true,
      "23453": true,
      "23454": true,
      "23455": true,
      "23456": true,
      "23457": true,
      "23460": true,
      "23462": true,
      "23463": true,
      "23467": true,
      "23468": true,
      "23469": true,
      "23470": true,
      "23472": true,
      "23473": true,
      "23474": true,
      "23475": true,
      "23476": true,
      "23477": true,
      "23478": true,
      "23500": true,
      "23501": true,
      "23503": true,
      "23510": true,
      "23520": true,
      "23522": true,
      "23523": true,
      "23530": true,
      "23533": true,
      "23535": true,
      "23563": true,
      "23567": true,
      "23570": true,
      "23580": true,
      "23581": true,
      "23586": true,
      "23590": true,
      "23593": true,
      "23597": true
    },
    "MULEGE": {
      "23900": true,
      "23902": true,
      "23903": true,
      "23910": true,
      "23911": true,
      "23916": true,
      "23917": true,
      "23920": true,
      "23935": true,
      "23936": true,
      "23938": true,
      "23940": true,
      "23948": true,
      "23949": true,
      "23950": true,
      "23951": true,
      "23959": true,
      "23960": true,
      "23970": true,
      "23972": true,
      "23973": true,
      "23990": true,
      "23997": true
    }
  },
  "CAMPECHE": {
    "CALKINI": {
      "24900": true,
      "24902": true,
      "24903": true,
      "24904": true,
      "24905": true,
      "24910": true,
      "24913": true,
      "24914": true,
      "24915": true,
      "24920": true,
      "24925": true,
      "24929": true,
      "24930": true,
      "24933": true,
      "24934": true,
      "24935": true,
      "24936": true,
      "24940": true
    },
    "CAMPECHE": {
      "24000": true,
      "24010": true,
      "24014": true,
      "24020": true,
      "24022": true,
      "24023": true,
      "24024": true,
      "24025": true,
      "24026": true,
      "24027": true,
      "24028": true,
      "24029": true,
      "24030": true,
      "24035": true,
      "24036": true,
      "24037": true,
      "24038": true,
      "24039": true,
      "24040": true,
      "24044": true,
      "24049": true,
      "24050": true,
      "24058": true,
      "24060": true,
      "24063": true,
      "24069": true,
      "24070": true,
      "24073": true,
      "24075": true,
      "24079": true,
      "24080": true,
      "24083": true,
      "24084": true,
      "24085": true,
      "24086": true,
      "24087": true,
      "24088": true,
      "24089": true,
      "24090": true,
      "24093": true,
      "24094": true,
      "24095": true,
      "24096": true,
      "24097": true,
      "24098": true,
      "24099": true,
      "24500": true,
      "24505": true,
      "24517": true,
      "24520": true,
      "24522": true,
      "24523": true,
      "24532": true,
      "24536": true,
      "24537": true,
      "24540": true,
      "24550": true,
      "24552": true,
      "24553": true,
      "24557": true,
      "24560": true,
      "24561": true,
      "24562": true,
      "24564": true,
      "24570": true,
      "24572": true,
      "24573": true,
      "24574": true,
      "24575": true
    },
    "CARMEN": {
      "24100": true,
      "24108": true,
      "24110": true,
      "24114": true,
      "24115": true,
      "24116": true,
      "24117": true,
      "24118": true,
      "24119": true,
      "24120": true,
      "24129": true,
      "24130": true,
      "24139": true,
      "24140": true,
      "24150": true,
      "24153": true,
      "24154": true,
      "24155": true,
      "24156": true,
      "24157": true,
      "24158": true,
      "24160": true,
      "24166": true,
      "24167": true,
      "24169": true,
      "24170": true,
      "24178": true,
      "24179": true,
      "24180": true,
      "24185": true,
      "24186": true,
      "24187": true,
      "24188": true,
      "24189": true,
      "24190": true,
      "24195": true,
      "24197": true,
      "24198": true,
      "24199": true,
      "24315": true,
      "24316": true,
      "24320": true,
      "24322": true,
      "24325": true,
      "24327": true
    },
    "CHAMPOTON": {
      "24400": true,
      "24402": true,
      "24404": true,
      "24416": true,
      "24418": true,
      "24420": true,
      "24440": true,
      "24443": true,
      "24450": true,
      "24451": true,
      "24459": true
    },
    "ESCARCEGA": {
      "24350": true,
      "24353": true,
      "24354": true,
      "24356": true,
      "24368": true,
      "24369": true,
      "24370": true,
      "24372": true,
      "24375": true,
      "24376": true,
      "24377": true
    },
    "HECELCHAKAN": {
      "24800": true,
      "24810": true,
      "24813": true,
      "24820": true,
      "24826": true,
      "24830": true,
      "24831": true,
      "24836": true,
      "24837": true,
      "24839": true,
      "24863": true
    },
    "HOPELCHEN": {
      "24600": true,
      "24604": true,
      "24605": true,
      "24606": true,
      "24609": true,
      "24612": true,
      "24615": true,
      "24663": true,
      "24667": true,
      "24670": true
    },
    "SEYBAPLAYA": {
      "24460": true,
      "24462": true,
      "24464": true
    },
    "TENABO": {
      "24700": true,
      "24703": true,
      "24704": true,
      "24705": true,
      "24706": true,
      "24707": true,
      "24720": true,
      "24723": true,
      "24730": true,
      "24732": true,
      "24733": true,
      "24734": true,
      "24740": true,
      "24746": true
    }
  },
  "CHIAPAS": {
    "TAPACHULA": {
      "30700": true,
      "30705": true,
      "30710": true,
      "30716": true,
      "30718": true,
      "30719": true,
      "30720": true,
      "30723": true,
      "30724": true,
      "30725": true,
      "30726": true,
      "30729": true,
      "30730": true,
      "30734": true,
      "30735": true,
      "30737": true,
      "30738": true,
      "30739": true,
      "30740": true,
      "30745": true,
      "30747": true,
      "30748": true,
      "30749": true,
      "30750": true,
      "30755": true,
      "30757": true,
      "30760": true,
      "30763": true,
      "30766": true,
      "30767": true,
      "30768": true,
      "30769": true,
      "30770": true,
      "30778": true,
      "30779": true,
      "30780": true,
      "30783": true,
      "30784": true,
      "30785": true,
      "30786": true,
      "30787": true,
      "30788": true,
      "30789": true,
      "30790": true,
      "30792": true,
      "30793": true,
      "30794": true,
      "30795": true,
      "30796": true,
      "30797": true,
      "30798": true,
      "30799": true
    },
    "TUXTLA GUTIÉRREZ": {
      "29000": true,
      "29010": true,
      "29014": true,
      "29016": true,
      "29017": true,
      "29018": true,
      "29019": true,
      "29020": true,
      "29023": true,
      "29024": true,
      "29025": true,
      "29026": true,
      "29027": true,
      "29028": true,
      "29030": true,
      "29034": true,
      "29037": true,
      "29038": true,
      "29039": true,
      "29040": true,
      "29044": true,
      "29045": true,
      "29047": true,
      "29049": true,
      "29050": true,
      "29054": true,
      "29055": true,
      "29056": true,
      "29057": true,
      "29058": true,
      "29059": true,
      "29060": true,
      "29064": true,
      "29065": true,
      "29066": true,
      "29067": true,
      "29070": true,
      "29073": true,
      "29075": true,
      "29076": true,
      "29077": true,
      "29078": true,
      "29080": true,
      "29086": true,
      "29087": true,
      "29089": true,
      "29090": true,
      "29094": true,
      "29096": true,
      "29098": true,
      "29100": true
    }
  },
  "CHIHUAHUA": {
    "AHUMADA": {
      "32800": true,
      "32812": true,
      "32814": true,
      "32815": true,
      "32820": true,
      "32832": true,
      "32833": true
    },
    "ALDAMA": {
      "32900": true,
      "32902": true,
      "32903": true,
      "32910": true,
      "32912": true,
      "32913": true,
      "32914": true,
      "32917": true,
      "32918": true,
      "32930": true
    },
    "AQUILES SERDAN": {
      "31650": true,
      "31653": true,
      "31657": true
    },
    "ASCENSION": {
      "31820": true,
      "31821": true,
      "31822": true,
      "31823": true,
      "31825": true,
      "31830": true,
      "31832": true,
      "31837": true
    },
    "BUENAVENTURA": {
      "31880": true,
      "31884": true,
      "31886": true,
      "31890": true,
      "31891": true,
      "31894": true,
      "31896": true,
      "31897": true,
      "31898": true,
      "31899": true
    },
    "CAMARGO": {
      "33600": true,
      "33601": true,
      "33610": true,
      "33700": true,
      "33710": true,
      "33720": true,
      "33730": true,
      "33737": true,
      "33739": true,
      "33740": true,
      "33748": true,
      "33749": true,
      "33750": true,
      "33759": true,
      "33760": true,
      "33765": true,
      "33768": true,
      "33769": true,
      "33770": true,
      "33777": true,
      "33778": true,
      "33779": true
    },
    "CHIHUAHUA": {
      "31000": true,
      "31020": true,
      "31029": true,
      "31030": true,
      "31034": true,
      "31050": true,
      "31054": true,
      "31060": true,
      "31063": true,
      "31064": true,
      "31065": true,
      "31066": true,
      "31067": true,
      "31074": true,
      "31075": true,
      "31076": true,
      "31100": true,
      "31104": true,
      "31105": true,
      "31106": true,
      "31107": true,
      "31110": true,
      "31114": true,
      "31115": true,
      "31116": true,
      "31120": true,
      "31122": true,
      "31123": true,
      "31124": true,
      "31125": true,
      "31126": true,
      "31127": true,
      "31130": true,
      "31134": true,
      "31135": true,
      "31136": true,
      "31137": true,
      "31140": true,
      "31143": true,
      "31144": true,
      "31146": true,
      "31150": true,
      "31153": true,
      "31160": true,
      "31170": true,
      "31180": true,
      "31183": true,
      "31184": true,
      "31186": true,
      "31200": true,
      "31203": true,
      "31204": true,
      "31205": true,
      "31206": true,
      "31207": true,
      "31210": true,
      "31213": true,
      "31214": true,
      "31215": true,
      "31216": true,
      "31217": true,
      "31220": true,
      "31223": true,
      "31300": true,
      "31304": true,
      "31310": true,
      "31313": true,
      "31314": true,
      "31350": true,
      "31370": true,
      "31375": true,
      "31376": true,
      "31380": true,
      "31384": true,
      "31385": true,
      "31390": true,
      "31410": true,
      "31414": true,
      "31415": true,
      "31416": true,
      "31450": true,
      "31453": true,
      "31455": true,
      "31456": true,
      "31460": true,
      "31470": true,
      "31620": true,
      "31622": true,
      "31623": true,
      "31624": true,
      "31625": true,
      "31626": true,
      "31627": true,
      "31628": true,
      "31630": true,
      "31631": true,
      "31632": true,
      "31633": true
    },
    "CUAUHTÉMOC": {
      "31500": true,
      "31510": true,
      "31512": true,
      "31513": true,
      "31515": true,
      "31516": true,
      "31517": true,
      "31520": true,
      "31522": true,
      "31523": true,
      "31524": true,
      "31526": true,
      "31527": true,
      "31528": true,
      "31529": true,
      "31530": true,
      "31532": true,
      "31533": true,
      "31540": true,
      "31542": true,
      "31543": true,
      "31544": true,
      "31550": true,
      "31552": true,
      "31555": true,
      "31560": true,
      "31570": true,
      "31572": true,
      "31573": true,
      "31579": true,
      "31580": true,
      "31590": true,
      "31600": true,
      "31604": true,
      "31605": true,
      "31606": true,
      "31607": true,
      "31608": true,
      "31609": true,
      "31610": true,
      "31613": true,
      "31614": true,
      "31615": true
    },
    "DELICIAS": {
      "33000": true,
      "33010": true,
      "33013": true,
      "33014": true,
      "33016": true,
      "33017": true,
      "33018": true,
      "33019": true,
      "33020": true,
      "33023": true,
      "33029": true,
      "33030": true,
      "33038": true,
      "33039": true,
      "33040": true,
      "33050": true,
      "33058": true,
      "33059": true,
      "33060": true,
      "33063": true,
      "33065": true,
      "33066": true,
      "33067": true,
      "33068": true,
      "33069": true,
      "33070": true,
      "33076": true,
      "33077": true,
      "33078": true,
      "33080": true,
      "33084": true,
      "33085": true,
      "33086": true,
      "33087": true,
      "33088": true,
      "33089": true,
      "33090": true,
      "33093": true,
      "33100": true,
      "33103": true,
      "33104": true,
      "33105": true,
      "33106": true,
      "33107": true,
      "33108": true,
      "33113": true,
      "33114": true,
      "33115": true,
      "33116": true
    },
    "GUACHOCHI": {
      "33180": true,
      "33183": true,
      "33184": true,
      "33185": true,
      "33186": true,
      "33187": true,
      "33197": true
    },
    "GUADALUPE": {
      "32740": true,
      "32741": true,
      "32742": true,
      "32743": true,
      "32767": true,
      "32776": true
    },
    "GUERRERO": {
      "31680": true,
      "31681": true,
      "31684": true,
      "31685": true,
      "31686": true,
      "31687": true,
      "31688": true,
      "31689": true,
      "31690": true,
      "31691": true,
      "31693": true,
      "31696": true,
      "31698": true
    },
    "HIDALGO DEL PARRAL": {
      "33800": true,
      "33810": true,
      "33814": true,
      "33815": true,
      "33816": true,
      "33818": true,
      "33820": true,
      "33823": true,
      "33824": true,
      "33825": true,
      "33826": true,
      "33827": true,
      "33830": true,
      "33834": true,
      "33839": true,
      "33840": true,
      "33846": true,
      "33848": true,
      "33850": true,
      "33856": true,
      "33857": true,
      "33858": true,
      "33860": true,
      "33863": true,
      "33870": true,
      "33873": true,
      "33879": true,
      "33880": true,
      "33884": true,
      "33885": true,
      "33886": true,
      "33890": true,
      "33896": true,
      "33898": true,
      "33900": true,
      "33902": true,
      "33903": true,
      "33905": true,
      "33906": true,
      "33907": true,
      "33908": true,
      "33913": true,
      "33914": true,
      "33917": true,
      "33918": true
    },
    "JIMENEZ": {
      "33970": true,
      "33974": true,
      "33976": true,
      "33980": true,
      "33983": true,
      "33984": true,
      "33985": true,
      "33986": true,
      "33987": true
    },
    "JULIMES": {
      "32950": true,
      "32951": true,
      "32952": true,
      "32953": true,
      "32955": true,
      "32957": true,
      "32958": true
    },
    "JUÁREZ": {
      "32000": true,
      "32010": true,
      "32020": true,
      "32030": true,
      "32040": true,
      "32050": true,
      "32060": true,
      "32070": true,
      "32080": true,
      "32090": true,
      "32100": true,
      "32107": true,
      "32108": true,
      "32109": true,
      "32110": true,
      "32120": true,
      "32127": true,
      "32130": true,
      "32140": true,
      "32150": true,
      "32153": true,
      "32159": true,
      "32160": true,
      "32170": true,
      "32177": true,
      "32178": true,
      "32180": true,
      "32190": true,
      "32200": true,
      "32210": true,
      "32215": true,
      "32217": true,
      "32220": true,
      "32223": true,
      "32230": true,
      "32234": true,
      "32240": true,
      "32250": true,
      "32260": true,
      "32270": true,
      "32280": true,
      "32290": true,
      "32295": true,
      "32299": true,
      "32300": true,
      "32310": true,
      "32315": true,
      "32317": true,
      "32319": true,
      "32320": true,
      "32330": true,
      "32340": true,
      "32349": true,
      "32350": true,
      "32354": true,
      "32360": true,
      "32370": true,
      "32376": true,
      "32380": true,
      "32389": true,
      "32390": true,
      "32398": true,
      "32400": true,
      "32401": true,
      "32402": true,
      "32403": true,
      "32404": true,
      "32405": true,
      "32408": true,
      "32409": true,
      "32410": true,
      "32413": true,
      "32414": true,
      "32415": true,
      "32416": true,
      "32417": true,
      "32419": true,
      "32420": true,
      "32422": true,
      "32423": true,
      "32424": true,
      "32425": true,
      "32427": true,
      "32430": true,
      "32434": true,
      "32435": true,
      "32437": true,
      "32439": true,
      "32440": true,
      "32446": true,
      "32448": true,
      "32449": true,
      "32450": true,
      "32451": true,
      "32452": true,
      "32457": true,
      "32459": true,
      "32460": true,
      "32469": true,
      "32470": true,
      "32471": true,
      "32472": true,
      "32500": true,
      "32505": true,
      "32507": true,
      "32509": true,
      "32510": true,
      "32519": true,
      "32520": true,
      "32528": true,
      "32530": true,
      "32534": true,
      "32535": true,
      "32536": true,
      "32537": true,
      "32538": true,
      "32539": true,
      "32540": true,
      "32543": true,
      "32544": true,
      "32545": true,
      "32546": true,
      "32548": true,
      "32550": true,
      "32553": true,
      "32557": true,
      "32560": true,
      "32563": true,
      "32565": true,
      "32573": true,
      "32574": true,
      "32575": true,
      "32576": true,
      "32577": true,
      "32579": true,
      "32580": true,
      "32583": true,
      "32584": true,
      "32585": true,
      "32586": true,
      "32587": true,
      "32590": true,
      "32594": true,
      "32598": true,
      "32599": true,
      "32600": true,
      "32605": true,
      "32606": true,
      "32607": true,
      "32609": true,
      "32616": true,
      "32617": true,
      "32618": true,
      "32620": true,
      "32625": true,
      "32628": true,
      "32629": true,
      "32630": true,
      "32640": true,
      "32647": true,
      "32648": true,
      "32649": true,
      "32650": true,
      "32651": true,
      "32652": true,
      "32653": true,
      "32654": true,
      "32658": true,
      "32659": true,
      "32660": true,
      "32662": true,
      "32663": true,
      "32664": true,
      "32665": true,
      "32667": true,
      "32668": true,
      "32670": true,
      "32674": true,
      "32675": true,
      "32676": true,
      "32677": true,
      "32679": true,
      "32680": true,
      "32685": true,
      "32688": true,
      "32690": true,
      "32692": true,
      "32693": true,
      "32694": true,
      "32695": true,
      "32696": true,
      "32697": true,
      "32698": true,
      "32699": true,
      "32702": true,
      "32703": true,
      "32720": true,
      "32721": true,
      "32722": true,
      "32724": true,
      "32725": true,
      "32730": true,
      "32737": true
    },
    "MADERA": {
      "31940": true,
      "31942": true,
      "31943": true,
      "31953": true,
      "31955": true,
      "31957": true,
      "31958": true
    },
    "MEOQUI": {
      "33130": true,
      "33131": true,
      "33132": true,
      "33133": true,
      "33135": true,
      "33136": true,
      "33137": true,
      "33138": true,
      "33139": true
    },
    "NAMIQUIPA": {
      "31960": true,
      "31963": true,
      "31964": true,
      "31967": true,
      "31975": true,
      "31978": true
    },
    "NUEVO CASAS GRANDES": {
      "31700": true,
      "31704": true,
      "31710": true,
      "31719": true,
      "31720": true,
      "31730": true,
      "31735": true,
      "31750": true,
      "31755": true,
      "31758": true,
      "31760": true,
      "31770": true,
      "31777": true,
      "31778": true,
      "31780": true,
      "31783": true,
      "31789": true,
      "31806": true,
      "31807": true,
      "31810": true
    },
    "OJINAGA": {
      "32880": true,
      "32882": true,
      "32883": true,
      "32884": true,
      "32885": true,
      "32886": true,
      "32888": true,
      "32894": true,
      "32895": true,
      "32896": true,
      "32897": true
    },
    "PRAXEDIS G. GUERRERO": {
      "32780": true,
      "32783": true,
      "32785": true,
      "32789": true,
      "32793": true,
      "32797": true
    },
    "RIVA PALACIO": {
      "31640": true,
      "31644": true,
      "31645": true,
      "31646": true,
      "31647": true
    },
    "ROSALES": {
      "33120": true,
      "33123": true,
      "33126": true,
      "33127": true,
      "33128": true
    },
    "SANTA ISABEL": {
      "33270": true,
      "33273": true,
      "33274": true,
      "33275": true,
      "33276": true,
      "33277": true
    },
    "SAUCILLO": {
      "33620": true,
      "33623": true,
      "33624": true,
      "33625": true,
      "33626": true,
      "33627": true,
      "33630": true,
      "33633": true,
      "33634": true,
      "33636": true,
      "33637": true,
      "33640": true,
      "33645": true,
      "33646": true
    }
  },
  "COAHUILA DE ZARAGOZA": {
    "ABASOLO": {
      "25540": true,
      "25543": true,
      "25544": true,
      "25545": true,
      "25547": true,
      "25550": true,
      "25554": true,
      "25555": true,
      "25567": true
    },
    "ACUNA": {
      "26200": true,
      "26210": true,
      "26215": true,
      "26220": true,
      "26230": true,
      "26233": true,
      "26234": true,
      "26235": true,
      "26236": true,
      "26237": true,
      "26238": true,
      "26239": true,
      "26240": true,
      "26248": true,
      "26249": true,
      "26250": true,
      "26260": true,
      "26263": true,
      "26264": true,
      "26269": true,
      "26270": true,
      "26272": true,
      "26278": true,
      "26279": true,
      "26280": true,
      "26282": true,
      "26283": true,
      "26284": true,
      "26288": true,
      "26289": true,
      "26290": true,
      "26293": true,
      "26299": true,
      "26300": true,
      "26302": true,
      "26308": true,
      "26309": true,
      "26328": true
    },
    "ALLENDE": {
      "26530": true,
      "26532": true,
      "26533": true,
      "26534": true,
      "26540": true,
      "26543": true,
      "26544": true,
      "26545": true,
      "26546": true,
      "26547": true,
      "26550": true,
      "26553": true,
      "26554": true,
      "26555": true,
      "26556": true,
      "26557": true,
      "26563": true,
      "26564": true,
      "26565": true,
      "26566": true,
      "26567": true,
      "26570": true,
      "26573": true,
      "26574": true,
      "26575": true,
      "26577": true,
      "26580": true,
      "26590": true,
      "26593": true,
      "26595": true
    },
    "ARTEAGA": {
      "25350": true,
      "25352": true,
      "25353": true,
      "25354": true,
      "25355": true,
      "25356": true,
      "25357": true,
      "25360": true,
      "25363": true,
      "25365": true,
      "25366": true,
      "25367": true,
      "25368": true,
      "25369": true,
      "25370": true,
      "25372": true,
      "25373": true,
      "25374": true,
      "25375": true,
      "25376": true,
      "25380": true,
      "25382": true,
      "25385": true,
      "25386": true,
      "25387": true,
      "25389": true,
      "25390": true,
      "25393": true,
      "25395": true,
      "25396": true,
      "25398": true,
      "25399": true
    },
    "CANDELA": {
      "25570": true,
      "25571": true,
      "25576": true,
      "25580": true,
      "25587": true
    },
    "CASTANOS": {
      "25870": true,
      "25873": true,
      "25874": true,
      "25875": true,
      "25876": true,
      "25879": true,
      "25884": true,
      "25886": true,
      "25887": true,
      "25896": true
    },
    "CUATRO CIENEGAS": {
      "27640": true,
      "27642": true,
      "27643": true,
      "27644": true,
      "27645": true,
      "27650": true,
      "27657": true,
      "27689": true,
      "27695": true
    },
    "ESCOBEDO": {
      "25470": true,
      "25490": true,
      "25494": true,
      "25495": true,
      "25496": true
    },
    "FRANCISCO I. MADERO": {
      "27900": true,
      "27902": true,
      "27904": true,
      "27905": true,
      "27906": true,
      "27907": true,
      "27908": true,
      "27911": true,
      "27913": true,
      "27914": true,
      "27915": true,
      "27916": true,
      "27917": true,
      "27918": true,
      "27923": true,
      "27924": true,
      "27925": true,
      "27926": true,
      "27933": true,
      "27935": true,
      "27937": true
    },
    "FRONTERA": {
      "25600": true,
      "25610": true,
      "25616": true,
      "25617": true,
      "25618": true,
      "25619": true,
      "25626": true,
      "25627": true,
      "25628": true,
      "25629": true,
      "25630": true,
      "25640": true,
      "25643": true,
      "25644": true,
      "25650": true,
      "25660": true,
      "25668": true,
      "25669": true,
      "25670": true,
      "25680": true,
      "25800": true,
      "25802": true,
      "25803": true,
      "25804": true,
      "25805": true,
      "25810": true,
      "25815": true,
      "25820": true,
      "25823": true
    },
    "GENERAL CEPEDA": {
      "25950": true,
      "25953": true,
      "25954": true,
      "25955": true,
      "25956": true,
      "25974": true,
      "25975": true,
      "25976": true,
      "25977": true,
      "25978": true,
      "25987": true,
      "25990": true
    },
    "GUERRERO": {
      "26640": true,
      "26643": true,
      "26646": true
    },
    "JIMENEZ": {
      "26400": true,
      "26401": true,
      "26409": true,
      "26420": true,
      "26423": true,
      "26431": true,
      "26435": true
    },
    "JUÁREZ": {
      "25400": true,
      "25406": true,
      "25410": true,
      "25413": true
    },
    "LAMADRID": {
      "27700": true,
      "27704": true
    },
    "MATAMOROS": {
      "27440": true,
      "27442": true,
      "27443": true,
      "27444": true,
      "27445": true,
      "27446": true,
      "27447": true,
      "27448": true,
      "27449": true,
      "27450": true,
      "27453": true,
      "27454": true,
      "27455": true,
      "27456": true,
      "27457": true,
      "27458": true,
      "27459": true,
      "27460": true,
      "27463": true,
      "27464": true,
      "27465": true,
      "27466": true,
      "27467": true,
      "27468": true,
      "27470": true,
      "27473": true,
      "27475": true,
      "27477": true,
      "27478": true,
      "27479": true
    },
    "MONCLOVA": {
      "25700": true,
      "25710": true,
      "25714": true,
      "25716": true,
      "25717": true,
      "25718": true,
      "25720": true,
      "25724": true,
      "25725": true,
      "25726": true,
      "25730": true,
      "25732": true,
      "25733": true,
      "25734": true,
      "25740": true,
      "25743": true,
      "25746": true,
      "25747": true,
      "25748": true,
      "25749": true,
      "25750": true,
      "25756": true,
      "25757": true,
      "25758": true,
      "25760": true,
      "25766": true,
      "25767": true,
      "25768": true,
      "25770": true,
      "25775": true,
      "25776": true,
      "25777": true,
      "25780": true,
      "25785": true,
      "25790": true,
      "25793": true,
      "25796": true,
      "25799": true,
      "25836": true,
      "25843": true,
      "25844": true,
      "25845": true,
      "25846": true,
      "25847": true,
      "25850": true,
      "25851": true,
      "25853": true,
      "25855": true,
      "25860": true,
      "25865": true,
      "25866": true
    },
    "MORELOS": {
      "26500": true,
      "26506": true,
      "26507": true,
      "26510": true,
      "26513": true,
      "26516": true,
      "26517": true
    },
    "MUZQUIZ": {
      "26340": true,
      "26342": true,
      "26343": true,
      "26344": true,
      "26345": true,
      "26346": true,
      "26348": true,
      "26350": true,
      "26356": true,
      "26363": true,
      "26366": true,
      "26370": true,
      "26384": true
    },
    "NADADORES": {
      "27550": true,
      "27560": true,
      "27565": true,
      "27575": true,
      "27588": true
    },
    "NAVA": {
      "26170": true,
      "26172": true,
      "26173": true,
      "26174": true,
      "26175": true,
      "26176": true,
      "26177": true,
      "26183": true,
      "26190": true,
      "26196": true
    },
    "PARRAS": {
      "27980": true,
      "27983": true,
      "27984": true,
      "27985": true,
      "27986": true,
      "27987": true,
      "27988": true,
      "27989": true,
      "27990": true,
      "27992": true,
      "27995": true,
      "27996": true
    },
    "PIEDRAS NEGRAS": {
      "26000": true,
      "26010": true,
      "26013": true,
      "26014": true,
      "26015": true,
      "26016": true,
      "26017": true,
      "26018": true,
      "26020": true,
      "26025": true,
      "26030": true,
      "26033": true,
      "26034": true,
      "26035": true,
      "26040": true,
      "26050": true,
      "26060": true,
      "26063": true,
      "26064": true,
      "26065": true,
      "26068": true,
      "26069": true,
      "26070": true,
      "26073": true,
      "26080": true,
      "26083": true,
      "26085": true,
      "26086": true,
      "26088": true,
      "26089": true,
      "26090": true,
      "26092": true,
      "26093": true,
      "26094": true,
      "26095": true,
      "26096": true,
      "26099": true,
      "26110": true,
      "26114": true,
      "26119": true,
      "26120": true,
      "26133": true,
      "26137": true,
      "26140": true,
      "26145": true
    },
    "PROGRESO": {
      "25420": true,
      "25428": true,
      "25431": true,
      "25443": true,
      "25445": true,
      "25447": true,
      "25463": true
    },
    "RAMOS ARIZPE": {
      "25900": true,
      "25902": true,
      "25903": true,
      "25904": true,
      "25905": true,
      "25908": true,
      "25909": true,
      "25910": true,
      "25913": true,
      "25914": true,
      "25915": true,
      "25916": true,
      "25917": true,
      "25918": true,
      "25925": true,
      "25927": true,
      "25929": true,
      "25930": true,
      "25932": true,
      "25933": true,
      "25934": true,
      "25935": true,
      "25936": true,
      "25937": true,
      "25942": true,
      "25943": true,
      "25944": true,
      "25946": true,
      "25947": true
    },
    "SABINAS": {
      "26700": true,
      "26710": true,
      "26719": true,
      "26720": true,
      "26729": true,
      "26730": true,
      "26736": true,
      "26737": true,
      "26739": true,
      "26740": true,
      "26741": true,
      "26747": true,
      "26748": true,
      "26749": true,
      "26750": true,
      "26759": true,
      "26760": true,
      "26763": true,
      "26764": true,
      "26765": true,
      "26766": true,
      "26768": true,
      "26769": true,
      "26770": true,
      "26779": true,
      "26780": true,
      "26788": true,
      "26790": true,
      "26799": true,
      "26950": true,
      "26959": true,
      "26960": true,
      "26963": true,
      "26980": true
    },
    "SACRAMENTO": {
      "27750": true,
      "27755": true,
      "27758": true,
      "27760": true
    },
    "SALTILLO": {
      "25000": true,
      "25008": true,
      "25010": true,
      "25013": true,
      "25014": true,
      "25015": true,
      "25016": true,
      "25017": true,
      "25019": true,
      "25020": true,
      "25022": true,
      "25023": true,
      "25030": true,
      "25034": true,
      "25036": true,
      "25038": true,
      "25039": true,
      "25040": true,
      "25043": true,
      "25044": true,
      "25045": true,
      "25047": true,
      "25048": true,
      "25049": true,
      "25050": true,
      "25056": true,
      "25057": true,
      "25060": true,
      "25065": true,
      "25067": true,
      "25068": true,
      "25069": true,
      "25070": true,
      "25075": true,
      "25076": true,
      "25077": true,
      "25080": true,
      "25083": true,
      "25084": true,
      "25085": true,
      "25086": true,
      "25087": true,
      "25088": true,
      "25090": true,
      "25092": true,
      "25093": true,
      "25094": true,
      "25096": true,
      "25097": true,
      "25100": true,
      "25107": true,
      "25110": true,
      "25113": true,
      "25114": true,
      "25115": true,
      "25116": true,
      "25117": true,
      "25120": true,
      "25123": true,
      "25124": true,
      "25125": true,
      "25128": true,
      "25130": true,
      "25137": true,
      "25138": true,
      "25140": true,
      "25146": true,
      "25147": true,
      "25150": true,
      "25154": true,
      "25155": true,
      "25156": true,
      "25157": true,
      "25160": true,
      "25167": true,
      "25168": true,
      "25169": true,
      "25170": true,
      "25179": true,
      "25180": true,
      "25186": true,
      "25188": true,
      "25190": true,
      "25193": true,
      "25194": true,
      "25195": true,
      "25196": true,
      "25197": true,
      "25198": true,
      "25199": true,
      "25200": true,
      "25203": true,
      "25204": true,
      "25205": true,
      "25206": true,
      "25207": true,
      "25208": true,
      "25209": true,
      "25210": true,
      "25215": true,
      "25220": true,
      "25225": true,
      "25230": true,
      "25238": true,
      "25239": true,
      "25240": true,
      "25250": true,
      "25253": true,
      "25254": true,
      "25256": true,
      "25260": true,
      "25265": true,
      "25270": true,
      "25277": true,
      "25279": true,
      "25280": true,
      "25284": true,
      "25285": true,
      "25286": true,
      "25290": true,
      "25293": true,
      "25294": true,
      "25295": true,
      "25296": true,
      "25297": true,
      "25298": true,
      "25300": true,
      "25301": true,
      "25302": true,
      "25303": true,
      "25304": true,
      "25305": true,
      "25306": true,
      "25307": true,
      "25310": true,
      "25311": true,
      "25313": true,
      "25315": true,
      "25316": true,
      "25317": true,
      "25318": true,
      "25320": true,
      "25321": true,
      "25322": true,
      "25324": true,
      "25325": true,
      "25326": true,
      "25327": true,
      "25328": true,
      "25329": true,
      "25330": true,
      "25331": true,
      "25332": true,
      "25333": true,
      "25334": true,
      "25335": true,
      "25336": true,
      "25337": true,
      "25338": true,
      "25340": true,
      "25343": true,
      "25344": true,
      "25345": true,
      "25346": true,
      "25347": true,
      "25348": true
    },
    "SAN BUENAVENTURA": {
      "25500": true,
      "25503": true,
      "25504": true,
      "25505": true,
      "25506": true,
      "25507": true,
      "25508": true,
      "25530": true,
      "25536": true
    },
    "SAN JUAN DE SABINAS": {
      "26800": true,
      "26809": true,
      "26810": true,
      "26813": true,
      "26820": true,
      "26825": true,
      "26830": true,
      "26832": true,
      "26834": true,
      "26840": true,
      "26843": true,
      "26850": true,
      "26860": true,
      "26862": true,
      "26870": true,
      "26875": true,
      "26879": true,
      "26880": true,
      "26885": true,
      "26886": true,
      "26890": true,
      "26900": true,
      "26903": true,
      "26908": true,
      "26940": true,
      "26942": true
    },
    "SAN PEDRO": {
      "27800": true,
      "27804": true,
      "27805": true,
      "27810": true,
      "27811": true,
      "27812": true,
      "27813": true,
      "27820": true,
      "27822": true,
      "27823": true,
      "27830": true,
      "27838": true,
      "27839": true,
      "27840": true,
      "27845": true,
      "27846": true,
      "27847": true,
      "27848": true,
      "27850": true,
      "27860": true,
      "27863": true,
      "27870": true,
      "27880": true,
      "27890": true,
      "27940": true,
      "27943": true,
      "27944": true,
      "27945": true,
      "27946": true,
      "27950": true,
      "27953": true,
      "27954": true,
      "27955": true,
      "27956": true,
      "27957": true,
      "27958": true,
      "27960": true,
      "27966": true,
      "27970": true,
      "27974": true
    },
    "TORREON": {
      "27000": true,
      "27009": true,
      "27010": true,
      "27013": true,
      "27014": true,
      "27015": true,
      "27016": true,
      "27017": true,
      "27018": true,
      "27019": true,
      "27020": true,
      "27023": true,
      "27029": true,
      "27030": true,
      "27039": true,
      "27040": true,
      "27050": true,
      "27053": true,
      "27054": true,
      "27055": true,
      "27056": true,
      "27057": true,
      "27058": true,
      "27059": true,
      "27060": true,
      "27070": true,
      "27073": true,
      "27080": true,
      "27083": true,
      "27084": true,
      "27085": true,
      "27086": true,
      "27087": true,
      "27088": true,
      "27089": true,
      "27090": true,
      "27096": true,
      "27098": true,
      "27100": true,
      "27103": true,
      "27104": true,
      "27105": true,
      "27106": true,
      "27107": true,
      "27108": true,
      "27110": true,
      "27119": true,
      "27120": true,
      "27130": true,
      "27140": true,
      "27148": true,
      "27150": true,
      "27159": true,
      "27160": true,
      "27167": true,
      "27168": true,
      "27170": true,
      "27180": true,
      "27190": true,
      "27199": true,
      "27200": true,
      "27210": true,
      "27217": true,
      "27220": true,
      "27228": true,
      "27229": true,
      "27230": true,
      "27240": true,
      "27250": true,
      "27258": true,
      "27260": true,
      "27265": true,
      "27266": true,
      "27267": true,
      "27268": true,
      "27269": true,
      "27270": true,
      "27272": true,
      "27273": true,
      "27274": true,
      "27275": true,
      "27276": true,
      "27277": true,
      "27278": true,
      "27279": true,
      "27280": true,
      "27287": true,
      "27289": true,
      "27290": true,
      "27293": true,
      "27294": true,
      "27295": true,
      "27296": true,
      "27297": true,
      "27298": true,
      "27299": true,
      "27300": true,
      "27309": true,
      "27310": true,
      "27320": true,
      "27329": true,
      "27330": true,
      "27338": true,
      "27340": true,
      "27349": true,
      "27350": true,
      "27357": true,
      "27360": true,
      "27364": true,
      "27368": true,
      "27370": true,
      "27376": true,
      "27377": true,
      "27380": true,
      "27390": true,
      "27397": true,
      "27399": true,
      "27400": true,
      "27403": true,
      "27405": true,
      "27406": true,
      "27407": true,
      "27410": true,
      "27412": true,
      "27413": true,
      "27414": true,
      "27415": true,
      "27416": true,
      "27420": true,
      "27422": true,
      "27423": true,
      "27425": true,
      "27426": true,
      "27430": true,
      "27433": true,
      "27434": true,
      "27435": true,
      "27436": true,
      "27438": true
    },
    "VIESCA": {
      "27480": true,
      "27485": true,
      "27487": true
    },
    "VILLA UNION": {
      "26600": true,
      "26603": true,
      "26604": true,
      "26605": true,
      "26606": true,
      "26607": true,
      "26610": true,
      "26613": true,
      "26617": true,
      "26624": true,
      "26630": true,
      "26636": true
    },
    "ZARAGOZA": {
      "26450": true,
      "26452": true,
      "26453": true,
      "26463": true,
      "26464": true,
      "26467": true,
      "26470": true,
      "26485": true
    }
  },
  "COLIMA": {
    "ARMERIA": {
      "28300": true,
      "28304": true,
      "28305": true,
      "28306": true,
      "28307": true,
      "28310": true,
      "28313": true,
      "28315": true,
      "28317": true,
      "28320": true,
      "28330": true,
      "28340": true,
      "28350": true
    },
    "COLIMA": {
      "28000": true,
      "28010": true,
      "28014": true,
      "28016": true,
      "28017": true,
      "28018": true,
      "28019": true,
      "28020": true,
      "28023": true,
      "28025": true,
      "28030": true,
      "28035": true,
      "28037": true,
      "28040": true,
      "28043": true,
      "28044": true,
      "28045": true,
      "28046": true,
      "28047": true,
      "28048": true,
      "28050": true,
      "28060": true,
      "28063": true,
      "28067": true,
      "28070": true,
      "28075": true,
      "28077": true,
      "28078": true,
      "28079": true,
      "28080": true,
      "28085": true,
      "28089": true,
      "28090": true,
      "28600": true,
      "28610": true,
      "28613": true,
      "28620": true,
      "28626": true,
      "28627": true,
      "28628": true,
      "28629": true,
      "28630": true,
      "28633": true,
      "28634": true,
      "28635": true,
      "28640": true,
      "28645": true,
      "28646": true,
      "28647": true,
      "28655": true,
      "28656": true
    },
    "COMALA": {
      "28450": true,
      "28452": true,
      "28454": true,
      "28455": true,
      "28456": true,
      "28459": true,
      "28460": true,
      "28461": true,
      "28464": true,
      "28466": true
    },
    "COQUIMATLAN": {
      "28400": true,
      "28402": true,
      "28403": true,
      "28405": true,
      "28410": true,
      "28413": true,
      "28414": true,
      "28420": true,
      "28424": true
    },
    "CUAUHTÉMOC": {
      "28500": true,
      "28504": true,
      "28506": true,
      "28507": true,
      "28510": true,
      "28513": true,
      "28514": true,
      "28515": true,
      "28516": true,
      "28520": true,
      "28521": true,
      "28523": true,
      "28530": true,
      "28550": true,
      "28553": true,
      "28555": true,
      "28557": true,
      "28590": true,
      "28599": true
    },
    "IXTLAHUACAN": {
      "28700": true,
      "28703": true,
      "28704": true,
      "28705": true,
      "28720": true,
      "28724": true,
      "28730": true,
      "28735": true
    },
    "MANZANILLO": {
      "28200": true,
      "28218": true,
      "28219": true,
      "28230": true,
      "28236": true,
      "28237": true,
      "28238": true,
      "28239": true,
      "28240": true,
      "28250": true,
      "28259": true,
      "28260": true,
      "28269": true,
      "28270": true,
      "28278": true,
      "28279": true,
      "28800": true,
      "28808": true,
      "28809": true,
      "28820": true,
      "28830": true,
      "28836": true,
      "28840": true,
      "28860": true,
      "28863": true,
      "28864": true,
      "28865": true,
      "28867": true,
      "28868": true,
      "28869": true,
      "28870": true,
      "28872": true,
      "28880": true
    },
    "MINATITLAN": {
      "28750": true,
      "28760": true,
      "28764": true,
      "28765": true,
      "28766": true,
      "28767": true,
      "28770": true,
      "28772": true,
      "28773": true,
      "28774": true,
      "28784": true
    },
    "TECOMAN": {
      "28100": true,
      "28110": true,
      "28113": true,
      "28114": true,
      "28120": true,
      "28123": true,
      "28130": true,
      "28133": true,
      "28134": true,
      "28140": true,
      "28143": true,
      "28150": true,
      "28159": true,
      "28160": true,
      "28170": true,
      "28180": true,
      "28184": true,
      "28189": true,
      "28190": true,
      "28900": true,
      "28910": true,
      "28915": true,
      "28920": true,
      "28930": true,
      "28934": true,
      "28935": true,
      "28936": true,
      "28937": true,
      "28938": true,
      "28944": true
    },
    "VILLA DE ALVAREZ": {
      "28950": true,
      "28952": true,
      "28955": true,
      "28958": true,
      "28959": true,
      "28960": true,
      "28963": true,
      "28964": true,
      "28965": true,
      "28968": true,
      "28970": true,
      "28973": true,
      "28974": true,
      "28975": true,
      "28976": true,
      "28977": true,
      "28978": true,
      "28979": true,
      "28980": true,
      "28982": true,
      "28983": true,
      "28984": true,
      "28985": true,
      "28986": true,
      "28987": true,
      "28988": true,
      "28989": true
    }
  },
  "DURANGO": {
    "CANATLAN": {
      "34400": true,
      "34405": true,
      "34406": true,
      "34407": true,
      "34444": true,
      "34446": true,
      "34450": true,
      "34453": true,
      "34454": true,
      "34455": true,
      "34456": true,
      "34457": true,
      "34460": true,
      "34464": true,
      "34465": true,
      "34466": true,
      "34467": true
    },
    "CUENCAME": {
      "35800": true,
      "35803": true,
      "35804": true,
      "35805": true,
      "35806": true,
      "35807": true,
      "35815": true,
      "35817": true,
      "35824": true,
      "35827": true,
      "35830": true,
      "35833": true,
      "35834": true,
      "35835": true,
      "35837": true
    },
    "DURANGO": {
      "34000": true,
      "34010": true,
      "34014": true,
      "34015": true,
      "34016": true,
      "34017": true,
      "34018": true,
      "34019": true,
      "34020": true,
      "34024": true,
      "34027": true,
      "34028": true,
      "34029": true,
      "34030": true,
      "34034": true,
      "34038": true,
      "34039": true,
      "34040": true,
      "34043": true,
      "34045": true,
      "34046": true,
      "34047": true,
      "34048": true,
      "34049": true,
      "34050": true,
      "34058": true,
      "34060": true,
      "34069": true,
      "34070": true,
      "34074": true,
      "34075": true,
      "34076": true,
      "34077": true,
      "34080": true,
      "34090": true,
      "34100": true,
      "34103": true,
      "34104": true,
      "34105": true,
      "34106": true,
      "34107": true,
      "34108": true,
      "34109": true,
      "34110": true,
      "34113": true,
      "34116": true,
      "34119": true,
      "34120": true,
      "34123": true,
      "34124": true,
      "34125": true,
      "34126": true,
      "34127": true,
      "34128": true,
      "34129": true,
      "34130": true,
      "34135": true,
      "34136": true,
      "34137": true,
      "34138": true,
      "34139": true,
      "34140": true,
      "34143": true,
      "34144": true,
      "34145": true,
      "34146": true,
      "34147": true,
      "34150": true,
      "34156": true,
      "34157": true,
      "34158": true,
      "34159": true,
      "34160": true,
      "34162": true,
      "34163": true,
      "34164": true,
      "34165": true,
      "34166": true,
      "34167": true,
      "34168": true,
      "34169": true,
      "34170": true,
      "34175": true,
      "34176": true,
      "34179": true,
      "34180": true,
      "34185": true,
      "34186": true,
      "34187": true,
      "34188": true,
      "34189": true,
      "34190": true,
      "34193": true,
      "34194": true,
      "34195": true,
      "34196": true,
      "34197": true,
      "34198": true,
      "34199": true,
      "34200": true,
      "34204": true,
      "34205": true,
      "34206": true,
      "34207": true,
      "34208": true,
      "34209": true,
      "34210": true,
      "34214": true,
      "34215": true,
      "34216": true,
      "34217": true,
      "34218": true,
      "34219": true,
      "34220": true,
      "34224": true,
      "34225": true,
      "34226": true,
      "34227": true,
      "34228": true,
      "34229": true,
      "34230": true,
      "34233": true,
      "34234": true,
      "34235": true,
      "34236": true,
      "34237": true,
      "34238": true,
      "34239": true,
      "34240": true,
      "34250": true,
      "34260": true,
      "34269": true,
      "34270": true,
      "34277": true,
      "34278": true,
      "34279": true,
      "34280": true,
      "34284": true,
      "34285": true,
      "34286": true,
      "34287": true,
      "34289": true,
      "34290": true,
      "34298": true,
      "34299": true,
      "34300": true,
      "34303": true,
      "34304": true,
      "34305": true,
      "34306": true,
      "34307": true,
      "34308": true,
      "34310": true,
      "34313": true,
      "34314": true,
      "34316": true,
      "34317": true,
      "34320": true,
      "34323": true,
      "34324": true,
      "34325": true,
      "34326": true,
      "34330": true,
      "34334": true,
      "34340": true,
      "34345": true,
      "34346": true,
      "34350": true,
      "34354": true,
      "34357": true,
      "34358": true,
      "34360": true,
      "34363": true,
      "34364": true,
      "34365": true,
      "34366": true,
      "34371": true,
      "34373": true,
      "34375": true,
      "34376": true,
      "34377": true,
      "34378": true,
      "34380": true,
      "34383": true,
      "34384": true,
      "34385": true,
      "34386": true,
      "34387": true,
      "34390": true,
      "34393": true,
      "34394": true,
      "34395": true,
      "34397": true,
      "34398": true
    },
    "GOMEZ PALACIO": {
      "35000": true,
      "35010": true,
      "35013": true,
      "35014": true,
      "35015": true,
      "35016": true,
      "35017": true,
      "35018": true,
      "35019": true,
      "35020": true,
      "35023": true,
      "35024": true,
      "35025": true,
      "35026": true,
      "35027": true,
      "35028": true,
      "35029": true,
      "35030": true,
      "35039": true,
      "35040": true,
      "35043": true,
      "35044": true,
      "35045": true,
      "35046": true,
      "35047": true,
      "35048": true,
      "35049": true,
      "35050": true,
      "35054": true,
      "35055": true,
      "35057": true,
      "35058": true,
      "35059": true,
      "35060": true,
      "35064": true,
      "35065": true,
      "35066": true,
      "35067": true,
      "35068": true,
      "35069": true,
      "35070": true,
      "35073": true,
      "35074": true,
      "35075": true,
      "35076": true,
      "35077": true,
      "35078": true,
      "35079": true,
      "35080": true,
      "35090": true,
      "35099": true,
      "35100": true,
      "35101": true,
      "35102": true,
      "35103": true,
      "35104": true,
      "35105": true,
      "35106": true,
      "35107": true,
      "35108": true,
      "35109": true,
      "35110": true,
      "35111": true,
      "35112": true,
      "35113": true,
      "35114": true,
      "35115": true,
      "35117": true,
      "35118": true,
      "35119": true,
      "35120": true,
      "35121": true,
      "35123": true,
      "35125": true,
      "35127": true,
      "35128": true,
      "35129": true,
      "35130": true,
      "35132": true,
      "35133": true,
      "35134": true,
      "35135": true,
      "35136": true,
      "35137": true,
      "35138": true,
      "35139": true,
      "35140": true,
      "35141": true,
      "35143": true,
      "35144": true,
      "35146": true,
      "35147": true
    },
    "GUADALUPE VICTORIA": {
      "34700": true,
      "34703": true,
      "34704": true,
      "34705": true,
      "34706": true,
      "34707": true,
      "34710": true,
      "34713": true,
      "34715": true,
      "34716": true,
      "34720": true,
      "34723": true,
      "34724": true,
      "34725": true,
      "34726": true,
      "34727": true,
      "34733": true
    },
    "LERDO": {
      "35150": true,
      "35153": true,
      "35154": true,
      "35155": true,
      "35156": true,
      "35157": true,
      "35158": true,
      "35159": true,
      "35160": true,
      "35163": true,
      "35164": true,
      "35165": true,
      "35166": true,
      "35167": true,
      "35168": true,
      "35169": true,
      "35170": true,
      "35179": true,
      "35180": true,
      "35181": true,
      "35185": true,
      "35186": true,
      "35187": true,
      "35188": true,
      "35189": true,
      "35190": true
    },
    "MAPIMI": {
      "35200": true,
      "35219": true,
      "35220": true,
      "35222": true,
      "35223": true,
      "35230": true,
      "35235": true,
      "35238": true,
      "35239": true
    },
    "MEZQUITAL": {
      "34970": true,
      "34973": true,
      "34974": true,
      "34975": true,
      "34978": true,
      "34987": true,
      "34996": true
    },
    "NAZAS": {
      "35700": true,
      "35703": true,
      "35704": true,
      "35705": true,
      "35706": true,
      "35707": true,
      "35710": true,
      "35713": true,
      "35714": true,
      "35720": true,
      "35724": true,
      "35726": true,
      "35727": true,
      "35730": true,
      "35733": true,
      "35737": true
    },
    "NOMBRE DE DIOS": {
      "34840": true,
      "34842": true,
      "34843": true,
      "34844": true,
      "34845": true,
      "34846": true,
      "34847": true,
      "34848": true,
      "34850": true,
      "34854": true,
      "34855": true,
      "34856": true,
      "34857": true,
      "34864": true,
      "34865": true,
      "34874": true,
      "34880": true,
      "34885": true,
      "34887": true
    },
    "NUEVO IDEAL": {
      "34410": true,
      "34413": true,
      "34414": true,
      "34415": true,
      "34416": true,
      "34417": true,
      "34420": true,
      "34423": true,
      "34424": true,
      "34425": true,
      "34426": true,
      "34427": true,
      "34430": true,
      "34433": true,
      "34434": true,
      "34435": true,
      "34436": true
    },
    "PANUCO DE CORONADO": {
      "34770": true,
      "34773": true,
      "34774": true,
      "34775": true,
      "34776": true,
      "34777": true,
      "34780": true,
      "34782": true,
      "34783": true,
      "34785": true,
      "34787": true,
      "34788": true,
      "34793": true
    },
    "PENON BLANCO": {
      "34740": true,
      "34743": true,
      "34744": true,
      "34745": true,
      "34748": true,
      "34755": true,
      "34760": true,
      "34763": true,
      "34764": true,
      "34765": true,
      "34766": true,
      "34767": true,
      "34768": true
    },
    "POANAS": {
      "34800": true,
      "34803": true,
      "34810": true,
      "34813": true,
      "34816": true,
      "34820": true,
      "34823": true,
      "34825": true,
      "34826": true,
      "34830": true,
      "34837": true
    },
    "PUEBLO NUEVO": {
      "34940": true,
      "34942": true,
      "34945": true,
      "34946": true,
      "34947": true,
      "34948": true,
      "34950": true,
      "34953": true,
      "34957": true,
      "34960": true,
      "34965": true,
      "34966": true
    },
    "SAN JUAN DEL RIO": {
      "34480": true,
      "34482": true,
      "34483": true,
      "34484": true,
      "34485": true,
      "34486": true,
      "34487": true,
      "34490": true,
      "34493": true,
      "34494": true,
      "34495": true,
      "34496": true,
      "34497": true
    },
    "SANTIAGO PAPASQUIARO": {
      "34600": true,
      "34605": true,
      "34606": true,
      "34607": true,
      "34610": true,
      "34614": true,
      "34630": true,
      "34634": true,
      "34635": true,
      "34636": true,
      "34637": true,
      "34638": true,
      "34639": true,
      "34640": true,
      "34644": true,
      "34645": true,
      "34646": true,
      "34647": true,
      "34648": true,
      "34649": true
    },
    "SUCHIL": {
      "34900": true,
      "34903": true,
      "34904": true,
      "34905": true,
      "34906": true,
      "34907": true,
      "34910": true,
      "34913": true,
      "34915": true,
      "34917": true,
      "34923": true,
      "34926": true,
      "34927": true,
      "34935": true
    },
    "TLAHUALILO": {
      "35250": true,
      "35253": true,
      "35254": true,
      "35255": true,
      "35256": true,
      "35257": true,
      "35260": true,
      "35263": true,
      "35264": true,
      "35265": true,
      "35266": true,
      "35270": true,
      "35274": true,
      "35280": true,
      "35284": true,
      "35286": true,
      "35296": true
    },
    "VICENTE GUERRERO": {
      "34890": true,
      "34892": true,
      "34893": true,
      "34894": true,
      "34895": true,
      "34896": true,
      "34897": true,
      "34898": true
    }
  },
  "GUANAJUATO": {
    "ABASOLO": {
      "36970": true,
      "36973": true,
      "36974": true,
      "36975": true,
      "36976": true,
      "36977": true,
      "36980": true,
      "36983": true,
      "36984": true,
      "36985": true,
      "36986": true,
      "36987": true
    },
    "ACAMBARO": {
      "38600": true,
      "38610": true,
      "38612": true,
      "38613": true,
      "38614": true,
      "38620": true,
      "38623": true,
      "38624": true,
      "38625": true,
      "38630": true,
      "38640": true,
      "38642": true,
      "38650": true,
      "38652": true,
      "38653": true,
      "38654": true,
      "38660": true,
      "38664": true,
      "38670": true,
      "38672": true,
      "38673": true,
      "38674": true,
      "38675": true,
      "38676": true,
      "38679": true,
      "38680": true,
      "38683": true,
      "38689": true,
      "38730": true,
      "38733": true,
      "38734": true,
      "38735": true,
      "38736": true,
      "38737": true,
      "38740": true,
      "38743": true,
      "38747": true,
      "38750": true,
      "38753": true,
      "38754": true,
      "38755": true,
      "38756": true,
      "38757": true,
      "38760": true,
      "38763": true,
      "38764": true,
      "38765": true,
      "38766": true,
      "38770": true,
      "38776": true,
      "38777": true,
      "38780": true,
      "38783": true,
      "38784": true,
      "38785": true,
      "38786": true,
      "38787": true
    },
    "APASEO EL ALTO": {
      "38500": true,
      "38503": true,
      "38504": true,
      "38505": true,
      "38506": true,
      "38507": true,
      "38510": true,
      "38513": true,
      "38514": true,
      "38515": true,
      "38517": true,
      "38520": true,
      "38523": true,
      "38524": true,
      "38525": true,
      "38526": true,
      "38527": true,
      "38530": true,
      "38534": true,
      "38535": true
    },
    "APASEO EL GRANDE": {
      "38160": true,
      "38163": true,
      "38164": true,
      "38165": true,
      "38166": true,
      "38167": true,
      "38168": true,
      "38173": true,
      "38174": true,
      "38176": true,
      "38177": true,
      "38180": true,
      "38185": true,
      "38186": true,
      "38187": true,
      "38190": true,
      "38194": true,
      "38195": true,
      "38196": true,
      "38197": true,
      "38198": true,
      "38199": true
    },
    "CELAYA": {
      "38000": true,
      "38010": true,
      "38013": true,
      "38014": true,
      "38015": true,
      "38016": true,
      "38017": true,
      "38018": true,
      "38019": true,
      "38020": true,
      "38024": true,
      "38027": true,
      "38028": true,
      "38030": true,
      "38033": true,
      "38034": true,
      "38035": true,
      "38036": true,
      "38037": true,
      "38040": true,
      "38046": true,
      "38047": true,
      "38048": true,
      "38050": true,
      "38057": true,
      "38060": true,
      "38063": true,
      "38065": true,
      "38067": true,
      "38068": true,
      "38070": true,
      "38078": true,
      "38079": true,
      "38080": true,
      "38085": true,
      "38086": true,
      "38088": true,
      "38090": true,
      "38094": true,
      "38095": true,
      "38096": true,
      "38097": true,
      "38098": true,
      "38099": true,
      "38100": true,
      "38104": true,
      "38105": true,
      "38106": true,
      "38110": true,
      "38113": true,
      "38114": true,
      "38115": true,
      "38116": true,
      "38117": true,
      "38119": true,
      "38120": true,
      "38123": true,
      "38124": true,
      "38125": true,
      "38126": true,
      "38127": true,
      "38130": true,
      "38133": true,
      "38134": true,
      "38135": true,
      "38136": true,
      "38137": true,
      "38140": true,
      "38143": true,
      "38144": true,
      "38145": true,
      "38146": true,
      "38147": true,
      "38150": true,
      "38152": true,
      "38153": true,
      "38154": true,
      "38155": true,
      "38156": true,
      "38157": true,
      "38158": true,
      "38159": true
    },
    "COMONFORT": {
      "38200": true,
      "38202": true,
      "38203": true,
      "38204": true,
      "38205": true,
      "38206": true,
      "38207": true,
      "38210": true,
      "38213": true,
      "38214": true,
      "38215": true,
      "38216": true,
      "38217": true,
      "38220": true,
      "38223": true,
      "38224": true,
      "38225": true,
      "38227": true
    },
    "CORONEO": {
      "38590": true,
      "38593": true,
      "38594": true,
      "38595": true,
      "38596": true,
      "38597": true
    },
    "CORTAZAR": {
      "38300": true,
      "38309": true,
      "38310": true,
      "38312": true,
      "38314": true,
      "38315": true,
      "38317": true,
      "38320": true,
      "38322": true,
      "38324": true,
      "38329": true,
      "38330": true,
      "38332": true,
      "38333": true,
      "38334": true,
      "38335": true,
      "38337": true,
      "38338": true,
      "38342": true,
      "38344": true,
      "38345": true,
      "38346": true,
      "38349": true,
      "38350": true,
      "38356": true,
      "38357": true,
      "38358": true,
      "38359": true,
      "38360": true,
      "38362": true,
      "38373": true,
      "38374": true,
      "38490": true,
      "38493": true,
      "38494": true,
      "38495": true,
      "38496": true,
      "38497": true,
      "38499": true
    },
    "CUERAMARO": {
      "36960": true,
      "36963": true,
      "36964": true,
      "36966": true,
      "36967": true,
      "36968": true,
      "36969": true
    },
    "DOLORES HIDALGO CUNA DE LA INDEPENDENCIA NACIONAL": {
      "37800": true,
      "37803": true,
      "37804": true,
      "37805": true,
      "37806": true,
      "37807": true,
      "37810": true,
      "37814": true,
      "37816": true,
      "37817": true,
      "37821": true,
      "37825": true,
      "37828": true,
      "37829": true,
      "37830": true,
      "37832": true,
      "37840": true,
      "37842": true,
      "37843": true,
      "37844": true,
      "37846": true,
      "37848": true,
      "37849": true
    },
    "GUANAJUATO": {
      "36000": true,
      "36003": true,
      "36010": true,
      "36013": true,
      "36014": true,
      "36015": true,
      "36016": true,
      "36020": true,
      "36023": true,
      "36024": true,
      "36030": true,
      "36033": true,
      "36040": true,
      "36043": true,
      "36044": true,
      "36050": true,
      "36053": true,
      "36060": true,
      "36080": true,
      "36086": true,
      "36089": true,
      "36090": true,
      "36093": true,
      "36094": true,
      "36220": true,
      "36223": true,
      "36224": true,
      "36225": true,
      "36227": true,
      "36228": true,
      "36230": true,
      "36235": true,
      "36236": true,
      "36237": true,
      "36240": true,
      "36243": true,
      "36244": true,
      "36246": true,
      "36247": true,
      "36250": true,
      "36253": true,
      "36254": true,
      "36255": true,
      "36256": true,
      "36257": true,
      "36258": true,
      "36259": true,
      "36260": true,
      "36263": true,
      "36264": true,
      "36265": true,
      "36266": true,
      "36267": true,
      "36268": true
    },
    "HUANIMARO": {
      "36990": true,
      "36993": true,
      "36994": true,
      "36995": true,
      "36996": true,
      "36997": true,
      "36998": true
    },
    "IRAPUATO": {
      "36500": true,
      "36510": true,
      "36511": true,
      "36512": true,
      "36513": true,
      "36515": true,
      "36520": true,
      "36524": true,
      "36525": true,
      "36526": true,
      "36530": true,
      "36540": true,
      "36541": true,
      "36542": true,
      "36544": true,
      "36545": true,
      "36546": true,
      "36547": true,
      "36550": true,
      "36554": true,
      "36555": true,
      "36556": true,
      "36557": true,
      "36558": true,
      "36559": true,
      "36560": true,
      "36566": true,
      "36567": true,
      "36568": true,
      "36570": true,
      "36576": true,
      "36577": true,
      "36578": true,
      "36580": true,
      "36583": true,
      "36584": true,
      "36585": true,
      "36586": true,
      "36587": true,
      "36588": true,
      "36589": true,
      "36590": true,
      "36593": true,
      "36595": true,
      "36597": true,
      "36599": true,
      "36600": true,
      "36610": true,
      "36611": true,
      "36612": true,
      "36613": true,
      "36614": true,
      "36615": true,
      "36620": true,
      "36624": true,
      "36625": true,
      "36626": true,
      "36630": true,
      "36631": true,
      "36633": true,
      "36640": true,
      "36643": true,
      "36644": true,
      "36645": true,
      "36646": true,
      "36648": true,
      "36649": true,
      "36650": true,
      "36659": true,
      "36660": true,
      "36666": true,
      "36667": true,
      "36668": true,
      "36669": true,
      "36670": true,
      "36673": true,
      "36680": true,
      "36683": true,
      "36687": true,
      "36690": true,
      "36691": true,
      "36698": true,
      "36699": true,
      "36800": true,
      "36803": true,
      "36804": true,
      "36805": true,
      "36806": true,
      "36807": true,
      "36810": true,
      "36813": true,
      "36814": true,
      "36815": true,
      "36817": true,
      "36821": true,
      "36822": true,
      "36823": true,
      "36824": true,
      "36825": true,
      "36826": true,
      "36827": true,
      "36830": true,
      "36833": true,
      "36834": true,
      "36835": true,
      "36836": true,
      "36837": true,
      "36840": true,
      "36843": true,
      "36844": true,
      "36845": true,
      "36846": true,
      "36847": true,
      "36849": true
    },
    "JARAL DEL PROGRESO": {
      "38470": true,
      "38473": true,
      "38474": true,
      "38475": true,
      "38476": true,
      "38477": true,
      "38480": true,
      "38483": true,
      "38484": true,
      "38485": true,
      "38486": true,
      "38487": true,
      "38488": true
    },
    "JERECUARO": {
      "38540": true,
      "38542": true,
      "38543": true,
      "38544": true,
      "38545": true,
      "38550": true,
      "38553": true,
      "38554": true,
      "38555": true,
      "38556": true,
      "38557": true,
      "38560": true,
      "38563": true,
      "38564": true,
      "38565": true,
      "38566": true,
      "38567": true,
      "38570": true,
      "38573": true,
      "38574": true,
      "38575": true,
      "38576": true,
      "38577": true,
      "38578": true,
      "38584": true,
      "38586": true,
      "38587": true
    },
    "LEÓN": {
      "37000": true,
      "37004": true,
      "37010": true,
      "37020": true,
      "37100": true,
      "37104": true,
      "37105": true,
      "37106": true,
      "37107": true,
      "37108": true,
      "37109": true,
      "37110": true,
      "37118": true,
      "37119": true,
      "37120": true,
      "37123": true,
      "37125": true,
      "37128": true,
      "37129": true,
      "37130": true,
      "37134": true,
      "37138": true,
      "37140": true,
      "37147": true,
      "37148": true,
      "37149": true,
      "37150": true,
      "37156": true,
      "37157": true,
      "37160": true,
      "37168": true,
      "37170": true,
      "37178": true,
      "37179": true,
      "37180": true,
      "37187": true,
      "37188": true,
      "37189": true,
      "37190": true,
      "37199": true,
      "37200": true,
      "37204": true,
      "37205": true,
      "37207": true,
      "37208": true,
      "37209": true,
      "37210": true,
      "37217": true,
      "37218": true,
      "37219": true,
      "37220": true,
      "37225": true,
      "37227": true,
      "37230": true,
      "37233": true,
      "37234": true,
      "37235": true,
      "37236": true,
      "37237": true,
      "37238": true,
      "37239": true,
      "37240": true,
      "37249": true,
      "37250": true,
      "37257": true,
      "37258": true,
      "37259": true,
      "37260": true,
      "37266": true,
      "37267": true,
      "37268": true,
      "37269": true,
      "37270": true,
      "37276": true,
      "37277": true,
      "37278": true,
      "37279": true,
      "37280": true,
      "37287": true,
      "37288": true,
      "37289": true,
      "37290": true,
      "37293": true,
      "37294": true,
      "37295": true,
      "37296": true,
      "37297": true,
      "37298": true,
      "37299": true,
      "37300": true,
      "37306": true,
      "37310": true,
      "37315": true,
      "37316": true,
      "37317": true,
      "37318": true,
      "37319": true,
      "37320": true,
      "37327": true,
      "37328": true,
      "37330": true,
      "37340": true,
      "37350": true,
      "37353": true,
      "37355": true,
      "37357": true,
      "37358": true,
      "37359": true,
      "37360": true,
      "37364": true,
      "37366": true,
      "37368": true,
      "37369": true,
      "37380": true,
      "37390": true,
      "37399": true,
      "37400": true,
      "37407": true,
      "37408": true,
      "37410": true,
      "37414": true,
      "37415": true,
      "37416": true,
      "37417": true,
      "37418": true,
      "37419": true,
      "37420": true,
      "37425": true,
      "37426": true,
      "37427": true,
      "37428": true,
      "37430": true,
      "37433": true,
      "37434": true,
      "37436": true,
      "37438": true,
      "37439": true,
      "37440": true,
      "37443": true,
      "37444": true,
      "37446": true,
      "37448": true,
      "37450": true,
      "37455": true,
      "37456": true,
      "37457": true,
      "37458": true,
      "37459": true,
      "37460": true,
      "37468": true,
      "37470": true,
      "37477": true,
      "37478": true,
      "37479": true,
      "37480": true,
      "37487": true,
      "37490": true,
      "37500": true,
      "37510": true,
      "37520": true,
      "37526": true,
      "37530": true,
      "37536": true,
      "37538": true,
      "37539": true,
      "37544": true,
      "37545": true,
      "37547": true,
      "37548": true,
      "37549": true,
      "37550": true,
      "37555": true,
      "37557": true,
      "37560": true,
      "37564": true,
      "37566": true,
      "37570": true,
      "37580": true,
      "37590": true,
      "37650": true,
      "37653": true,
      "37654": true,
      "37655": true,
      "37660": true,
      "37664": true,
      "37665": true,
      "37666": true,
      "37667": true,
      "37668": true,
      "37669": true,
      "37670": true,
      "37673": true,
      "37674": true,
      "37675": true,
      "37676": true,
      "37677": true,
      "37680": true,
      "37683": true,
      "37684": true,
      "37685": true,
      "37686": true,
      "37687": true,
      "37688": true,
      "37689": true,
      "37690": true,
      "37693": true,
      "37696": true,
      "37697": true,
      "37698": true
    },
    "MANUEL DOBLADO": {
      "36470": true,
      "36473": true,
      "36474": true,
      "36475": true,
      "36476": true,
      "36477": true,
      "36480": true,
      "36483": true,
      "36484": true,
      "36485": true,
      "36486": true,
      "36487": true,
      "36490": true,
      "36493": true,
      "36494": true,
      "36496": true,
      "36497": true
    },
    "MOROLEON": {
      "38800": true,
      "38810": true,
      "38817": true,
      "38820": true,
      "38823": true,
      "38825": true,
      "38826": true,
      "38827": true,
      "38830": true,
      "38833": true,
      "38834": true,
      "38835": true,
      "38836": true,
      "38837": true,
      "38838": true,
      "38840": true,
      "38844": true,
      "38845": true,
      "38848": true,
      "38850": true,
      "38853": true,
      "38854": true,
      "38855": true,
      "38860": true,
      "38863": true,
      "38864": true,
      "38865": true,
      "38866": true,
      "38867": true,
      "38868": true,
      "38870": true,
      "38873": true,
      "38874": true,
      "38880": true,
      "38887": true,
      "38990": true,
      "38993": true,
      "38994": true,
      "38995": true,
      "38996": true,
      "38997": true
    },
    "OCAMPO": {
      "37630": true,
      "37631": true,
      "37632": true,
      "37634": true,
      "37636": true,
      "37642": true,
      "37645": true
    },
    "PENJAMO": {
      "36900": true,
      "36903": true,
      "36904": true,
      "36905": true,
      "36906": true,
      "36907": true,
      "36910": true,
      "36923": true,
      "36924": true,
      "36925": true,
      "36926": true,
      "36927": true,
      "36930": true,
      "36933": true,
      "36935": true,
      "36936": true,
      "36937": true,
      "36938": true,
      "36943": true,
      "36946": true,
      "36947": true,
      "36948": true
    },
    "PUEBLO NUEVO": {
      "36890": true,
      "36893": true,
      "36894": true,
      "36895": true,
      "36896": true,
      "36897": true
    },
    "PURISIMA DEL RINCON": {
      "36400": true,
      "36403": true,
      "36404": true,
      "36405": true,
      "36406": true,
      "36407": true,
      "36410": true,
      "36413": true,
      "36414": true,
      "36415": true,
      "36416": true,
      "36417": true,
      "36418": true,
      "36420": true,
      "36423": true,
      "36424": true,
      "36425": true,
      "36426": true,
      "36427": true,
      "36433": true,
      "36436": true
    },
    "ROMITA": {
      "36200": true,
      "36203": true,
      "36204": true,
      "36205": true,
      "36206": true,
      "36207": true,
      "36210": true,
      "36212": true,
      "36213": true,
      "36214": true,
      "36215": true,
      "36216": true,
      "36217": true,
      "36218": true
    },
    "SALAMANCA": {
      "36700": true,
      "36704": true,
      "36710": true,
      "36714": true,
      "36715": true,
      "36717": true,
      "36720": true,
      "36722": true,
      "36723": true,
      "36724": true,
      "36726": true,
      "36730": true,
      "36732": true,
      "36733": true,
      "36740": true,
      "36743": true,
      "36744": true,
      "36747": true,
      "36748": true,
      "36749": true,
      "36750": true,
      "36752": true,
      "36753": true,
      "36754": true,
      "36759": true,
      "36760": true,
      "36764": true,
      "36765": true,
      "36766": true,
      "36770": true,
      "36773": true,
      "36774": true,
      "36775": true,
      "36776": true,
      "36777": true,
      "36778": true,
      "36780": true,
      "36782": true,
      "36783": true,
      "36784": true,
      "36785": true,
      "36786": true,
      "36787": true,
      "36790": true,
      "36793": true,
      "36850": true,
      "36853": true,
      "36854": true,
      "36855": true,
      "36856": true,
      "36857": true,
      "36860": true,
      "36863": true,
      "36864": true,
      "36865": true,
      "36866": true,
      "36867": true,
      "36870": true,
      "36873": true,
      "36874": true,
      "36875": true,
      "36876": true,
      "36877": true,
      "36878": true,
      "36880": true,
      "36883": true,
      "36884": true,
      "36885": true,
      "36886": true,
      "36887": true,
      "36888": true
    },
    "SALVATIERRA": {
      "38900": true,
      "38903": true,
      "38904": true,
      "38905": true,
      "38910": true,
      "38911": true,
      "38912": true,
      "38914": true,
      "38915": true,
      "38919": true,
      "38920": true,
      "38921": true,
      "38930": true,
      "38931": true,
      "38932": true,
      "38933": true
    },
    "SAN FELIPE": {
      "37600": true,
      "37603": true,
      "37604": true,
      "37605": true,
      "37606": true,
      "37610": true,
      "37611": true,
      "37614": true,
      "37615": true,
      "37616": true
    },
    "SAN FRANCISCO DEL RINCON": {
      "36300": true,
      "36310": true,
      "36312": true,
      "36313": true,
      "36314": true,
      "36315": true,
      "36320": true,
      "36322": true,
      "36330": true,
      "36333": true,
      "36340": true,
      "36342": true,
      "36350": true,
      "36352": true,
      "36353": true,
      "36354": true,
      "36360": true,
      "36361": true,
      "36364": true,
      "36365": true,
      "36369": true,
      "36370": true,
      "36372": true,
      "36380": true,
      "36390": true,
      "36394": true,
      "36440": true,
      "36441": true,
      "36443": true,
      "36444": true,
      "36445": true,
      "36446": true,
      "36447": true,
      "36450": true,
      "36452": true,
      "36453": true,
      "36456": true,
      "36460": true,
      "36462": true,
      "36463": true,
      "36464": true,
      "36465": true,
      "36466": true,
      "36467": true,
      "36468": true
    },
    "SAN JOSE ITURBIDE": {
      "37980": true,
      "37983": true,
      "37984": true,
      "37985": true,
      "37986": true,
      "37987": true,
      "37988": true,
      "37990": true,
      "37991": true,
      "37993": true,
      "37994": true,
      "37995": true,
      "37996": true,
      "37997": true,
      "37998": true
    },
    "SAN LUIS DE LA PAZ": {
      "37900": true,
      "37903": true,
      "37904": true,
      "37905": true,
      "37906": true,
      "37907": true,
      "37914": true,
      "37915": true,
      "37917": true
    },
    "SAN MIGUEL DE ALLENDE": {
      "37700": true,
      "37710": true,
      "37713": true,
      "37715": true,
      "37716": true,
      "37717": true,
      "37718": true,
      "37720": true,
      "37725": true,
      "37727": true,
      "37728": true,
      "37729": true,
      "37730": true,
      "37732": true,
      "37733": true,
      "37734": true,
      "37736": true,
      "37737": true,
      "37738": true,
      "37740": true,
      "37745": true,
      "37746": true,
      "37747": true,
      "37748": true,
      "37749": true,
      "37750": true,
      "37753": true,
      "37754": true,
      "37755": true,
      "37756": true,
      "37759": true,
      "37760": true,
      "37765": true,
      "37766": true,
      "37769": true,
      "37770": true,
      "37773": true,
      "37774": true,
      "37775": true,
      "37776": true,
      "37777": true,
      "37790": true,
      "37793": true,
      "37795": true,
      "37796": true,
      "37797": true,
      "37880": true,
      "37883": true,
      "37884": true,
      "37885": true,
      "37886": true,
      "37887": true,
      "37888": true,
      "37890": true,
      "37892": true,
      "37893": true,
      "37894": true,
      "37896": true,
      "37897": true,
      "37898": true
    },
    "SANTA CRUZ DE JUVENTINO ROSAS": {
      "38240": true,
      "38243": true,
      "38244": true,
      "38245": true,
      "38246": true,
      "38247": true,
      "38250": true,
      "38253": true,
      "38254": true,
      "38255": true,
      "38256": true
    },
    "SANTIAGO MARAVATIO": {
      "38970": true,
      "38973": true,
      "38974": true,
      "38975": true,
      "38977": true,
      "38978": true
    },
    "SILAO DE LA VICTORIA": {
      "36100": true,
      "36110": true,
      "36112": true,
      "36113": true,
      "36118": true,
      "36119": true,
      "36120": true,
      "36122": true,
      "36125": true,
      "36126": true,
      "36127": true,
      "36129": true,
      "36130": true,
      "36132": true,
      "36133": true,
      "36135": true,
      "36140": true,
      "36142": true,
      "36143": true,
      "36149": true,
      "36150": true,
      "36155": true,
      "36156": true,
      "36158": true,
      "36159": true,
      "36160": true,
      "36169": true,
      "36170": true,
      "36172": true,
      "36270": true,
      "36273": true,
      "36274": true,
      "36275": true,
      "36276": true,
      "36277": true,
      "36278": true,
      "36279": true,
      "36280": true,
      "36283": true,
      "36284": true,
      "36285": true,
      "36286": true,
      "36287": true,
      "36288": true,
      "36290": true,
      "36293": true,
      "36294": true,
      "36295": true,
      "36296": true,
      "36297": true,
      "36298": true
    },
    "TARANDACUAO": {
      "38790": true,
      "38793": true,
      "38794": true,
      "38795": true,
      "38796": true,
      "38797": true,
      "38798": true
    },
    "TARIMORO": {
      "38700": true,
      "38701": true,
      "38702": true,
      "38703": true,
      "38704": true,
      "38705": true,
      "38706": true,
      "38708": true,
      "38709": true,
      "38710": true,
      "38714": true,
      "38715": true,
      "38716": true,
      "38717": true,
      "38720": true,
      "38724": true,
      "38725": true
    },
    "URIANGATO": {
      "38980": true,
      "38982": true,
      "38983": true,
      "38984": true,
      "38985": true,
      "38986": true,
      "38987": true,
      "38988": true,
      "38989": true
    },
    "VALLE DE SANTIAGO": {
      "38400": true,
      "38403": true,
      "38404": true,
      "38405": true,
      "38406": true,
      "38407": true,
      "38410": true,
      "38413": true,
      "38414": true,
      "38415": true,
      "38416": true,
      "38417": true,
      "38420": true,
      "38423": true,
      "38424": true,
      "38425": true,
      "38426": true,
      "38427": true,
      "38430": true,
      "38434": true,
      "38435": true,
      "38440": true,
      "38443": true,
      "38446": true,
      "38447": true,
      "38450": true,
      "38453": true,
      "38455": true,
      "38456": true,
      "38457": true,
      "38460": true,
      "38464": true
    },
    "VILLAGRAN": {
      "38260": true,
      "38263": true,
      "38265": true,
      "38269": true,
      "38271": true,
      "38272": true,
      "38273": true,
      "38280": true,
      "38290": true,
      "38291": true,
      "38293": true,
      "38294": true,
      "38295": true
    },
    "YURIRIA": {
      "38940": true,
      "38943": true,
      "38944": true,
      "38945": true,
      "38946": true,
      "38947": true,
      "38950": true,
      "38953": true,
      "38954": true,
      "38955": true,
      "38956": true,
      "38957": true,
      "38960": true,
      "38961": true,
      "38963": true,
      "38964": true,
      "38965": true,
      "38966": true,
      "38967": true
    }
  },
  "GUERRERO": {
    "ACAPULCO DE JUAREZ": {
      "39300": true,
      "39350": true,
      "39355": true,
      "39360": true,
      "39370": true,
      "39390": true,
      "39405": true,
      "39406": true,
      "39407": true,
      "39412": true,
      "39422": true,
      "39430": true,
      "39450": true,
      "39460": true,
      "39463": true,
      "39470": true,
      "39480": true,
      "39500": true,
      "39510": true,
      "39528": true,
      "39530": true,
      "39540": true,
      "39550": true,
      "39560": true,
      "39573": true,
      "39574": true,
      "39580": true,
      "39589": true,
      "39590": true,
      "39600": true,
      "39610": true,
      "39613": true,
      "39620": true,
      "39630": true,
      "39640": true,
      "39650": true,
      "39660": true,
      "39670": true,
      "39679": true,
      "39680": true,
      "39689": true,
      "39690": true,
      "39699": true,
      "39700": true,
      "39703": true,
      "39704": true,
      "39710": true,
      "39713": true,
      "39714": true,
      "39715": true,
      "39720": true,
      "39730": true,
      "39740": true,
      "39745": true,
      "39746": true,
      "39747": true,
      "39750": true,
      "39753": true,
      "39759": true,
      "39760": true,
      "39770": true,
      "39773": true,
      "39774": true,
      "39780": true,
      "39787": true,
      "39790": true,
      "39799": true,
      "39800": true,
      "39803": true,
      "39810": true,
      "39813": true,
      "39814": true,
      "39815": true,
      "39820": true,
      "39830": true,
      "39840": true,
      "39845": true,
      "39850": true,
      "39859": true,
      "39860": true,
      "39865": true,
      "39867": true,
      "39869": true,
      "39880": true,
      "39887": true,
      "39888": true,
      "39890": true,
      "39893": true,
      "39897": true,
      "39898": true,
      "39899": true,
      "39900": true,
      "39901": true,
      "39903": true,
      "39904": true,
      "39905": true,
      "39906": true,
      "39908": true,
      "39909": true,
      "39910": true,
      "39911": true,
      "39914": true,
      "39917": true,
      "39918": true,
      "39919": true,
      "39920": true,
      "39921": true,
      "39922": true,
      "39923": true,
      "39924": true,
      "39925": true,
      "39926": true,
      "39927": true,
      "39928": true,
      "39930": true,
      "39931": true,
      "39932": true,
      "39934": true,
      "39935": true,
      "39936": true,
      "39937": true
    },
    "ATOYAC DE ALVAREZ": {
      "40930": true,
      "40932": true,
      "40933": true,
      "40934": true,
      "40935": true,
      "40936": true,
      "40937": true,
      "40938": true,
      "40939": true,
      "40941": true,
      "40942": true,
      "40947": true,
      "40952": true,
      "40955": true
    },
    "AYUTLA DE LOS LIBRES": {
      "39200": true,
      "39202": true,
      "39203": true,
      "39204": true,
      "39205": true,
      "39207": true,
      "39208": true,
      "39212": true,
      "39215": true,
      "39217": true,
      "39220": true,
      "39221": true,
      "39223": true,
      "39225": true
    },
    "BENITO JUÁREZ": {
      "40960": true,
      "40961": true,
      "40962": true,
      "40963": true,
      "40964": true,
      "40966": true,
      "40967": true,
      "40968": true
    },
    "BUENAVISTA DE CUELLAR": {
      "40330": true,
      "40333": true,
      "40334": true,
      "40335": true,
      "40336": true,
      "40337": true,
      "40338": true,
      "40341": true,
      "40342": true,
      "40348": true,
      "40350": true,
      "40351": true,
      "40352": true,
      "40355": true
    },
    "CHILAPA DE ALVAREZ": {
      "41100": true,
      "41103": true,
      "41104": true,
      "41105": true,
      "41106": true,
      "41107": true,
      "41109": true,
      "41110": true,
      "41113": true,
      "41114": true,
      "41115": true,
      "41118": true
    },
    "CHILPANCINGO DE LOS BRAVO": {
      "39000": true,
      "39010": true,
      "39012": true,
      "39013": true,
      "39014": true,
      "39015": true,
      "39016": true,
      "39017": true,
      "39018": true,
      "39020": true,
      "39022": true,
      "39025": true,
      "39026": true,
      "39028": true,
      "39029": true,
      "39030": true,
      "39034": true,
      "39036": true,
      "39038": true,
      "39040": true,
      "39043": true,
      "39044": true,
      "39047": true,
      "39048": true,
      "39050": true,
      "39056": true,
      "39058": true,
      "39060": true,
      "39068": true,
      "39069": true,
      "39070": true,
      "39073": true,
      "39074": true,
      "39075": true,
      "39076": true,
      "39077": true,
      "39078": true,
      "39079": true,
      "39080": true,
      "39085": true,
      "39086": true,
      "39087": true,
      "39089": true,
      "39090": true,
      "39093": true,
      "39094": true,
      "39095": true,
      "39096": true,
      "39097": true,
      "39098": true,
      "39100": true,
      "39101": true,
      "39102": true,
      "39103": true,
      "39104": true,
      "39105": true,
      "39107": true,
      "39110": true,
      "39111": true,
      "39112": true,
      "39113": true,
      "39115": true,
      "39116": true,
      "39118": true,
      "39119": true,
      "39120": true,
      "39122": true,
      "39123": true,
      "39125": true,
      "39126": true,
      "39127": true,
      "39128": true,
      "39129": true
    },
    "COCULA": {
      "40580": true,
      "40582": true,
      "40583": true,
      "40584": true,
      "40585": true,
      "40586": true,
      "40590": true,
      "40598": true,
      "40599": true
    },
    "COPALA": {
      "41870": true,
      "41872": true,
      "41873": true,
      "41874": true,
      "41875": true,
      "41879": true,
      "41880": true,
      "41887": true,
      "41890": true,
      "41892": true
    },
    "COYUCA DE BENITEZ": {
      "40970": true,
      "40972": true,
      "40973": true,
      "40974": true,
      "40976": true,
      "40977": true,
      "40978": true,
      "40980": true,
      "40982": true,
      "40983": true,
      "40984": true,
      "40985": true,
      "40986": true,
      "40987": true,
      "40988": true,
      "40989": true
    },
    "EDUARDO NERI": {
      "40180": true,
      "40181": true,
      "40182": true,
      "40185": true,
      "40186": true,
      "40187": true,
      "40188": true,
      "40189": true,
      "40190": true,
      "40191": true,
      "40192": true,
      "40193": true,
      "40194": true,
      "40195": true,
      "40196": true,
      "40199": true
    },
    "FLORENCIO VILLARREAL": {
      "41800": true,
      "41811": true,
      "41820": true,
      "41821": true,
      "41828": true,
      "41829": true,
      "41830": true
    },
    "HUITZUCO DE LOS FIGUEROA": {
      "40130": true,
      "40132": true,
      "40133": true,
      "40134": true,
      "40141": true,
      "40142": true
    },
    "IGUALA DE LA INDEPENDENCIA": {
      "40000": true,
      "40010": true,
      "40011": true,
      "40013": true,
      "40014": true,
      "40015": true,
      "40020": true,
      "40023": true,
      "40024": true,
      "40025": true,
      "40026": true,
      "40027": true,
      "40030": true,
      "40033": true,
      "40034": true,
      "40036": true,
      "40040": true,
      "40044": true,
      "40045": true,
      "40046": true,
      "40050": true,
      "40053": true,
      "40054": true,
      "40060": true,
      "40066": true,
      "40067": true,
      "40068": true,
      "40070": true,
      "40080": true,
      "40083": true,
      "40090": true,
      "40095": true,
      "40096": true,
      "40097": true,
      "40099": true,
      "40100": true,
      "40101": true,
      "40102": true,
      "40104": true,
      "40105": true,
      "40106": true,
      "40109": true,
      "40110": true,
      "40111": true,
      "40112": true,
      "40113": true,
      "40114": true
    },
    "ILIATENCO": {
      "41530": true,
      "41533": true,
      "41535": true,
      "41536": true,
      "41537": true,
      "41538": true
    },
    "JOSE JOAQUIN DE HERRERA": {
      "41120": true,
      "41122": true,
      "41123": true,
      "41124": true,
      "41125": true,
      "41126": true,
      "41127": true
    },
    "JUAN R. ESCUDERO": {
      "39940": true,
      "39941": true,
      "39942": true,
      "39944": true,
      "39946": true,
      "39956": true,
      "39957": true,
      "39958": true,
      "39959": true
    },
    "LEONARDO BRAVO": {
      "39150": true,
      "39151": true,
      "39154": true,
      "39159": true,
      "39163": true
    },
    "MARTIR DE CUILAPAN": {
      "41180": true,
      "41191": true,
      "41193": true,
      "41194": true,
      "41197": true
    },
    "MOCHITLAN": {
      "39230": true,
      "39232": true,
      "39233": true,
      "39234": true,
      "39235": true,
      "39241": true
    },
    "OMETEPEC": {
      "41700": true,
      "41701": true,
      "41702": true,
      "41703": true,
      "41704": true,
      "41705": true,
      "41710": true,
      "41711": true,
      "41713": true,
      "41725": true,
      "41730": true,
      "41731": true,
      "41733": true,
      "41734": true,
      "41735": true
    },
    "PETATLAN": {
      "40830": true,
      "40831": true,
      "40832": true,
      "40833": true,
      "40837": true,
      "40840": true,
      "40841": true,
      "40847": true,
      "40849": true,
      "40850": true,
      "40852": true,
      "40853": true,
      "40854": true,
      "40855": true
    },
    "QUECHULTENANGO": {
      "39250": true,
      "39252": true,
      "39253": true,
      "39255": true,
      "39256": true,
      "39260": true,
      "39261": true,
      "39263": true
    },
    "SAN MARCOS": {
      "39960": true,
      "39964": true,
      "39965": true,
      "39966": true,
      "39968": true,
      "39969": true,
      "39970": true,
      "39971": true,
      "39972": true,
      "39980": true,
      "39981": true,
      "39982": true,
      "39983": true,
      "39985": true,
      "39989": true,
      "39990": true,
      "39992": true,
      "39993": true,
      "39994": true,
      "39995": true,
      "39996": true
    },
    "TAXCO DE ALARCON": {
      "40200": true,
      "40210": true,
      "40212": true,
      "40213": true,
      "40214": true,
      "40220": true,
      "40221": true,
      "40222": true,
      "40223": true,
      "40224": true,
      "40225": true,
      "40226": true,
      "40227": true,
      "40230": true,
      "40233": true,
      "40238": true,
      "40239": true,
      "40240": true,
      "40250": true,
      "40252": true,
      "40253": true,
      "40254": true,
      "40260": true,
      "40270": true,
      "40272": true,
      "40273": true,
      "40274": true,
      "40275": true,
      "40280": true,
      "40283": true,
      "40289": true,
      "40290": true,
      "40293": true,
      "40300": true,
      "40301": true,
      "40305": true,
      "40306": true,
      "40310": true,
      "40311": true,
      "40312": true,
      "40313": true,
      "40314": true,
      "40315": true,
      "40316": true,
      "40320": true,
      "40321": true,
      "40322": true,
      "40323": true,
      "40325": true,
      "40327": true,
      "40329": true
    },
    "TECOANAPA": {
      "39270": true,
      "39271": true,
      "39272": true,
      "39273": true,
      "39274": true,
      "39275": true,
      "39277": true,
      "39279": true,
      "39280": true,
      "39281": true,
      "39282": true,
      "39283": true,
      "39286": true,
      "39287": true,
      "39294": true,
      "39299": true
    },
    "TECPAN DE GALEANA": {
      "40900": true,
      "40902": true,
      "40903": true,
      "40904": true,
      "40905": true,
      "40906": true,
      "40908": true,
      "40913": true,
      "40914": true,
      "40922": true,
      "40928": true,
      "40929": true
    },
    "TELOLOAPAN": {
      "40400": true,
      "40402": true,
      "40406": true,
      "40410": true,
      "40413": true,
      "40418": true,
      "40420": true,
      "40421": true,
      "40422": true,
      "40425": true,
      "40428": true
    },
    "TEPECOACUILCO DE TRUJANO": {
      "40160": true,
      "40162": true,
      "40164": true,
      "40165": true,
      "40166": true,
      "40174": true
    },
    "TIXTLA DE GUERRERO": {
      "39170": true,
      "39172": true,
      "39173": true,
      "39174": true,
      "39175": true,
      "39177": true,
      "39179": true,
      "39180": true,
      "39183": true,
      "39193": true,
      "39195": true,
      "39196": true
    },
    "TLAPA DE COMONFORT": {
      "41300": true,
      "41302": true,
      "41303": true,
      "41304": true,
      "41305": true,
      "41320": true,
      "41322": true,
      "41327": true,
      "41328": true,
      "41330": true,
      "41347": true,
      "41349": true
    },
    "ZIHUATANEJO DE AZUETA": {
      "40880": true,
      "40881": true,
      "40882": true,
      "40883": true,
      "40886": true,
      "40888": true,
      "40889": true,
      "40890": true,
      "40893": true,
      "40894": true,
      "40895": true,
      "40896": true,
      "40897": true
    },
    "ZITLALA": {
      "41160": true,
      "41161": true,
      "41163": true,
      "41164": true,
      "41165": true,
      "41166": true,
      "41167": true,
      "41168": true,
      "41169": true,
      "41179": true
    }
  },
  "HIDALGO": {
    "ACATLAN": {
      "43540": true,
      "43542": true,
      "43543": true,
      "43544": true,
      "43545": true,
      "43547": true,
      "43550": true,
      "43553": true,
      "43554": true,
      "43558": true,
      "43559": true
    },
    "ACAXOCHITLAN": {
      "43720": true,
      "43721": true,
      "43723": true,
      "43725": true,
      "43726": true,
      "43728": true,
      "43730": true,
      "43731": true,
      "43733": true,
      "43734": true,
      "43735": true,
      "43736": true,
      "43739": true
    },
    "ACTOPAN": {
      "42500": true,
      "42503": true,
      "42504": true,
      "42505": true,
      "42506": true,
      "42507": true,
      "42510": true,
      "42512": true,
      "42523": true,
      "42524": true,
      "42600": true,
      "42601": true,
      "42602": true,
      "42603": true,
      "42604": true,
      "42608": true,
      "42610": true,
      "42613": true,
      "42616": true
    },
    "AGUA BLANCA DE ITURBIDE": {
      "43460": true,
      "43463": true,
      "43464": true,
      "43468": true,
      "43469": true,
      "43470": true,
      "43473": true,
      "43474": true
    },
    "AJACUBA": {
      "42150": true,
      "42151": true,
      "42152": true,
      "42153": true,
      "42154": true,
      "42156": true,
      "42157": true
    },
    "ALMOLOYA": {
      "43940": true,
      "43943": true,
      "43944": true,
      "43945": true,
      "43946": true,
      "43947": true,
      "43950": true,
      "43953": true,
      "43954": true,
      "43955": true,
      "43956": true
    },
    "APAN": {
      "43900": true,
      "43902": true,
      "43904": true,
      "43905": true,
      "43906": true,
      "43907": true,
      "43908": true,
      "43909": true,
      "43915": true,
      "43916": true,
      "43917": true,
      "43918": true,
      "43920": true,
      "43921": true,
      "43922": true,
      "43923": true,
      "43924": true
    },
    "ATITALAQUIA": {
      "42970": true,
      "42975": true,
      "42976": true,
      "42977": true,
      "42978": true
    },
    "ATOTONILCO DE TULA": {
      "42980": true,
      "42982": true,
      "42985": true,
      "42986": true,
      "42987": true,
      "42988": true,
      "42990": true,
      "42992": true,
      "42993": true,
      "42994": true,
      "42995": true
    },
    "ATOTONILCO EL GRANDE": {
      "43300": true,
      "43301": true,
      "43302": true,
      "43304": true,
      "43305": true,
      "43306": true,
      "43307": true,
      "43308": true,
      "43309": true,
      "43310": true,
      "43313": true,
      "43320": true,
      "43321": true,
      "43324": true,
      "43328": true
    },
    "CHILCUAUTLA": {
      "42750": true,
      "42752": true,
      "42753": true,
      "42755": true,
      "42757": true
    },
    "CUAUTEPEC DE HINOJOSA": {
      "43740": true,
      "43745": true,
      "43746": true,
      "43748": true,
      "43750": true
    },
    "EL ARENAL": {
      "42680": true,
      "42682": true,
      "42683": true,
      "42684": true,
      "42685": true,
      "42686": true,
      "42689": true,
      "42690": true,
      "42693": true,
      "42694": true,
      "42695": true
    },
    "EMILIANO ZAPATA": {
      "43960": true,
      "43961": true,
      "43963": true,
      "43964": true,
      "43965": true,
      "43966": true
    },
    "EPAZOYUCAN": {
      "43580": true,
      "43583": true,
      "43584": true,
      "43585": true,
      "43586": true,
      "43587": true,
      "43590": true,
      "43592": true,
      "43593": true,
      "43594": true,
      "43595": true,
      "43596": true
    },
    "FRANCISCO I. MADERO": {
      "42660": true,
      "42663": true,
      "42664": true,
      "42665": true,
      "42666": true,
      "42667": true,
      "42670": true,
      "42671": true,
      "42672": true,
      "42673": true
    },
    "HUASCA DE OCAMPO": {
      "43500": true,
      "43503": true,
      "43510": true,
      "43514": true,
      "43515": true,
      "43516": true,
      "43517": true,
      "43525": true
    },
    "HUEJUTLA DE REYES": {
      "43000": true,
      "43001": true,
      "43002": true,
      "43004": true,
      "43005": true,
      "43006": true,
      "43011": true,
      "43014": true,
      "43015": true,
      "43016": true,
      "43018": true,
      "43019": true
    },
    "HUICHAPAN": {
      "42400": true,
      "42403": true,
      "42404": true,
      "42405": true,
      "42410": true,
      "42412": true,
      "42413": true,
      "42414": true,
      "42416": true,
      "42422": true,
      "42424": true,
      "42430": true,
      "42433": true,
      "42434": true,
      "42435": true,
      "42436": true,
      "42437": true,
      "42438": true,
      "42439": true
    },
    "IXMIQUILPAN": {
      "42300": true,
      "42302": true,
      "42303": true,
      "42304": true,
      "42305": true,
      "42306": true,
      "42310": true,
      "42313": true,
      "42315": true,
      "42320": true,
      "42321": true,
      "42323": true,
      "42324": true,
      "42325": true,
      "42326": true,
      "42327": true
    },
    "JUAREZ HIDALGO": {
      "43190": true,
      "43191": true
    },
    "METEPEC": {
      "43400": true,
      "43401": true,
      "43403": true,
      "43404": true,
      "43406": true,
      "43407": true,
      "43408": true,
      "43409": true,
      "43410": true,
      "43411": true,
      "43412": true
    },
    "METZTITLAN": {
      "43350": true,
      "43353": true,
      "43354": true,
      "43355": true,
      "43356": true,
      "43357": true,
      "43358": true,
      "43360": true,
      "43361": true,
      "43362": true,
      "43370": true,
      "43371": true,
      "43374": true
    },
    "MINERAL DE LA REFORMA": {
      "42180": true,
      "42181": true,
      "42182": true,
      "42183": true,
      "42184": true,
      "42185": true,
      "42186": true,
      "42187": true,
      "42188": true
    },
    "MINERAL DEL CHICO": {
      "42120": true,
      "42122": true,
      "42123": true,
      "42124": true,
      "42125": true,
      "42127": true
    },
    "MINERAL DEL MONTE": {
      "42130": true,
      "42133": true,
      "42134": true,
      "42135": true,
      "42136": true,
      "42137": true,
      "42138": true,
      "42139": true,
      "42140": true,
      "42143": true,
      "42144": true,
      "42145": true,
      "42146": true,
      "42149": true
    },
    "MIXQUIAHUALA DE JUAREZ": {
      "42700": true,
      "42710": true,
      "42718": true,
      "42719": true,
      "42723": true,
      "42724": true,
      "42725": true,
      "42727": true,
      "42728": true,
      "42729": true
    },
    "OMITLAN DE JUAREZ": {
      "43560": true,
      "43563": true,
      "43564": true,
      "43565": true,
      "43567": true,
      "43568": true,
      "43569": true,
      "43570": true,
      "43571": true,
      "43573": true,
      "43574": true,
      "43575": true,
      "43576": true
    },
    "PACHUCA DE SOTO": {
      "42000": true,
      "42004": true,
      "42010": true,
      "42014": true,
      "42015": true,
      "42018": true,
      "42020": true,
      "42026": true,
      "42027": true,
      "42029": true,
      "42030": true,
      "42032": true,
      "42033": true,
      "42034": true,
      "42035": true,
      "42036": true,
      "42037": true,
      "42039": true,
      "42040": true,
      "42050": true,
      "42055": true,
      "42056": true,
      "42057": true,
      "42058": true,
      "42060": true,
      "42064": true,
      "42070": true,
      "42075": true,
      "42078": true,
      "42079": true,
      "42080": true,
      "42082": true,
      "42083": true,
      "42084": true,
      "42086": true,
      "42088": true,
      "42090": true,
      "42092": true,
      "42094": true,
      "42095": true,
      "42097": true,
      "42098": true,
      "42099": true,
      "42100": true,
      "42101": true,
      "42102": true,
      "42104": true,
      "42110": true,
      "42111": true,
      "42113": true,
      "42115": true,
      "42116": true,
      "42117": true,
      "42119": true
    },
    "PROGRESO DE OBREGON": {
      "42730": true,
      "42733": true,
      "42740": true,
      "42743": true,
      "42745": true,
      "42746": true,
      "42747": true,
      "42748": true
    },
    "SAN AGUSTIN METZQUITITLAN": {
      "43380": true,
      "43381": true,
      "43382": true,
      "43383": true,
      "43384": true,
      "43385": true,
      "43386": true,
      "43387": true,
      "43389": true,
      "43391": true
    },
    "SAN AGUSTIN TLAXIACA": {
      "42160": true,
      "42162": true,
      "42163": true,
      "42164": true,
      "42165": true,
      "42170": true,
      "42171": true,
      "42175": true,
      "42176": true,
      "42177": true,
      "42178": true,
      "42179": true
    },
    "SAN SALVADOR": {
      "42640": true,
      "42642": true,
      "42644": true,
      "42645": true,
      "42646": true,
      "42647": true,
      "42650": true,
      "42651": true,
      "42653": true,
      "42654": true,
      "42655": true,
      "42656": true
    },
    "SANTIAGO DE ANAYA": {
      "42620": true,
      "42621": true,
      "42622": true,
      "42623": true,
      "42624": true,
      "42625": true,
      "42626": true,
      "42627": true,
      "42629": true,
      "42630": true
    },
    "SANTIAGO TULANTEPEC DE LUGO GUERRERO": {
      "43760": true,
      "43762": true,
      "43763": true,
      "43764": true,
      "43767": true,
      "43770": true,
      "43773": true,
      "43774": true,
      "43775": true
    },
    "SINGUILUCAN": {
      "43780": true,
      "43782": true,
      "43783": true,
      "43784": true,
      "43785": true,
      "43786": true,
      "43787": true,
      "43788": true,
      "43790": true,
      "43793": true,
      "43794": true,
      "43795": true,
      "43797": true
    },
    "TASQUILLO": {
      "42380": true,
      "42381": true,
      "42382": true,
      "42383": true,
      "42386": true,
      "42387": true,
      "42389": true
    },
    "TEPEAPULCO": {
      "43970": true,
      "43973": true,
      "43974": true,
      "43975": true,
      "43976": true,
      "43977": true,
      "43980": true,
      "43983": true,
      "43985": true,
      "43986": true,
      "43987": true,
      "43988": true,
      "43989": true,
      "43990": true,
      "43991": true,
      "43993": true,
      "43994": true,
      "43995": true,
      "43996": true,
      "43997": true,
      "43998": true
    },
    "TEPEJI DEL RIO DE OCAMPO": {
      "42852": true,
      "42853": true,
      "42854": true,
      "42855": true,
      "42858": true,
      "42860": true,
      "42863": true,
      "42865": true,
      "42866": true,
      "42870": true,
      "42873": true,
      "42874": true,
      "42875": true,
      "42876": true,
      "42880": true,
      "42883": true,
      "42884": true,
      "42885": true,
      "42890": true,
      "42893": true,
      "42894": true,
      "42895": true
    },
    "TETEPANGO": {
      "42940": true,
      "42943": true,
      "42944": true,
      "42945": true
    },
    "TEZONTEPEC DE ALDAMA": {
      "42760": true,
      "42763": true,
      "42764": true,
      "42765": true,
      "42766": true,
      "42767": true,
      "42768": true,
      "42770": true,
      "42771": true,
      "42772": true,
      "42773": true,
      "42774": true,
      "42775": true,
      "42776": true,
      "42777": true
    },
    "TIZAYUCA": {
      "43800": true,
      "43802": true,
      "43803": true,
      "43804": true,
      "43806": true,
      "43807": true,
      "43808": true,
      "43810": true,
      "43815": true,
      "43816": true,
      "43817": true,
      "43820": true,
      "43823": true,
      "43824": true,
      "43825": true
    },
    "TLAHUELILPAN": {
      "42780": true,
      "42783": true,
      "42784": true,
      "42785": true,
      "42789": true,
      "42790": true,
      "42793": true,
      "42794": true,
      "42795": true,
      "42796": true
    },
    "TLANALAPA": {
      "43930": true,
      "43933": true,
      "43934": true,
      "43935": true,
      "43937": true
    },
    "TLAXCOAPAN": {
      "42950": true,
      "42952": true,
      "42953": true,
      "42954": true,
      "42955": true,
      "42956": true,
      "42957": true,
      "42960": true,
      "42963": true,
      "42964": true,
      "42965": true,
      "42967": true
    },
    "TOLCAYUCA": {
      "43860": true,
      "43862": true,
      "43863": true,
      "43864": true,
      "43865": true,
      "43866": true,
      "43867": true,
      "43870": true,
      "43873": true,
      "43875": true
    },
    "TULA DE ALLENDE": {
      "42800": true,
      "42803": true,
      "42804": true,
      "42805": true,
      "42806": true,
      "42807": true,
      "42808": true,
      "42809": true,
      "42810": true,
      "42812": true,
      "42813": true,
      "42814": true,
      "42815": true,
      "42816": true,
      "42820": true,
      "42823": true,
      "42824": true,
      "42825": true,
      "42826": true,
      "42827": true,
      "42830": true,
      "42831": true,
      "42832": true,
      "42833": true,
      "42834": true,
      "42835": true,
      "42836": true,
      "42837": true,
      "42838": true,
      "42840": true,
      "42842": true,
      "42843": true,
      "42844": true,
      "42845": true,
      "42846": true,
      "42847": true,
      "42848": true,
      "42849": true
    },
    "TULANCINGO DE BRAVO": {
      "43600": true,
      "43604": true,
      "43610": true,
      "43612": true,
      "43615": true,
      "43623": true,
      "43624": true,
      "43625": true,
      "43626": true,
      "43628": true,
      "43629": true,
      "43630": true,
      "43632": true,
      "43633": true,
      "43640": true,
      "43642": true,
      "43645": true,
      "43646": true,
      "43648": true,
      "43649": true,
      "43650": true,
      "43659": true,
      "43660": true,
      "43669": true,
      "43670": true,
      "43673": true,
      "43679": true,
      "43680": true,
      "43684": true,
      "43685": true,
      "43688": true,
      "43689": true,
      "43690": true,
      "43695": true,
      "43696": true,
      "43697": true,
      "43698": true,
      "43699": true,
      "43700": true,
      "43703": true,
      "43704": true,
      "43705": true,
      "43707": true,
      "43709": true,
      "43710": true,
      "43715": true
    },
    "VILLA DE TEZONTEPEC": {
      "43880": true,
      "43882": true,
      "43883": true,
      "43884": true,
      "43885": true,
      "43890": true,
      "43893": true,
      "43894": true,
      "43895": true,
      "43896": true,
      "43897": true
    },
    "ZACUALTIPAN DE ANGELES": {
      "43200": true,
      "43201": true,
      "43202": true,
      "43203": true,
      "43204": true,
      "43205": true,
      "43206": true,
      "43210": true,
      "43211": true,
      "43212": true,
      "43219": true,
      "43220": true,
      "43221": true,
      "43222": true,
      "43225": true
    },
    "ZAPOTLAN DE JUAREZ": {
      "42190": true,
      "42191": true,
      "42192": true,
      "42194": true,
      "42195": true,
      "42196": true,
      "42198": true
    },
    "ZEMPOALA": {
      "43830": true,
      "43831": true,
      "43832": true,
      "43833": true,
      "43834": true,
      "43835": true,
      "43836": true,
      "43837": true,
      "43838": true,
      "43840": true,
      "43841": true,
      "43844": true,
      "43845": true,
      "43846": true,
      "43848": true,
      "43851": true,
      "43852": true,
      "43854": true,
      "43855": true,
      "43859": true
    },
    "ZIMAPAN": {
      "42330": true,
      "42332": true,
      "42333": true,
      "42334": true,
      "42335": true,
      "42336": true,
      "42337": true,
      "42338": true,
      "42339": true,
      "42343": true,
      "42344": true,
      "42345": true,
      "42346": true,
      "42351": true,
      "42352": true,
      "42353": true,
      "42354": true,
      "42356": true,
      "42357": true,
      "42359": true
    }
  },
  "JALISCO": {
    "ACATIC": {
      "45470": true,
      "45473": true,
      "45474": true,
      "45475": true,
      "45476": true,
      "45477": true,
      "45478": true,
      "45479": true
    },
    "ACATLAN DE JUAREZ": {
      "45700": true,
      "45710": true,
      "45712": true,
      "45713": true,
      "45718": true,
      "45720": true,
      "45723": true,
      "45724": true
    },
    "AHUALULCO DE MERCADO": {
      "46730": true,
      "46732": true,
      "46733": true,
      "46734": true,
      "46735": true,
      "46736": true,
      "46737": true,
      "46738": true,
      "46740": true,
      "46745": true,
      "46746": true,
      "46749": true,
      "46750": true,
      "46757": true,
      "46758": true
    },
    "AMACUECA": {
      "49370": true,
      "49375": true,
      "49380": true,
      "49388": true
    },
    "AMATITAN": {
      "45380": true,
      "45390": true,
      "45398": true,
      "45399": true
    },
    "AMECA": {
      "46600": true,
      "46614": true,
      "46615": true,
      "46616": true,
      "46620": true,
      "46626": true,
      "46627": true,
      "46630": true,
      "46640": true,
      "46649": true,
      "46680": true,
      "46686": true,
      "46687": true,
      "46688": true,
      "46689": true,
      "46700": true,
      "46706": true,
      "46707": true,
      "46708": true,
      "46709": true,
      "46710": true,
      "46715": true,
      "46716": true,
      "46718": true,
      "46720": true,
      "46723": true,
      "46724": true,
      "46725": true,
      "46726": true,
      "46728": true,
      "46729": true
    },
    "ARANDAS": {
      "47180": true,
      "47182": true,
      "47183": true,
      "47184": true,
      "47185": true,
      "47186": true,
      "47187": true,
      "47188": true,
      "47189": true,
      "47196": true,
      "47197": true
    },
    "ATEMAJAC DE BRIZUELA": {
      "45790": true,
      "45796": true,
      "45798": true,
      "45799": true
    },
    "ATOTONILCO EL ALTO": {
      "47750": true,
      "47755": true,
      "47760": true,
      "47764": true,
      "47765": true,
      "47766": true,
      "47767": true,
      "47768": true,
      "47769": true,
      "47770": true,
      "47775": true,
      "47777": true,
      "47778": true,
      "47779": true
    },
    "ATOYAC": {
      "49200": true,
      "49220": true,
      "49224": true,
      "49225": true,
      "49228": true,
      "49229": true
    },
    "AUTLAN DE NAVARRO": {
      "48900": true,
      "48902": true,
      "48903": true,
      "48904": true,
      "48905": true,
      "48906": true,
      "48907": true,
      "48908": true,
      "48909": true,
      "48910": true,
      "48914": true,
      "48915": true,
      "48916": true,
      "48917": true,
      "48918": true,
      "48919": true,
      "48920": true,
      "48922": true,
      "48923": true,
      "48926": true
    },
    "AYOTLAN": {
      "47930": true,
      "47934": true,
      "47935": true,
      "47936": true,
      "47938": true,
      "47940": true,
      "47945": true,
      "47947": true,
      "47948": true
    },
    "CABO CORRIENTES": {
      "48400": true,
      "48413": true,
      "48424": true,
      "48426": true,
      "48428": true,
      "48430": true,
      "48432": true,
      "48445": true,
      "48447": true,
      "48448": true
    },
    "CANADAS DE OBREGON": {
      "47360": true,
      "47369": true,
      "47370": true,
      "47373": true,
      "47374": true,
      "47378": true
    },
    "CASIMIRO CASTILLO": {
      "48930": true,
      "48938": true,
      "48939": true,
      "48940": true,
      "48942": true,
      "48943": true,
      "48944": true,
      "48945": true,
      "48946": true,
      "48947": true,
      "48948": true
    },
    "CHAPALA": {
      "45900": true,
      "45902": true,
      "45903": true,
      "45905": true,
      "45906": true,
      "45907": true,
      "45908": true,
      "45920": true,
      "45922": true,
      "45925": true,
      "45930": true,
      "45933": true,
      "45934": true,
      "45935": true,
      "45936": true,
      "45940": true,
      "45943": true,
      "45944": true,
      "45945": true,
      "45946": true
    },
    "CHIMALTITAN": {
      "46300": true,
      "46305": true,
      "46330": true
    },
    "CIHUATLAN": {
      "48970": true,
      "48972": true,
      "48973": true,
      "48974": true,
      "48980": true,
      "48983": true,
      "48985": true,
      "48987": true,
      "48988": true,
      "48990": true,
      "48995": true
    },
    "COCULA": {
      "48500": true,
      "48502": true,
      "48503": true,
      "48504": true,
      "48506": true,
      "48507": true,
      "48508": true,
      "48509": true,
      "48510": true,
      "48512": true,
      "48520": true,
      "48525": true,
      "48526": true,
      "48530": true,
      "48532": true
    },
    "COLOTLAN": {
      "46200": true,
      "46202": true,
      "46203": true,
      "46204": true,
      "46205": true,
      "46206": true,
      "46207": true,
      "46208": true,
      "46225": true,
      "46227": true,
      "46228": true,
      "46230": true,
      "46235": true,
      "46236": true,
      "46237": true,
      "46238": true,
      "46239": true
    },
    "CONCEPCION DE BUENOS AIRES": {
      "49170": true,
      "49175": true,
      "49176": true,
      "49177": true,
      "49178": true
    },
    "CUAUTITLAN DE GARCIA BARRAGAN": {
      "48950": true,
      "48953": true,
      "48954": true,
      "48955": true,
      "48959": true,
      "48962": true,
      "48963": true,
      "48965": true,
      "48966": true
    },
    "CUQUIO": {
      "45480": true,
      "45482": true,
      "45483": true,
      "45484": true,
      "45485": true,
      "45486": true,
      "45487": true,
      "45492": true,
      "45493": true,
      "45494": true,
      "45495": true,
      "45496": true
    },
    "DEGOLLADO": {
      "47980": true,
      "47983": true,
      "47984": true,
      "47986": true,
      "47987": true,
      "47988": true,
      "47989": true,
      "47990": true,
      "47993": true,
      "47995": true,
      "47996": true,
      "47997": true,
      "47998": true
    },
    "EL ARENAL": {
      "45350": true,
      "45353": true,
      "45355": true,
      "45359": true,
      "45360": true,
      "45364": true,
      "45368": true
    },
    "EL GRULLO": {
      "48740": true,
      "48742": true,
      "48743": true,
      "48744": true,
      "48745": true,
      "48747": true,
      "48748": true,
      "48750": true,
      "48753": true
    },
    "EL SALTO": {
      "45680": true,
      "45683": true,
      "45685": true,
      "45686": true,
      "45687": true,
      "45690": true,
      "45692": true,
      "45693": true,
      "45694": true,
      "45696": true
    },
    "ENCARNACION DE DIAZ": {
      "47270": true,
      "47276": true,
      "47280": true,
      "47282": true,
      "47285": true,
      "47290": true,
      "47293": true,
      "47294": true,
      "47295": true,
      "47296": true,
      "47298": true
    },
    "ETZATLAN": {
      "46500": true,
      "46506": true,
      "46520": true,
      "46525": true,
      "46530": true,
      "46532": true
    },
    "GOMEZ FARIAS": {
      "49120": true,
      "49123": true,
      "49124": true,
      "49126": true,
      "49130": true
    },
    "GUADALAJARA": {
      "44100": true,
      "44110": true,
      "44130": true,
      "44140": true,
      "44150": true,
      "44158": true,
      "44160": true,
      "44170": true,
      "44180": true,
      "44190": true,
      "44200": true,
      "44210": true,
      "44214": true,
      "44215": true,
      "44216": true,
      "44217": true,
      "44218": true,
      "44219": true,
      "44220": true,
      "44227": true,
      "44230": true,
      "44240": true,
      "44246": true,
      "44247": true,
      "44249": true,
      "44250": true,
      "44257": true,
      "44259": true,
      "44260": true,
      "44265": true,
      "44266": true,
      "44267": true,
      "44268": true,
      "44270": true,
      "44280": true,
      "44290": true,
      "44298": true,
      "44299": true,
      "44300": true,
      "44306": true,
      "44307": true,
      "44320": true,
      "44329": true,
      "44330": true,
      "44340": true,
      "44350": true,
      "44360": true,
      "44370": true,
      "44380": true,
      "44390": true,
      "44395": true,
      "44398": true,
      "44399": true,
      "44400": true,
      "44410": true,
      "44419": true,
      "44420": true,
      "44430": true,
      "44440": true,
      "44450": true,
      "44460": true,
      "44467": true,
      "44469": true,
      "44470": true,
      "44490": true,
      "44493": true,
      "44500": true,
      "44509": true,
      "44510": true,
      "44520": true,
      "44530": true,
      "44535": true,
      "44538": true,
      "44540": true,
      "44549": true,
      "44550": true,
      "44559": true,
      "44560": true,
      "44580": true,
      "44600": true,
      "44610": true,
      "44619": true,
      "44620": true,
      "44630": true,
      "44635": true,
      "44638": true,
      "44639": true,
      "44647": true,
      "44648": true,
      "44650": true,
      "44656": true,
      "44657": true,
      "44658": true,
      "44660": true,
      "44665": true,
      "44667": true,
      "44668": true,
      "44670": true,
      "44678": true,
      "44679": true,
      "44680": true,
      "44689": true,
      "44690": true,
      "44700": true,
      "44710": true,
      "44716": true,
      "44719": true,
      "44720": true,
      "44723": true,
      "44724": true,
      "44725": true,
      "44726": true,
      "44727": true,
      "44729": true,
      "44730": true,
      "44737": true,
      "44739": true,
      "44740": true,
      "44748": true,
      "44750": true,
      "44755": true,
      "44757": true,
      "44760": true,
      "44765": true,
      "44766": true,
      "44768": true,
      "44769": true,
      "44770": true,
      "44780": true,
      "44790": true,
      "44799": true,
      "44800": true,
      "44810": true,
      "44815": true,
      "44817": true,
      "44818": true,
      "44820": true,
      "44824": true,
      "44825": true,
      "44827": true,
      "44828": true,
      "44829": true,
      "44840": true,
      "44860": true,
      "44870": true,
      "44890": true,
      "44895": true,
      "44896": true,
      "44897": true,
      "44898": true,
      "44899": true,
      "44900": true,
      "44910": true,
      "44918": true,
      "44919": true,
      "44920": true,
      "44929": true,
      "44930": true,
      "44940": true,
      "44948": true,
      "44949": true,
      "44950": true,
      "44956": true,
      "44959": true,
      "44960": true,
      "44966": true,
      "44967": true,
      "44969": true,
      "44970": true,
      "44977": true,
      "44978": true,
      "44980": true,
      "44984": true,
      "44985": true,
      "44986": true,
      "44987": true,
      "44989": true,
      "44990": true
    },
    "IXTLAHUACAN DE LOS MEMBRILLOS": {
      "45850": true,
      "45857": true,
      "45860": true,
      "45870": true,
      "45875": true,
      "45876": true,
      "45877": true
    },
    "IXTLAHUACAN DEL RIO": {
      "45260": true,
      "45270": true,
      "45274": true,
      "45275": true,
      "45276": true,
      "45277": true,
      "45278": true,
      "45280": true,
      "45281": true,
      "45286": true,
      "45287": true,
      "45290": true,
      "45299": true
    },
    "JALOSTOTITLAN": {
      "47120": true,
      "47123": true,
      "47124": true,
      "47126": true,
      "47127": true,
      "47128": true,
      "47129": true,
      "47130": true,
      "47133": true,
      "47135": true,
      "47137": true,
      "47138": true,
      "47139": true
    },
    "JAMAY": {
      "47900": true,
      "47902": true,
      "47903": true,
      "47904": true,
      "47905": true,
      "47909": true
    },
    "JESÚS MARÍA": {
      "47950": true,
      "47952": true,
      "47955": true,
      "47956": true,
      "47957": true,
      "47958": true,
      "47959": true,
      "47960": true,
      "47964": true,
      "47965": true,
      "47974": true,
      "47975": true,
      "47977": true
    },
    "JOCOTEPEC": {
      "45800": true,
      "45802": true,
      "45803": true,
      "45804": true,
      "45805": true,
      "45806": true,
      "45810": true,
      "45811": true,
      "45812": true,
      "45815": true,
      "45816": true,
      "45820": true,
      "45822": true,
      "45825": true,
      "45830": true,
      "45840": true
    },
    "JUANACATLAN": {
      "45880": true,
      "45883": true,
      "45884": true,
      "45887": true,
      "45899": true
    },
    "LA BARCA": {
      "47910": true,
      "47912": true,
      "47913": true,
      "47914": true,
      "47915": true,
      "47916": true,
      "47917": true,
      "47918": true,
      "47920": true,
      "47924": true,
      "47925": true,
      "47926": true,
      "47927": true
    },
    "LA HUERTA": {
      "48850": true,
      "48862": true,
      "48869": true,
      "48870": true,
      "48872": true,
      "48878": true,
      "48880": true,
      "48890": true,
      "48892": true,
      "48893": true,
      "48896": true,
      "48898": true
    },
    "LA MANZANILLA DE LA PAZ": {
      "49460": true,
      "49462": true,
      "49463": true,
      "49470": true,
      "49490": true
    },
    "LAGOS DE MORENO": {
      "47400": true,
      "47410": true,
      "47420": true,
      "47423": true,
      "47425": true,
      "47430": true,
      "47433": true,
      "47440": true,
      "47443": true,
      "47450": true,
      "47457": true,
      "47460": true,
      "47463": true,
      "47470": true,
      "47472": true,
      "47473": true,
      "47474": true,
      "47476": true,
      "47479": true,
      "47480": true,
      "47490": true,
      "47504": true,
      "47513": true,
      "47514": true,
      "47515": true,
      "47520": true,
      "47525": true,
      "47528": true,
      "47530": true,
      "47532": true,
      "47533": true,
      "47534": true,
      "47535": true,
      "47536": true,
      "47537": true
    },
    "MAGDALENA": {
      "46470": true,
      "46472": true,
      "46473": true,
      "46474": true,
      "46475": true,
      "46476": true,
      "46480": true,
      "46488": true,
      "46489": true,
      "46490": true,
      "46495": true
    },
    "MASCOTA": {
      "46900": true,
      "46903": true,
      "46905": true,
      "46907": true,
      "46930": true,
      "46934": true,
      "46940": true,
      "46943": true
    },
    "MAZAMITLA": {
      "49500": true,
      "49510": true,
      "49514": true,
      "49515": true,
      "49516": true,
      "49520": true,
      "49530": true,
      "49532": true
    },
    "MEXTICACAN": {
      "47340": true,
      "47343": true,
      "47344": true,
      "47347": true,
      "47348": true,
      "47350": true,
      "47359": true
    },
    "OCOTLAN": {
      "47780": true,
      "47785": true,
      "47786": true,
      "47795": true,
      "47797": true,
      "47798": true,
      "47799": true,
      "47800": true,
      "47810": true,
      "47820": true,
      "47829": true,
      "47830": true,
      "47840": true,
      "47849": true,
      "47850": true,
      "47860": true,
      "47862": true,
      "47870": true,
      "47880": true,
      "47882": true,
      "47890": true,
      "47892": true,
      "47898": true,
      "47899": true
    },
    "OJUELOS DE JALISCO": {
      "47540": true,
      "47542": true,
      "47547": true,
      "47548": true,
      "47549": true,
      "47550": true,
      "47557": true,
      "47560": true,
      "47563": true,
      "47564": true,
      "47566": true
    },
    "PIHUAMO": {
      "49870": true,
      "49873": true,
      "49874": true,
      "49875": true,
      "49876": true,
      "49885": true,
      "49886": true,
      "49887": true,
      "49896": true,
      "49897": true
    },
    "PONCITLAN": {
      "45950": true,
      "45954": true,
      "45955": true,
      "45956": true,
      "45957": true,
      "45959": true,
      "45960": true,
      "45961": true,
      "45965": true,
      "45967": true,
      "45970": true,
      "45975": true,
      "45976": true,
      "45977": true,
      "45978": true,
      "45979": true
    },
    "PUERTO VALLARTA": {
      "48260": true,
      "48262": true,
      "48264": true,
      "48265": true,
      "48266": true,
      "48267": true,
      "48276": true,
      "48280": true,
      "48283": true,
      "48284": true,
      "48290": true,
      "48291": true,
      "48292": true,
      "48294": true,
      "48296": true,
      "48298": true,
      "48300": true,
      "48304": true,
      "48310": true,
      "48312": true,
      "48313": true,
      "48314": true,
      "48315": true,
      "48317": true,
      "48318": true,
      "48320": true,
      "48325": true,
      "48327": true,
      "48328": true,
      "48330": true,
      "48333": true,
      "48334": true,
      "48335": true,
      "48338": true,
      "48339": true,
      "48340": true,
      "48343": true,
      "48344": true,
      "48350": true,
      "48353": true,
      "48360": true,
      "48370": true,
      "48373": true,
      "48380": true,
      "48389": true,
      "48399": true
    },
    "SAN CRISTOBAL DE LA BARRANCA": {
      "45250": true,
      "45255": true,
      "45256": true,
      "45259": true
    },
    "SAN DIEGO DE ALEJANDRIA": {
      "47590": true,
      "47592": true,
      "47593": true,
      "47595": true,
      "47596": true,
      "47597": true,
      "47599": true
    },
    "SAN IGNACIO CERRO GORDO": {
      "47190": true,
      "47192": true,
      "47193": true,
      "47194": true,
      "47195": true
    },
    "SAN JUAN DE LOS LAGOS": {
      "47000": true,
      "47010": true,
      "47011": true,
      "47013": true,
      "47014": true,
      "47015": true,
      "47020": true,
      "47023": true,
      "47030": true,
      "47040": true,
      "47050": true,
      "47059": true,
      "47060": true,
      "47069": true,
      "47070": true,
      "47073": true,
      "47078": true,
      "47079": true,
      "47080": true,
      "47089": true,
      "47090": true,
      "47093": true,
      "47095": true,
      "47100": true,
      "47103": true,
      "47106": true,
      "47107": true,
      "47109": true,
      "47116": true,
      "47117": true,
      "47118": true
    },
    "SAN JUANITO DE ESCOBEDO": {
      "46560": true,
      "46565": true,
      "46566": true,
      "46570": true,
      "46572": true,
      "46573": true,
      "46574": true,
      "46580": true
    },
    "SAN JULIAN": {
      "47170": true,
      "47173": true,
      "47174": true,
      "47175": true,
      "47177": true,
      "47179": true
    },
    "SAN MARTIN DE BOLANOS": {
      "46350": true,
      "46360": true,
      "46370": true,
      "46380": true,
      "46385": true,
      "46386": true
    },
    "SAN MARTIN HIDALGO": {
      "46770": true,
      "46775": true,
      "46776": true,
      "46777": true,
      "46780": true,
      "46783": true,
      "46785": true,
      "46790": true,
      "46792": true,
      "46794": true,
      "46797": true,
      "46798": true,
      "46799": true
    },
    "SAN MIGUEL EL ALTO": {
      "47140": true,
      "47142": true,
      "47143": true,
      "47144": true,
      "47146": true,
      "47147": true,
      "47150": true,
      "47154": true,
      "47157": true,
      "47160": true
    },
    "SAN PEDRO TLAQUEPAQUE": {
      "45403": true,
      "45500": true,
      "45509": true,
      "45510": true,
      "45519": true,
      "45520": true,
      "45525": true,
      "45527": true,
      "45528": true,
      "45530": true,
      "45535": true,
      "45540": true,
      "45550": true,
      "45559": true,
      "45560": true,
      "45567": true,
      "45570": true,
      "45579": true,
      "45580": true,
      "45588": true,
      "45589": true,
      "45590": true,
      "45593": true,
      "45594": true,
      "45595": true,
      "45596": true,
      "45597": true,
      "45598": true,
      "45599": true,
      "45600": true,
      "45601": true,
      "45602": true,
      "45604": true,
      "45605": true,
      "45606": true,
      "45607": true,
      "45608": true,
      "45609": true,
      "45610": true,
      "45613": true,
      "45615": true,
      "45618": true,
      "45619": true,
      "45620": true,
      "45623": true,
      "45625": true,
      "45626": true,
      "45627": true,
      "45628": true,
      "45629": true,
      "45630": true,
      "45638": true
    },
    "SANTA MARIA DEL ORO": {
      "49970": true,
      "49979": true,
      "49996": true
    },
    "SAYULA": {
      "49300": true,
      "49302": true,
      "49303": true,
      "49304": true,
      "49305": true,
      "49306": true,
      "49310": true,
      "49312": true,
      "49313": true,
      "49314": true,
      "49315": true,
      "49316": true,
      "49317": true,
      "49318": true,
      "49330": true,
      "49333": true,
      "49334": true,
      "49336": true,
      "49339": true
    },
    "TALA": {
      "45300": true,
      "45303": true,
      "45305": true,
      "45306": true,
      "45307": true,
      "45308": true,
      "45310": true,
      "45314": true,
      "45320": true,
      "45325": true,
      "45330": true,
      "45331": true,
      "45335": true,
      "45340": true,
      "45341": true,
      "45345": true,
      "45349": true
    },
    "TALPA DE ALLENDE": {
      "48200": true,
      "48210": true,
      "48212": true,
      "48240": true,
      "48245": true,
      "48247": true
    },
    "TAMAZULA DE GORDIANO": {
      "49650": true,
      "49652": true,
      "49653": true,
      "49654": true,
      "49655": true,
      "49656": true,
      "49657": true,
      "49658": true,
      "49659": true,
      "49660": true,
      "49667": true,
      "49675": true,
      "49676": true,
      "49677": true,
      "49678": true,
      "49687": true
    },
    "TAPALPA": {
      "49340": true,
      "49344": true,
      "49345": true,
      "49346": true,
      "49350": true,
      "49356": true,
      "49358": true,
      "49360": true
    },
    "TECALITLAN": {
      "49900": true,
      "49910": true,
      "49920": true,
      "49924": true,
      "49925": true
    },
    "TECHALUTA DE MONTENEGRO": {
      "49230": true,
      "49239": true,
      "49240": true
    },
    "TECOLOTLAN": {
      "48540": true,
      "48542": true,
      "48546": true,
      "48553": true,
      "48554": true,
      "48555": true,
      "48556": true,
      "48558": true,
      "48560": true,
      "48563": true,
      "48564": true,
      "48568": true,
      "48569": true
    },
    "TEOCALTICHE": {
      "47200": true,
      "47202": true,
      "47203": true,
      "47204": true,
      "47206": true,
      "47207": true,
      "47210": true,
      "47214": true,
      "47215": true,
      "47216": true,
      "47220": true,
      "47223": true,
      "47227": true,
      "47228": true,
      "47229": true,
      "47232": true,
      "47235": true,
      "47236": true,
      "47237": true,
      "47238": true,
      "47239": true,
      "47244": true,
      "47245": true,
      "47246": true,
      "47247": true,
      "47249": true
    },
    "TEOCUITATLAN DE CORONA": {
      "49250": true,
      "49253": true,
      "49260": true,
      "49265": true,
      "49270": true,
      "49274": true,
      "49275": true,
      "49276": true,
      "49277": true,
      "49280": true,
      "49285": true,
      "49286": true,
      "49290": true,
      "49295": true,
      "49296": true
    },
    "TEPATITLAN DE MORELOS": {
      "47600": true,
      "47610": true,
      "47614": true,
      "47620": true,
      "47622": true,
      "47630": true,
      "47634": true,
      "47635": true,
      "47636": true,
      "47637": true,
      "47639": true,
      "47640": true,
      "47649": true,
      "47650": true,
      "47655": true,
      "47656": true,
      "47657": true,
      "47660": true,
      "47664": true,
      "47670": true,
      "47674": true,
      "47675": true,
      "47676": true,
      "47680": true,
      "47684": true,
      "47685": true,
      "47690": true,
      "47694": true,
      "47698": true,
      "47700": true,
      "47703": true,
      "47707": true,
      "47714": true,
      "47715": true,
      "47716": true,
      "47720": true,
      "47723": true,
      "47724": true,
      "47727": true,
      "47728": true,
      "47729": true
    },
    "TEQUILA": {
      "46400": true,
      "46402": true,
      "46403": true,
      "46404": true,
      "46405": true,
      "46407": true,
      "46409": true
    },
    "TEUCHITLAN": {
      "46760": true,
      "46762": true,
      "46763": true,
      "46764": true,
      "46765": true
    },
    "TIZAPAN EL ALTO": {
      "49400": true,
      "49403": true,
      "49410": true,
      "49420": true,
      "49421": true,
      "49423": true
    },
    "TLAJOMULCO DE ZUNIGA": {
      "45640": true,
      "45641": true,
      "45643": true,
      "45644": true,
      "45645": true,
      "45646": true,
      "45647": true,
      "45650": true,
      "45653": true,
      "45654": true,
      "45655": true,
      "45656": true,
      "45659": true,
      "45660": true,
      "45663": true,
      "45664": true,
      "45665": true,
      "45670": true,
      "45672": true,
      "45675": true,
      "45676": true,
      "45677": true,
      "45678": true,
      "45679": true
    },
    "TOMATLAN": {
      "48450": true,
      "48451": true,
      "48453": true,
      "48455": true,
      "48456": true,
      "48457": true,
      "48458": true,
      "48460": true,
      "48461": true,
      "48462": true,
      "48464": true,
      "48465": true,
      "48466": true,
      "48470": true,
      "48473": true,
      "48479": true,
      "48480": true,
      "48481": true,
      "48490": true,
      "48495": true
    },
    "TONALÁ": {
      "45400": true,
      "45402": true,
      "45403": true,
      "45404": true,
      "45405": true,
      "45406": true,
      "45407": true,
      "45408": true,
      "45410": true,
      "45412": true,
      "45413": true,
      "45415": true,
      "45416": true,
      "45417": true,
      "45420": true,
      "45422": true,
      "45424": true,
      "45425": true,
      "45426": true,
      "45427": true,
      "45428": true,
      "45429": true
    },
    "TONILA": {
      "49840": true,
      "49848": true,
      "49850": true,
      "49867": true,
      "49869": true
    },
    "TOTOTLAN": {
      "47730": true,
      "47732": true,
      "47733": true,
      "47734": true,
      "47736": true,
      "47740": true,
      "47741": true,
      "47742": true,
      "47743": true,
      "47746": true,
      "47748": true
    },
    "TUXCUECA": {
      "49430": true,
      "49432": true,
      "49439": true,
      "49440": true,
      "49446": true
    },
    "TUXPAN": {
      "49800": true,
      "49804": true,
      "49805": true,
      "49806": true,
      "49807": true,
      "49808": true,
      "49810": true,
      "49815": true,
      "49816": true,
      "49817": true,
      "49820": true,
      "49825": true,
      "49828": true,
      "49829": true,
      "49836": true
    },
    "UNION DE SAN ANTONIO": {
      "47570": true,
      "47572": true,
      "47573": true,
      "47574": true,
      "47576": true,
      "47577": true,
      "47580": true,
      "47584": true,
      "47585": true,
      "47586": true,
      "47587": true
    },
    "VALLE DE GUADALUPE": {
      "47380": true,
      "47383": true,
      "47384": true,
      "47386": true,
      "47398": true
    },
    "VALLE DE JUAREZ": {
      "49540": true,
      "49542": true,
      "49544": true,
      "49547": true,
      "49548": true,
      "49550": true
    },
    "VILLA CORONA": {
      "45730": true,
      "45737": true,
      "45740": true,
      "45745": true,
      "45746": true
    },
    "VILLA HIDALGO": {
      "47250": true,
      "47252": true,
      "47253": true,
      "47254": true,
      "47256": true,
      "47258": true,
      "47259": true,
      "47260": true,
      "47263": true,
      "47264": true,
      "47265": true,
      "47267": true,
      "47268": true,
      "47269": true
    },
    "VILLA PURIFICACION": {
      "48800": true,
      "48802": true,
      "48803": true,
      "48804": true,
      "48805": true,
      "48806": true,
      "48815": true,
      "48816": true,
      "48823": true
    },
    "YAHUALICA DE GONZALEZ GALLO": {
      "47300": true,
      "47302": true,
      "47303": true,
      "47308": true,
      "47309": true,
      "47310": true,
      "47314": true,
      "47315": true,
      "47320": true,
      "47325": true,
      "47327": true,
      "47330": true,
      "47335": true,
      "47336": true,
      "47337": true,
      "47338": true,
      "47339": true
    },
    "ZACOALCO DE TORRES": {
      "45750": true,
      "45752": true,
      "45753": true,
      "45754": true,
      "45755": true,
      "45756": true,
      "45757": true,
      "45758": true,
      "45760": true,
      "45763": true,
      "45764": true,
      "45765": true,
      "45766": true,
      "45767": true,
      "45770": true,
      "45773": true,
      "45774": true,
      "45775": true,
      "45776": true,
      "45777": true,
      "45780": true,
      "45783": true,
      "45784": true,
      "45785": true,
      "45786": true,
      "45787": true,
      "45788": true,
      "45789": true
    },
    "ZAPOPAN": {
      "45010": true,
      "45012": true,
      "45014": true,
      "45015": true,
      "45016": true,
      "45017": true,
      "45018": true,
      "45019": true,
      "45020": true,
      "45027": true,
      "45030": true,
      "45034": true,
      "45036": true,
      "45037": true,
      "45038": true,
      "45039": true,
      "45040": true,
      "45047": true,
      "45049": true,
      "45050": true,
      "45053": true,
      "45054": true,
      "45055": true,
      "45056": true,
      "45057": true,
      "45058": true,
      "45059": true,
      "45060": true,
      "45065": true,
      "45066": true,
      "45067": true,
      "45068": true,
      "45069": true,
      "45070": true,
      "45076": true,
      "45077": true,
      "45078": true,
      "45079": true,
      "45080": true,
      "45085": true,
      "45086": true,
      "45087": true,
      "45088": true,
      "45089": true,
      "45100": true,
      "45110": true,
      "45115": true,
      "45116": true,
      "45117": true,
      "45118": true,
      "45119": true,
      "45120": true,
      "45128": true,
      "45129": true,
      "45130": true,
      "45133": true,
      "45134": true,
      "45136": true,
      "45138": true,
      "45140": true,
      "45145": true,
      "45146": true,
      "45147": true,
      "45148": true,
      "45149": true,
      "45150": true,
      "45157": true,
      "45158": true,
      "45159": true,
      "45160": true,
      "45167": true,
      "45168": true,
      "45169": true,
      "45170": true,
      "45176": true,
      "45177": true,
      "45178": true,
      "45179": true,
      "45180": true,
      "45184": true,
      "45185": true,
      "45186": true,
      "45187": true,
      "45188": true,
      "45189": true,
      "45190": true,
      "45198": true,
      "45199": true,
      "45200": true,
      "45205": true,
      "45210": true,
      "45213": true,
      "45220": true,
      "45221": true,
      "45222": true,
      "45226": true,
      "45230": true,
      "45233": true,
      "45234": true,
      "45235": true,
      "45236": true,
      "45237": true,
      "45238": true,
      "45239": true,
      "45242": true,
      "45245": true
    },
    "ZAPOTILTIC": {
      "49600": true,
      "49602": true,
      "49603": true,
      "49604": true,
      "49605": true,
      "49606": true,
      "49608": true,
      "49610": true,
      "49615": true,
      "49620": true,
      "49623": true,
      "49624": true,
      "49635": true,
      "49638": true,
      "49639": true,
      "49640": true,
      "49642": true,
      "49647": true
    },
    "ZAPOTITLAN DE VADILLO": {
      "49770": true,
      "49775": true,
      "49779": true,
      "49783": true,
      "49784": true,
      "49786": true,
      "49789": true
    },
    "ZAPOTLAN DEL REY": {
      "45980": true,
      "45982": true,
      "45983": true,
      "45986": true,
      "45987": true,
      "45988": true,
      "45990": true,
      "45992": true,
      "45993": true,
      "45994": true,
      "45995": true,
      "45996": true,
      "45997": true,
      "45998": true
    },
    "ZAPOTLAN EL GRANDE": {
      "49000": true,
      "49010": true,
      "49011": true,
      "49012": true,
      "49013": true,
      "49014": true,
      "49015": true,
      "49016": true,
      "49019": true,
      "49020": true,
      "49023": true,
      "49024": true,
      "49026": true,
      "49027": true,
      "49028": true,
      "49031": true,
      "49032": true,
      "49033": true,
      "49035": true,
      "49040": true,
      "49050": true,
      "49051": true,
      "49052": true,
      "49053": true,
      "49055": true,
      "49056": true,
      "49057": true,
      "49059": true,
      "49060": true,
      "49063": true,
      "49064": true,
      "49065": true,
      "49066": true,
      "49070": true,
      "49078": true,
      "49079": true,
      "49080": true,
      "49086": true,
      "49087": true,
      "49088": true,
      "49089": true,
      "49090": true,
      "49093": true,
      "49094": true,
      "49095": true,
      "49096": true,
      "49097": true,
      "49098": true,
      "49099": true,
      "49100": true,
      "49106": true,
      "49109": true,
      "49110": true,
      "49112": true,
      "49113": true
    },
    "ZAPOTLANEJO": {
      "45430": true,
      "45434": true,
      "45435": true,
      "45437": true,
      "45438": true,
      "45440": true,
      "45443": true,
      "45444": true,
      "45445": true,
      "45446": true,
      "45448": true,
      "45453": true,
      "45454": true,
      "45455": true,
      "45460": true,
      "45462": true,
      "45464": true,
      "45465": true
    }
  },
  "MICHOACAN": {
    "ACUITZIO": {
      "58460": true,
      "58463": true,
      "58464": true,
      "58465": true,
      "58466": true,
      "58467": true,
      "58468": true
    },
    "ANGAMACUTIRO": {
      "58550": true,
      "58552": true,
      "58557": true,
      "58558": true,
      "58559": true,
      "58560": true,
      "58563": true,
      "58564": true,
      "58566": true,
      "58567": true
    },
    "ANGANGUEO": {
      "61410": true,
      "61413": true,
      "61414": true,
      "61415": true,
      "61416": true,
      "61417": true
    },
    "APATZINGAN": {
      "60600": true,
      "60610": true,
      "60615": true,
      "60616": true,
      "60619": true,
      "60620": true,
      "60626": true,
      "60627": true,
      "60628": true,
      "60630": true,
      "60633": true,
      "60637": true,
      "60639": true,
      "60640": true,
      "60650": true,
      "60654": true,
      "60656": true,
      "60658": true,
      "60660": true,
      "60663": true,
      "60664": true,
      "60667": true,
      "60670": true,
      "60673": true,
      "60674": true,
      "60676": true,
      "60677": true,
      "60680": true,
      "60683": true,
      "60684": true,
      "60685": true,
      "60689": true,
      "60690": true,
      "60693": true,
      "60694": true,
      "60695": true,
      "60696": true,
      "60697": true,
      "60698": true,
      "60699": true,
      "60700": true,
      "60710": true,
      "60713": true,
      "60714": true,
      "60715": true,
      "60717": true,
      "60720": true,
      "60725": true,
      "60730": true,
      "60740": true,
      "60742": true,
      "60743": true,
      "60744": true,
      "60745": true,
      "60746": true,
      "60753": true,
      "60754": true
    },
    "ARIO": {
      "61830": true,
      "61834": true,
      "61836": true,
      "61837": true,
      "61838": true,
      "61845": true,
      "61846": true,
      "61847": true,
      "61848": true,
      "61849": true
    },
    "ARTEAGA": {
      "60920": true,
      "60921": true,
      "60923": true,
      "60926": true,
      "60929": true,
      "60932": true,
      "60934": true,
      "60940": true,
      "60943": true,
      "60944": true,
      "60945": true,
      "60946": true,
      "60947": true
    },
    "BRISENAS": {
      "59120": true,
      "59124": true,
      "59125": true
    },
    "BUENAVISTA": {
      "60500": true,
      "60501": true,
      "60520": true,
      "60521": true,
      "60522": true,
      "60525": true,
      "60526": true,
      "60529": true,
      "60530": true,
      "60531": true,
      "60532": true,
      "60533": true,
      "60534": true,
      "60536": true
    },
    "CHARAPAN": {
      "60240": true,
      "60244": true,
      "60246": true,
      "60247": true
    },
    "CHARO": {
      "61300": true,
      "61303": true,
      "61304": true,
      "61305": true,
      "61306": true,
      "61307": true,
      "61310": true,
      "61311": true,
      "61312": true,
      "61313": true,
      "61314": true,
      "61320": true,
      "61321": true,
      "61322": true,
      "61323": true,
      "61324": true,
      "61325": true,
      "61326": true,
      "61327": true
    },
    "CHAVINDA": {
      "59580": true,
      "59590": true,
      "59593": true,
      "59594": true,
      "59595": true
    },
    "CHERAN": {
      "60270": true,
      "60271": true,
      "60273": true,
      "60276": true
    },
    "CHILCHOTA": {
      "59780": true,
      "59783": true,
      "59786": true,
      "59787": true,
      "59790": true,
      "59791": true,
      "59792": true,
      "59793": true,
      "59794": true,
      "59795": true,
      "59796": true,
      "59797": true,
      "59799": true
    },
    "CHUCANDIRO": {
      "58860": true,
      "58862": true,
      "58863": true,
      "58864": true,
      "58866": true,
      "58867": true,
      "58868": true
    },
    "CHURINTZIO": {
      "59440": true,
      "59443": true,
      "59444": true,
      "59445": true,
      "59446": true,
      "59447": true,
      "59450": true,
      "59451": true,
      "59453": true,
      "59454": true,
      "59455": true
    },
    "COAHUAYANA": {
      "60800": true,
      "60803": true,
      "60804": true,
      "60805": true,
      "60806": true,
      "60807": true,
      "60810": true,
      "60814": true
    },
    "COALCOMAN DE VAZQUEZ PALLARES": {
      "60840": true,
      "60843": true,
      "60845": true,
      "60856": true,
      "60857": true,
      "60866": true
    },
    "COENEO": {
      "58400": true,
      "58406": true,
      "58407": true
    },
    "COJUMATLAN DE REGULES": {
      "59140": true,
      "59143": true,
      "59144": true,
      "59146": true,
      "59150": true,
      "59154": true,
      "59155": true
    },
    "CONTEPEC": {
      "61020": true,
      "61023": true,
      "61024": true,
      "61025": true,
      "61026": true,
      "61030": true,
      "61034": true,
      "61035": true,
      "61036": true,
      "61037": true,
      "61040": true,
      "61041": true,
      "61042": true,
      "61043": true,
      "61045": true,
      "61046": true,
      "61047": true,
      "61048": true,
      "61050": true,
      "61051": true,
      "61053": true,
      "61054": true,
      "61055": true
    },
    "COPANDARO": {
      "58870": true,
      "58873": true,
      "58874": true,
      "58875": true,
      "58876": true
    },
    "COTIJA": {
      "59940": true,
      "59943": true,
      "59944": true,
      "59945": true,
      "59946": true,
      "59947": true,
      "59948": true,
      "59950": true,
      "59953": true,
      "59954": true
    },
    "CUITZEO": {
      "58840": true,
      "58842": true,
      "58843": true,
      "58845": true,
      "58846": true,
      "58850": true,
      "58853": true,
      "58854": true,
      "58855": true
    },
    "ECUANDUREO": {
      "59730": true,
      "59732": true,
      "59734": true,
      "59735": true,
      "59736": true,
      "59737": true,
      "59740": true,
      "59744": true,
      "59745": true
    },
    "ERONGARICUARO": {
      "61630": true,
      "61632": true,
      "61633": true,
      "61634": true,
      "61636": true,
      "61637": true
    },
    "GABRIEL ZAMORA": {
      "61730": true,
      "61732": true,
      "61734": true,
      "61735": true,
      "61740": true,
      "61745": true,
      "61746": true,
      "61747": true
    },
    "HIDALGO": {
      "61100": true,
      "61105": true,
      "61110": true,
      "61112": true,
      "61113": true,
      "61114": true,
      "61115": true,
      "61116": true,
      "61120": true,
      "61125": true,
      "61128": true,
      "61129": true,
      "61130": true,
      "61133": true,
      "61134": true,
      "61135": true,
      "61137": true,
      "61139": true,
      "61140": true,
      "61143": true,
      "61149": true,
      "61150": true,
      "61153": true,
      "61154": true,
      "61155": true,
      "61156": true,
      "61160": true,
      "61164": true,
      "61165": true,
      "61166": true,
      "61167": true,
      "61168": true,
      "61169": true,
      "61170": true,
      "61173": true,
      "61174": true,
      "61177": true,
      "61180": true,
      "61182": true,
      "61183": true,
      "61190": true,
      "61192": true,
      "61194": true,
      "61196": true,
      "61201": true,
      "61203": true,
      "61205": true,
      "61206": true,
      "61207": true,
      "61210": true,
      "61211": true,
      "61213": true,
      "61214": true,
      "61215": true,
      "61216": true,
      "61217": true,
      "61223": true,
      "61224": true,
      "61225": true,
      "61226": true,
      "61228": true,
      "61230": true,
      "61231": true,
      "61233": true,
      "61235": true,
      "61236": true,
      "61237": true,
      "61240": true,
      "61241": true,
      "61243": true,
      "61244": true,
      "61245": true,
      "61247": true,
      "61248": true
    },
    "HUANDACAREO": {
      "58820": true,
      "58825": true,
      "58827": true,
      "58830": true,
      "58833": true
    },
    "HUANIQUEO": {
      "58360": true,
      "58362": true,
      "58363": true,
      "58364": true,
      "58365": true,
      "58380": true,
      "58383": true,
      "58384": true,
      "58390": true,
      "58391": true,
      "58398": true,
      "58399": true
    },
    "HUETAMO": {
      "61940": true,
      "61942": true,
      "61943": true,
      "61944": true,
      "61945": true,
      "61946": true,
      "61947": true,
      "61948": true,
      "61950": true,
      "61956": true,
      "61957": true,
      "61958": true,
      "61959": true,
      "61960": true,
      "61969": true,
      "61970": true,
      "61971": true,
      "61972": true,
      "61973": true,
      "61974": true,
      "61975": true,
      "61976": true,
      "61978": true,
      "61979": true
    },
    "HUIRAMBA": {
      "61640": true,
      "61643": true,
      "61644": true,
      "61645": true,
      "61646": true,
      "61647": true,
      "61648": true
    },
    "INDAPARAPEO": {
      "58970": true,
      "58972": true,
      "58973": true,
      "58974": true,
      "58975": true,
      "58976": true,
      "58977": true,
      "58978": true
    },
    "IRIMBO": {
      "61280": true,
      "61282": true,
      "61283": true,
      "61284": true,
      "61285": true,
      "61286": true,
      "61287": true,
      "61288": true
    },
    "IXTLAN": {
      "59280": true,
      "59283": true,
      "59284": true,
      "59285": true,
      "59286": true,
      "59290": true,
      "59295": true,
      "59296": true,
      "59297": true
    },
    "JACONA": {
      "59800": true,
      "59810": true,
      "59813": true,
      "59816": true,
      "59817": true,
      "59820": true,
      "59823": true,
      "59824": true,
      "59828": true,
      "59830": true,
      "59833": true,
      "59834": true,
      "59835": true,
      "59836": true,
      "59840": true,
      "59843": true,
      "59844": true,
      "59845": true,
      "59850": true,
      "59853": true,
      "59854": true,
      "59855": true,
      "59856": true,
      "59857": true,
      "59860": true,
      "59863": true,
      "59864": true,
      "59865": true,
      "59870": true,
      "59873": true,
      "59874": true,
      "59875": true,
      "59880": true,
      "59884": true,
      "59885": true,
      "59890": true,
      "59893": true,
      "59894": true,
      "59900": true,
      "59904": true,
      "59905": true,
      "59906": true,
      "59908": true
    },
    "JIMENEZ": {
      "58780": true,
      "58782": true,
      "58783": true,
      "58785": true,
      "58786": true,
      "58787": true,
      "58790": true,
      "58794": true,
      "58795": true,
      "58796": true
    },
    "JIQUILPAN": {
      "59510": true,
      "59512": true,
      "59513": true,
      "59514": true,
      "59515": true,
      "59516": true,
      "59517": true,
      "59518": true,
      "59520": true,
      "59523": true,
      "59524": true,
      "59525": true,
      "59526": true,
      "59527": true,
      "59530": true,
      "59531": true,
      "59532": true,
      "59533": true,
      "59534": true,
      "59540": true,
      "59543": true,
      "59544": true,
      "59546": true,
      "59547": true
    },
    "JOSE SIXTO VERDUZCO": {
      "58540": true,
      "58542": true,
      "58543": true,
      "58544": true,
      "58545": true,
      "58546": true,
      "58547": true
    },
    "JUNGAPEO": {
      "61470": true,
      "61472": true,
      "61473": true,
      "61474": true,
      "61475": true,
      "61477": true,
      "61480": true,
      "61483": true,
      "61484": true,
      "61485": true,
      "61486": true,
      "61487": true,
      "61493": true,
      "61498": true
    },
    "LA HUACANA": {
      "61850": true,
      "61852": true,
      "61854": true,
      "61855": true,
      "61856": true,
      "61863": true,
      "61865": true,
      "61866": true,
      "61870": true,
      "61874": true,
      "61877": true,
      "61878": true
    },
    "LA PIEDAD": {
      "59300": true,
      "59310": true,
      "59319": true,
      "59320": true,
      "59330": true,
      "59334": true,
      "59335": true,
      "59340": true,
      "59349": true,
      "59350": true,
      "59359": true,
      "59360": true,
      "59363": true,
      "59370": true,
      "59373": true,
      "59374": true,
      "59375": true,
      "59376": true,
      "59377": true,
      "59379": true,
      "59380": true,
      "59384": true,
      "59386": true,
      "59387": true,
      "59389": true,
      "59390": true,
      "59392": true,
      "59393": true,
      "59400": true,
      "59410": true,
      "59414": true,
      "59415": true,
      "59420": true,
      "59423": true,
      "59424": true,
      "59425": true,
      "59426": true,
      "59427": true,
      "59428": true
    },
    "LAGUNILLAS": {
      "58450": true,
      "58453": true,
      "58454": true,
      "58455": true,
      "58456": true
    },
    "LAZARO CARDENAS": {
      "60950": true,
      "60952": true,
      "60953": true,
      "60954": true,
      "60955": true,
      "60956": true,
      "60967": true,
      "60970": true,
      "60980": true,
      "60982": true,
      "60983": true,
      "60985": true,
      "60987": true,
      "60990": true,
      "60992": true,
      "60993": true,
      "60994": true,
      "60995": true,
      "60996": true,
      "60997": true,
      "60998": true
    },
    "LOS REYES": {
      "60300": true,
      "60320": true,
      "60322": true,
      "60324": true,
      "60330": true,
      "60340": true,
      "60350": true,
      "60360": true,
      "60364": true,
      "60365": true,
      "60370": true,
      "60373": true,
      "60374": true,
      "60376": true,
      "60377": true,
      "60378": true,
      "60379": true,
      "60380": true,
      "60384": true,
      "60385": true,
      "60390": true,
      "60393": true,
      "60394": true,
      "60400": true,
      "60403": true,
      "60404": true,
      "60413": true,
      "60414": true,
      "60417": true,
      "60420": true,
      "60421": true,
      "60422": true,
      "60423": true,
      "60424": true,
      "60425": true,
      "60430": true,
      "60431": true,
      "60432": true,
      "60433": true
    },
    "MADERO": {
      "58480": true,
      "58481": true,
      "58483": true,
      "58486": true,
      "58487": true,
      "58488": true,
      "58489": true,
      "58497": true,
      "58498": true,
      "58499": true
    },
    "MARAVATIO": {
      "61250": true,
      "61252": true,
      "61253": true,
      "61254": true,
      "61255": true,
      "61256": true,
      "61258": true,
      "61259": true,
      "61260": true,
      "61261": true,
      "61262": true,
      "61263": true,
      "61264": true,
      "61266": true,
      "61267": true,
      "61274": true,
      "61276": true,
      "61277": true
    },
    "MARCOS CASTELLANOS": {
      "59500": true,
      "59503": true,
      "59505": true,
      "59506": true,
      "59507": true,
      "59508": true
    },
    "MORELIA": {
      "58000": true,
      "58004": true,
      "58006": true,
      "58009": true,
      "58010": true,
      "58013": true,
      "58020": true,
      "58030": true,
      "58040": true,
      "58048": true,
      "58049": true,
      "58050": true,
      "58055": true,
      "58056": true,
      "58057": true,
      "58058": true,
      "58060": true,
      "58066": true,
      "58067": true,
      "58069": true,
      "58070": true,
      "58078": true,
      "58080": true,
      "58085": true,
      "58086": true,
      "58087": true,
      "58088": true,
      "58089": true,
      "58090": true,
      "58093": true,
      "58095": true,
      "58096": true,
      "58097": true,
      "58098": true,
      "58099": true,
      "58100": true,
      "58110": true,
      "58114": true,
      "58115": true,
      "58116": true,
      "58117": true,
      "58118": true,
      "58120": true,
      "58127": true,
      "58128": true,
      "58130": true,
      "58140": true,
      "58145": true,
      "58146": true,
      "58147": true,
      "58148": true,
      "58149": true,
      "58150": true,
      "58158": true,
      "58160": true,
      "58168": true,
      "58170": true,
      "58175": true,
      "58178": true,
      "58179": true,
      "58180": true,
      "58183": true,
      "58186": true,
      "58187": true,
      "58188": true,
      "58189": true,
      "58190": true,
      "58194": true,
      "58195": true,
      "58196": true,
      "58197": true,
      "58199": true,
      "58200": true,
      "58210": true,
      "58216": true,
      "58217": true,
      "58218": true,
      "58219": true,
      "58220": true,
      "58226": true,
      "58227": true,
      "58228": true,
      "58229": true,
      "58230": true,
      "58240": true,
      "58244": true,
      "58245": true,
      "58248": true,
      "58249": true,
      "58250": true,
      "58253": true,
      "58254": true,
      "58255": true,
      "58256": true,
      "58257": true,
      "58258": true,
      "58259": true,
      "58260": true,
      "58270": true,
      "58277": true,
      "58278": true,
      "58280": true,
      "58290": true,
      "58295": true,
      "58296": true,
      "58297": true,
      "58300": true,
      "58301": true,
      "58302": true,
      "58303": true,
      "58304": true,
      "58310": true,
      "58312": true,
      "58313": true,
      "58314": true,
      "58317": true,
      "58320": true,
      "58321": true,
      "58322": true,
      "58323": true,
      "58324": true,
      "58330": true,
      "58331": true,
      "58332": true,
      "58333": true,
      "58334": true,
      "58335": true,
      "58336": true,
      "58337": true,
      "58338": true,
      "58340": true,
      "58341": true,
      "58342": true,
      "58343": true,
      "58344": true,
      "58345": true,
      "58346": true,
      "58347": true,
      "58348": true,
      "58350": true,
      "58352": true,
      "58353": true,
      "58355": true,
      "58356": true,
      "58357": true,
      "58358": true,
      "58359": true
    },
    "MORELOS": {
      "58800": true,
      "58803": true,
      "58804": true,
      "58805": true
    },
    "MUGICA": {
      "61760": true,
      "61763": true,
      "61770": true,
      "61790": true
    },
    "NAHUATZEN": {
      "60280": true,
      "60282": true,
      "60285": true,
      "60286": true,
      "60287": true
    },
    "NUEVO PARANGARICUTIRO": {
      "60490": true,
      "60492": true,
      "60493": true,
      "60494": true,
      "60495": true
    },
    "NUEVO URECHO": {
      "61750": true,
      "61752": true,
      "61753": true,
      "61754": true,
      "61755": true,
      "61756": true,
      "61757": true,
      "61759": true
    },
    "NUMARAN": {
      "59430": true,
      "59433": true,
      "59434": true,
      "59435": true,
      "59436": true,
      "59438": true
    },
    "OCAMPO": {
      "61450": true,
      "61453": true,
      "61454": true,
      "61455": true,
      "61458": true,
      "61460": true,
      "61464": true,
      "61465": true,
      "61467": true,
      "61468": true
    },
    "PAJACUARAN": {
      "59180": true,
      "59184": true,
      "59185": true,
      "59186": true,
      "59187": true,
      "59190": true,
      "59193": true,
      "59194": true,
      "59195": true
    },
    "PANINDICUARO": {
      "58570": true,
      "58574": true,
      "58578": true,
      "58579": true,
      "58580": true,
      "58581": true,
      "58585": true,
      "58586": true,
      "58590": true,
      "58591": true,
      "58593": true,
      "58594": true,
      "58598": true
    },
    "PARACHO": {
      "60250": true,
      "60251": true,
      "60252": true,
      "60254": true,
      "60255": true,
      "60256": true,
      "60257": true,
      "60258": true,
      "60259": true,
      "60260": true,
      "60261": true,
      "60262": true,
      "60263": true,
      "60264": true,
      "60265": true,
      "60266": true,
      "60267": true
    },
    "PARACUARO": {
      "60760": true,
      "60765": true,
      "60780": true,
      "60782": true,
      "60783": true,
      "60784": true,
      "60785": true,
      "60786": true,
      "60790": true,
      "60793": true,
      "60794": true,
      "60795": true
    },
    "PATZCUARO": {
      "61600": true,
      "61604": true,
      "61605": true,
      "61606": true,
      "61607": true,
      "61608": true,
      "61609": true,
      "61610": true,
      "61611": true,
      "61612": true,
      "61613": true,
      "61614": true,
      "61615": true,
      "61616": true,
      "61617": true,
      "61618": true,
      "61620": true,
      "61623": true,
      "61624": true,
      "61625": true,
      "61626": true
    },
    "PENJAMILLO": {
      "59470": true,
      "59472": true,
      "59473": true,
      "59474": true,
      "59475": true,
      "59476": true,
      "59482": true,
      "59490": true,
      "59493": true,
      "59494": true,
      "59497": true,
      "59498": true
    },
    "PERIBAN": {
      "60440": true,
      "60442": true,
      "60443": true,
      "60445": true,
      "60446": true,
      "60447": true
    },
    "PUREPERO": {
      "58760": true,
      "58762": true,
      "58763": true,
      "58764": true,
      "58765": true,
      "58766": true,
      "58767": true,
      "58770": true,
      "58774": true
    },
    "PURUANDIRO": {
      "58500": true,
      "58502": true,
      "58503": true,
      "58504": true,
      "58505": true,
      "58506": true,
      "58507": true,
      "58508": true,
      "58510": true,
      "58511": true,
      "58512": true,
      "58513": true,
      "58514": true,
      "58515": true,
      "58516": true,
      "58517": true,
      "58520": true,
      "58523": true,
      "58524": true,
      "58530": true,
      "58531": true,
      "58532": true,
      "58533": true
    },
    "QUIROGA": {
      "58420": true,
      "58423": true,
      "58424": true,
      "58425": true,
      "58426": true,
      "58430": true,
      "58433": true,
      "58435": true
    },
    "SAHUAYO": {
      "59000": true,
      "59010": true,
      "59012": true,
      "59013": true,
      "59014": true,
      "59015": true,
      "59020": true,
      "59023": true,
      "59026": true,
      "59027": true,
      "59028": true,
      "59030": true,
      "59033": true,
      "59034": true,
      "59035": true,
      "59036": true,
      "59040": true,
      "59043": true,
      "59044": true,
      "59045": true,
      "59050": true,
      "59057": true,
      "59058": true,
      "59100": true,
      "59102": true,
      "59103": true,
      "59104": true,
      "59105": true
    },
    "SALVADOR ESCALANTE": {
      "61800": true,
      "61803": true,
      "61804": true,
      "61805": true,
      "61806": true,
      "61807": true,
      "61810": true,
      "61812": true,
      "61815": true,
      "61816": true,
      "61820": true,
      "61823": true,
      "61824": true,
      "61825": true,
      "61827": true
    },
    "SANTA ANA MAYA": {
      "58900": true,
      "58905": true,
      "58909": true,
      "58910": true,
      "58912": true,
      "58913": true,
      "58914": true,
      "58915": true,
      "58918": true,
      "58919": true
    },
    "SENGUIO": {
      "61290": true,
      "61292": true,
      "61293": true,
      "61295": true,
      "61296": true,
      "61297": true
    },
    "TACAMBARO": {
      "61650": true,
      "61652": true,
      "61653": true,
      "61654": true,
      "61655": true,
      "61656": true,
      "61657": true,
      "61658": true,
      "61659": true,
      "61663": true,
      "61664": true,
      "61665": true,
      "61670": true,
      "61673": true,
      "61674": true,
      "61677": true,
      "61678": true
    },
    "TANCITARO": {
      "60460": true,
      "60464": true,
      "60465": true,
      "60466": true,
      "60467": true,
      "60468": true,
      "60473": true,
      "60474": true,
      "60476": true,
      "60477": true,
      "60480": true,
      "60483": true,
      "60484": true,
      "60485": true,
      "60486": true
    },
    "TANGAMANDAPIO": {
      "59920": true,
      "59921": true,
      "59923": true,
      "59925": true,
      "59926": true,
      "59927": true,
      "59928": true,
      "59930": true,
      "59931": true,
      "59934": true
    },
    "TANGANCICUARO": {
      "59750": true,
      "59753": true,
      "59758": true,
      "59759": true,
      "59760": true,
      "59762": true,
      "59763": true,
      "59764": true,
      "59765": true,
      "59766": true,
      "59770": true,
      "59773": true,
      "59774": true,
      "59775": true
    },
    "TANHUATO": {
      "59230": true,
      "59235": true,
      "59237": true,
      "59240": true,
      "59243": true,
      "59244": true
    },
    "TARETAN": {
      "61710": true,
      "61712": true,
      "61713": true,
      "61714": true,
      "61716": true,
      "61717": true,
      "61718": true
    },
    "TARIMBARO": {
      "58880": true,
      "58881": true,
      "58883": true,
      "58885": true,
      "58886": true,
      "58887": true,
      "58890": true,
      "58891": true,
      "58893": true,
      "58894": true,
      "58895": true,
      "58896": true
    },
    "TEPALCATEPEC": {
      "60540": true,
      "60542": true,
      "60544": true,
      "60545": true,
      "60547": true,
      "60550": true,
      "60553": true,
      "60555": true,
      "60560": true,
      "60564": true,
      "60565": true,
      "60566": true,
      "60567": true
    },
    "TINGAMBATO": {
      "60290": true,
      "60293": true,
      "60294": true,
      "60295": true
    },
    "TINGUINDIN": {
      "59980": true,
      "59983": true,
      "59986": true,
      "59987": true,
      "59990": true,
      "59991": true,
      "59993": true,
      "59995": true
    },
    "TLALPUJAHUA": {
      "61060": true,
      "61062": true,
      "61063": true,
      "61064": true,
      "61065": true,
      "61066": true,
      "61067": true,
      "61070": true,
      "61072": true,
      "61073": true,
      "61074": true,
      "61075": true,
      "61080": true,
      "61082": true,
      "61083": true,
      "61084": true,
      "61086": true
    },
    "TLAZAZALCA": {
      "58740": true,
      "58741": true,
      "58742": true,
      "58743": true,
      "58744": true,
      "58745": true,
      "58746": true,
      "58750": true,
      "58751": true,
      "58754": true,
      "58755": true
    },
    "TOCUMBO": {
      "59960": true,
      "59963": true,
      "59964": true,
      "59965": true,
      "59970": true,
      "59972": true,
      "59973": true
    },
    "TURICATO": {
      "61680": true,
      "61682": true,
      "61687": true,
      "61688": true,
      "61698": true
    },
    "TUXPAN": {
      "61420": true,
      "61423": true,
      "61424": true,
      "61425": true,
      "61426": true,
      "61427": true,
      "61428": true,
      "61430": true,
      "61434": true,
      "61435": true,
      "61436": true,
      "61437": true,
      "61438": true,
      "61440": true,
      "61443": true,
      "61444": true,
      "61445": true,
      "61446": true,
      "61447": true
    },
    "TZINTZUNTZAN": {
      "58440": true,
      "58443": true,
      "58444": true,
      "58445": true,
      "58446": true,
      "58448": true
    },
    "TZITZIO": {
      "61336": true,
      "61340": true,
      "61341": true,
      "61343": true,
      "61345": true,
      "61346": true,
      "61347": true,
      "61350": true,
      "61358": true,
      "61360": true,
      "61363": true,
      "61364": true,
      "61365": true,
      "61367": true
    },
    "URUAPAN": {
      "60000": true,
      "60010": true,
      "60013": true,
      "60014": true,
      "60016": true,
      "60017": true,
      "60020": true,
      "60024": true,
      "60030": true,
      "60033": true,
      "60040": true,
      "60044": true,
      "60050": true,
      "60054": true,
      "60060": true,
      "60063": true,
      "60070": true,
      "60073": true,
      "60074": true,
      "60080": true,
      "60090": true,
      "60094": true,
      "60095": true,
      "60100": true,
      "60105": true,
      "60110": true,
      "60120": true,
      "60123": true,
      "60124": true,
      "60125": true,
      "60126": true,
      "60127": true,
      "60128": true,
      "60130": true,
      "60133": true,
      "60134": true,
      "60135": true,
      "60136": true,
      "60137": true,
      "60140": true,
      "60143": true,
      "60150": true,
      "60153": true,
      "60154": true,
      "60155": true,
      "60156": true,
      "60157": true,
      "60160": true,
      "60170": true,
      "60173": true,
      "60174": true,
      "60175": true,
      "60180": true,
      "60183": true,
      "60190": true,
      "60193": true,
      "60194": true,
      "60200": true,
      "60201": true,
      "60202": true,
      "60203": true,
      "60205": true,
      "60206": true,
      "60207": true,
      "60210": true,
      "60211": true,
      "60213": true,
      "60215": true,
      "60216": true,
      "60220": true,
      "60222": true,
      "60223": true,
      "60224": true,
      "60225": true,
      "60226": true,
      "60227": true,
      "60230": true,
      "60233": true,
      "60234": true,
      "60235": true,
      "60236": true,
      "60237": true
    },
    "VENUSTIANO CARRANZA": {
      "59160": true,
      "59163": true,
      "59164": true,
      "59165": true,
      "59167": true,
      "59168": true
    },
    "VILLAMAR": {
      "59550": true,
      "59552": true,
      "59553": true,
      "59554": true,
      "59557": true,
      "59560": true,
      "59563": true,
      "59566": true,
      "59570": true,
      "59573": true,
      "59574": true,
      "59575": true,
      "59576": true,
      "59577": true,
      "59578": true
    },
    "VISTA HERMOSA": {
      "59200": true,
      "59203": true,
      "59204": true,
      "59205": true,
      "59206": true,
      "59210": true,
      "59220": true
    },
    "YURECUARO": {
      "59250": true,
      "59253": true,
      "59254": true,
      "59256": true,
      "59257": true,
      "59258": true,
      "59265": true,
      "59266": true
    },
    "ZACAPU": {
      "58600": true,
      "58610": true,
      "58616": true,
      "58617": true,
      "58620": true,
      "58624": true,
      "58627": true,
      "58628": true,
      "58630": true,
      "58635": true,
      "58637": true,
      "58638": true,
      "58639": true,
      "58640": true,
      "58649": true,
      "58650": true,
      "58653": true,
      "58654": true,
      "58660": true,
      "58664": true,
      "58665": true,
      "58667": true,
      "58670": true,
      "58676": true,
      "58677": true,
      "58680": true,
      "58685": true,
      "58688": true,
      "58689": true,
      "58690": true,
      "58698": true,
      "58701": true,
      "58702": true,
      "58703": true,
      "58710": true,
      "58716": true,
      "58720": true,
      "58728": true,
      "58730": true,
      "58731": true,
      "58733": true,
      "58734": true,
      "58735": true,
      "58739": true
    },
    "ZAMORA": {
      "59600": true,
      "59610": true,
      "59613": true,
      "59614": true,
      "59615": true,
      "59617": true,
      "59618": true,
      "59620": true,
      "59624": true,
      "59625": true,
      "59626": true,
      "59627": true,
      "59630": true,
      "59633": true,
      "59634": true,
      "59635": true,
      "59636": true,
      "59637": true,
      "59638": true,
      "59640": true,
      "59643": true,
      "59646": true,
      "59650": true,
      "59653": true,
      "59655": true,
      "59656": true,
      "59660": true,
      "59664": true,
      "59665": true,
      "59666": true,
      "59667": true,
      "59669": true,
      "59670": true,
      "59674": true,
      "59675": true,
      "59676": true,
      "59680": true,
      "59683": true,
      "59684": true,
      "59688": true,
      "59689": true,
      "59690": true,
      "59694": true,
      "59695": true,
      "59696": true,
      "59697": true,
      "59698": true,
      "59699": true,
      "59700": true,
      "59701": true,
      "59703": true,
      "59704": true,
      "59710": true,
      "59711": true,
      "59712": true,
      "59713": true,
      "59714": true,
      "59715": true,
      "59716": true,
      "59720": true,
      "59721": true,
      "59722": true,
      "59723": true,
      "59724": true,
      "59725": true
    },
    "ZINAPARO": {
      "59460": true,
      "59463": true,
      "59464": true,
      "59466": true,
      "59467": true
    },
    "ZINAPECUARO": {
      "58930": true,
      "58931": true,
      "58932": true,
      "58933": true,
      "58935": true,
      "58936": true,
      "58937": true,
      "58938": true,
      "58940": true,
      "58942": true,
      "58944": true,
      "58945": true,
      "58946": true,
      "58948": true,
      "58949": true,
      "58950": true,
      "58953": true,
      "58954": true,
      "58956": true,
      "58957": true,
      "58958": true,
      "58959": true,
      "58962": true,
      "58963": true
    },
    "ZIRACUARETIRO": {
      "61700": true,
      "61702": true,
      "61703": true,
      "61705": true,
      "61706": true,
      "61707": true,
      "61708": true
    },
    "ZITACUARO": {
      "61500": true,
      "61502": true,
      "61503": true,
      "61505": true,
      "61506": true,
      "61507": true,
      "61508": true,
      "61509": true,
      "61510": true,
      "61511": true,
      "61512": true,
      "61514": true,
      "61515": true,
      "61516": true,
      "61517": true,
      "61518": true,
      "61519": true,
      "61520": true,
      "61524": true,
      "61525": true,
      "61526": true,
      "61527": true,
      "61528": true,
      "61529": true,
      "61530": true,
      "61533": true,
      "61534": true,
      "61535": true,
      "61536": true,
      "61537": true,
      "61539": true
    },
    "ÁLVARO OBREGÓN": {
      "58920": true,
      "58923": true,
      "58924": true,
      "58925": true,
      "58926": true,
      "58927": true,
      "58928": true
    }
  },
  "MORELOS": {
    "AMACUZAC": {
      "62640": true,
      "62643": true,
      "62644": true,
      "62645": true,
      "62646": true,
      "62647": true,
      "62653": true,
      "62654": true,
      "62655": true,
      "62656": true
    },
    "ATLATLAHUCAN": {
      "62840": true,
      "62845": true,
      "62846": true,
      "62847": true
    },
    "AXOCHIAPAN": {
      "62950": true,
      "62952": true,
      "62953": true,
      "62954": true,
      "62955": true,
      "62956": true,
      "62957": true,
      "62962": true,
      "62963": true,
      "62965": true,
      "62966": true
    },
    "AYALA": {
      "62700": true,
      "62704": true,
      "62710": true,
      "62713": true,
      "62714": true,
      "62715": true,
      "62717": true,
      "62718": true,
      "62720": true,
      "62723": true,
      "62724": true,
      "62725": true
    },
    "COATETELCO": {
      "62606": true
    },
    "COATLAN DEL RIO": {
      "62610": true,
      "62613": true,
      "62614": true,
      "62615": true,
      "62616": true
    },
    "CUAUTLA": {
      "62740": true,
      "62742": true,
      "62743": true,
      "62744": true,
      "62746": true,
      "62747": true,
      "62748": true,
      "62754": true,
      "62755": true,
      "62756": true,
      "62757": true
    },
    "CUERNAVACA": {
      "62000": true,
      "62010": true,
      "62017": true,
      "62018": true,
      "62019": true,
      "62020": true,
      "62028": true,
      "62029": true,
      "62030": true,
      "62037": true,
      "62038": true,
      "62039": true,
      "62040": true,
      "62050": true,
      "62057": true,
      "62059": true,
      "62060": true,
      "62070": true,
      "62076": true,
      "62080": true,
      "62083": true,
      "62084": true,
      "62100": true,
      "62103": true,
      "62115": true,
      "62116": true,
      "62117": true,
      "62120": true,
      "62130": true,
      "62136": true,
      "62137": true,
      "62139": true,
      "62140": true,
      "62143": true,
      "62144": true,
      "62145": true,
      "62150": true,
      "62154": true,
      "62156": true,
      "62157": true,
      "62159": true,
      "62160": true,
      "62165": true,
      "62166": true,
      "62170": true,
      "62173": true,
      "62175": true,
      "62179": true,
      "62180": true,
      "62190": true,
      "62193": true,
      "62200": true,
      "62203": true,
      "62210": true,
      "62215": true,
      "62218": true,
      "62219": true,
      "62220": true,
      "62226": true,
      "62227": true,
      "62228": true,
      "62229": true,
      "62230": true,
      "62233": true,
      "62237": true,
      "62239": true,
      "62240": true,
      "62243": true,
      "62245": true,
      "62247": true,
      "62248": true,
      "62249": true,
      "62250": true,
      "62253": true,
      "62260": true,
      "62269": true,
      "62270": true,
      "62280": true,
      "62283": true,
      "62284": true,
      "62285": true,
      "62290": true,
      "62293": true,
      "62294": true,
      "62295": true,
      "62296": true,
      "62300": true,
      "62303": true,
      "62304": true,
      "62305": true,
      "62306": true,
      "62309": true,
      "62320": true,
      "62323": true,
      "62324": true,
      "62325": true,
      "62326": true,
      "62328": true,
      "62329": true,
      "62330": true,
      "62334": true,
      "62335": true,
      "62340": true,
      "62343": true,
      "62345": true,
      "62350": true,
      "62360": true,
      "62363": true,
      "62370": true,
      "62373": true,
      "62374": true,
      "62375": true,
      "62376": true,
      "62380": true,
      "62382": true,
      "62384": true,
      "62385": true,
      "62387": true,
      "62388": true,
      "62389": true,
      "62390": true,
      "62398": true,
      "62399": true,
      "62400": true,
      "62409": true,
      "62410": true,
      "62420": true,
      "62428": true,
      "62430": true,
      "62433": true,
      "62440": true,
      "62445": true,
      "62446": true,
      "62447": true,
      "62448": true,
      "62450": true,
      "62460": true,
      "62466": true,
      "62469": true,
      "62470": true,
      "62473": true,
      "62474": true,
      "62475": true,
      "62480": true,
      "62490": true,
      "62493": true,
      "62494": true,
      "62496": true,
      "62497": true,
      "62498": true,
      "62499": true,
      "62508": true
    },
    "EMILIANO ZAPATA": {
      "62760": true,
      "62763": true,
      "62764": true,
      "62765": true,
      "62766": true,
      "62767": true,
      "62768": true
    },
    "HUEYAPAN": {
      "62810": true,
      "62813": true,
      "62814": true,
      "62815": true
    },
    "HUITZILAC": {
      "62510": true,
      "62514": true,
      "62515": true
    },
    "JANTETELCO": {
      "62970": true,
      "62972": true,
      "62974": true,
      "62975": true,
      "62976": true,
      "62977": true,
      "62978": true
    },
    "JIUTEPEC": {
      "62550": true,
      "62553": true,
      "62554": true,
      "62555": true,
      "62556": true,
      "62560": true,
      "62563": true,
      "62564": true,
      "62565": true,
      "62566": true,
      "62570": true,
      "62573": true,
      "62574": true,
      "62575": true,
      "62576": true,
      "62577": true,
      "62578": true
    },
    "JOJUTLA": {
      "62900": true,
      "62905": true,
      "62906": true,
      "62907": true,
      "62908": true,
      "62909": true,
      "62910": true,
      "62912": true,
      "62914": true,
      "62915": true,
      "62917": true
    },
    "JONACATEPEC": {
      "62930": true,
      "62933": true,
      "62934": true,
      "62935": true,
      "62936": true,
      "62937": true,
      "62940": true,
      "62943": true
    },
    "MAZATEPEC": {
      "62630": true,
      "62633": true,
      "62634": true,
      "62635": true,
      "62636": true
    },
    "MIACATLAN": {
      "62600": true,
      "62605": true,
      "62607": true,
      "62608": true
    },
    "OCUITUCO": {
      "62850": true,
      "62853": true,
      "62854": true,
      "62855": true,
      "62856": true,
      "62857": true,
      "62860": true,
      "62863": true,
      "62864": true,
      "62865": true,
      "62866": true,
      "62867": true
    },
    "PUENTE DE IXTLA": {
      "62660": true,
      "62662": true,
      "62663": true,
      "62664": true,
      "62665": true,
      "62666": true,
      "62668": true,
      "62670": true,
      "62676": true,
      "62690": true,
      "62693": true,
      "62695": true,
      "62697": true
    },
    "TEMIXCO": {
      "62580": true,
      "62583": true,
      "62584": true,
      "62585": true,
      "62586": true,
      "62587": true,
      "62588": true,
      "62590": true,
      "62593": true,
      "62594": true,
      "62595": true,
      "62596": true,
      "62599": true
    },
    "TEMOAC": {
      "62870": true,
      "62873": true,
      "62880": true,
      "62885": true,
      "62887": true
    },
    "TEPALCINGO": {
      "62920": true,
      "62923": true,
      "62924": true,
      "62925": true,
      "62926": true,
      "62927": true
    },
    "TEPOZTLAN": {
      "62520": true,
      "62523": true,
      "62524": true,
      "62525": true,
      "62526": true,
      "62527": true,
      "62528": true,
      "62529": true
    },
    "TETECALA": {
      "62620": true,
      "62624": true,
      "62625": true,
      "62626": true
    },
    "TETELA DEL VOLCAN": {
      "62800": true,
      "62802": true,
      "62803": true,
      "62804": true,
      "62805": true,
      "62806": true
    },
    "TLALTIZAPAN DE ZAPATA": {
      "62770": true,
      "62772": true,
      "62773": true,
      "62774": true,
      "62776": true,
      "62777": true,
      "62778": true
    },
    "TLANEPANTLA": {
      "62530": true,
      "62534": true,
      "62535": true,
      "62536": true
    },
    "TLAQUILTENANGO": {
      "62980": true,
      "62982": true,
      "62983": true,
      "62984": true,
      "62985": true,
      "62986": true,
      "62987": true,
      "62988": true
    },
    "TLAYACAPAN": {
      "62540": true,
      "62543": true,
      "62544": true,
      "62545": true,
      "62546": true,
      "62547": true
    },
    "TOTOLAPAN": {
      "62830": true,
      "62832": true,
      "62834": true,
      "62835": true
    },
    "XOCHITEPEC": {
      "62790": true,
      "62793": true,
      "62794": true,
      "62795": true,
      "62796": true,
      "62797": true
    },
    "XOXOCOTLA": {
      "62680": true,
      "62684": true,
      "62685": true,
      "62686": true,
      "62687": true
    },
    "YAUTEPEC": {
      "62730": true,
      "62732": true,
      "62733": true,
      "62735": true,
      "62736": true,
      "62737": true,
      "62738": true,
      "62739": true
    },
    "YECAPIXTLA": {
      "62820": true,
      "62823": true,
      "62824": true,
      "62825": true,
      "62826": true,
      "62827": true,
      "62828": true
    },
    "ZACATEPEC": {
      "62780": true,
      "62785": true
    },
    "ZACUALPAN": {
      "62890": true,
      "62893": true,
      "62895": true,
      "62896": true,
      "62897": true
    }
  },
  "NAYARIT": {
    "ACAPONETA": {
      "63400": true,
      "63403": true,
      "63405": true,
      "63406": true,
      "63408": true,
      "63409": true,
      "63410": true,
      "63412": true,
      "63413": true,
      "63414": true,
      "63416": true,
      "63420": true,
      "63421": true,
      "63423": true,
      "63425": true,
      "63429": true,
      "63430": true,
      "63434": true,
      "63435": true,
      "63436": true,
      "63437": true,
      "63438": true
    },
    "AHUACATLAN": {
      "63900": true,
      "63904": true,
      "63905": true,
      "63910": true,
      "63911": true,
      "63913": true,
      "63914": true,
      "63915": true,
      "63920": true,
      "63923": true,
      "63925": true,
      "63927": true,
      "63928": true,
      "63938": true
    },
    "AMATLAN DE CANAS": {
      "63960": true,
      "63963": true,
      "63967": true,
      "63970": true,
      "63973": true,
      "63974": true,
      "63975": true,
      "63980": true,
      "63985": true,
      "63990": true,
      "63996": true
    },
    "BAHIA DE BANDERAS": {
      "63726": true,
      "63728": true,
      "63729": true,
      "63730": true,
      "63732": true,
      "63734": true,
      "63735": true,
      "63737": true,
      "63738": true
    },
    "COMPOSTELA": {
      "63700": true,
      "63702": true,
      "63703": true,
      "63704": true,
      "63705": true,
      "63708": true,
      "63709": true,
      "63710": true,
      "63713": true,
      "63714": true,
      "63715": true,
      "63717": true,
      "63719": true,
      "63720": true,
      "63722": true,
      "63723": true,
      "63724": true
    },
    "IXTLAN DEL RIO": {
      "63940": true,
      "63944": true,
      "63946": true,
      "63950": true,
      "63953": true,
      "63954": true,
      "63955": true,
      "63956": true,
      "63957": true,
      "63958": true,
      "63959": true
    },
    "JALA": {
      "63880": true,
      "63883": true,
      "63885": true,
      "63890": true,
      "63893": true,
      "63894": true,
      "63895": true,
      "63897": true,
      "63899": true
    },
    "ROSAMORADA": {
      "63630": true,
      "63633": true,
      "63634": true,
      "63635": true,
      "63636": true,
      "63637": true,
      "63638": true,
      "63640": true,
      "63644": true,
      "63645": true,
      "63646": true,
      "63648": true,
      "63650": true,
      "63652": true,
      "63655": true,
      "63656": true,
      "63658": true
    },
    "RUIZ": {
      "63600": true,
      "63603": true,
      "63604": true,
      "63605": true,
      "63606": true,
      "63607": true,
      "63610": true,
      "63613": true,
      "63616": true,
      "63617": true,
      "63620": true,
      "63622": true,
      "63623": true,
      "63625": true,
      "63626": true,
      "63627": true,
      "63628": true
    },
    "SAN BLAS": {
      "63740": true,
      "63742": true,
      "63743": true,
      "63744": true,
      "63745": true,
      "63750": true,
      "63754": true,
      "63755": true,
      "63757": true,
      "63758": true,
      "63760": true,
      "63762": true,
      "63764": true,
      "63765": true,
      "63766": true,
      "63771": true,
      "63772": true,
      "63773": true,
      "63774": true,
      "63775": true,
      "63776": true,
      "63777": true,
      "63779": true
    },
    "SAN PEDRO LAGUNILLAS": {
      "63800": true,
      "63804": true,
      "63810": true,
      "63820": true
    },
    "SANTA MARIA DEL ORO": {
      "63830": true,
      "63833": true,
      "63834": true,
      "63835": true,
      "63836": true,
      "63837": true,
      "63840": true,
      "63843": true,
      "63844": true,
      "63845": true,
      "63850": true,
      "63853": true,
      "63856": true,
      "63865": true,
      "63866": true,
      "63867": true,
      "63870": true,
      "63874": true
    },
    "SANTIAGO IXCUINTLA": {
      "63300": true,
      "63310": true,
      "63311": true,
      "63312": true,
      "63313": true,
      "63320": true,
      "63321": true,
      "63330": true,
      "63340": true,
      "63341": true,
      "63350": true,
      "63351": true,
      "63352": true,
      "63360": true,
      "63380": true,
      "63383": true,
      "63384": true,
      "63385": true,
      "63386": true,
      "63550": true,
      "63552": true,
      "63553": true,
      "63554": true,
      "63555": true,
      "63556": true,
      "63557": true,
      "63558": true,
      "63559": true,
      "63565": true,
      "63567": true,
      "63570": true,
      "63575": true,
      "63576": true,
      "63577": true,
      "63579": true
    },
    "TECUALA": {
      "63440": true,
      "63444": true,
      "63445": true,
      "63446": true,
      "63447": true,
      "63450": true,
      "63453": true,
      "63454": true,
      "63455": true,
      "63456": true,
      "63457": true,
      "63458": true,
      "63459": true,
      "63460": true,
      "63463": true
    },
    "TEPIC": {
      "63000": true,
      "63010": true,
      "63018": true,
      "63019": true,
      "63020": true,
      "63021": true,
      "63022": true,
      "63023": true,
      "63030": true,
      "63035": true,
      "63037": true,
      "63038": true,
      "63039": true,
      "63040": true,
      "63050": true,
      "63058": true,
      "63059": true,
      "63060": true,
      "63061": true,
      "63062": true,
      "63066": true,
      "63067": true,
      "63068": true,
      "63069": true,
      "63070": true,
      "63080": true,
      "63081": true,
      "63082": true,
      "63083": true,
      "63084": true,
      "63088": true,
      "63089": true,
      "63100": true,
      "63109": true,
      "63110": true,
      "63114": true,
      "63115": true,
      "63116": true,
      "63117": true,
      "63119": true,
      "63120": true,
      "63128": true,
      "63129": true,
      "63130": true,
      "63135": true,
      "63136": true,
      "63137": true,
      "63138": true,
      "63139": true,
      "63150": true,
      "63155": true,
      "63156": true,
      "63157": true,
      "63158": true,
      "63159": true,
      "63160": true,
      "63163": true,
      "63164": true,
      "63165": true,
      "63166": true,
      "63167": true,
      "63168": true,
      "63169": true,
      "63170": true,
      "63172": true,
      "63173": true,
      "63174": true,
      "63175": true,
      "63176": true,
      "63177": true,
      "63178": true,
      "63179": true,
      "63180": true,
      "63183": true,
      "63184": true,
      "63185": true,
      "63186": true,
      "63190": true,
      "63193": true,
      "63194": true,
      "63195": true,
      "63196": true,
      "63197": true,
      "63500": true,
      "63501": true,
      "63502": true,
      "63503": true,
      "63504": true,
      "63505": true,
      "63506": true,
      "63507": true,
      "63508": true,
      "63509": true,
      "63510": true,
      "63511": true,
      "63512": true,
      "63513": true,
      "63514": true,
      "63515": true,
      "63517": true,
      "63519": true,
      "63522": true,
      "63523": true,
      "63524": true,
      "63526": true,
      "63527": true,
      "63528": true,
      "63529": true
    },
    "TUXPAN": {
      "63200": true,
      "63202": true,
      "63203": true,
      "63205": true,
      "63207": true,
      "63225": true,
      "63227": true,
      "63660": true
    },
    "XALISCO": {
      "63780": true,
      "63782": true,
      "63783": true,
      "63784": true,
      "63785": true,
      "63786": true,
      "63787": true,
      "63788": true,
      "63790": true,
      "63792": true,
      "63793": true,
      "63794": true,
      "63795": true,
      "63797": true,
      "63799": true
    }
  },
  "NUEVO LEÓN": {
    "ABASOLO": {
      "65650": true,
      "65653": true,
      "65654": true,
      "65660": true,
      "65663": true
    },
    "ALLENDE": {
      "67350": true,
      "67353": true,
      "67354": true,
      "67362": true,
      "67363": true,
      "67370": true,
      "67373": true,
      "67374": true,
      "67380": true,
      "67383": true
    },
    "APODACA": {
      "66600": true,
      "66603": true,
      "66604": true,
      "66605": true,
      "66606": true,
      "66607": true,
      "66609": true,
      "66610": true,
      "66612": true,
      "66613": true,
      "66614": true,
      "66616": true,
      "66620": true,
      "66623": true,
      "66625": true,
      "66626": true,
      "66627": true,
      "66628": true,
      "66629": true,
      "66630": true,
      "66632": true,
      "66633": true,
      "66634": true,
      "66635": true,
      "66636": true,
      "66637": true,
      "66640": true,
      "66643": true,
      "66644": true,
      "66645": true,
      "66646": true,
      "66647": true,
      "66648": true,
      "66649": true
    },
    "CADEREYTA JIMENEZ": {
      "67451": true,
      "67453": true,
      "67454": true,
      "67455": true,
      "67456": true,
      "67457": true,
      "67458": true,
      "67459": true,
      "67462": true,
      "67463": true,
      "67464": true,
      "67467": true,
      "67469": true,
      "67470": true,
      "67473": true,
      "67474": true,
      "67475": true,
      "67476": true,
      "67480": true,
      "67483": true,
      "67484": true,
      "67485": true,
      "67486": true,
      "67488": true,
      "67492": true,
      "67499": true
    },
    "CERRALVO": {
      "65900": true,
      "65907": true,
      "65920": true,
      "65936": true,
      "65940": true
    },
    "CHINA": {
      "67050": true,
      "67052": true,
      "67066": true
    },
    "CIENEGA DE FLORES": {
      "65550": true,
      "65554": true,
      "65555": true,
      "65556": true,
      "65558": true,
      "65559": true,
      "65560": true,
      "65562": true,
      "65563": true,
      "65564": true,
      "65565": true,
      "65567": true,
      "65573": true,
      "65580": true,
      "65583": true
    },
    "DOCTOR GONZALEZ": {
      "66750": true,
      "66757": true,
      "66765": true,
      "66770": true,
      "66773": true
    },
    "EL CARMEN": {
      "66550": true,
      "66553": true,
      "66556": true,
      "66563": true,
      "66580": true,
      "66583": true
    },
    "GARCÍA": {
      "66000": true,
      "66003": true,
      "66004": true,
      "66005": true,
      "66006": true,
      "66007": true,
      "66008": true,
      "66009": true,
      "66012": true,
      "66013": true,
      "66014": true,
      "66017": true,
      "66018": true,
      "66020": true,
      "66023": true,
      "66024": true,
      "66026": true,
      "66027": true,
      "66035": true,
      "66036": true,
      "66037": true
    },
    "GENERAL BRAVO": {
      "67000": true,
      "67002": true,
      "67003": true,
      "67004": true,
      "67006": true,
      "67012": true
    },
    "GENERAL ESCOBEDO": {
      "66050": true,
      "66051": true,
      "66052": true,
      "66053": true,
      "66054": true,
      "66055": true,
      "66056": true,
      "66057": true,
      "66058": true,
      "66059": true,
      "66061": true,
      "66062": true,
      "66063": true,
      "66064": true,
      "66065": true,
      "66068": true,
      "66070": true,
      "66072": true,
      "66073": true,
      "66074": true,
      "66075": true,
      "66080": true,
      "66083": true,
      "66084": true,
      "66085": true
    },
    "GENERAL TERAN": {
      "67400": true,
      "67403": true,
      "67405": true,
      "67406": true,
      "67413": true,
      "67415": true,
      "67416": true,
      "67417": true,
      "67430": true,
      "67440": true,
      "67448": true,
      "67450": true
    },
    "GENERAL ZUAZUA": {
      "65750": true,
      "65760": true,
      "65766": true,
      "65776": true,
      "65780": true,
      "65783": true,
      "65796": true
    },
    "GUADALUPE": {
      "67100": true,
      "67110": true,
      "67112": true,
      "67113": true,
      "67115": true,
      "67116": true,
      "67117": true,
      "67118": true,
      "67119": true,
      "67120": true,
      "67123": true,
      "67124": true,
      "67125": true,
      "67126": true,
      "67128": true,
      "67129": true,
      "67130": true,
      "67132": true,
      "67133": true,
      "67134": true,
      "67140": true,
      "67144": true,
      "67150": true,
      "67153": true,
      "67154": true,
      "67155": true,
      "67160": true,
      "67163": true,
      "67164": true,
      "67165": true,
      "67167": true,
      "67168": true,
      "67169": true,
      "67170": true,
      "67173": true,
      "67174": true,
      "67175": true,
      "67176": true,
      "67177": true,
      "67178": true,
      "67179": true,
      "67180": true,
      "67182": true,
      "67183": true,
      "67184": true,
      "67185": true,
      "67186": true,
      "67188": true,
      "67189": true,
      "67190": true,
      "67192": true,
      "67193": true,
      "67194": true,
      "67195": true,
      "67196": true,
      "67197": true,
      "67198": true,
      "67199": true,
      "67200": true,
      "67202": true,
      "67203": true,
      "67204": true,
      "67205": true
    },
    "HIDALGO": {
      "65600": true
    },
    "HIGUERAS": {
      "65700": true,
      "65706": true,
      "65719": true
    },
    "HUALAHUISES": {
      "67880": true,
      "67881": true,
      "67884": true,
      "67885": true,
      "67890": true,
      "67893": true,
      "67895": true,
      "67896": true,
      "67897": true,
      "67898": true,
      "67899": true
    },
    "JUÁREZ": {
      "67250": true,
      "67253": true,
      "67254": true,
      "67255": true,
      "67256": true,
      "67257": true,
      "67258": true,
      "67259": true,
      "67260": true,
      "67262": true,
      "67265": true,
      "67266": true,
      "67267": true,
      "67269": true,
      "67275": true,
      "67276": true,
      "67277": true,
      "67279": true,
      "67280": true,
      "67286": true,
      "67287": true,
      "67288": true,
      "67289": true,
      "67290": true,
      "67293": true,
      "67294": true,
      "67296": true,
      "67298": true
    },
    "LINARES": {
      "67700": true,
      "67710": true,
      "67713": true,
      "67714": true,
      "67715": true,
      "67716": true,
      "67720": true,
      "67730": true,
      "67735": true,
      "67740": true,
      "67750": true,
      "67754": true,
      "67755": true,
      "67756": true,
      "67760": true,
      "67767": true,
      "67768": true,
      "67769": true,
      "67770": true,
      "67778": true,
      "67779": true,
      "67780": true,
      "67790": true,
      "67802": true,
      "67803": true,
      "67804": true,
      "67805": true,
      "67806": true,
      "67808": true,
      "67824": true,
      "67825": true,
      "67826": true
    },
    "LOS RAMONES": {
      "66800": true,
      "66810": true,
      "66812": true,
      "66820": true,
      "66824": true,
      "66825": true,
      "66826": true,
      "66827": true,
      "66830": true,
      "66835": true,
      "66840": true,
      "66842": true,
      "66847": true
    },
    "MARIN": {
      "66700": true,
      "66708": true,
      "66710": true,
      "66715": true
    },
    "MELCHOR OCAMPO": {
      "65950": true,
      "65957": true,
      "65958": true
    },
    "MINA": {
      "65100": true,
      "65116": true
    },
    "MONTEMORELOS": {
      "67500": true,
      "67510": true,
      "67512": true,
      "67515": true,
      "67520": true,
      "67528": true,
      "67530": true,
      "67535": true,
      "67540": true,
      "67541": true,
      "67543": true,
      "67544": true,
      "67550": true,
      "67554": true,
      "67560": true,
      "67563": true,
      "67570": true,
      "67580": true,
      "67587": true,
      "67588": true,
      "67589": true,
      "67590": true,
      "67599": true,
      "67600": true,
      "67604": true,
      "67606": true,
      "67607": true,
      "67608": true,
      "67610": true,
      "67611": true,
      "67612": true,
      "67613": true,
      "67614": true,
      "67615": true,
      "67616": true,
      "67617": true,
      "67618": true,
      "67619": true,
      "67640": true
    },
    "MONTERREY": {
      "64000": true,
      "64010": true,
      "64018": true,
      "64019": true,
      "64020": true,
      "64030": true,
      "64040": true,
      "64049": true,
      "64050": true,
      "64060": true,
      "64070": true,
      "64100": true,
      "64102": true,
      "64103": true,
      "64104": true,
      "64105": true,
      "64106": true,
      "64107": true,
      "64108": true,
      "64109": true,
      "64110": true,
      "64116": true,
      "64117": true,
      "64118": true,
      "64119": true,
      "64120": true,
      "64130": true,
      "64140": true,
      "64145": true,
      "64148": true,
      "64150": true,
      "64157": true,
      "64158": true,
      "64159": true,
      "64160": true,
      "64165": true,
      "64167": true,
      "64168": true,
      "64170": true,
      "64178": true,
      "64180": true,
      "64186": true,
      "64190": true,
      "64200": true,
      "64204": true,
      "64205": true,
      "64206": true,
      "64208": true,
      "64209": true,
      "64210": true,
      "64215": true,
      "64217": true,
      "64218": true,
      "64219": true,
      "64220": true,
      "64225": true,
      "64226": true,
      "64227": true,
      "64228": true,
      "64229": true,
      "64230": true,
      "64233": true,
      "64234": true,
      "64235": true,
      "64236": true,
      "64237": true,
      "64238": true,
      "64240": true,
      "64244": true,
      "64245": true,
      "64246": true,
      "64247": true,
      "64248": true,
      "64249": true,
      "64250": true,
      "64258": true,
      "64259": true,
      "64260": true,
      "64264": true,
      "64265": true,
      "64266": true,
      "64268": true,
      "64269": true,
      "64270": true,
      "64280": true,
      "64290": true,
      "64299": true,
      "64300": true,
      "64310": true,
      "64320": true,
      "64330": true,
      "64339": true,
      "64340": true,
      "64344": true,
      "64345": true,
      "64346": true,
      "64347": true,
      "64348": true,
      "64349": true,
      "64350": true,
      "64360": true,
      "64365": true,
      "64366": true,
      "64367": true,
      "64368": true,
      "64369": true,
      "64370": true,
      "64380": true,
      "64390": true,
      "64400": true,
      "64410": true,
      "64420": true,
      "64430": true,
      "64440": true,
      "64450": true,
      "64460": true,
      "64470": true,
      "64480": true,
      "64488": true,
      "64489": true,
      "64490": true,
      "64500": true,
      "64508": true,
      "64510": true,
      "64517": true,
      "64520": true,
      "64530": true,
      "64536": true,
      "64540": true,
      "64549": true,
      "64550": true,
      "64560": true,
      "64568": true,
      "64570": true,
      "64580": true,
      "64590": true,
      "64600": true,
      "64610": true,
      "64618": true,
      "64619": true,
      "64620": true,
      "64623": true,
      "64630": true,
      "64632": true,
      "64633": true,
      "64634": true,
      "64635": true,
      "64636": true,
      "64637": true,
      "64638": true,
      "64639": true,
      "64640": true,
      "64649": true,
      "64650": true,
      "64659": true,
      "64660": true,
      "64700": true,
      "64710": true,
      "64715": true,
      "64718": true,
      "64720": true,
      "64730": true,
      "64740": true,
      "64750": true,
      "64753": true,
      "64754": true,
      "64760": true,
      "64764": true,
      "64765": true,
      "64769": true,
      "64770": true,
      "64780": true,
      "64783": true,
      "64788": true,
      "64790": true,
      "64798": true,
      "64800": true,
      "64810": true,
      "64820": true,
      "64830": true,
      "64833": true,
      "64834": true,
      "64836": true,
      "64840": true,
      "64844": true,
      "64845": true,
      "64849": true,
      "64850": true,
      "64858": true,
      "64859": true,
      "64860": true,
      "64865": true,
      "64878": true,
      "64880": true,
      "64890": true,
      "64893": true,
      "64898": true,
      "64900": true,
      "64909": true,
      "64910": true,
      "64920": true,
      "64925": true,
      "64926": true,
      "64930": true,
      "64940": true,
      "64949": true,
      "64950": true,
      "64960": true,
      "64968": true,
      "64969": true,
      "64970": true,
      "64978": true,
      "64979": true,
      "64980": true,
      "64983": true,
      "64984": true,
      "64985": true,
      "64986": true,
      "64987": true,
      "64988": true,
      "64989": true,
      "64990": true,
      "64996": true,
      "64997": true
    },
    "PESQUERIA": {
      "66650": true,
      "66653": true,
      "66655": true,
      "66657": true,
      "66658": true,
      "66660": true,
      "66670": true,
      "66672": true,
      "66673": true,
      "66674": true,
      "66675": true,
      "66676": true,
      "66677": true
    },
    "SABINAS HIDALGO": {
      "65200": true,
      "65210": true,
      "65220": true,
      "65230": true,
      "65234": true,
      "65240": true,
      "65243": true,
      "65244": true,
      "65249": true,
      "65250": true,
      "65255": true,
      "65256": true,
      "65257": true,
      "65260": true,
      "65270": true,
      "65272": true,
      "65276": true,
      "65280": true,
      "65288": true,
      "65289": true,
      "65290": true,
      "65299": true,
      "65300": true,
      "65302": true,
      "65336": true,
      "65340": true,
      "65347": true,
      "65348": true
    },
    "SALINAS VICTORIA": {
      "65500": true,
      "65503": true,
      "65504": true,
      "65505": true,
      "65510": true,
      "65513": true,
      "65514": true,
      "65515": true,
      "65516": true,
      "65517": true,
      "65526": true,
      "65527": true,
      "65537": true,
      "65546": true,
      "65548": true
    },
    "SAN NICOLAS DE LOS GARZA": {
      "66400": true,
      "66410": true,
      "66413": true,
      "66414": true,
      "66415": true,
      "66417": true,
      "66418": true,
      "66420": true,
      "66422": true,
      "66423": true,
      "66424": true,
      "66425": true,
      "66427": true,
      "66428": true,
      "66430": true,
      "66434": true,
      "66435": true,
      "66436": true,
      "66437": true,
      "66438": true,
      "66440": true,
      "66444": true,
      "66445": true,
      "66446": true,
      "66447": true,
      "66448": true,
      "66449": true,
      "66450": true,
      "66455": true,
      "66456": true,
      "66457": true,
      "66458": true,
      "66459": true,
      "66460": true,
      "66463": true,
      "66464": true,
      "66465": true,
      "66466": true,
      "66468": true,
      "66469": true,
      "66470": true,
      "66473": true,
      "66475": true,
      "66476": true,
      "66477": true,
      "66478": true,
      "66479": true,
      "66480": true,
      "66482": true,
      "66484": true,
      "66485": true,
      "66486": true,
      "66488": true,
      "66489": true,
      "66490": true,
      "66494": true,
      "66495": true,
      "66496": true,
      "66499": true
    },
    "SAN NICOLÁS DE LOS GARZA": {
      "66400": true,
      "66410": true,
      "66413": true,
      "66414": true,
      "66415": true,
      "66417": true,
      "66418": true,
      "66420": true,
      "66422": true,
      "66425": true,
      "66427": true,
      "66428": true,
      "66430": true,
      "66435": true,
      "66436": true,
      "66437": true,
      "66438": true,
      "66440": true,
      "66444": true,
      "66445": true,
      "66446": true,
      "66447": true,
      "66448": true,
      "66449": true,
      "66450": true,
      "66455": true,
      "66456": true,
      "66457": true,
      "66458": true,
      "66460": true,
      "66463": true,
      "66465": true,
      "66466": true,
      "66468": true,
      "66469": true,
      "66470": true,
      "66473": true,
      "66475": true,
      "66476": true,
      "66477": true,
      "66478": true,
      "66479": true,
      "66480": true,
      "66482": true,
      "66484": true,
      "66485": true,
      "66486": true,
      "66488": true,
      "66489": true,
      "66490": true,
      "66494": true,
      "66495": true,
      "66496": true,
      "66499": true
    },
    "SAN PEDRO GARZA GARCIA": {
      "66200": true,
      "66210": true,
      "66214": true,
      "66215": true,
      "66216": true,
      "66217": true,
      "66218": true,
      "66219": true,
      "66220": true,
      "66224": true,
      "66225": true,
      "66226": true,
      "66227": true,
      "66228": true,
      "66230": true,
      "66233": true,
      "66234": true,
      "66235": true,
      "66236": true,
      "66237": true,
      "66238": true,
      "66239": true,
      "66240": true,
      "66244": true,
      "66245": true,
      "66246": true,
      "66247": true,
      "66249": true,
      "66250": true,
      "66254": true,
      "66256": true,
      "66257": true,
      "66259": true,
      "66260": true,
      "66263": true,
      "66265": true,
      "66266": true,
      "66267": true,
      "66268": true,
      "66270": true,
      "66273": true,
      "66274": true,
      "66275": true,
      "66276": true,
      "66277": true,
      "66278": true,
      "66279": true,
      "66280": true,
      "66284": true,
      "66285": true,
      "66286": true,
      "66287": true,
      "66290": true,
      "66295": true,
      "66296": true,
      "66297": true
    },
    "SAN PEDRO GARZA GARCÍA": {
      "66200": true,
      "66210": true,
      "66214": true,
      "66215": true,
      "66216": true,
      "66217": true,
      "66218": true,
      "66219": true,
      "66220": true,
      "66224": true,
      "66225": true,
      "66226": true,
      "66227": true,
      "66228": true,
      "66230": true,
      "66233": true,
      "66235": true,
      "66236": true,
      "66237": true,
      "66238": true,
      "66239": true,
      "66240": true,
      "66244": true,
      "66245": true,
      "66247": true,
      "66249": true,
      "66250": true,
      "66254": true,
      "66256": true,
      "66257": true,
      "66259": true,
      "66260": true,
      "66263": true,
      "66265": true,
      "66266": true,
      "66267": true,
      "66268": true,
      "66270": true,
      "66273": true,
      "66276": true,
      "66277": true,
      "66280": true,
      "66285": true,
      "66287": true,
      "66295": true,
      "66297": true
    },
    "SANTA CATARINA": {
      "66100": true,
      "66110": true,
      "66114": true,
      "66115": true,
      "66116": true,
      "66117": true,
      "66118": true,
      "66119": true,
      "66120": true,
      "66129": true,
      "66139": true,
      "66140": true,
      "66145": true,
      "66147": true,
      "66149": true,
      "66150": true,
      "66160": true,
      "66165": true,
      "66166": true,
      "66167": true,
      "66168": true,
      "66169": true,
      "66170": true,
      "66179": true,
      "66180": true,
      "66187": true,
      "66188": true,
      "66189": true,
      "66190": true,
      "66195": true,
      "66196": true,
      "66197": true,
      "66198": true,
      "66199": true,
      "66350": true,
      "66353": true,
      "66354": true,
      "66356": true,
      "66357": true,
      "66358": true,
      "66359": true,
      "66360": true,
      "66362": true,
      "66363": true,
      "66364": true,
      "66365": true,
      "66366": true,
      "66367": true,
      "66368": true,
      "66369": true,
      "66370": true,
      "66373": true,
      "66374": true,
      "66375": true,
      "66376": true,
      "66377": true,
      "66378": true,
      "66380": true,
      "66384": true,
      "66390": true
    },
    "SANTIAGO": {
      "67300": true,
      "67302": true,
      "67303": true,
      "67307": true,
      "67308": true,
      "67310": true,
      "67312": true,
      "67313": true,
      "67314": true,
      "67315": true,
      "67316": true,
      "67317": true,
      "67318": true,
      "67320": true,
      "67322": true,
      "67323": true,
      "67324": true,
      "67325": true,
      "67327": true,
      "67328": true,
      "67329": true,
      "67330": true,
      "67340": true,
      "67344": true
    },
    "VILLALDAMA": {
      "65350": true,
      "65357": true,
      "65390": true,
      "65395": true
    }
  },
  "OAXACA": {
    "OAXACA DE JUAREZ": {
      "68000": true,
      "68010": true,
      "68013": true,
      "68016": true,
      "68018": true,
      "68020": true,
      "68023": true,
      "68024": true,
      "68025": true,
      "68026": true,
      "68027": true,
      "68028": true,
      "68030": true,
      "68033": true,
      "68034": true,
      "68039": true,
      "68040": true,
      "68043": true,
      "68044": true,
      "68045": true,
      "68050": true,
      "68060": true,
      "68067": true,
      "68068": true,
      "68070": true,
      "68075": true,
      "68080": true,
      "68083": true,
      "68090": true,
      "68100": true,
      "68103": true,
      "68104": true,
      "68110": true,
      "68115": true,
      "68120": true,
      "68125": true,
      "68126": true,
      "68127": true,
      "68128": true,
      "68130": true,
      "68133": true,
      "68134": true,
      "68140": true,
      "68143": true,
      "68144": true,
      "68146": true,
      "68148": true,
      "68149": true,
      "68150": true,
      "68153": true,
      "68154": true,
      "68155": true,
      "68156": true,
      "68157": true,
      "68159": true,
      "68274": true,
      "68275": true,
      "68276": true,
      "68277": true,
      "68278": true,
      "68280": true,
      "68283": true,
      "68284": true
    },
    "SAN AGUSTIN YATARENI": {
      "68290": true
    },
    "SAN ANDRES HUAYAPAM": {
      "68287": true,
      "68288": true
    },
    "SAN ANTONIO DE LA CAL": {
      "71256": true
    },
    "SAN JACINTO AMILPAS": {
      "68285": true
    },
    "SAN SEBASTIAN TUTLA": {
      "71320": true,
      "71323": true,
      "71324": true
    },
    "SANTA CRUZ AMILPAS": {
      "71226": true,
      "71227": true,
      "71228": true
    },
    "SANTA CRUZ XOXOCOTLAN": {
      "71230": true,
      "71231": true,
      "71232": true,
      "71233": true,
      "71235": true
    },
    "SANTA LUCIA DEL CAMINO": {
      "71240": true,
      "71242": true,
      "71243": true,
      "71244": true,
      "71245": true
    },
    "SANTA MARIA ATZOMPA": {
      "71220": true,
      "71222": true,
      "71223": true
    },
    "SANTA MARIA DEL TULE": {
      "68297": true,
      "68299": true
    },
    "TLALIXTAC DE CABRERA": {
      "68270": true
    }
  },
  "PUEBLA": {
    "ACAJETE": {
      "75110": true,
      "75112": true,
      "75113": true,
      "75114": true,
      "75116": true,
      "75117": true,
      "75118": true,
      "75119": true
    },
    "ACATZINGO": {
      "75150": true,
      "75151": true,
      "75153": true,
      "75154": true,
      "75155": true,
      "75157": true,
      "75158": true,
      "75159": true
    },
    "ACTEOPAN": {
      "74510": true,
      "74514": true
    },
    "AHUATLAN": {
      "74640": true,
      "74641": true,
      "74645": true,
      "74646": true,
      "74647": true,
      "74649": true
    },
    "AJALPAN": {
      "75910": true,
      "75914": true
    },
    "AMOZOC": {
      "72980": true,
      "72983": true,
      "72984": true,
      "72985": true,
      "72986": true,
      "72987": true,
      "72988": true,
      "72989": true,
      "72990": true,
      "72992": true,
      "72993": true,
      "72994": true,
      "72995": true,
      "72996": true,
      "72997": true
    },
    "ATEMPAN": {
      "73940": true,
      "73941": true,
      "73948": true,
      "73949": true
    },
    "ATLIXCO": {
      "74200": true,
      "74210": true,
      "74215": true,
      "74218": true,
      "74220": true,
      "74227": true,
      "74230": true,
      "74239": true,
      "74240": true,
      "74250": true,
      "74260": true,
      "74270": true,
      "74280": true,
      "74290": true,
      "74293": true,
      "74294": true,
      "74295": true,
      "74360": true,
      "74363": true,
      "74365": true,
      "74367": true,
      "74368": true,
      "74369": true
    },
    "ATOYATEMPAN": {
      "75620": true,
      "75623": true
    },
    "ATZALA": {
      "74590": true
    },
    "ATZITZIHUACAN": {
      "74500": true,
      "74505": true,
      "74506": true,
      "74507": true,
      "74508": true
    },
    "CALPAN": {
      "74180": true,
      "74183": true
    },
    "CANADA MORELOS": {
      "75580": true,
      "75584": true,
      "75585": true,
      "75587": true,
      "75588": true,
      "75589": true,
      "75590": true,
      "75591": true,
      "75592": true,
      "75593": true,
      "75597": true
    },
    "CHALCHICOMULA DE SESMA": {
      "75520": true,
      "75524": true,
      "75525": true,
      "75526": true,
      "75527": true,
      "75528": true,
      "75529": true,
      "75530": true,
      "75535": true,
      "75536": true,
      "75537": true,
      "75538": true,
      "75539": true
    },
    "CHIAUTLA": {
      "74730": true,
      "74732": true,
      "74734": true,
      "74737": true
    },
    "CHIAUTZINGO": {
      "74150": true,
      "74155": true
    },
    "CHIETLA": {
      "74580": true,
      "74582": true,
      "74584": true,
      "74585": true,
      "74587": true,
      "74589": true
    },
    "CHIGNAHUAPAN": {
      "73298": true,
      "73299": true,
      "73300": true,
      "73303": true,
      "73304": true,
      "73305": true,
      "73306": true,
      "73307": true,
      "73308": true,
      "73309": true
    },
    "COATZINGO": {
      "74650": true,
      "74653": true,
      "74656": true
    },
    "COHUECAN": {
      "74520": true,
      "74521": true,
      "74522": true
    },
    "CORONANGO": {
      "72670": true,
      "72680": true,
      "72683": true,
      "72684": true,
      "72685": true
    },
    "CUAPIAXTLA DE MADERO": {
      "75420": true,
      "75421": true,
      "75424": true
    },
    "CUAUTINCHAN": {
      "75220": true,
      "75221": true,
      "75223": true,
      "75225": true,
      "75226": true,
      "75230": true,
      "75232": true,
      "75233": true,
      "75234": true,
      "75235": true,
      "75237": true,
      "75238": true
    },
    "CUAUTLANCINGO": {
      "72700": true,
      "72702": true,
      "72703": true,
      "72704": true,
      "72705": true,
      "72706": true,
      "72707": true,
      "72710": true,
      "72712": true,
      "72713": true,
      "72720": true,
      "72723": true,
      "72724": true,
      "72725": true,
      "72730": true,
      "72733": true,
      "72735": true
    },
    "DOMINGO ARENAS": {
      "74170": true,
      "74173": true
    },
    "EPATLAN": {
      "74630": true,
      "74633": true,
      "74634": true,
      "74635": true
    },
    "ESPERANZA": {
      "75560": true,
      "75562": true,
      "75563": true,
      "75565": true,
      "75570": true,
      "75571": true
    },
    "GENERAL FELIPE ANGELES": {
      "75170": true,
      "75171": true,
      "75173": true,
      "75175": true,
      "75176": true,
      "75178": true,
      "75179": true
    },
    "HUAQUECHULA": {
      "74370": true,
      "74372": true,
      "74373": true,
      "74374": true,
      "74375": true,
      "74376": true,
      "74377": true,
      "74378": true,
      "74379": true
    },
    "HUATLATLAUCA": {
      "75399": true
    },
    "HUAUCHINANGO": {
      "73160": true,
      "73161": true,
      "73163": true,
      "73164": true,
      "73165": true,
      "73166": true,
      "73167": true,
      "73168": true,
      "73169": true,
      "73170": true,
      "73172": true,
      "73173": true,
      "73174": true,
      "73175": true,
      "73176": true,
      "73177": true,
      "73178": true
    },
    "HUEJOTZINGO": {
      "74160": true,
      "74162": true,
      "74163": true,
      "74165": true,
      "74166": true,
      "74167": true,
      "74168": true,
      "74169": true
    },
    "HUITZILTEPEC": {
      "75640": true,
      "75641": true
    },
    "IZUCAR DE MATAMOROS": {
      "74400": true,
      "74410": true,
      "74418": true,
      "74419": true,
      "74420": true,
      "74430": true,
      "74435": true,
      "74440": true,
      "74443": true,
      "74448": true,
      "74450": true,
      "74460": true,
      "74463": true,
      "74467": true,
      "74470": true,
      "74480": true,
      "74490": true,
      "74570": true,
      "74573": true,
      "74575": true,
      "74577": true
    },
    "JUAN C. BONILLA": {
      "72640": true,
      "72660": true,
      "72665": true,
      "72668": true,
      "72669": true
    },
    "JUAN N. MENDEZ": {
      "75690": true,
      "75694": true,
      "75695": true,
      "75698": true,
      "75699": true
    },
    "LIBRES": {
      "73780": true,
      "73783": true,
      "73784": true,
      "73785": true,
      "73790": true,
      "73791": true,
      "73792": true,
      "73794": true,
      "73795": true,
      "73796": true,
      "73797": true,
      "73798": true,
      "73799": true
    },
    "LOS REYES DE JUAREZ": {
      "75400": true,
      "75404": true,
      "75410": true,
      "75412": true,
      "75415": true
    },
    "MAZAPILTEPEC DE JUAREZ": {
      "75130": true,
      "75133": true,
      "75134": true,
      "75135": true,
      "75136": true,
      "75137": true,
      "75138": true
    },
    "MIXTLA": {
      "75260": true,
      "75270": true
    },
    "MOLCAXAC": {
      "75650": true,
      "75653": true,
      "75655": true,
      "75657": true,
      "75659": true
    },
    "NEALTICAN": {
      "74300": true
    },
    "NOPALUCAN": {
      "75120": true,
      "75125": true,
      "75126": true,
      "75127": true,
      "75128": true,
      "75129": true
    },
    "OCOYUCAN": {
      "72850": true,
      "72860": true,
      "72861": true,
      "72863": true,
      "72864": true,
      "72865": true,
      "72866": true
    },
    "ORIENTAL": {
      "75020": true,
      "75021": true,
      "75023": true,
      "75024": true,
      "75025": true,
      "75026": true,
      "75029": true
    },
    "PALMAR DE BRAVO": {
      "75500": true,
      "75505": true,
      "75507": true,
      "75510": true,
      "75512": true,
      "75513": true,
      "75514": true,
      "75515": true,
      "75517": true
    },
    "PUEBLA": {
      "72000": true,
      "72010": true,
      "72013": true,
      "72014": true,
      "72015": true,
      "72016": true,
      "72017": true,
      "72019": true,
      "72020": true,
      "72023": true,
      "72029": true,
      "72030": true,
      "72040": true,
      "72044": true,
      "72045": true,
      "72050": true,
      "72060": true,
      "72062": true,
      "72070": true,
      "72080": true,
      "72089": true,
      "72090": true,
      "72094": true,
      "72100": true,
      "72103": true,
      "72104": true,
      "72105": true,
      "72106": true,
      "72108": true,
      "72110": true,
      "72114": true,
      "72115": true,
      "72120": true,
      "72124": true,
      "72127": true,
      "72130": true,
      "72135": true,
      "72140": true,
      "72150": true,
      "72154": true,
      "72160": true,
      "72170": true,
      "72176": true,
      "72180": true,
      "72189": true,
      "72190": true,
      "72193": true,
      "72194": true,
      "72197": true,
      "72200": true,
      "72210": true,
      "72219": true,
      "72220": true,
      "72223": true,
      "72225": true,
      "72227": true,
      "72228": true,
      "72229": true,
      "72230": true,
      "72240": true,
      "72243": true,
      "72250": true,
      "72260": true,
      "72266": true,
      "72267": true,
      "72270": true,
      "72280": true,
      "72290": true,
      "72300": true,
      "72303": true,
      "72304": true,
      "72307": true,
      "72308": true,
      "72309": true,
      "72310": true,
      "72314": true,
      "72320": true,
      "72330": true,
      "72340": true,
      "72350": true,
      "72359": true,
      "72360": true,
      "72364": true,
      "72365": true,
      "72370": true,
      "72373": true,
      "72377": true,
      "72380": true,
      "72390": true,
      "72400": true,
      "72403": true,
      "72410": true,
      "72420": true,
      "72423": true,
      "72424": true,
      "72425": true,
      "72430": true,
      "72440": true,
      "72450": true,
      "72453": true,
      "72456": true,
      "72459": true,
      "72460": true,
      "72464": true,
      "72468": true,
      "72470": true,
      "72474": true,
      "72477": true,
      "72478": true,
      "72480": true,
      "72482": true,
      "72483": true,
      "72484": true,
      "72490": true,
      "72492": true,
      "72494": true,
      "72495": true,
      "72496": true,
      "72497": true,
      "72498": true,
      "72499": true,
      "72500": true,
      "72501": true,
      "72503": true,
      "72504": true,
      "72505": true,
      "72510": true,
      "72520": true,
      "72523": true,
      "72530": true,
      "72532": true,
      "72533": true,
      "72534": true,
      "72538": true,
      "72540": true,
      "72543": true,
      "72550": true,
      "72560": true,
      "72564": true,
      "72565": true,
      "72567": true,
      "72570": true,
      "72573": true,
      "72574": true,
      "72575": true,
      "72580": true,
      "72582": true,
      "72583": true,
      "72584": true,
      "72587": true,
      "72589": true,
      "72590": true,
      "72592": true,
      "72593": true,
      "72594": true,
      "72595": true,
      "72596": true,
      "72597": true,
      "72599": true,
      "72900": true,
      "72943": true,
      "72960": true,
      "72967": true,
      "72970": true,
      "72971": true,
      "72973": true,
      "72975": true,
      "72977": true,
      "72978": true
    },
    "QUECHOLAC": {
      "75460": true,
      "75464": true,
      "75465": true,
      "75466": true,
      "75467": true,
      "75468": true,
      "75469": true,
      "75470": true,
      "75471": true,
      "75472": true,
      "75476": true
    },
    "RAFAEL LARA GRAJALES": {
      "75000": true
    },
    "SAN ANDRES CHOLULA": {
      "72803": true,
      "72805": true,
      "72810": true,
      "72813": true,
      "72814": true,
      "72815": true,
      "72817": true,
      "72819": true,
      "72820": true,
      "72823": true,
      "72824": true,
      "72825": true,
      "72826": true,
      "72828": true,
      "72830": true,
      "72833": true,
      "72835": true,
      "72836": true,
      "72837": true,
      "72840": true,
      "72843": true,
      "72846": true,
      "72848": true
    },
    "SAN ANDRÉS CHOLULA": {
      "72803": true,
      "72805": true,
      "72810": true,
      "72813": true,
      "72814": true,
      "72815": true,
      "72817": true,
      "72819": true,
      "72820": true,
      "72823": true,
      "72824": true,
      "72825": true,
      "72826": true,
      "72828": true,
      "72830": true,
      "72833": true,
      "72835": true,
      "72836": true,
      "72837": true,
      "72840": true,
      "72843": true,
      "72846": true
    },
    "SAN DIEGO LA MESA TOCHIMILTZINGO": {
      "74380": true,
      "74382": true,
      "74385": true,
      "74389": true
    },
    "SAN FELIPE TEOTLALCINGO": {
      "74140": true,
      "74144": true
    },
    "SAN GREGORIO ATZOMPA": {
      "74320": true,
      "74325": true
    },
    "SAN JERONIMO TECUANIPAN": {
      "74310": true
    },
    "SAN JOSE CHIAPA": {
      "75010": true,
      "75012": true,
      "75014": true,
      "75016": true
    },
    "SAN JUAN ATZOMPA": {
      "75360": true
    },
    "SAN MARTIN TEXMELUCAN": {
      "74000": true,
      "74010": true,
      "74013": true,
      "74020": true,
      "74021": true,
      "74030": true,
      "74031": true,
      "74040": true,
      "74041": true,
      "74042": true,
      "74050": true,
      "74053": true,
      "74058": true,
      "74059": true,
      "74060": true,
      "74064": true,
      "74068": true,
      "74069": true,
      "74070": true,
      "74074": true,
      "74078": true,
      "74079": true,
      "74080": true,
      "74088": true,
      "74089": true,
      "74090": true,
      "74120": true,
      "74122": true,
      "74125": true,
      "74126": true,
      "74128": true,
      "74129": true
    },
    "SAN MARTIN TOTOLTEPEC": {
      "74610": true
    },
    "SAN MATIAS TLALANCALECA": {
      "74110": true,
      "74115": true,
      "74116": true,
      "74117": true
    },
    "SAN MIGUEL XOXTLA": {
      "72620": true,
      "72623": true
    },
    "SAN NICOLAS DE LOS RANCHOS": {
      "74190": true
    },
    "SAN PEDRO CHOLULA": {
      "72750": true,
      "72754": true,
      "72755": true,
      "72756": true,
      "72757": true,
      "72760": true,
      "72762": true,
      "72764": true,
      "72765": true,
      "72766": true,
      "72767": true,
      "72768": true,
      "72770": true,
      "72772": true,
      "72774": true,
      "72775": true,
      "72776": true,
      "72777": true,
      "72778": true
    },
    "SAN SALVADOR EL SECO": {
      "75160": true,
      "75162": true,
      "75163": true,
      "75164": true,
      "75165": true,
      "75166": true,
      "75167": true,
      "75169": true
    },
    "SAN SALVADOR EL VERDE": {
      "74130": true,
      "74133": true,
      "74134": true,
      "74135": true,
      "74136": true,
      "74137": true,
      "74138": true
    },
    "SAN SALVADOR HUIXCOLOTLA": {
      "75440": true,
      "75443": true,
      "75444": true,
      "75445": true
    },
    "SANTA ISABEL CHOLULA": {
      "74350": true,
      "74355": true,
      "74357": true,
      "74358": true
    },
    "SANTIAGO MIAHUATLAN": {
      "75820": true,
      "75822": true,
      "75824": true,
      "75825": true,
      "75827": true
    },
    "SANTO TOMAS HUEYOTLIPAN": {
      "75280": true,
      "75290": true
    },
    "SOLTEPEC": {
      "75140": true,
      "75142": true,
      "75143": true,
      "75145": true,
      "75147": true,
      "75148": true
    },
    "TECALI DE HERRERA": {
      "75240": true,
      "75245": true,
      "75250": true,
      "75254": true,
      "75256": true,
      "75257": true,
      "75258": true,
      "75259": true
    },
    "TECAMACHALCO": {
      "75480": true,
      "75483": true,
      "75484": true,
      "75485": true,
      "75486": true,
      "75487": true,
      "75490": true,
      "75491": true,
      "75492": true,
      "75494": true,
      "75495": true,
      "75497": true,
      "75498": true,
      "75499": true
    },
    "TEHUACAN": {
      "75700": true,
      "75710": true,
      "75717": true,
      "75718": true,
      "75719": true,
      "75720": true,
      "75725": true,
      "75726": true,
      "75730": true,
      "75731": true,
      "75732": true,
      "75740": true,
      "75741": true,
      "75742": true,
      "75743": true,
      "75750": true,
      "75758": true,
      "75760": true,
      "75763": true,
      "75764": true,
      "75765": true,
      "75766": true,
      "75768": true,
      "75769": true,
      "75770": true,
      "75780": true,
      "75784": true,
      "75786": true,
      "75790": true,
      "75793": true,
      "75794": true,
      "75795": true,
      "75796": true,
      "75797": true,
      "75799": true,
      "75853": true,
      "75855": true,
      "75857": true,
      "75858": true,
      "75859": true
    },
    "TEOPANTLAN": {
      "74600": true
    },
    "TEPANCO DE LOPEZ": {
      "75800": true,
      "75805": true,
      "75807": true,
      "75809": true
    },
    "TEPATLAXCO DE HIDALGO": {
      "75100": true
    },
    "TEPEACA": {
      "75200": true,
      "75203": true,
      "75204": true,
      "75205": true,
      "75206": true,
      "75207": true,
      "75210": true,
      "75211": true,
      "75212": true,
      "75214": true,
      "75215": true,
      "75219": true
    },
    "TEPEOJUMA": {
      "74390": true,
      "74393": true,
      "74394": true,
      "74395": true,
      "74397": true
    },
    "TEPEXCO": {
      "74550": true,
      "74557": true
    },
    "TEPEXI DE RODRIGUEZ": {
      "74690": true,
      "74691": true,
      "74692": true,
      "74693": true,
      "74694": true,
      "74695": true,
      "74696": true,
      "74697": true,
      "74698": true
    },
    "TEPEYAHUALCO DE CUAUHTEMOC": {
      "75630": true,
      "75635": true
    },
    "TEZIUTLAN": {
      "73800": true,
      "73803": true,
      "73811": true,
      "73815": true,
      "73816": true,
      "73820": true,
      "73830": true,
      "73831": true,
      "73840": true,
      "73841": true,
      "73850": true,
      "73860": true,
      "73863": true,
      "73870": true,
      "73880": true,
      "73881": true,
      "73885": true,
      "73886": true,
      "73887": true,
      "73890": true,
      "73895": true,
      "73899": true,
      "73960": true,
      "73965": true,
      "73966": true,
      "73967": true,
      "73968": true
    },
    "TIANGUISMANALCO": {
      "74340": true,
      "74342": true,
      "74343": true,
      "74347": true,
      "74348": true
    },
    "TILAPA": {
      "74560": true,
      "74565": true,
      "74566": true,
      "74567": true,
      "74568": true
    },
    "TLACHICHUCA": {
      "75050": true,
      "75053": true,
      "75054": true,
      "75055": true,
      "75057": true,
      "75058": true,
      "75059": true
    },
    "TLACOTEPEC DE BENITO JUAREZ": {
      "75680": true,
      "75681": true,
      "75685": true,
      "75686": true,
      "75687": true,
      "75689": true
    },
    "TLAHUAPAN": {
      "74100": true,
      "74102": true,
      "74103": true,
      "74104": true,
      "74105": true,
      "74106": true,
      "74107": true,
      "74108": true,
      "74109": true
    },
    "TLALTENANGO": {
      "72600": true
    },
    "TLANEPANTLA": {
      "75600": true
    },
    "TLAPANALA": {
      "74540": true,
      "74544": true,
      "74545": true,
      "74546": true,
      "74547": true
    },
    "TLATLAUQUITEPEC": {
      "73900": true,
      "73903": true,
      "73904": true,
      "73905": true,
      "73906": true,
      "73907": true,
      "73909": true
    },
    "TLAXCO": {
      "73060": true,
      "73063": true,
      "73064": true,
      "73065": true,
      "73067": true,
      "73068": true,
      "73069": true
    },
    "TOCHIMILCO": {
      "74330": true,
      "74334": true,
      "74336": true,
      "74337": true,
      "74339": true
    },
    "TOCHTEPEC": {
      "75610": true,
      "75613": true,
      "75614": true,
      "75615": true,
      "75616": true,
      "75617": true,
      "75618": true,
      "75619": true
    },
    "TZICATLACOYAN": {
      "75300": true,
      "75301": true,
      "75305": true,
      "75306": true,
      "75307": true,
      "75310": true,
      "75311": true
    },
    "VENUSTIANO CARRANZA": {
      "73030": true,
      "73036": true,
      "73037": true,
      "73040": true,
      "73042": true,
      "73045": true,
      "73047": true,
      "73048": true,
      "73049": true
    },
    "XICOTEPEC": {
      "73080": true,
      "73087": true,
      "73089": true,
      "73090": true,
      "73098": true,
      "73099": true
    },
    "XOCHILTEPEC": {
      "74620": true
    },
    "XOCHITLAN TODOS SANTOS": {
      "75660": true,
      "75664": true,
      "75666": true,
      "75667": true
    },
    "YEHUALTEPEC": {
      "75670": true,
      "75673": true,
      "75675": true,
      "75676": true,
      "75678": true,
      "75679": true
    },
    "ZACAPOAXTLA": {
      "73680": true,
      "73681": true,
      "73683": true,
      "73684": true,
      "73685": true,
      "73686": true,
      "73687": true,
      "73688": true,
      "73689": true,
      "73690": true,
      "73691": true,
      "73692": true,
      "73693": true,
      "73694": true,
      "73697": true
    },
    "ZACATLAN": {
      "73310": true,
      "73312": true,
      "73313": true,
      "73314": true,
      "73315": true,
      "73316": true,
      "73317": true
    },
    "ZARAGOZA": {
      "73700": true,
      "73702": true,
      "73703": true
    }
  },
  "QUERÉTARO": {
    "AMEALCO DE BONFIL": {
      "76850": true,
      "76860": true,
      "76862": true,
      "76863": true,
      "76870": true,
      "76874": true,
      "76875": true,
      "76876": true,
      "76877": true,
      "76878": true,
      "76880": true,
      "76883": true,
      "76884": true,
      "76885": true,
      "76886": true,
      "76887": true,
      "76888": true,
      "76889": true,
      "76894": true,
      "76895": true,
      "76896": true
    },
    "CADEREYTA DE MONTES": {
      "76500": true,
      "76503": true,
      "76504": true,
      "76505": true,
      "76506": true,
      "76510": true,
      "76513": true,
      "76514": true,
      "76515": true,
      "76516": true,
      "76517": true,
      "76525": true,
      "76540": true,
      "76543": true,
      "76548": true
    },
    "COLON": {
      "76270": true,
      "76274": true,
      "76276": true,
      "76277": true,
      "76279": true,
      "76280": true,
      "76281": true,
      "76282": true,
      "76283": true,
      "76284": true,
      "76286": true,
      "76288": true,
      "76289": true,
      "76290": true,
      "76293": true,
      "76295": true,
      "76296": true,
      "76297": true,
      "76298": true,
      "76299": true
    },
    "CORREGIDORA": {
      "76900": true,
      "76902": true,
      "76903": true,
      "76904": true,
      "76905": true,
      "76906": true,
      "76907": true,
      "76908": true,
      "76910": true,
      "76912": true,
      "76915": true,
      "76920": true,
      "76922": true,
      "76923": true,
      "76924": true,
      "76925": true,
      "76926": true,
      "76927": true,
      "76928": true,
      "76930": true
    },
    "EL MARQUÉS": {
      "76240": true,
      "76243": true,
      "76244": true,
      "76245": true,
      "76246": true,
      "76247": true,
      "76248": true,
      "76249": true,
      "76250": true,
      "76251": true,
      "76252": true,
      "76253": true,
      "76254": true,
      "76255": true,
      "76256": true,
      "76257": true,
      "76258": true,
      "76259": true,
      "76260": true,
      "76261": true,
      "76262": true,
      "76263": true,
      "76264": true,
      "76265": true,
      "76266": true,
      "76267": true,
      "76268": true,
      "76269": true
    },
    "EZEQUIEL MONTES": {
      "76650": true,
      "76651": true,
      "76654": true,
      "76655": true,
      "76656": true,
      "76657": true,
      "76663": true,
      "76664": true,
      "76665": true,
      "76666": true,
      "76667": true,
      "76670": true,
      "76674": true,
      "76675": true,
      "76676": true,
      "76677": true,
      "76680": true,
      "76681": true,
      "76685": true,
      "76686": true,
      "76687": true,
      "76690": true,
      "76693": true,
      "76694": true,
      "76697": true
    },
    "HUIMILPAN": {
      "76950": true,
      "76951": true,
      "76952": true,
      "76956": true,
      "76957": true,
      "76958": true,
      "76963": true,
      "76964": true,
      "76965": true,
      "76970": true,
      "76973": true,
      "76974": true,
      "76975": true,
      "76976": true,
      "76980": true,
      "76981": true,
      "76983": true,
      "76984": true,
      "76985": true
    },
    "JALPAN DE SERRA": {
      "76340": true,
      "76342": true,
      "76344": true,
      "76345": true,
      "76346": true,
      "76347": true,
      "76348": true,
      "76353": true,
      "76355": true,
      "76359": true
    },
    "PEDRO ESCOBEDO": {
      "76700": true,
      "76703": true,
      "76705": true,
      "76707": true,
      "76708": true,
      "76709": true,
      "76710": true,
      "76713": true,
      "76714": true,
      "76715": true,
      "76720": true,
      "76721": true,
      "76722": true,
      "76723": true,
      "76724": true,
      "76725": true,
      "76726": true,
      "76729": true,
      "76740": true,
      "76741": true,
      "76743": true,
      "76746": true
    },
    "QUERETARO": {
      "76000": true,
      "76010": true,
      "76017": true,
      "76020": true,
      "76024": true,
      "76025": true,
      "76027": true,
      "76028": true,
      "76030": true,
      "76036": true,
      "76037": true,
      "76040": true,
      "76046": true,
      "76047": true,
      "76048": true,
      "76049": true,
      "76050": true,
      "76057": true,
      "76058": true,
      "76059": true,
      "76060": true,
      "76063": true,
      "76067": true,
      "76069": true,
      "76070": true,
      "76074": true,
      "76079": true,
      "76080": true,
      "76085": true,
      "76086": true,
      "76087": true,
      "76090": true,
      "76093": true,
      "76099": true,
      "76100": true,
      "76110": true,
      "76113": true,
      "76114": true,
      "76115": true,
      "76116": true,
      "76117": true,
      "76118": true,
      "76120": true,
      "76121": true,
      "76125": true,
      "76127": true,
      "76130": true,
      "76134": true,
      "76135": true,
      "76136": true,
      "76137": true,
      "76138": true,
      "76139": true,
      "76140": true,
      "76144": true,
      "76146": true,
      "76147": true,
      "76148": true,
      "76149": true,
      "76150": true,
      "76154": true,
      "76155": true,
      "76156": true,
      "76157": true,
      "76158": true,
      "76159": true,
      "76160": true,
      "76164": true,
      "76165": true,
      "76166": true,
      "76168": true,
      "76169": true,
      "76170": true,
      "76175": true,
      "76176": true,
      "76177": true,
      "76178": true,
      "76179": true,
      "76180": true,
      "76185": true,
      "76190": true,
      "76197": true,
      "76199": true,
      "76210": true,
      "76215": true,
      "76220": true,
      "76223": true,
      "76224": true,
      "76225": true,
      "76226": true,
      "76228": true,
      "76229": true,
      "76230": true,
      "76233": true,
      "76235": true,
      "76237": true,
      "76238": true
    },
    "QUERÉTARO": {
      "76000": true,
      "76010": true,
      "76017": true,
      "76020": true,
      "76024": true,
      "76025": true,
      "76026": true,
      "76027": true,
      "76028": true,
      "76030": true,
      "76036": true,
      "76037": true,
      "76040": true,
      "76046": true,
      "76047": true,
      "76048": true,
      "76049": true,
      "76050": true,
      "76057": true,
      "76058": true,
      "76059": true,
      "76060": true,
      "76063": true,
      "76067": true,
      "76069": true,
      "76070": true,
      "76074": true,
      "76078": true,
      "76079": true,
      "76080": true,
      "76085": true,
      "76086": true,
      "76087": true,
      "76090": true,
      "76093": true,
      "76099": true,
      "76100": true,
      "76110": true,
      "76113": true,
      "76114": true,
      "76115": true,
      "76116": true,
      "76117": true,
      "76118": true,
      "76120": true,
      "76121": true,
      "76125": true,
      "76127": true,
      "76130": true,
      "76134": true,
      "76135": true,
      "76136": true,
      "76137": true,
      "76138": true,
      "76139": true,
      "76140": true,
      "76144": true,
      "76146": true,
      "76147": true,
      "76148": true,
      "76149": true,
      "76150": true,
      "76154": true,
      "76155": true,
      "76156": true,
      "76157": true,
      "76158": true,
      "76159": true,
      "76160": true,
      "76164": true,
      "76165": true,
      "76166": true,
      "76168": true,
      "76169": true,
      "76170": true,
      "76175": true,
      "76176": true,
      "76177": true,
      "76178": true,
      "76179": true,
      "76180": true,
      "76185": true,
      "76190": true,
      "76197": true,
      "76199": true,
      "76212": true,
      "76215": true,
      "76220": true,
      "76223": true,
      "76225": true,
      "76226": true,
      "76227": true,
      "76229": true,
      "76230": true,
      "76233": true,
      "76235": true,
      "76237": true,
      "76238": true
    },
    "SAN JOAQUIN": {
      "76550": true,
      "76553": true,
      "76554": true,
      "76555": true,
      "76556": true,
      "76557": true,
      "76558": true,
      "76560": true,
      "76564": true,
      "76565": true,
      "76566": true,
      "76568": true
    },
    "SAN JUAN DEL RIO": {
      "76800": true,
      "76803": true,
      "76804": true,
      "76805": true,
      "76806": true,
      "76807": true,
      "76809": true,
      "76810": true,
      "76812": true,
      "76813": true,
      "76814": true,
      "76815": true,
      "76820": true,
      "76821": true,
      "76823": true,
      "76824": true,
      "76826": true,
      "76827": true,
      "76828": true,
      "76829": true,
      "76830": true,
      "76833": true,
      "76835": true,
      "76837": true,
      "76838": true,
      "76840": true,
      "76842": true,
      "76843": true,
      "76844": true,
      "76845": true,
      "76846": true,
      "76847": true,
      "76848": true,
      "76849": true
    },
    "TEQUISQUIAPAN": {
      "76750": true,
      "76753": true,
      "76755": true,
      "76756": true,
      "76757": true,
      "76773": true,
      "76774": true,
      "76775": true,
      "76776": true,
      "76780": true,
      "76781": true,
      "76783": true,
      "76785": true,
      "76786": true,
      "76790": true,
      "76791": true,
      "76794": true,
      "76795": true,
      "76796": true,
      "76799": true
    },
    "TOLIMAN": {
      "76600": true,
      "76605": true,
      "76610": true,
      "76613": true,
      "76614": true,
      "76615": true,
      "76617": true,
      "76618": true,
      "76620": true,
      "76623": true,
      "76624": true,
      "76626": true,
      "76628": true,
      "76630": true,
      "76631": true,
      "76632": true,
      "76633": true,
      "76634": true,
      "76636": true,
      "76637": true,
      "76640": true,
      "76643": true,
      "76644": true,
      "76646": true,
      "76647": true,
      "76649": true
    }
  },
  "QUINTANA ROO": {
    "BENITO JUÁREZ": {
      "77500": true,
      "77503": true,
      "77504": true,
      "77505": true,
      "77506": true,
      "77507": true,
      "77508": true,
      "77509": true,
      "77510": true,
      "77513": true,
      "77514": true,
      "77515": true,
      "77516": true,
      "77517": true,
      "77518": true,
      "77519": true,
      "77520": true,
      "77524": true,
      "77525": true,
      "77526": true,
      "77527": true,
      "77528": true,
      "77530": true,
      "77533": true,
      "77534": true,
      "77535": true,
      "77536": true,
      "77537": true,
      "77538": true,
      "77539": true,
      "77550": true,
      "77560": true,
      "77567": true,
      "77569": true
    }
  },
  "SAN LUIS POTOSÍ": {
    "AHUALULCO": {
      "78450": true,
      "78455": true,
      "78456": true,
      "78457": true
    },
    "ARMADILLO DE LOS INFANTE": {
      "78980": true,
      "78984": true,
      "78985": true,
      "78986": true,
      "78987": true,
      "78990": true,
      "78993": true,
      "78994": true,
      "78995": true,
      "78996": true,
      "78997": true
    },
    "CARDENAS": {
      "79380": true,
      "79382": true,
      "79383": true,
      "79384": true,
      "79385": true,
      "79386": true,
      "79387": true,
      "79390": true,
      "79393": true,
      "79394": true,
      "79395": true,
      "79397": true
    },
    "CEDRAL": {
      "78520": true,
      "78524": true,
      "78525": true,
      "78527": true,
      "78530": true,
      "78536": true,
      "78537": true
    },
    "CERRITOS": {
      "79400": true,
      "79406": true,
      "79407": true,
      "79408": true,
      "79420": true,
      "79421": true,
      "79427": true,
      "79428": true,
      "79430": true,
      "79431": true,
      "79433": true,
      "79435": true,
      "79436": true,
      "79440": true,
      "79442": true,
      "79443": true,
      "79444": true,
      "79445": true,
      "79446": true,
      "79447": true
    },
    "CERRO DE SAN PEDRO": {
      "78440": true,
      "78443": true,
      "78444": true,
      "78445": true,
      "78446": true,
      "78447": true,
      "78448": true
    },
    "CHARCAS": {
      "78570": true,
      "78573": true,
      "78574": true,
      "78575": true,
      "78576": true,
      "78577": true,
      "78583": true,
      "78584": true,
      "78586": true,
      "78590": true,
      "78593": true,
      "78594": true,
      "78595": true,
      "78596": true,
      "78597": true
    },
    "CIUDAD FERNANDEZ": {
      "79650": true,
      "79653": true,
      "79654": true,
      "79655": true,
      "79657": true,
      "79660": true,
      "79676": true
    },
    "CIUDAD VALLES": {
      "79000": true,
      "79010": true,
      "79019": true,
      "79020": true,
      "79023": true,
      "79025": true,
      "79027": true,
      "79028": true,
      "79030": true,
      "79033": true,
      "79034": true,
      "79035": true,
      "79036": true,
      "79040": true,
      "79043": true,
      "79050": true,
      "79058": true,
      "79059": true,
      "79060": true,
      "79063": true,
      "79064": true,
      "79068": true,
      "79070": true,
      "79080": true,
      "79082": true,
      "79083": true,
      "79084": true,
      "79085": true,
      "79090": true,
      "79092": true,
      "79093": true,
      "79094": true,
      "79095": true,
      "79097": true,
      "79098": true,
      "79246": true,
      "79247": true,
      "79250": true,
      "79253": true,
      "79254": true,
      "79255": true,
      "79256": true,
      "79257": true,
      "79260": true,
      "79263": true,
      "79264": true,
      "79265": true,
      "79266": true,
      "79267": true,
      "79270": true,
      "79273": true,
      "79274": true,
      "79275": true,
      "79276": true,
      "79277": true,
      "79286": true,
      "79287": true
    },
    "EBANO": {
      "79100": true,
      "79110": true,
      "79120": true,
      "79122": true,
      "79130": true,
      "79139": true,
      "79140": true,
      "79142": true,
      "79143": true,
      "79150": true,
      "79152": true,
      "79153": true,
      "79160": true,
      "79161": true,
      "79162": true,
      "79170": true,
      "79180": true,
      "79182": true,
      "79183": true,
      "79190": true,
      "79293": true,
      "79296": true
    },
    "GUADALCAZAR": {
      "78880": true,
      "78884": true,
      "78885": true,
      "78893": true,
      "78897": true
    },
    "MATEHUALA": {
      "78700": true,
      "78710": true,
      "78712": true,
      "78715": true,
      "78716": true,
      "78717": true,
      "78720": true,
      "78721": true,
      "78722": true,
      "78724": true,
      "78725": true,
      "78726": true,
      "78730": true,
      "78740": true,
      "78745": true,
      "78746": true,
      "78747": true,
      "78750": true,
      "78759": true,
      "78760": true,
      "78769": true,
      "78770": true,
      "78779": true,
      "78780": true,
      "78783": true,
      "78784": true,
      "78785": true,
      "78786": true,
      "78788": true,
      "78789": true,
      "78790": true,
      "78792": true,
      "78796": true,
      "78797": true,
      "78798": true,
      "78799": true,
      "78800": true,
      "78801": true,
      "78802": true,
      "78803": true,
      "78804": true,
      "78805": true,
      "78810": true,
      "78811": true,
      "78812": true,
      "78814": true,
      "78815": true,
      "78816": true,
      "78818": true,
      "78819": true,
      "78821": true
    },
    "MEXQUITIC DE CARMONA": {
      "78463": true,
      "78464": true,
      "78465": true,
      "78466": true,
      "78467": true,
      "78470": true,
      "78473": true,
      "78476": true,
      "78480": true,
      "78483": true,
      "78484": true,
      "78485": true,
      "78486": true
    },
    "MOCTEZUMA": {
      "78900": true,
      "78902": true,
      "78903": true,
      "78904": true,
      "78905": true,
      "78906": true,
      "78908": true,
      "78910": true,
      "78914": true,
      "78919": true
    },
    "RIOVERDE": {
      "79600": true,
      "79604": true,
      "79610": true,
      "79613": true,
      "79614": true,
      "79615": true,
      "79616": true,
      "79617": true,
      "79618": true,
      "79619": true,
      "79620": true,
      "79623": true,
      "79624": true,
      "79625": true,
      "79626": true,
      "79630": true,
      "79633": true,
      "79636": true,
      "79640": true,
      "79645": true
    },
    "SALINAS": {
      "78600": true,
      "78601": true,
      "78604": true,
      "78605": true,
      "78609": true,
      "78610": true,
      "78620": true,
      "78622": true,
      "78624": true,
      "78625": true,
      "78626": true
    },
    "SAN LUIS POTOSI": {
      "78000": true,
      "78037": true,
      "78038": true,
      "78040": true,
      "78048": true,
      "78049": true,
      "78100": true,
      "78106": true,
      "78107": true,
      "78109": true,
      "78110": true,
      "78115": true,
      "78116": true,
      "78117": true,
      "78120": true,
      "78130": true,
      "78133": true,
      "78135": true,
      "78136": true,
      "78137": true,
      "78140": true,
      "78143": true,
      "78144": true,
      "78145": true,
      "78146": true,
      "78147": true,
      "78148": true,
      "78150": true,
      "78153": true,
      "78154": true,
      "78165": true,
      "78170": true,
      "78173": true,
      "78174": true,
      "78175": true,
      "78176": true,
      "78177": true,
      "78178": true,
      "78180": true,
      "78183": true,
      "78200": true,
      "78209": true,
      "78210": true,
      "78213": true,
      "78214": true,
      "78215": true,
      "78216": true,
      "78218": true,
      "78219": true,
      "78220": true,
      "78230": true,
      "78233": true,
      "78234": true,
      "78235": true,
      "78236": true,
      "78238": true,
      "78239": true,
      "78240": true,
      "78250": true,
      "78258": true,
      "78260": true,
      "78268": true,
      "78269": true,
      "78270": true,
      "78280": true,
      "78290": true,
      "78294": true,
      "78295": true,
      "78298": true,
      "78300": true,
      "78306": true,
      "78307": true,
      "78308": true,
      "78309": true,
      "78310": true,
      "78318": true,
      "78319": true,
      "78320": true,
      "78328": true,
      "78330": true,
      "78338": true,
      "78339": true,
      "78340": true,
      "78342": true,
      "78349": true,
      "78350": true,
      "78356": true,
      "78357": true,
      "78358": true,
      "78359": true,
      "78360": true,
      "78363": true,
      "78364": true,
      "78365": true,
      "78366": true,
      "78367": true,
      "78368": true,
      "78369": true,
      "78370": true,
      "78377": true,
      "78378": true,
      "78379": true,
      "78380": true,
      "78384": true,
      "78385": true,
      "78387": true,
      "78388": true,
      "78389": true,
      "78390": true,
      "78394": true,
      "78395": true,
      "78396": true,
      "78397": true,
      "78398": true,
      "78399": true,
      "78400": true,
      "78406": true,
      "78413": true,
      "78414": true,
      "78415": true,
      "78418": true,
      "78420": true,
      "78421": true,
      "78423": true,
      "78424": true,
      "78425": true,
      "78426": true,
      "78427": true
    },
    "SAN NICOLAS TOLENTINO": {
      "79480": true,
      "79482": true,
      "79483": true,
      "79484": true,
      "79485": true,
      "79486": true,
      "79490": true,
      "79491": true
    },
    "SAN VICENTE TANCUAYALAB": {
      "79820": true,
      "79821": true,
      "79823": true,
      "79825": true
    },
    "SANTA MARIA DEL RIO": {
      "79560": true,
      "79562": true,
      "79563": true,
      "79564": true,
      "79565": true,
      "79566": true,
      "79567": true,
      "79581": true
    },
    "SANTO DOMINGO": {
      "78630": true,
      "78634": true,
      "78635": true,
      "78637": true,
      "78639": true,
      "78640": true,
      "78643": true,
      "78649": true
    },
    "SOLEDAD DE GRACIANO SANCHEZ": {
      "78430": true,
      "78432": true,
      "78433": true,
      "78434": true,
      "78435": true,
      "78436": true,
      "78437": true,
      "78438": true,
      "78439": true
    },
    "SOLEDAD DE GRACIANO SÁNCHEZ": {
      "78430": true,
      "78432": true,
      "78433": true,
      "78434": true,
      "78435": true,
      "78436": true,
      "78437": true,
      "78438": true
    },
    "TAMAZUNCHALE": {
      "79960": true,
      "79980": true,
      "79982": true,
      "79983": true,
      "79985": true,
      "79986": true,
      "79987": true,
      "79988": true,
      "79991": true,
      "79993": true,
      "79994": true,
      "79995": true,
      "79996": true,
      "79997": true,
      "79998": true
    },
    "TAMUIN": {
      "79200": true,
      "79202": true,
      "79203": true,
      "79204": true,
      "79205": true,
      "79206": true,
      "79207": true,
      "79208": true,
      "79210": true,
      "79213": true,
      "79214": true,
      "79217": true,
      "79219": true,
      "79220": true,
      "79224": true,
      "79225": true,
      "79226": true,
      "79227": true,
      "79228": true,
      "79229": true
    },
    "TANQUIAN DE ESCOBEDO": {
      "79840": true,
      "79841": true,
      "79842": true,
      "79843": true,
      "79846": true,
      "79849": true
    },
    "TIERRA NUEVA": {
      "79590": true,
      "79592": true,
      "79593": true,
      "79594": true,
      "79595": true,
      "79596": true
    },
    "VENADO": {
      "78920": true,
      "78923": true,
      "78924": true,
      "78925": true,
      "78926": true,
      "78927": true,
      "78933": true,
      "78934": true,
      "78935": true,
      "78936": true,
      "78937": true
    },
    "VILLA DE ARISTA": {
      "78940": true,
      "78943": true,
      "78944": true,
      "78947": true,
      "78950": true,
      "78953": true,
      "78954": true,
      "78955": true,
      "78956": true,
      "78957": true
    },
    "VILLA DE ARRIAGA": {
      "78490": true,
      "78493": true,
      "78495": true,
      "78496": true,
      "78497": true
    },
    "VILLA DE REYES": {
      "79500": true,
      "79502": true,
      "79503": true,
      "79505": true,
      "79506": true,
      "79507": true,
      "79510": true,
      "79513": true,
      "79521": true,
      "79523": true,
      "79524": true,
      "79525": true,
      "79526": true,
      "79530": true,
      "79532": true,
      "79533": true
    },
    "VILLA HIDALGO": {
      "78960": true,
      "78963": true,
      "78964": true,
      "78965": true,
      "78966": true,
      "78967": true,
      "78968": true,
      "78970": true,
      "78973": true
    },
    "XILITLA": {
      "79900": true,
      "79901": true,
      "79903": true,
      "79904": true,
      "79905": true,
      "79906": true,
      "79907": true,
      "79908": true,
      "79910": true,
      "79913": true,
      "79915": true,
      "79916": true,
      "79917": true,
      "79920": true,
      "79922": true,
      "79923": true,
      "79924": true,
      "79925": true,
      "79926": true,
      "79927": true,
      "79928": true,
      "79929": true
    },
    "ZARAGOZA": {
      "79540": true,
      "79543": true,
      "79544": true,
      "79545": true,
      "79546": true,
      "79547": true,
      "79554": true,
      "79555": true,
      "79556": true,
      "79557": true
    }
  },
  "SINALOA": {
    "AHOME": {
      "81200": true,
      "81210": true,
      "81215": true,
      "81216": true,
      "81217": true,
      "81218": true,
      "81220": true,
      "81223": true,
      "81224": true,
      "81225": true,
      "81226": true,
      "81227": true,
      "81228": true,
      "81229": true,
      "81230": true,
      "81233": true,
      "81234": true,
      "81235": true,
      "81236": true,
      "81237": true,
      "81238": true,
      "81240": true,
      "81245": true,
      "81247": true,
      "81248": true,
      "81249": true,
      "81250": true,
      "81254": true,
      "81255": true,
      "81256": true,
      "81257": true,
      "81259": true,
      "81260": true,
      "81263": true,
      "81265": true,
      "81270": true,
      "81271": true,
      "81277": true,
      "81278": true,
      "81280": true,
      "81285": true,
      "81289": true,
      "81290": true,
      "81293": true,
      "81294": true,
      "81295": true,
      "81296": true,
      "81303": true,
      "81304": true,
      "81305": true,
      "81307": true,
      "81310": true,
      "81311": true,
      "81315": true,
      "81316": true,
      "81317": true,
      "81318": true,
      "81320": true,
      "81323": true,
      "81324": true,
      "81325": true,
      "81330": true,
      "81336": true,
      "81340": true,
      "81341": true,
      "81343": true,
      "81346": true,
      "81350": true,
      "81360": true,
      "81361": true,
      "81363": true,
      "81364": true,
      "81367": true,
      "81369": true,
      "81370": true,
      "81372": true,
      "81373": true,
      "81374": true,
      "81375": true,
      "81376": true,
      "81379": true,
      "81384": true,
      "81386": true
    },
    "ANGOSTURA": {
      "81600": true,
      "81610": true,
      "81613": true,
      "81620": true,
      "81621": true,
      "81622": true,
      "81623": true,
      "81624": true,
      "81625": true,
      "81630": true,
      "81632": true,
      "81635": true,
      "81639": true,
      "81640": true,
      "81642": true,
      "81649": true,
      "81650": true,
      "81652": true,
      "81653": true,
      "81654": true,
      "81655": true,
      "81660": true,
      "81663": true,
      "81664": true,
      "81666": true,
      "81670": true,
      "81680": true,
      "81690": true
    },
    "BADIRAGUATO": {
      "80500": true,
      "80503": true,
      "80504": true,
      "80505": true,
      "80524": true,
      "80526": true,
      "80527": true,
      "80533": true,
      "80537": true,
      "80550": true,
      "80553": true,
      "80554": true,
      "80555": true,
      "80556": true,
      "80557": true,
      "80563": true,
      "80565": true,
      "80566": true,
      "80567": true,
      "80570": true,
      "80573": true,
      "80574": true,
      "80575": true,
      "80576": true,
      "80577": true,
      "80580": true,
      "80583": true,
      "80585": true,
      "80620": true,
      "80625": true,
      "80645": true,
      "80646": true,
      "80680": true,
      "80683": true,
      "80686": true,
      "80687": true
    },
    "CHOIX": {
      "81700": true,
      "81703": true,
      "81705": true,
      "81706": true,
      "81707": true,
      "81708": true,
      "81709": true,
      "81710": true,
      "81713": true,
      "81715": true,
      "81716": true,
      "81717": true,
      "81737": true,
      "81738": true,
      "81743": true,
      "81745": true,
      "81746": true,
      "81749": true,
      "81756": true,
      "81757": true,
      "81760": true,
      "81763": true,
      "81764": true,
      "81765": true,
      "81777": true,
      "81780": true,
      "81783": true,
      "81784": true
    },
    "CONCORDIA": {
      "82600": true,
      "82603": true,
      "82604": true,
      "82605": true,
      "82607": true,
      "82608": true,
      "82613": true,
      "82614": true,
      "82620": true,
      "82625": true,
      "82628": true,
      "82640": true,
      "82646": true,
      "82648": true,
      "82658": true,
      "82675": true,
      "82680": true,
      "82684": true,
      "82685": true,
      "82686": true
    },
    "CULIACAN": {
      "80000": true,
      "80010": true,
      "80013": true,
      "80014": true,
      "80015": true,
      "80016": true,
      "80017": true,
      "80018": true,
      "80019": true,
      "80020": true,
      "80025": true,
      "80026": true,
      "80027": true,
      "80028": true,
      "80029": true,
      "80030": true,
      "80034": true,
      "80040": true,
      "80050": true,
      "80054": true,
      "80055": true,
      "80058": true,
      "80059": true,
      "80060": true,
      "80063": true,
      "80064": true,
      "80065": true,
      "80070": true,
      "80080": true,
      "80088": true,
      "80090": true,
      "80093": true,
      "80100": true,
      "80103": true,
      "80104": true,
      "80105": true,
      "80106": true,
      "80107": true,
      "80109": true,
      "80110": true,
      "80120": true,
      "80128": true,
      "80130": true,
      "80135": true,
      "80139": true,
      "80140": true,
      "80143": true,
      "80144": true,
      "80145": true,
      "80150": true,
      "80155": true,
      "80159": true,
      "80160": true,
      "80170": true,
      "80176": true,
      "80177": true,
      "80178": true,
      "80179": true,
      "80180": true,
      "80184": true,
      "80189": true,
      "80190": true,
      "80194": true,
      "80197": true,
      "80199": true,
      "80200": true,
      "80210": true,
      "80220": true,
      "80225": true,
      "80227": true,
      "80228": true,
      "80230": true,
      "80240": true,
      "80246": true,
      "80247": true,
      "80248": true,
      "80249": true,
      "80250": true,
      "80260": true,
      "80270": true,
      "80279": true,
      "80280": true,
      "80290": true,
      "80294": true,
      "80295": true,
      "80296": true,
      "80297": true,
      "80298": true,
      "80299": true,
      "80300": true,
      "80301": true,
      "80302": true,
      "80303": true,
      "80304": true,
      "80305": true,
      "80308": true,
      "80309": true,
      "80310": true,
      "80311": true,
      "80313": true,
      "80314": true,
      "80315": true,
      "80316": true,
      "80317": true,
      "80318": true,
      "80319": true,
      "80380": true,
      "80383": true,
      "80384": true,
      "80385": true,
      "80386": true,
      "80387": true,
      "80390": true,
      "80391": true,
      "80393": true,
      "80394": true,
      "80395": true,
      "80396": true,
      "80397": true,
      "80398": true,
      "80400": true,
      "80402": true,
      "80403": true,
      "80405": true,
      "80408": true,
      "80409": true,
      "80410": true,
      "80411": true,
      "80415": true,
      "80416": true,
      "80417": true,
      "80419": true,
      "80430": true,
      "80433": true,
      "80434": true,
      "80435": true,
      "80436": true,
      "80437": true,
      "80439": true,
      "80440": true,
      "80441": true,
      "80442": true,
      "80443": true,
      "80444": true,
      "80447": true,
      "80449": true,
      "80450": true,
      "80452": true,
      "80453": true,
      "80454": true,
      "80455": true,
      "80457": true,
      "80458": true,
      "80460": true,
      "80463": true,
      "80464": true,
      "80465": true,
      "80466": true,
      "80467": true,
      "80468": true,
      "80470": true,
      "80473": true,
      "80475": true,
      "80480": true,
      "80481": true,
      "80483": true,
      "80484": true,
      "80485": true,
      "80486": true,
      "80489": true,
      "80490": true,
      "80491": true,
      "80492": true,
      "80493": true,
      "80496": true,
      "80498": true
    },
    "CULIACÁN": {
      "80000": true,
      "80010": true,
      "80013": true,
      "80014": true,
      "80015": true,
      "80016": true,
      "80017": true,
      "80018": true,
      "80019": true,
      "80020": true,
      "80025": true,
      "80026": true,
      "80027": true,
      "80028": true,
      "80029": true,
      "80030": true,
      "80034": true,
      "80040": true,
      "80050": true,
      "80054": true,
      "80055": true,
      "80058": true,
      "80059": true,
      "80060": true,
      "80063": true,
      "80064": true,
      "80065": true,
      "80070": true,
      "80080": true,
      "80088": true,
      "80090": true,
      "80093": true,
      "80100": true,
      "80103": true,
      "80104": true,
      "80105": true,
      "80106": true,
      "80107": true,
      "80109": true,
      "80110": true,
      "80120": true,
      "80128": true,
      "80130": true,
      "80135": true,
      "80139": true,
      "80140": true,
      "80143": true,
      "80144": true,
      "80145": true,
      "80150": true,
      "80155": true,
      "80159": true,
      "80160": true,
      "80170": true,
      "80176": true,
      "80177": true,
      "80178": true,
      "80179": true,
      "80180": true,
      "80184": true,
      "80189": true,
      "80190": true,
      "80194": true,
      "80197": true,
      "80199": true,
      "80200": true,
      "80210": true,
      "80220": true,
      "80225": true,
      "80227": true,
      "80228": true,
      "80230": true,
      "80240": true,
      "80246": true,
      "80247": true,
      "80248": true,
      "80249": true,
      "80250": true,
      "80260": true,
      "80270": true,
      "80279": true,
      "80280": true,
      "80290": true,
      "80294": true,
      "80295": true,
      "80296": true,
      "80297": true,
      "80298": true,
      "80299": true,
      "80308": true
    },
    "EL FUERTE": {
      "81800": true,
      "81802": true,
      "81803": true,
      "81804": true,
      "81805": true,
      "81810": true,
      "81812": true,
      "81820": true,
      "81825": true,
      "81827": true,
      "81828": true,
      "81830": true,
      "81833": true,
      "81834": true,
      "81847": true,
      "81850": true,
      "81854": true,
      "81856": true,
      "81860": true,
      "81864": true,
      "81871": true,
      "81872": true,
      "81873": true,
      "81880": true,
      "81887": true,
      "81889": true,
      "81890": true,
      "81891": true,
      "81892": true,
      "81893": true
    },
    "ELOTA": {
      "82700": true,
      "82702": true,
      "82703": true,
      "82705": true,
      "82706": true,
      "82707": true,
      "82708": true,
      "82724": true,
      "82725": true,
      "82726": true,
      "82730": true,
      "82739": true,
      "82740": true,
      "82741": true,
      "82747": true,
      "82750": true,
      "82755": true,
      "82758": true,
      "82760": true,
      "82763": true,
      "82764": true,
      "82765": true,
      "82773": true,
      "82774": true,
      "82775": true,
      "82776": true,
      "82780": true,
      "82783": true,
      "82786": true,
      "82787": true,
      "82788": true,
      "82790": true,
      "82793": true,
      "82794": true,
      "82795": true,
      "82796": true,
      "82797": true
    },
    "ESCUINAPA": {
      "82400": true,
      "82410": true,
      "82419": true,
      "82420": true,
      "82430": true,
      "82440": true,
      "82457": true,
      "82458": true,
      "82459": true,
      "82460": true,
      "82470": true,
      "82478": true,
      "82500": true,
      "82505": true,
      "82513": true,
      "82530": true,
      "82534": true,
      "82540": true,
      "82545": true,
      "82553": true,
      "82560": true
    },
    "GUASAVE": {
      "81000": true,
      "81010": true,
      "81014": true,
      "81015": true,
      "81016": true,
      "81017": true,
      "81018": true,
      "81020": true,
      "81028": true,
      "81029": true,
      "81030": true,
      "81040": true,
      "81042": true,
      "81043": true,
      "81044": true,
      "81045": true,
      "81048": true,
      "81049": true,
      "81050": true,
      "81060": true,
      "81065": true,
      "81066": true,
      "81075": true,
      "81077": true,
      "81090": true,
      "81095": true,
      "81100": true,
      "81101": true,
      "81102": true,
      "81103": true,
      "81104": true,
      "81106": true,
      "81107": true,
      "81108": true,
      "81110": true,
      "81118": true,
      "81120": true,
      "81121": true,
      "81122": true,
      "81124": true,
      "81127": true,
      "81128": true,
      "81130": true,
      "81131": true,
      "81132": true,
      "81133": true,
      "81134": true,
      "81135": true,
      "81136": true,
      "81140": true,
      "81141": true,
      "81142": true,
      "81143": true,
      "81144": true,
      "81147": true,
      "81148": true,
      "81149": true,
      "81160": true,
      "81161": true,
      "81162": true,
      "81163": true,
      "81164": true,
      "81165": true,
      "81166": true,
      "81167": true,
      "81170": true,
      "81173": true,
      "81174": true,
      "81175": true,
      "81176": true,
      "81177": true,
      "81178": true,
      "81180": true,
      "81181": true,
      "81182": true,
      "81183": true,
      "81184": true,
      "81186": true,
      "81189": true,
      "81190": true,
      "81197": true
    },
    "MAZATLÁN": {
      "82000": true,
      "82010": true,
      "82013": true,
      "82014": true,
      "82015": true,
      "82016": true,
      "82017": true,
      "82018": true,
      "82019": true,
      "82020": true,
      "82028": true,
      "82030": true,
      "82035": true,
      "82037": true,
      "82038": true,
      "82040": true,
      "82043": true,
      "82047": true,
      "82050": true,
      "82059": true,
      "82060": true,
      "82070": true,
      "82080": true,
      "82089": true,
      "82090": true,
      "82099": true,
      "82100": true,
      "82102": true,
      "82103": true,
      "82110": true,
      "82112": true,
      "82113": true,
      "82118": true,
      "82120": true,
      "82123": true,
      "82124": true,
      "82125": true,
      "82126": true,
      "82127": true,
      "82128": true,
      "82129": true,
      "82130": true,
      "82132": true,
      "82133": true,
      "82134": true,
      "82136": true,
      "82137": true,
      "82138": true,
      "82139": true,
      "82140": true,
      "82143": true,
      "82144": true,
      "82146": true,
      "82147": true,
      "82148": true,
      "82149": true,
      "82150": true,
      "82153": true,
      "82154": true,
      "82155": true,
      "82156": true,
      "82157": true,
      "82158": true,
      "82159": true,
      "82160": true,
      "82163": true,
      "82164": true,
      "82165": true,
      "82170": true,
      "82180": true,
      "82183": true,
      "82185": true,
      "82186": true,
      "82187": true,
      "82188": true,
      "82190": true,
      "82195": true,
      "82197": true,
      "82198": true,
      "82199": true,
      "82200": true,
      "82203": true,
      "82204": true,
      "82206": true,
      "82207": true,
      "82210": true,
      "82213": true,
      "82214": true,
      "82215": true,
      "82216": true,
      "82217": true,
      "82230": true,
      "82235": true,
      "82238": true,
      "82243": true,
      "82245": true,
      "82248": true,
      "82264": true,
      "82267": true,
      "82269": true,
      "82270": true,
      "82273": true,
      "82274": true,
      "82275": true,
      "82277": true,
      "82290": true,
      "82303": true,
      "82305": true,
      "82310": true,
      "82334": true,
      "82335": true,
      "82355": true,
      "82360": true,
      "82366": true,
      "82369": true
    },
    "MOCORITO": {
      "80800": true,
      "80803": true,
      "80804": true,
      "80805": true,
      "80806": true,
      "80807": true,
      "80808": true,
      "80810": true,
      "80830": true,
      "80833": true,
      "80834": true,
      "80850": true,
      "80855": true,
      "80870": true,
      "80875": true,
      "80880": true,
      "80883": true,
      "80885": true,
      "80890": true,
      "80893": true,
      "80894": true,
      "80895": true,
      "80896": true,
      "80897": true,
      "80950": true,
      "80956": true
    },
    "NAVOLATO": {
      "80320": true,
      "80322": true,
      "80323": true,
      "80324": true,
      "80327": true,
      "80333": true,
      "80334": true,
      "80335": true,
      "80336": true,
      "80337": true,
      "80338": true,
      "80339": true,
      "80345": true,
      "80346": true,
      "80347": true,
      "80348": true,
      "80349": true,
      "80367": true,
      "80370": true,
      "80371": true,
      "80372": true,
      "80373": true,
      "80374": true,
      "80376": true,
      "80377": true,
      "80378": true
    },
    "ROSARIO": {
      "82800": true,
      "82802": true,
      "82803": true,
      "82804": true,
      "82805": true,
      "82806": true,
      "82807": true,
      "82808": true,
      "82809": true,
      "82810": true,
      "82813": true,
      "82814": true,
      "82817": true,
      "82823": true,
      "82824": true,
      "82826": true,
      "82827": true,
      "82830": true,
      "82832": true,
      "82833": true,
      "82834": true,
      "82835": true,
      "82839": true,
      "82860": true,
      "82864": true,
      "82866": true,
      "82871": true,
      "82872": true,
      "82874": true,
      "82875": true,
      "82876": true,
      "82880": true,
      "82883": true,
      "82884": true,
      "82887": true
    },
    "SALVADOR ALVARADO": {
      "81400": true,
      "81410": true,
      "81413": true,
      "81420": true,
      "81426": true,
      "81427": true,
      "81429": true,
      "81430": true,
      "81440": true,
      "81448": true,
      "81450": true,
      "81460": true,
      "81470": true,
      "81474": true,
      "81475": true,
      "81476": true,
      "81477": true,
      "81478": true,
      "81479": true,
      "81480": true,
      "81489": true,
      "81490": true,
      "81493": true,
      "81500": true,
      "81520": true,
      "81530": true,
      "81533": true,
      "81535": true,
      "81540": true,
      "81545": true
    },
    "SAN IGNACIO": {
      "82900": true,
      "82902": true,
      "82904": true,
      "82905": true,
      "82906": true,
      "82907": true,
      "82909": true,
      "82910": true,
      "82912": true,
      "82916": true,
      "82917": true,
      "82918": true,
      "82920": true,
      "82937": true,
      "82940": true,
      "82943": true,
      "82945": true,
      "82953": true,
      "82954": true,
      "82955": true,
      "82956": true,
      "82963": true,
      "82969": true,
      "82970": true,
      "82973": true,
      "82975": true,
      "82976": true,
      "82980": true,
      "82983": true,
      "82984": true,
      "82990": true
    },
    "SINALOA": {
      "81900": true,
      "81902": true,
      "81903": true,
      "81904": true,
      "81906": true,
      "81910": true,
      "81912": true,
      "81913": true,
      "81915": true,
      "81930": true,
      "81940": true,
      "81946": true,
      "81947": true,
      "81960": true,
      "81963": true,
      "81964": true,
      "81965": true,
      "81967": true,
      "81980": true,
      "81983": true,
      "81985": true,
      "81986": true,
      "81988": true,
      "81989": true,
      "81990": true,
      "81995": true,
      "81996": true,
      "81997": true
    }
  },
  "SONORA": {
    "AGUA PRIETA": {
      "84200": true,
      "84210": true,
      "84212": true,
      "84213": true,
      "84214": true,
      "84215": true,
      "84220": true,
      "84230": true,
      "84240": true,
      "84250": true,
      "84259": true,
      "84260": true,
      "84267": true,
      "84269": true,
      "84270": true,
      "84279": true,
      "84303": true,
      "84304": true,
      "84305": true,
      "84315": true,
      "84316": true
    },
    "BACUM": {
      "85260": true,
      "85265": true,
      "85268": true,
      "85270": true,
      "85275": true,
      "85276": true
    },
    "BENITO JUÁREZ": {
      "85290": true,
      "85293": true,
      "85294": true,
      "85295": true,
      "85296": true,
      "85297": true,
      "85298": true
    },
    "CABORCA": {
      "83600": true,
      "83610": true,
      "83620": true,
      "83621": true,
      "83624": true,
      "83630": true,
      "83634": true,
      "83635": true,
      "83640": true,
      "83650": true,
      "83660": true,
      "83663": true,
      "83664": true,
      "83665": true,
      "83666": true,
      "83670": true,
      "83680": true,
      "83690": true,
      "83693": true,
      "83695": true,
      "83723": true,
      "83727": true
    },
    "CAJEME": {
      "85000": true,
      "85010": true,
      "85013": true,
      "85017": true,
      "85019": true,
      "85020": true,
      "85023": true,
      "85024": true,
      "85030": true,
      "85037": true,
      "85038": true,
      "85039": true,
      "85040": true,
      "85050": true,
      "85053": true,
      "85059": true,
      "85060": true,
      "85063": true,
      "85064": true,
      "85065": true,
      "85070": true,
      "85080": true,
      "85090": true,
      "85095": true,
      "85096": true,
      "85097": true,
      "85098": true,
      "85099": true,
      "85100": true,
      "85110": true,
      "85120": true,
      "85130": true,
      "85134": true,
      "85136": true,
      "85137": true,
      "85138": true,
      "85140": true,
      "85149": true,
      "85150": true,
      "85154": true,
      "85157": true,
      "85160": true,
      "85167": true,
      "85168": true,
      "85169": true,
      "85170": true,
      "85180": true,
      "85190": true,
      "85193": true,
      "85194": true,
      "85195": true,
      "85196": true,
      "85197": true,
      "85198": true,
      "85199": true,
      "85200": true,
      "85203": true,
      "85204": true,
      "85210": true,
      "85215": true,
      "85216": true,
      "85218": true,
      "85219": true
    },
    "CANANEA": {
      "84620": true,
      "84622": true,
      "84623": true,
      "84624": true,
      "84625": true,
      "84630": true,
      "84633": true,
      "84635": true,
      "84636": true
    },
    "CARBO": {
      "83380": true,
      "83383": true,
      "83384": true,
      "83385": true,
      "83386": true,
      "83393": true,
      "83394": true,
      "83395": true,
      "83396": true,
      "83398": true
    },
    "EMPALME": {
      "85300": true,
      "85310": true,
      "85319": true,
      "85320": true,
      "85330": true,
      "85338": true,
      "85339": true,
      "85340": true,
      "85347": true,
      "85349": true,
      "85350": true,
      "85360": true,
      "85370": true,
      "85385": true,
      "85386": true,
      "85388": true,
      "85389": true,
      "85390": true,
      "85397": true,
      "85398": true,
      "85399": true,
      "85520": true,
      "85523": true,
      "85524": true,
      "85526": true,
      "85530": true,
      "85533": true,
      "85534": true,
      "85535": true,
      "85536": true
    },
    "ETCHOJOA": {
      "85280": true,
      "85285": true,
      "85286": true,
      "85287": true
    },
    "GUAYMAS": {
      "85400": true,
      "85405": true,
      "85406": true,
      "85409": true,
      "85410": true,
      "85420": true,
      "85423": true,
      "85424": true,
      "85425": true,
      "85426": true,
      "85427": true,
      "85430": true,
      "85440": true,
      "85444": true,
      "85447": true,
      "85448": true,
      "85450": true,
      "85454": true,
      "85455": true,
      "85456": true,
      "85457": true,
      "85460": true,
      "85463": true,
      "85465": true,
      "85467": true,
      "85470": true,
      "85477": true,
      "85480": true,
      "85484": true,
      "85486": true,
      "85488": true,
      "85489": true,
      "85490": true,
      "85499": true,
      "85500": true,
      "85503": true,
      "85505": true,
      "85506": true,
      "85510": true
    },
    "HERMOSILLO": {
      "83000": true,
      "83010": true,
      "83013": true,
      "83015": true,
      "83016": true,
      "83020": true,
      "83029": true,
      "83030": true,
      "83040": true,
      "83050": true,
      "83060": true,
      "83067": true,
      "83068": true,
      "83070": true,
      "83078": true,
      "83079": true,
      "83080": true,
      "83089": true,
      "83090": true,
      "83100": true,
      "83103": true,
      "83104": true,
      "83105": true,
      "83106": true,
      "83107": true,
      "83108": true,
      "83110": true,
      "83113": true,
      "83114": true,
      "83115": true,
      "83116": true,
      "83117": true,
      "83118": true,
      "83120": true,
      "83125": true,
      "83126": true,
      "83128": true,
      "83130": true,
      "83136": true,
      "83137": true,
      "83138": true,
      "83139": true,
      "83140": true,
      "83143": true,
      "83144": true,
      "83145": true,
      "83146": true,
      "83147": true,
      "83148": true,
      "83149": true,
      "83150": true,
      "83156": true,
      "83157": true,
      "83159": true,
      "83160": true,
      "83165": true,
      "83166": true,
      "83170": true,
      "83171": true,
      "83173": true,
      "83174": true,
      "83175": true,
      "83176": true,
      "83177": true,
      "83178": true,
      "83179": true,
      "83180": true,
      "83188": true,
      "83190": true,
      "83200": true,
      "83204": true,
      "83205": true,
      "83206": true,
      "83207": true,
      "83208": true,
      "83209": true,
      "83210": true,
      "83214": true,
      "83220": true,
      "83223": true,
      "83224": true,
      "83229": true,
      "83230": true,
      "83240": true,
      "83243": true,
      "83244": true,
      "83245": true,
      "83246": true,
      "83247": true,
      "83248": true,
      "83249": true,
      "83250": true,
      "83260": true,
      "83270": true,
      "83278": true,
      "83280": true,
      "83283": true,
      "83284": true,
      "83285": true,
      "83286": true,
      "83287": true,
      "83288": true,
      "83289": true,
      "83290": true,
      "83293": true,
      "83294": true,
      "83295": true,
      "83296": true,
      "83297": true,
      "83299": true,
      "83300": true,
      "83303": true,
      "83304": true,
      "83305": true,
      "83306": true,
      "83307": true,
      "83309": true,
      "83310": true,
      "83313": true,
      "83314": true,
      "83315": true,
      "83316": true,
      "83317": true,
      "83320": true,
      "83323": true,
      "83324": true,
      "83325": true,
      "83326": true,
      "83327": true,
      "83328": true,
      "83330": true,
      "83333": true,
      "83334": true,
      "83335": true,
      "83336": true,
      "83337": true,
      "83338": true,
      "83340": true,
      "83342": true,
      "83343": true,
      "83344": true,
      "83346": true,
      "83347": true,
      "83348": true,
      "83349": true,
      "83350": true,
      "83353": true,
      "83354": true,
      "83355": true,
      "83356": true,
      "83357": true
    },
    "HUATABAMPO": {
      "85240": true,
      "85241": true,
      "85243": true,
      "85244": true,
      "85245": true,
      "85246": true,
      "85247": true,
      "85248": true,
      "85249": true,
      "85251": true,
      "85900": true,
      "85910": true,
      "85913": true,
      "85914": true,
      "85920": true,
      "85925": true,
      "85930": true,
      "85935": true,
      "85937": true,
      "85938": true,
      "85940": true,
      "85943": true,
      "85950": true,
      "85960": true,
      "85966": true,
      "85967": true,
      "85968": true,
      "85970": true,
      "85977": true,
      "85980": true,
      "85984": true,
      "85990": true,
      "85994": true
    },
    "LA COLORADA": {
      "85540": true,
      "85545": true
    },
    "MAGDALENA": {
      "84160": true,
      "84164": true,
      "84165": true,
      "84167": true,
      "84170": true,
      "84171": true,
      "84173": true,
      "84175": true
    },
    "MAZATAN": {
      "85560": true,
      "85563": true,
      "85575": true
    },
    "NACOZARI DE GARCIA": {
      "84340": true,
      "84345": true,
      "84346": true,
      "84347": true,
      "84348": true,
      "84349": true
    },
    "NAVOJOA": {
      "85224": true,
      "85225": true,
      "85226": true,
      "85228": true,
      "85229": true,
      "85230": true,
      "85235": true,
      "85238": true,
      "85239": true,
      "85800": true,
      "85810": true,
      "85820": true,
      "85823": true,
      "85825": true,
      "85826": true,
      "85827": true,
      "85830": true,
      "85835": true,
      "85840": true,
      "85843": true,
      "85845": true,
      "85850": true,
      "85860": true,
      "85864": true,
      "85865": true,
      "85870": true,
      "85874": true,
      "85880": true,
      "85890": true,
      "85893": true,
      "85894": true,
      "85895": true,
      "85896": true
    },
    "NOGALES": {
      "84000": true,
      "84009": true,
      "84010": true,
      "84014": true,
      "84015": true,
      "84017": true,
      "84018": true,
      "84020": true,
      "84024": true,
      "84030": true,
      "84035": true,
      "84040": true,
      "84046": true,
      "84047": true,
      "84048": true,
      "84050": true,
      "84055": true,
      "84060": true,
      "84062": true,
      "84063": true,
      "84064": true,
      "84065": true,
      "84066": true,
      "84067": true,
      "84068": true,
      "84069": true,
      "84074": true,
      "84075": true,
      "84076": true,
      "84080": true,
      "84085": true,
      "84086": true,
      "84090": true,
      "84093": true,
      "84094": true,
      "84100": true,
      "84103": true,
      "84105": true,
      "84107": true,
      "84113": true,
      "84114": true,
      "84115": true
    },
    "PUERTO PENASCO": {
      "83550": true,
      "83553": true,
      "83554": true,
      "83555": true,
      "83556": true,
      "83557": true,
      "83564": true,
      "83565": true
    },
    "SAN IGNACIO RIO MUERTO": {
      "85514": true,
      "85515": true,
      "85516": true
    },
    "SAN LUIS RIO COLORADO": {
      "83400": true,
      "83403": true,
      "83419": true,
      "83420": true,
      "83423": true,
      "83430": true,
      "83439": true,
      "83440": true,
      "83447": true,
      "83448": true,
      "83449": true,
      "83450": true,
      "83455": true,
      "83457": true,
      "83458": true,
      "83459": true,
      "83470": true,
      "83479": true,
      "83480": true,
      "83487": true,
      "83488": true,
      "83489": true,
      "83490": true,
      "83496": true,
      "83497": true,
      "83498": true,
      "83499": true,
      "83500": true,
      "83503": true,
      "83504": true,
      "83513": true,
      "83515": true,
      "83516": true,
      "83517": true
    },
    "SAN MIGUEL DE HORCASITAS": {
      "83360": true,
      "83365": true,
      "83366": true,
      "83367": true,
      "83373": true,
      "83374": true,
      "83375": true,
      "83376": true,
      "83377": true,
      "83378": true
    },
    "URES": {
      "84900": true,
      "84905": true,
      "84907": true,
      "84910": true,
      "84911": true,
      "84919": true
    }
  },
  "TABASCO": {
    "CENTRO": {
      "86000": true,
      "86010": true,
      "86017": true,
      "86018": true,
      "86019": true,
      "86020": true,
      "86025": true,
      "86026": true,
      "86027": true,
      "86029": true,
      "86030": true,
      "86035": true,
      "86037": true,
      "86038": true,
      "86040": true,
      "86050": true,
      "86059": true,
      "86060": true,
      "86067": true,
      "86068": true,
      "86069": true,
      "86070": true,
      "86079": true,
      "86080": true,
      "86087": true,
      "86090": true,
      "86095": true,
      "86096": true,
      "86097": true,
      "86098": true,
      "86099": true,
      "86100": true,
      "86107": true,
      "86108": true,
      "86109": true,
      "86120": true,
      "86125": true,
      "86129": true,
      "86130": true,
      "86137": true,
      "86140": true,
      "86149": true,
      "86150": true,
      "86160": true,
      "86167": true,
      "86168": true,
      "86169": true,
      "86170": true,
      "86179": true,
      "86180": true,
      "86189": true,
      "86190": true
    }
  },
  "TAMAULIPAS": {
    "ABASOLO": {
      "87760": true,
      "87766": true,
      "87767": true,
      "87769": true,
      "87770": true
    },
    "ALDAMA": {
      "89670": true,
      "89672": true,
      "89673": true,
      "89674": true,
      "89675": true,
      "89676": true
    },
    "ALTAMIRA": {
      "89600": true,
      "89602": true,
      "89603": true,
      "89604": true,
      "89605": true,
      "89606": true,
      "89607": true,
      "89610": true,
      "89613": true,
      "89614": true,
      "89615": true,
      "89620": true,
      "89625": true,
      "89630": true,
      "89632": true,
      "89633": true,
      "89635": true,
      "89636": true,
      "89640": true,
      "89641": true,
      "89642": true,
      "89643": true,
      "89644": true,
      "89645": true,
      "89650": true
    },
    "CAMARGO": {
      "88440": true,
      "88442": true,
      "88443": true,
      "88444": true,
      "88446": true,
      "88447": true,
      "88448": true,
      "88449": true,
      "88450": true,
      "88455": true,
      "88456": true,
      "88459": true,
      "88460": true,
      "88468": true,
      "88470": true,
      "88479": true,
      "88490": true
    },
    "CASAS": {
      "87250": true,
      "87254": true,
      "87258": true,
      "87259": true
    },
    "CIUDAD MADERO": {
      "89400": true,
      "89410": true,
      "89415": true,
      "89416": true,
      "89417": true,
      "89420": true,
      "89430": true,
      "89440": true,
      "89450": true,
      "89460": true,
      "89464": true,
      "89470": true,
      "89480": true,
      "89490": true,
      "89496": true,
      "89497": true,
      "89500": true,
      "89505": true,
      "89506": true,
      "89510": true,
      "89512": true,
      "89513": true,
      "89514": true,
      "89515": true,
      "89517": true,
      "89518": true,
      "89519": true,
      "89520": true,
      "89530": true,
      "89540": true,
      "89550": true,
      "89553": true,
      "89554": true,
      "89555": true,
      "89556": true,
      "89560": true,
      "89566": true,
      "89567": true,
      "89570": true,
      "89580": true,
      "89590": true
    },
    "EL MANTE": {
      "89800": true,
      "89810": true,
      "89815": true,
      "89816": true,
      "89817": true,
      "89818": true,
      "89819": true,
      "89820": true,
      "89827": true,
      "89829": true,
      "89830": true,
      "89837": true,
      "89838": true,
      "89839": true,
      "89840": true,
      "89843": true,
      "89846": true,
      "89847": true,
      "89848": true,
      "89849": true,
      "89850": true,
      "89853": true,
      "89858": true,
      "89860": true,
      "89865": true,
      "89866": true,
      "89867": true,
      "89868": true,
      "89869": true,
      "89870": true,
      "89880": true,
      "89884": true,
      "89885": true,
      "89886": true,
      "89887": true,
      "89888": true,
      "89889": true,
      "89890": true,
      "89893": true,
      "89895": true,
      "89896": true,
      "89897": true,
      "89898": true,
      "89899": true,
      "89910": true,
      "89912": true,
      "89913": true,
      "89914": true,
      "89918": true,
      "89920": true,
      "89922": true,
      "89923": true,
      "89925": true,
      "89929": true,
      "89930": true,
      "89938": true,
      "89939": true,
      "89940": true,
      "89942": true,
      "89943": true,
      "89950": true,
      "89953": true,
      "89955": true
    },
    "GONZALEZ": {
      "89700": true,
      "89703": true,
      "89705": true,
      "89706": true,
      "89707": true,
      "89710": true,
      "89712": true,
      "89713": true,
      "89715": true,
      "89716": true,
      "89730": true,
      "89731": true,
      "89732": true,
      "89734": true,
      "89736": true,
      "89744": true,
      "89746": true
    },
    "GUEMEZ": {
      "87230": true,
      "87232": true,
      "87233": true,
      "87235": true,
      "87236": true,
      "87237": true,
      "87238": true,
      "87239": true,
      "87240": true,
      "87244": true,
      "87245": true,
      "87247": true,
      "87248": true,
      "87249": true
    },
    "GUSTAVO DIAZ ORDAZ": {
      "88400": true,
      "88402": true,
      "88403": true,
      "88404": true,
      "88405": true,
      "88406": true,
      "88407": true,
      "88408": true,
      "88410": true,
      "88412": true,
      "88415": true,
      "88425": true,
      "88430": true,
      "88434": true,
      "88439": true
    },
    "HIDALGO": {
      "87800": true,
      "87801": true,
      "87803": true,
      "87804": true,
      "87805": true,
      "87806": true,
      "87808": true,
      "87810": true,
      "87816": true,
      "87819": true,
      "87822": true,
      "87823": true,
      "87824": true,
      "87825": true,
      "87826": true,
      "87827": true,
      "87829": true,
      "87830": true,
      "87834": true,
      "87835": true,
      "87843": true
    },
    "JAUMAVE": {
      "87930": true,
      "87932": true,
      "87933": true,
      "87936": true,
      "87937": true,
      "87939": true,
      "87940": true,
      "87943": true,
      "87945": true,
      "87946": true,
      "87947": true,
      "87949": true
    },
    "JIMENEZ": {
      "87700": true,
      "87710": true,
      "87720": true
    },
    "LLERA": {
      "87200": true,
      "87202": true,
      "87205": true,
      "87206": true,
      "87207": true,
      "87209": true,
      "87210": true,
      "87212": true,
      "87213": true,
      "87215": true,
      "87216": true,
      "87220": true
    },
    "MATAMOROS": {
      "87300": true,
      "87310": true,
      "87313": true,
      "87314": true,
      "87315": true,
      "87316": true,
      "87317": true,
      "87318": true,
      "87319": true,
      "87320": true,
      "87324": true,
      "87326": true,
      "87330": true,
      "87340": true,
      "87343": true,
      "87344": true,
      "87345": true,
      "87346": true,
      "87347": true,
      "87348": true,
      "87349": true,
      "87350": true,
      "87360": true,
      "87370": true,
      "87380": true,
      "87382": true,
      "87383": true,
      "87385": true,
      "87389": true,
      "87390": true,
      "87393": true,
      "87394": true,
      "87395": true,
      "87396": true,
      "87397": true,
      "87398": true,
      "87399": true,
      "87400": true,
      "87410": true,
      "87413": true,
      "87415": true,
      "87420": true,
      "87430": true,
      "87438": true,
      "87440": true,
      "87444": true,
      "87445": true,
      "87446": true,
      "87447": true,
      "87448": true,
      "87449": true,
      "87450": true,
      "87453": true,
      "87454": true,
      "87455": true,
      "87456": true,
      "87457": true,
      "87458": true,
      "87459": true,
      "87460": true,
      "87469": true,
      "87470": true,
      "87475": true,
      "87476": true,
      "87477": true,
      "87490": true,
      "87493": true,
      "87494": true,
      "87495": true,
      "87496": true,
      "87497": true,
      "87498": true,
      "87499": true,
      "87540": true,
      "87544": true,
      "87550": true,
      "87551": true,
      "87552": true,
      "87553": true,
      "87554": true,
      "87555": true,
      "87557": true,
      "87558": true,
      "87559": true,
      "87560": true,
      "87563": true,
      "87564": true,
      "87565": true,
      "87569": true,
      "87570": true,
      "87577": true,
      "87580": true,
      "87585": true,
      "87587": true,
      "87588": true,
      "87589": true
    },
    "MIGUEL ALEMAN": {
      "88300": true,
      "88302": true,
      "88303": true,
      "88304": true,
      "88305": true,
      "88306": true,
      "88307": true,
      "88310": true,
      "88321": true,
      "88338": true
    },
    "NUEVO LAREDO": {
      "88000": true,
      "88009": true,
      "88020": true,
      "88030": true,
      "88040": true,
      "88060": true,
      "88070": true,
      "88100": true,
      "88105": true,
      "88110": true,
      "88120": true,
      "88123": true,
      "88124": true,
      "88125": true,
      "88126": true,
      "88130": true,
      "88134": true,
      "88135": true,
      "88136": true,
      "88140": true,
      "88144": true,
      "88145": true,
      "88146": true,
      "88147": true,
      "88150": true,
      "88160": true,
      "88170": true,
      "88175": true,
      "88176": true,
      "88177": true,
      "88179": true,
      "88180": true,
      "88184": true,
      "88185": true,
      "88186": true,
      "88187": true,
      "88190": true,
      "88194": true,
      "88195": true,
      "88200": true,
      "88209": true,
      "88210": true,
      "88220": true,
      "88230": true,
      "88240": true,
      "88250": true,
      "88260": true,
      "88270": true,
      "88274": true,
      "88275": true,
      "88276": true,
      "88277": true,
      "88278": true,
      "88280": true,
      "88283": true,
      "88284": true,
      "88285": true,
      "88287": true,
      "88289": true,
      "88290": true,
      "88293": true,
      "88294": true,
      "88295": true,
      "88296": true,
      "88298": true,
      "88299": true,
      "88350": true
    },
    "PADILLA": {
      "87780": true,
      "87785": true,
      "87790": true,
      "87794": true,
      "87795": true,
      "87797": true,
      "87798": true,
      "87799": true
    },
    "PALMILLAS": {
      "87970": true,
      "87972": true,
      "87973": true,
      "87974": true,
      "87975": true
    },
    "REYNOSA": {
      "88500": true,
      "88509": true,
      "88510": true,
      "88520": true,
      "88522": true,
      "88540": true,
      "88550": true,
      "88560": true,
      "88570": true,
      "88580": true,
      "88589": true,
      "88595": true,
      "88596": true,
      "88597": true,
      "88598": true,
      "88599": true,
      "88600": true,
      "88610": true,
      "88614": true,
      "88615": true,
      "88620": true,
      "88630": true,
      "88631": true,
      "88632": true,
      "88640": true,
      "88649": true,
      "88650": true,
      "88651": true,
      "88653": true,
      "88654": true,
      "88655": true,
      "88656": true,
      "88660": true,
      "88670": true,
      "88680": true,
      "88684": true,
      "88687": true,
      "88689": true,
      "88690": true,
      "88700": true,
      "88703": true,
      "88706": true,
      "88707": true,
      "88708": true,
      "88709": true,
      "88710": true,
      "88713": true,
      "88715": true,
      "88720": true,
      "88727": true,
      "88729": true,
      "88730": true,
      "88733": true,
      "88734": true,
      "88735": true,
      "88736": true,
      "88740": true,
      "88745": true,
      "88746": true,
      "88747": true,
      "88748": true,
      "88749": true,
      "88750": true,
      "88754": true,
      "88755": true,
      "88756": true,
      "88757": true,
      "88758": true,
      "88759": true,
      "88760": true,
      "88763": true,
      "88764": true,
      "88769": true,
      "88770": true,
      "88776": true,
      "88777": true,
      "88778": true,
      "88779": true,
      "88780": true,
      "88783": true,
      "88784": true,
      "88785": true,
      "88786": true,
      "88787": true,
      "88788": true,
      "88789": true,
      "88790": true,
      "88793": true,
      "88794": true,
      "88795": true,
      "88796": true,
      "88797": true,
      "88798": true,
      "88799": true,
      "88850": true,
      "88854": true,
      "88855": true,
      "88856": true,
      "88857": true,
      "88859": true,
      "88864": true,
      "88866": true,
      "88875": true
    },
    "RIO BRAVO": {
      "88800": true,
      "88803": true,
      "88809": true,
      "88810": true,
      "88811": true,
      "88813": true,
      "88815": true,
      "88817": true,
      "88818": true,
      "88900": true,
      "88910": true,
      "88920": true,
      "88923": true,
      "88925": true,
      "88930": true,
      "88933": true,
      "88934": true,
      "88935": true,
      "88936": true,
      "88940": true,
      "88943": true,
      "88944": true,
      "88945": true,
      "88946": true,
      "88950": true,
      "88959": true,
      "88960": true,
      "88970": true,
      "88980": true,
      "88990": true,
      "88993": true,
      "88994": true,
      "88995": true
    },
    "SAN FERNANDO": {
      "87600": true,
      "87602": true,
      "87604": true,
      "87605": true,
      "87606": true,
      "87607": true,
      "87610": true,
      "87616": true,
      "87619": true,
      "87620": true,
      "87625": true,
      "87628": true,
      "87629": true,
      "87630": true
    },
    "SOTO LA MARINA": {
      "87670": true,
      "87675": true,
      "87678": true,
      "87690": true,
      "87693": true
    },
    "TAMPICO": {
      "89000": true,
      "89050": true,
      "89060": true,
      "89070": true,
      "89080": true,
      "89090": true,
      "89100": true,
      "89106": true,
      "89107": true,
      "89108": true,
      "89109": true,
      "89110": true,
      "89118": true,
      "89119": true,
      "89120": true,
      "89130": true,
      "89136": true,
      "89137": true,
      "89138": true,
      "89140": true,
      "89150": true,
      "89159": true,
      "89160": true,
      "89169": true,
      "89170": true,
      "89176": true,
      "89177": true,
      "89180": true,
      "89190": true,
      "89199": true,
      "89210": true,
      "89215": true,
      "89217": true,
      "89218": true,
      "89219": true,
      "89220": true,
      "89229": true,
      "89230": true,
      "89239": true,
      "89240": true,
      "89250": true,
      "89258": true,
      "89260": true,
      "89268": true,
      "89270": true,
      "89280": true,
      "89290": true,
      "89298": true,
      "89309": true,
      "89310": true,
      "89314": true,
      "89316": true,
      "89317": true,
      "89318": true,
      "89319": true,
      "89320": true,
      "89325": true,
      "89326": true,
      "89327": true,
      "89328": true,
      "89329": true,
      "89330": true,
      "89336": true,
      "89337": true,
      "89338": true,
      "89339": true,
      "89340": true,
      "89344": true,
      "89345": true,
      "89346": true,
      "89347": true,
      "89348": true,
      "89349": true,
      "89350": true,
      "89355": true,
      "89356": true,
      "89357": true,
      "89358": true,
      "89359": true,
      "89360": true,
      "89364": true,
      "89365": true,
      "89366": true,
      "89367": true,
      "89368": true,
      "89369": true
    },
    "TULA": {
      "87900": true,
      "87902": true,
      "87904": true,
      "87906": true,
      "87907": true,
      "87911": true,
      "87912": true,
      "87913": true,
      "87914": true,
      "87915": true,
      "87918": true,
      "87920": true,
      "87928": true
    },
    "VALLE HERMOSO": {
      "87500": true,
      "87503": true,
      "87504": true,
      "87505": true,
      "87506": true,
      "87507": true,
      "87510": true,
      "87511": true,
      "87520": true,
      "87524": true,
      "87530": true,
      "87535": true
    },
    "VICTORIA": {
      "87000": true,
      "87010": true,
      "87014": true,
      "87015": true,
      "87016": true,
      "87018": true,
      "87019": true,
      "87020": true,
      "87023": true,
      "87024": true,
      "87025": true,
      "87026": true,
      "87027": true,
      "87028": true,
      "87029": true,
      "87030": true,
      "87033": true,
      "87037": true,
      "87040": true,
      "87043": true,
      "87048": true,
      "87049": true,
      "87050": true,
      "87058": true,
      "87059": true,
      "87060": true,
      "87070": true,
      "87076": true,
      "87078": true,
      "87080": true,
      "87083": true,
      "87084": true,
      "87085": true,
      "87086": true,
      "87087": true,
      "87089": true,
      "87090": true,
      "87093": true,
      "87099": true,
      "87100": true,
      "87110": true,
      "87120": true,
      "87130": true,
      "87133": true,
      "87134": true,
      "87135": true,
      "87136": true,
      "87137": true,
      "87138": true,
      "87140": true,
      "87149": true,
      "87150": true,
      "87160": true,
      "87163": true,
      "87170": true,
      "87173": true,
      "87180": true,
      "87183": true,
      "87260": true,
      "87261": true,
      "87262": true,
      "87263": true,
      "87265": true,
      "87266": true,
      "87267": true,
      "87270": true,
      "87273": true,
      "87274": true,
      "87277": true,
      "87278": true,
      "87279": true,
      "87284": true
    },
    "XICOTENCATL": {
      "89750": true,
      "89751": true,
      "89752": true,
      "89753": true,
      "89755": true,
      "89756": true,
      "89757": true,
      "89758": true,
      "89759": true,
      "89760": true,
      "89762": true,
      "89763": true,
      "89764": true,
      "89774": true
    }
  },
  "TLAXCALA": {
    "ACUAMANALA DE MIGUEL HIDALGO": {
      "90860": true,
      "90861": true,
      "90864": true
    },
    "AMAXAC DE GUERRERO": {
      "90620": true,
      "90623": true,
      "90624": true,
      "90630": true,
      "90635": true
    },
    "APETATITLAN DE ANTONIO CARVAJAL": {
      "90600": true,
      "90604": true,
      "90605": true,
      "90606": true,
      "90608": true,
      "90610": true
    },
    "APIZACO": {
      "90300": true,
      "90319": true,
      "90320": true,
      "90323": true,
      "90329": true,
      "90330": true,
      "90337": true,
      "90338": true,
      "90339": true,
      "90340": true,
      "90341": true,
      "90342": true,
      "90347": true,
      "90350": true,
      "90355": true,
      "90356": true,
      "90357": true,
      "90358": true,
      "90360": true,
      "90370": true,
      "90378": true,
      "90380": true,
      "90401": true,
      "90402": true,
      "90403": true,
      "90404": true,
      "90405": true,
      "90406": true,
      "90407": true
    },
    "ATLANGATEPEC": {
      "90410": true,
      "90411": true,
      "90413": true,
      "90414": true,
      "90415": true,
      "90416": true,
      "90417": true,
      "90418": true
    },
    "ATLTZAYANCA": {
      "90550": true,
      "90553": true,
      "90554": true,
      "90555": true,
      "90556": true,
      "90557": true,
      "90558": true
    },
    "BENITO JUÁREZ": {
      "90235": true
    },
    "CALPULALPAN": {
      "90200": true,
      "90202": true,
      "90203": true,
      "90204": true,
      "90205": true,
      "90207": true,
      "90208": true,
      "90210": true,
      "90213": true,
      "90218": true,
      "90220": true,
      "90222": true,
      "90224": true,
      "90225": true,
      "90226": true
    },
    "CHIAUTEMPAN": {
      "90800": true,
      "90802": true,
      "90803": true,
      "90804": true,
      "90805": true,
      "90806": true,
      "90807": true,
      "90810": true,
      "90820": true,
      "90821": true
    },
    "CONTLA DE JUAN CUAMATZI": {
      "90670": true,
      "90676": true,
      "90680": true,
      "90690": true,
      "90692": true,
      "90693": true
    },
    "CUAPIAXTLA": {
      "90560": true,
      "90562": true,
      "90563": true,
      "90564": true,
      "90565": true,
      "90567": true,
      "90568": true
    },
    "CUAXOMULCO": {
      "90660": true
    },
    "EL CARMEN TEQUEXQUITLA": {
      "90570": true,
      "90573": true,
      "90575": true,
      "90576": true,
      "90577": true
    },
    "EMILIANO ZAPATA": {
      "90547": true,
      "90548": true
    },
    "ESPANITA": {
      "90290": true,
      "90291": true,
      "90292": true,
      "90293": true,
      "90294": true,
      "90295": true,
      "90297": true,
      "90298": true
    },
    "HUAMANTLA": {
      "90500": true,
      "90502": true,
      "90503": true,
      "90505": true,
      "90506": true,
      "90507": true,
      "90508": true,
      "90509": true,
      "90510": true,
      "90514": true,
      "90515": true,
      "90520": true,
      "90525": true,
      "90527": true,
      "90530": true,
      "90534": true,
      "90535": true
    },
    "HUEYOTLIPAN": {
      "90240": true,
      "90241": true,
      "90243": true,
      "90244": true,
      "90245": true,
      "90246": true,
      "90247": true
    },
    "IXTACUIXTLA DE MARIANO MATAMOROS": {
      "90120": true,
      "90121": true,
      "90122": true,
      "90123": true,
      "90124": true,
      "90125": true,
      "90126": true,
      "90127": true,
      "90128": true,
      "90130": true,
      "90131": true,
      "90132": true,
      "90133": true,
      "90134": true
    },
    "IXTENCO": {
      "90580": true,
      "90583": true,
      "90584": true,
      "90585": true,
      "90586": true
    },
    "LA MAGDALENA TLALTELULCO": {
      "90830": true,
      "90833": true,
      "90834": true,
      "90835": true
    },
    "LAZARO CARDENAS": {
      "90545": true,
      "90546": true
    },
    "MAZATECOCHCO DE JOSE MARIA MORELOS": {
      "90870": true,
      "90873": true,
      "90874": true,
      "90875": true,
      "90876": true,
      "90877": true
    },
    "MUNOZ DE DOMINGO ARENAS": {
      "90420": true,
      "90421": true,
      "90423": true,
      "90425": true,
      "90427": true,
      "90428": true
    },
    "NANACAMILPA DE MARIANO ARISTA": {
      "90280": true,
      "90283": true,
      "90284": true,
      "90285": true,
      "90286": true,
      "90287": true,
      "90288": true
    },
    "NATIVITAS": {
      "90710": true,
      "90712": true,
      "90713": true,
      "90715": true,
      "90716": true,
      "90717": true,
      "90718": true,
      "90721": true,
      "90722": true,
      "90723": true
    },
    "PANOTLA": {
      "90140": true,
      "90145": true,
      "90147": true,
      "90150": true,
      "90151": true,
      "90152": true,
      "90155": true
    },
    "PAPALOTLA DE XICOHTENCATL": {
      "90790": true,
      "90791": true,
      "90794": true,
      "90796": true
    },
    "SAN DAMIAN TEXOLOC": {
      "90735": true,
      "90736": true,
      "90737": true
    },
    "SAN FRANCISCO TETLANOHCAN": {
      "90843": true,
      "90845": true,
      "90847": true
    },
    "SAN JERONIMO ZACUALPAN": {
      "90738": true
    },
    "SAN JOSE TEACALCO": {
      "90495": true,
      "90496": true,
      "90497": true,
      "90498": true
    },
    "SAN JUAN HUACTZINCO": {
      "90195": true
    },
    "SAN LORENZO AXOCOMANITLA": {
      "90760": true
    },
    "SAN LUCAS TECOPILCO": {
      "90445": true,
      "90446": true,
      "90447": true,
      "90448": true
    },
    "SAN PABLO DEL MONTE": {
      "90890": true,
      "90894": true,
      "90895": true,
      "90896": true,
      "90897": true,
      "90898": true,
      "90900": true,
      "90920": true,
      "90930": true,
      "90940": true,
      "90950": true,
      "90960": true,
      "90970": true,
      "90980": true,
      "90990": true
    },
    "SANCTORUM DE LAZARO CARDENAS": {
      "90230": true,
      "90231": true,
      "90233": true,
      "90234": true
    },
    "SANTA ANA NOPALUCAN": {
      "90135": true,
      "90137": true,
      "90138": true,
      "90139": true
    },
    "SANTA APOLONIA TEACALCO": {
      "90725": true
    },
    "SANTA CATARINA AYOMETLA": {
      "90770": true,
      "90773": true,
      "90774": true,
      "90775": true
    },
    "SANTA CRUZ QUILEHTLA": {
      "90867": true
    },
    "SANTA CRUZ TLAXCALA": {
      "90640": true,
      "90643": true,
      "90644": true,
      "90645": true,
      "90646": true,
      "90650": true,
      "90653": true
    },
    "SANTA ISABEL XILOXOXTLA": {
      "90193": true,
      "90194": true
    },
    "TENANCINGO": {
      "90880": true,
      "90883": true,
      "90886": true,
      "90887": true
    },
    "TEOLOCHOLCO": {
      "90850": true,
      "90855": true
    },
    "TEPETITLA DE LARDIZABAL": {
      "90700": true
    },
    "TEPEYANCO": {
      "90180": true,
      "90182": true
    },
    "TERRENATE": {
      "90540": true,
      "90542": true,
      "90543": true,
      "90544": true
    },
    "TETLA DE LA SOLIDARIDAD": {
      "90430": true,
      "90432": true,
      "90433": true,
      "90434": true,
      "90435": true,
      "90436": true,
      "90437": true,
      "90438": true
    },
    "TETLATLAHUCA": {
      "90730": true,
      "90733": true,
      "90734": true
    },
    "TLAXCALA": {
      "90000": true,
      "90006": true,
      "90010": true,
      "90013": true,
      "90014": true,
      "90019": true,
      "90020": true,
      "90030": true,
      "90040": true,
      "90050": true,
      "90060": true,
      "90062": true,
      "90090": true,
      "90099": true,
      "90100": true,
      "90102": true,
      "90105": true,
      "90110": true,
      "90111": true,
      "90112": true,
      "90114": true,
      "90115": true,
      "90117": true,
      "90118": true
    },
    "TLAXCO": {
      "90250": true,
      "90251": true,
      "90253": true,
      "90255": true,
      "90256": true,
      "90257": true,
      "90258": true,
      "90259": true,
      "90260": true,
      "90261": true,
      "90262": true,
      "90264": true,
      "90265": true,
      "90266": true,
      "90267": true,
      "90270": true,
      "90271": true,
      "90273": true,
      "90274": true,
      "90275": true,
      "90276": true,
      "90277": true,
      "90278": true
    },
    "TOCATLAN": {
      "90480": true,
      "90482": true,
      "90484": true
    },
    "TOTOLAC": {
      "90160": true,
      "90163": true,
      "90164": true,
      "90165": true,
      "90166": true,
      "90168": true,
      "90170": true
    },
    "TZOMPANTEPEC": {
      "90490": true,
      "90491": true,
      "90493": true,
      "90494": true
    },
    "XALOZTOC": {
      "90460": true,
      "90463": true,
      "90465": true,
      "90470": true
    },
    "XALTOCAN": {
      "90440": true,
      "90443": true,
      "90444": true
    },
    "XICOHTZINCO": {
      "90780": true
    },
    "YAUHQUEMEHCAN": {
      "90450": true,
      "90453": true,
      "90454": true,
      "90455": true,
      "90456": true,
      "90457": true,
      "90458": true,
      "90459": true
    },
    "ZACATELCO": {
      "90740": true,
      "90750": true,
      "90754": true
    },
    "ZILTLALTEPEC DE TRINIDAD SANCHEZ SANTOS": {
      "90590": true,
      "90592": true,
      "90594": true,
      "90595": true,
      "90596": true
    }
  },
  "VERACRUZ DE IGNACIO DE LA LLAVE": {
    "ACAJETE": {
      "91320": true,
      "91322": true,
      "91323": true,
      "91324": true,
      "91325": true,
      "91326": true,
      "91327": true,
      "91328": true
    },
    "ACATLAN": {
      "91420": true
    },
    "ACAYUCAN": {
      "96000": true,
      "96010": true,
      "96014": true,
      "96020": true,
      "96025": true,
      "96026": true,
      "96028": true,
      "96029": true,
      "96030": true,
      "96039": true,
      "96048": true,
      "96049": true,
      "96050": true,
      "96054": true,
      "96055": true,
      "96056": true,
      "96057": true,
      "96067": true,
      "96068": true,
      "96069": true,
      "96070": true,
      "96079": true,
      "96100": true,
      "96103": true,
      "96107": true,
      "96108": true,
      "96112": true
    },
    "ACTOPAN": {
      "91480": true,
      "91481": true,
      "91482": true,
      "91484": true,
      "91485": true,
      "91487": true,
      "91489": true,
      "91490": true,
      "91495": true,
      "91496": true
    },
    "AGUA DULCE": {
      "96390": true,
      "96393": true,
      "96394": true,
      "96395": true,
      "96397": true,
      "96398": true,
      "96399": true,
      "96600": true,
      "96610": true,
      "96620": true,
      "96630": true,
      "96640": true,
      "96660": true,
      "96670": true,
      "96680": true,
      "96684": true,
      "96687": true,
      "96690": true
    },
    "ALAMO TEMAPACHE": {
      "92730": true,
      "92733": true,
      "92734": true,
      "92735": true,
      "92736": true,
      "92737": true,
      "92740": true,
      "92742": true,
      "92744": true,
      "92750": true,
      "92755": true,
      "92760": true,
      "92762": true,
      "92763": true,
      "92764": true,
      "92765": true
    },
    "ALTO LUCERO DE GUTIERREZ BARRIOS": {
      "91460": true,
      "91463": true,
      "91466": true,
      "91469": true,
      "91477": true
    },
    "ALTOTONGA": {
      "93700": true,
      "93710": true,
      "93720": true,
      "93721": true,
      "93723": true,
      "93724": true,
      "93725": true,
      "93726": true,
      "93730": true,
      "93732": true,
      "93733": true,
      "93734": true,
      "93735": true,
      "93737": true
    },
    "ALVARADO": {
      "95259": true,
      "95261": true,
      "95263": true,
      "95264": true,
      "95266": true,
      "95267": true,
      "95269": true,
      "95270": true,
      "95272": true,
      "95275": true,
      "95276": true,
      "95277": true,
      "95278": true
    },
    "AMATLAN DE LOS REYES": {
      "94940": true,
      "94943": true,
      "94944": true,
      "94945": true,
      "94946": true,
      "94950": true,
      "94953": true,
      "94954": true,
      "94955": true,
      "94956": true,
      "94957": true,
      "94959": true
    },
    "ANGEL R. CABADA": {
      "95840": true,
      "95842": true,
      "95843": true,
      "95844": true,
      "95845": true,
      "95846": true,
      "95847": true,
      "95848": true
    },
    "APAZAPAN": {
      "91645": true,
      "91646": true,
      "91647": true,
      "91649": true
    },
    "ATOYAC": {
      "94960": true,
      "94964": true,
      "94965": true,
      "94966": true,
      "94967": true
    },
    "ATZACAN": {
      "94440": true,
      "94442": true,
      "94445": true,
      "94446": true,
      "94447": true
    },
    "ATZALAN": {
      "93680": true,
      "93693": true,
      "93695": true,
      "93697": true,
      "93699": true
    },
    "AYAHUALULCO": {
      "91260": true,
      "91262": true,
      "91264": true,
      "91265": true,
      "91266": true,
      "91267": true,
      "91268": true
    },
    "BANDERILLA": {
      "91300": true,
      "91302": true,
      "91303": true,
      "91304": true,
      "91305": true,
      "91306": true,
      "91307": true,
      "91310": true,
      "91312": true
    },
    "BOCA DEL RÍO": {
      "94285": true,
      "94286": true,
      "94287": true,
      "94290": true,
      "94293": true,
      "94294": true,
      "94295": true,
      "94296": true,
      "94297": true,
      "94298": true,
      "94299": true
    },
    "CAMARON DE TEJEDA": {
      "94230": true,
      "94233": true,
      "94234": true,
      "94235": true,
      "94236": true,
      "94237": true
    },
    "CAMERINO Z. MENDOZA": {
      "94740": true,
      "94743": true,
      "94744": true,
      "94745": true,
      "94746": true,
      "94748": true
    },
    "CARRILLO PUERTO": {
      "94980": true,
      "94983": true,
      "94984": true,
      "94985": true,
      "94986": true,
      "94987": true,
      "94988": true,
      "94989": true
    },
    "CASTILLO DE TEAYO": {
      "92940": true,
      "92941": true,
      "92942": true,
      "92943": true,
      "92944": true,
      "92945": true,
      "92946": true,
      "92947": true,
      "92948": true,
      "92949": true
    },
    "CAZONES DE HERRERA": {
      "92970": true,
      "92972": true,
      "92973": true,
      "92974": true,
      "92975": true,
      "92976": true,
      "92977": true,
      "92978": true,
      "92979": true,
      "92980": true,
      "92983": true,
      "92984": true,
      "92985": true,
      "92987": true,
      "92990": true,
      "92992": true,
      "92993": true,
      "92994": true
    },
    "CERRO AZUL": {
      "92500": true,
      "92503": true,
      "92504": true,
      "92505": true,
      "92510": true,
      "92513": true,
      "92514": true,
      "92515": true,
      "92516": true,
      "92517": true,
      "92518": true,
      "92519": true,
      "92520": true,
      "92523": true,
      "92525": true,
      "92527": true
    },
    "CHICONQUIACO": {
      "93880": true,
      "93883": true,
      "93884": true,
      "93892": true,
      "93894": true,
      "93896": true,
      "93897": true
    },
    "CHINAMECA": {
      "95980": true,
      "95986": true,
      "95990": true,
      "95992": true,
      "95993": true,
      "95994": true,
      "95995": true,
      "95997": true
    },
    "CHUMATLAN": {
      "93040": true,
      "93041": true,
      "93050": true
    },
    "COACOATZINTLA": {
      "91370": true,
      "91373": true,
      "91374": true,
      "91375": true,
      "91376": true,
      "91377": true,
      "91378": true,
      "91379": true
    },
    "COAHUITLAN": {
      "93120": true,
      "93122": true,
      "93124": true
    },
    "COATEPEC": {
      "91500": true,
      "91503": true,
      "91505": true,
      "91506": true,
      "91510": true,
      "91514": true,
      "91515": true,
      "91516": true,
      "91517": true,
      "91518": true,
      "91519": true,
      "91520": true,
      "91521": true,
      "91527": true,
      "91528": true,
      "91529": true,
      "91530": true,
      "91533": true,
      "91537": true,
      "91538": true,
      "91539": true,
      "91540": true,
      "91549": true,
      "91550": true,
      "91556": true,
      "91557": true,
      "91559": true,
      "91560": true,
      "91565": true,
      "91566": true,
      "91567": true,
      "91568": true,
      "91569": true,
      "91570": true,
      "91575": true,
      "91576": true,
      "91579": true,
      "91580": true,
      "91581": true,
      "91583": true,
      "91584": true,
      "91589": true,
      "91601": true,
      "91602": true,
      "91603": true,
      "91604": true,
      "91606": true,
      "91607": true,
      "91608": true,
      "91609": true,
      "91610": true,
      "91611": true,
      "91612": true,
      "91614": true
    },
    "COATZACOALCOS": {
      "96380": true,
      "96385": true,
      "96386": true,
      "96387": true,
      "96389": true,
      "96400": true,
      "96410": true,
      "96420": true,
      "96430": true,
      "96440": true,
      "96458": true,
      "96460": true,
      "96470": true,
      "96480": true,
      "96490": true,
      "96492": true,
      "96495": true,
      "96496": true,
      "96497": true,
      "96499": true,
      "96500": true,
      "96510": true,
      "96518": true,
      "96519": true,
      "96520": true,
      "96523": true,
      "96529": true,
      "96530": true,
      "96535": true,
      "96536": true,
      "96537": true,
      "96538": true,
      "96539": true,
      "96540": true,
      "96550": true,
      "96556": true,
      "96557": true,
      "96558": true,
      "96559": true,
      "96560": true,
      "96564": true,
      "96565": true,
      "96566": true,
      "96567": true,
      "96568": true,
      "96569": true,
      "96570": true,
      "96575": true,
      "96576": true,
      "96577": true,
      "96578": true,
      "96579": true,
      "96580": true,
      "96588": true,
      "96590": true,
      "96598": true,
      "96599": true
    },
    "COATZINTLA": {
      "93160": true,
      "93162": true,
      "93163": true,
      "93164": true,
      "93165": true,
      "93166": true,
      "93167": true,
      "93169": true,
      "93172": true,
      "93173": true,
      "93174": true,
      "93175": true,
      "93176": true
    },
    "COLIPA": {
      "93950": true,
      "93953": true,
      "93954": true,
      "93955": true,
      "93956": true
    },
    "CORDOBA": {
      "94486": true,
      "94487": true,
      "94488": true,
      "94489": true,
      "94490": true,
      "94493": true,
      "94494": true,
      "94495": true,
      "94496": true,
      "94497": true,
      "94500": true,
      "94510": true,
      "94513": true,
      "94515": true,
      "94516": true,
      "94517": true,
      "94520": true,
      "94530": true,
      "94534": true,
      "94540": true,
      "94542": true,
      "94543": true,
      "94545": true,
      "94546": true,
      "94550": true,
      "94552": true,
      "94553": true,
      "94554": true,
      "94556": true,
      "94557": true,
      "94558": true,
      "94559": true,
      "94560": true,
      "94570": true,
      "94575": true,
      "94580": true,
      "94589": true,
      "94590": true,
      "94600": true,
      "94610": true,
      "94613": true,
      "94620": true,
      "94630": true,
      "94635": true,
      "94640": true,
      "94643": true,
      "94649": true,
      "94650": true,
      "94657": true,
      "94660": true,
      "94670": true,
      "94677": true,
      "94679": true,
      "94680": true,
      "94687": true,
      "94688": true,
      "94689": true,
      "94690": true,
      "94693": true,
      "94696": true,
      "94699": true
    },
    "COSAMALOAPAN DE CARPIO": {
      "95390": true,
      "95392": true,
      "95394": true,
      "95395": true,
      "95396": true,
      "95397": true,
      "95398": true,
      "95399": true,
      "95400": true,
      "95412": true,
      "95413": true,
      "95414": true,
      "95415": true,
      "95420": true,
      "95422": true,
      "95423": true,
      "95424": true,
      "95425": true,
      "95426": true,
      "95429": true
    },
    "COSAUTLAN DE CARVAJAL": {
      "91620": true,
      "91621": true,
      "91622": true,
      "91623": true,
      "91625": true
    },
    "COSCOMATEPEC": {
      "94140": true,
      "94142": true,
      "94143": true,
      "94144": true,
      "94145": true,
      "94147": true,
      "94149": true
    },
    "COSOLEACAQUE": {
      "96342": true,
      "96343": true,
      "96344": true,
      "96345": true,
      "96346": true,
      "96347": true,
      "96348": true,
      "96349": true,
      "96350": true,
      "96353": true,
      "96357": true,
      "96358": true
    },
    "COTAXTLA": {
      "94990": true,
      "94995": true,
      "94996": true,
      "94997": true
    },
    "COXQUIHUI": {
      "93060": true,
      "93062": true,
      "93063": true,
      "93065": true,
      "93067": true,
      "93068": true,
      "93070": true,
      "93071": true,
      "93072": true,
      "93073": true,
      "93074": true,
      "93076": true
    },
    "COYUTLA": {
      "93140": true,
      "93142": true,
      "93143": true,
      "93147": true,
      "93150": true,
      "93152": true,
      "93153": true,
      "93154": true,
      "93155": true,
      "93157": true,
      "93158": true
    },
    "CUITLAHUAC": {
      "94910": true,
      "94912": true,
      "94913": true,
      "94914": true,
      "94915": true,
      "94916": true,
      "94917": true,
      "94918": true
    },
    "EMILIANO ZAPATA": {
      "91630": true,
      "91633": true,
      "91634": true,
      "91635": true,
      "91636": true,
      "91637": true,
      "91640": true,
      "91643": true,
      "91644": true
    },
    "ESPINAL": {
      "93180": true,
      "93181": true,
      "93182": true,
      "93183": true,
      "93184": true,
      "93185": true,
      "93190": true,
      "93193": true,
      "93194": true,
      "93195": true,
      "93196": true,
      "93197": true,
      "93198": true
    },
    "FILOMENO MATA": {
      "93100": true,
      "93104": true,
      "93105": true,
      "93110": true
    },
    "FORTIN": {
      "94466": true,
      "94467": true,
      "94470": true,
      "94472": true,
      "94473": true,
      "94474": true,
      "94475": true,
      "94476": true,
      "94477": true,
      "94478": true,
      "94479": true
    },
    "GUTIERREZ ZAMORA": {
      "93550": true,
      "93552": true,
      "93553": true,
      "93554": true,
      "93556": true,
      "93557": true,
      "93558": true,
      "93559": true,
      "93560": true,
      "93562": true,
      "93563": true,
      "93564": true,
      "93565": true,
      "93566": true,
      "93568": true,
      "93569": true
    },
    "HIDALGOTITLAN": {
      "96930": true,
      "96933": true,
      "96934": true
    },
    "HUATUSCO": {
      "94100": true,
      "94103": true,
      "94106": true,
      "94107": true,
      "94108": true,
      "94110": true,
      "94112": true,
      "94113": true,
      "94116": true,
      "94117": true,
      "94118": true
    },
    "IGNACIO DE LA LLAVE": {
      "95240": true,
      "95243": true,
      "95244": true,
      "95246": true,
      "95247": true
    },
    "ISLA": {
      "95640": true,
      "95642": true,
      "95643": true,
      "95645": true,
      "95646": true,
      "95647": true,
      "95648": true,
      "95650": true,
      "95652": true,
      "95653": true,
      "95654": true,
      "95655": true,
      "95658": true,
      "95659": true
    },
    "IXHUACAN DE LOS REYES": {
      "91250": true,
      "91252": true,
      "91254": true,
      "91255": true,
      "91256": true,
      "91257": true
    },
    "IXHUATLAN DEL SURESTE": {
      "96365": true,
      "96366": true,
      "96367": true,
      "96368": true,
      "96369": true
    },
    "IXHUATLANCILLO": {
      "94430": true
    },
    "IXTACZOQUITLAN": {
      "94450": true,
      "94452": true,
      "94453": true,
      "94454": true,
      "94455": true,
      "94456": true,
      "94457": true,
      "94458": true,
      "94460": true,
      "94462": true,
      "94463": true,
      "94464": true,
      "94465": true
    },
    "JALACINGO": {
      "93660": true,
      "93662": true,
      "93664": true,
      "93668": true,
      "93671": true,
      "93672": true,
      "93675": true,
      "93676": true
    },
    "JALCOMULCO": {
      "94000": true,
      "94019": true
    },
    "JALTIPAN": {
      "96200": true,
      "96210": true,
      "96220": true,
      "96230": true,
      "96240": true,
      "96250": true,
      "96260": true,
      "96270": true,
      "96280": true,
      "96290": true,
      "96300": true,
      "96303": true,
      "96304": true,
      "96305": true,
      "96306": true,
      "96307": true,
      "96316": true,
      "96317": true
    },
    "JAMAPA": {
      "94260": true,
      "94263": true,
      "94264": true,
      "94265": true,
      "94266": true,
      "94267": true
    },
    "JESUS CARRANZA": {
      "96950": true,
      "96952": true,
      "96953": true,
      "96954": true,
      "96955": true,
      "96956": true,
      "96957": true,
      "96960": true,
      "96962": true,
      "96963": true,
      "96965": true,
      "96966": true,
      "96970": true,
      "96974": true,
      "96978": true
    },
    "JILOTEPEC": {
      "91380": true,
      "91382": true,
      "91383": true,
      "91384": true,
      "91385": true,
      "91389": true,
      "91390": true,
      "91393": true,
      "91394": true,
      "91396": true
    },
    "JUCHIQUE DE FERRER": {
      "91440": true,
      "91441": true,
      "91443": true,
      "91444": true,
      "91445": true,
      "91446": true,
      "91447": true,
      "91448": true,
      "91449": true,
      "91451": true
    },
    "LA ANTIGUA": {
      "91680": true,
      "91685": true,
      "91686": true,
      "91687": true,
      "91688": true,
      "91689": true
    },
    "LANDERO Y COSS": {
      "93860": true
    },
    "LAS CHOAPAS": {
      "96980": true,
      "96983": true,
      "96985": true,
      "96986": true
    },
    "LAS MINAS": {
      "93740": true,
      "93743": true,
      "93744": true,
      "93745": true,
      "93746": true,
      "93747": true,
      "93748": true,
      "93749": true,
      "93750": true
    },
    "LAS VIGAS DE RAMIREZ": {
      "91330": true,
      "91333": true,
      "91334": true,
      "91335": true,
      "91336": true,
      "91337": true,
      "91338": true,
      "91339": true
    },
    "LERDO DE TEJADA": {
      "95280": true,
      "95281": true,
      "95283": true,
      "95284": true,
      "95285": true,
      "95286": true,
      "95287": true,
      "95295": true
    },
    "MANLIO FABIO ALTAMIRANO": {
      "94250": true,
      "94253": true,
      "94254": true,
      "94255": true,
      "94256": true,
      "94257": true,
      "94258": true,
      "94259": true
    },
    "MARIANO ESCOBEDO": {
      "94420": true,
      "94422": true,
      "94423": true,
      "94424": true,
      "94425": true,
      "94426": true,
      "94427": true
    },
    "MARTINEZ DE LA TORRE": {
      "93600": true,
      "93603": true,
      "93604": true,
      "93605": true,
      "93606": true,
      "93607": true,
      "93608": true,
      "93610": true,
      "93613": true,
      "93633": true,
      "93634": true,
      "93635": true,
      "93638": true,
      "93640": true,
      "93641": true,
      "93643": true,
      "93644": true,
      "93645": true,
      "93646": true,
      "93647": true
    },
    "MECATLAN": {
      "93080": true,
      "93083": true,
      "93084": true,
      "93085": true,
      "93086": true
    },
    "MECAYAPAN": {
      "95930": true,
      "95932": true,
      "95933": true,
      "95935": true,
      "95947": true
    },
    "MEDELLIN": {
      "94270": true,
      "94273": true,
      "94274": true,
      "94275": true,
      "94276": true,
      "94277": true,
      "94278": true,
      "94280": true
    },
    "MIAHUATLAN": {
      "91410": true,
      "91413": true,
      "91414": true,
      "91415": true,
      "91416": true,
      "91417": true
    },
    "MINATITLAN": {
      "96700": true,
      "96710": true,
      "96716": true,
      "96717": true,
      "96719": true,
      "96720": true,
      "96728": true,
      "96729": true,
      "96730": true,
      "96734": true,
      "96735": true,
      "96736": true,
      "96737": true,
      "96739": true,
      "96740": true,
      "96750": true,
      "96757": true,
      "96760": true,
      "96770": true,
      "96773": true,
      "96780": true,
      "96790": true,
      "96798": true,
      "96799": true,
      "96840": true,
      "96848": true,
      "96849": true,
      "96850": true,
      "96858": true,
      "96860": true,
      "96870": true,
      "96873": true,
      "96879": true,
      "96880": true,
      "96890": true,
      "96900": true,
      "96904": true
    },
    "MISANTLA": {
      "93820": true,
      "93826": true,
      "93827": true,
      "93828": true,
      "93829": true,
      "93834": true,
      "93835": true,
      "93836": true,
      "93837": true,
      "93843": true,
      "93844": true,
      "93845": true,
      "93846": true,
      "93847": true
    },
    "MOLOACAN": {
      "96370": true,
      "96372": true,
      "96373": true,
      "96374": true,
      "96375": true,
      "96376": true
    },
    "NANCHITAL DE LAZARO CARDENAS DEL RIO": {
      "96360": true,
      "96362": true
    },
    "NAOLINCO": {
      "91400": true,
      "91402": true,
      "91404": true,
      "91406": true,
      "91407": true,
      "91409": true
    },
    "NARANJOS AMATLAN": {
      "92300": true,
      "92310": true,
      "92320": true,
      "92330": true,
      "92340": true,
      "92350": true,
      "92360": true,
      "92370": true,
      "92380": true,
      "92385": true,
      "92389": true,
      "92390": true,
      "92410": true,
      "92411": true,
      "92412": true,
      "92413": true,
      "92414": true,
      "92415": true,
      "92416": true,
      "92417": true,
      "92418": true,
      "92419": true
    },
    "NOGALES": {
      "94720": true,
      "94722": true,
      "94723": true,
      "94724": true,
      "94725": true,
      "94726": true,
      "94727": true
    },
    "OLUTA": {
      "96160": true,
      "96163": true,
      "96164": true,
      "96165": true,
      "96166": true,
      "96167": true,
      "96168": true,
      "96169": true
    },
    "ORIZABA": {
      "94300": true,
      "94303": true,
      "94310": true,
      "94311": true,
      "94315": true,
      "94320": true,
      "94324": true,
      "94326": true,
      "94327": true,
      "94328": true,
      "94329": true,
      "94330": true,
      "94333": true,
      "94334": true,
      "94335": true,
      "94337": true,
      "94339": true,
      "94340": true,
      "94344": true,
      "94345": true,
      "94346": true,
      "94347": true,
      "94349": true,
      "94350": true,
      "94353": true,
      "94360": true,
      "94363": true,
      "94364": true,
      "94370": true,
      "94380": true,
      "94384": true,
      "94389": true,
      "94390": true,
      "94393": true,
      "94394": true,
      "94399": true,
      "94400": true
    },
    "OTEAPAN": {
      "96330": true,
      "96335": true
    },
    "PAJAPAN": {
      "95960": true,
      "95963": true,
      "95965": true,
      "95966": true,
      "95967": true,
      "95969": true,
      "95970": true
    },
    "PANUCO": {
      "92000": true,
      "92001": true,
      "92002": true,
      "92003": true,
      "92004": true,
      "92005": true,
      "92009": true,
      "92010": true,
      "92012": true,
      "92015": true,
      "92017": true,
      "92018": true,
      "92020": true,
      "92023": true,
      "92025": true,
      "93990": true,
      "93994": true,
      "93995": true,
      "93996": true,
      "93997": true,
      "93998": true
    },
    "PAPANTLA": {
      "93400": true,
      "93410": true,
      "93413": true,
      "93418": true,
      "93419": true,
      "93420": true,
      "93425": true,
      "93426": true,
      "93427": true,
      "93428": true,
      "93429": true,
      "93430": true,
      "93438": true,
      "93440": true,
      "93449": true,
      "93450": true,
      "93458": true,
      "93460": true,
      "93466": true,
      "93467": true,
      "93468": true,
      "93470": true,
      "93477": true,
      "93478": true,
      "93479": true,
      "93480": true,
      "93484": true,
      "93485": true,
      "93486": true,
      "93487": true,
      "93489": true,
      "93490": true,
      "93498": true,
      "93499": true,
      "93520": true,
      "93523": true,
      "93524": true,
      "93525": true,
      "93526": true,
      "93527": true,
      "93530": true,
      "93532": true,
      "93533": true,
      "93534": true,
      "93535": true,
      "93537": true,
      "93542": true,
      "93543": true,
      "93544": true,
      "93549": true
    },
    "PASO DE OVEJAS": {
      "91670": true,
      "91672": true,
      "91673": true,
      "91674": true,
      "91675": true,
      "91676": true,
      "91677": true
    },
    "PASO DEL MACHO": {
      "94970": true,
      "94972": true,
      "94974": true,
      "94975": true,
      "94976": true,
      "94977": true,
      "94978": true
    },
    "PEROTE": {
      "91270": true,
      "91273": true,
      "91274": true,
      "91275": true,
      "91277": true,
      "91278": true,
      "91280": true,
      "91282": true,
      "91283": true,
      "91285": true,
      "91288": true,
      "91289": true
    },
    "POZA RICA DE HIDALGO": {
      "93210": true,
      "93213": true,
      "93220": true,
      "93228": true,
      "93230": true,
      "93236": true,
      "93240": true,
      "93248": true,
      "93249": true,
      "93250": true,
      "93260": true,
      "93269": true,
      "93270": true,
      "93276": true,
      "93279": true,
      "93280": true,
      "93290": true,
      "93294": true,
      "93295": true,
      "93300": true,
      "93305": true,
      "93306": true,
      "93308": true,
      "93310": true,
      "93319": true,
      "93320": true,
      "93327": true,
      "93330": true,
      "93340": true,
      "93350": true,
      "93360": true,
      "93367": true,
      "93368": true,
      "93369": true,
      "93370": true,
      "93380": true,
      "93384": true,
      "93386": true,
      "93387": true,
      "93388": true,
      "93389": true,
      "93390": true,
      "93393": true,
      "93396": true,
      "93398": true,
      "93399": true
    },
    "PUEBLO VIEJO": {
      "92030": true,
      "92033": true,
      "92034": true,
      "92035": true,
      "92036": true,
      "92037": true,
      "92038": true,
      "92039": true
    },
    "PUENTE NACIONAL": {
      "91653": true,
      "91656": true,
      "91658": true
    },
    "RAFAEL LUCIO": {
      "91315": true,
      "91316": true
    },
    "RIO BLANCO": {
      "94730": true,
      "94732": true,
      "94733": true,
      "94734": true
    },
    "SAN ANDRES TUXTLA": {
      "95700": true,
      "95710": true,
      "95714": true,
      "95716": true,
      "95717": true,
      "95718": true,
      "95720": true,
      "95725": true,
      "95726": true,
      "95729": true,
      "95730": true,
      "95736": true,
      "95739": true,
      "95740": true,
      "95746": true,
      "95748": true,
      "95749": true,
      "95750": true,
      "95756": true,
      "95760": true,
      "95763": true,
      "95765": true,
      "95770": true,
      "95775": true,
      "95778": true,
      "95780": true,
      "95786": true,
      "95790": true,
      "95795": true,
      "95797": true,
      "95800": true,
      "95801": true,
      "95802": true,
      "95803": true,
      "95804": true,
      "95805": true,
      "95806": true,
      "95807": true,
      "95809": true,
      "95810": true,
      "95812": true,
      "95813": true,
      "95814": true,
      "95816": true,
      "95821": true
    },
    "SAN JUAN EVANGELISTA": {
      "96120": true,
      "96130": true,
      "96132": true,
      "96133": true,
      "96134": true,
      "96135": true,
      "96136": true,
      "96137": true,
      "96140": true,
      "96143": true,
      "96144": true,
      "96146": true
    },
    "SAN RAFAEL": {
      "93620": true,
      "93623": true,
      "93624": true,
      "93625": true,
      "93626": true,
      "93627": true,
      "93628": true,
      "93629": true
    },
    "SANTIAGO TUXTLA": {
      "95830": true,
      "95832": true,
      "95833": true,
      "95834": true,
      "95835": true,
      "95839": true
    },
    "SAYULA DE ALEMAN": {
      "96150": true,
      "96151": true,
      "96152": true,
      "96153": true,
      "96154": true
    },
    "SOCONUSCO": {
      "96170": true,
      "96173": true,
      "96174": true,
      "96175": true,
      "96176": true,
      "96178": true
    },
    "SOLEDAD DE DOBLADO": {
      "94240": true,
      "94242": true,
      "94243": true,
      "94244": true,
      "94245": true,
      "94246": true,
      "94247": true,
      "94248": true,
      "94249": true
    },
    "TAMIAHUA": {
      "92560": true,
      "92562": true,
      "92563": true,
      "92570": true,
      "92571": true,
      "92576": true,
      "92580": true,
      "92584": true,
      "92585": true,
      "92586": true,
      "92590": true,
      "92592": true,
      "92594": true,
      "92597": true
    },
    "TAMPICO ALTO": {
      "92040": true,
      "92042": true,
      "92044": true,
      "92045": true,
      "92050": true,
      "92053": true,
      "92054": true,
      "92055": true,
      "92056": true
    },
    "TANTOYUCA": {
      "92100": true,
      "92103": true,
      "92104": true,
      "92105": true,
      "92108": true,
      "92110": true,
      "92113": true,
      "92114": true,
      "92116": true,
      "92117": true,
      "92120": true,
      "92122": true,
      "92123": true,
      "92124": true,
      "92125": true,
      "92126": true,
      "92127": true
    },
    "TATAHUICAPAN DE JUAREZ": {
      "95950": true,
      "95953": true,
      "95954": true,
      "95955": true
    },
    "TATATILA": {
      "93760": true,
      "93761": true,
      "93763": true,
      "93764": true,
      "93769": true
    },
    "TECOLUTLA": {
      "93570": true,
      "93575": true,
      "93576": true,
      "93577": true,
      "93578": true,
      "93579": true,
      "93585": true,
      "93588": true,
      "93590": true,
      "93597": true
    },
    "TENAMPA": {
      "94030": true,
      "94034": true,
      "94035": true
    },
    "TEOCELO": {
      "91615": true,
      "91618": true,
      "91619": true
    },
    "TEPETLAN": {
      "91430": true,
      "91433": true,
      "91434": true,
      "91436": true
    },
    "TEPETZINTLA": {
      "92530": true,
      "92532": true,
      "92533": true,
      "92534": true,
      "92535": true,
      "92536": true,
      "92537": true,
      "92538": true,
      "92539": true
    },
    "TEXISTEPEC": {
      "96180": true,
      "96185": true,
      "96186": true,
      "96187": true,
      "96192": true
    },
    "TEZONAPA": {
      "95080": true,
      "95083": true,
      "95085": true,
      "95093": true,
      "95094": true,
      "95095": true,
      "95096": true,
      "95097": true,
      "95098": true,
      "95099": true
    },
    "TIERRA BLANCA": {
      "95100": true,
      "95110": true,
      "95118": true,
      "95119": true,
      "95120": true,
      "95130": true,
      "95140": true,
      "95150": true,
      "95160": true,
      "95170": true,
      "95179": true,
      "95180": true,
      "95190": true,
      "95193": true,
      "95200": true,
      "95202": true,
      "95203": true,
      "95204": true,
      "95205": true,
      "95206": true,
      "95207": true,
      "95214": true,
      "95216": true,
      "95217": true
    },
    "TIHUATLAN": {
      "92900": true,
      "92903": true,
      "92904": true,
      "92905": true,
      "92906": true,
      "92907": true,
      "92909": true,
      "92910": true,
      "92911": true,
      "92912": true,
      "92914": true,
      "92916": true,
      "92917": true,
      "92920": true,
      "92922": true,
      "92925": true,
      "92928": true,
      "92929": true,
      "92930": true,
      "92933": true,
      "92934": true,
      "92935": true,
      "92936": true,
      "92937": true
    },
    "TLACOLULAN": {
      "91350": true,
      "91353": true,
      "91354": true,
      "91355": true,
      "91356": true
    },
    "TLACOTALPAN": {
      "95460": true,
      "95462": true,
      "95463": true,
      "95464": true,
      "95465": true,
      "95466": true,
      "95467": true,
      "95468": true,
      "95469": true
    },
    "TLALIXCOYAN": {
      "95220": true,
      "95224": true,
      "95225": true,
      "95226": true,
      "95230": true,
      "95233": true,
      "95234": true,
      "95235": true,
      "95236": true,
      "95237": true
    },
    "TLALNELHUAYOCAN": {
      "91230": true,
      "91231": true,
      "91233": true,
      "91236": true,
      "91237": true,
      "91238": true
    },
    "TLALTETELA": {
      "94020": true,
      "94023": true,
      "94024": true,
      "94027": true
    },
    "TLAPACOYAN": {
      "93650": true,
      "93653": true,
      "93654": true,
      "93655": true,
      "93656": true,
      "93657": true
    },
    "TONAYAN": {
      "91360": true,
      "91362": true,
      "91363": true,
      "91365": true,
      "91366": true,
      "91367": true
    },
    "TRES VALLES": {
      "95300": true,
      "95350": true,
      "95353": true,
      "95354": true,
      "95355": true,
      "95356": true,
      "95357": true,
      "95358": true,
      "95360": true,
      "95365": true,
      "95367": true,
      "95370": true,
      "95372": true,
      "95374": true,
      "95375": true,
      "95380": true,
      "95385": true,
      "95386": true
    },
    "TUXPAN": {
      "92770": true,
      "92773": true,
      "92774": true,
      "92775": true,
      "92776": true,
      "92780": true,
      "92783": true,
      "92784": true,
      "92785": true,
      "92786": true,
      "92789": true,
      "92800": true,
      "92810": true,
      "92820": true,
      "92830": true,
      "92834": true,
      "92840": true,
      "92845": true,
      "92850": true,
      "92853": true,
      "92854": true,
      "92860": true,
      "92863": true,
      "92870": true,
      "92875": true,
      "92876": true,
      "92880": true,
      "92883": true,
      "92888": true,
      "92890": true,
      "92893": true,
      "92894": true,
      "92895": true
    },
    "URSULO GALVAN": {
      "91660": true,
      "91663": true,
      "91664": true,
      "91666": true,
      "91667": true,
      "91668": true
    },
    "VEGA DE ALATORRE": {
      "93960": true,
      "93963": true,
      "93965": true,
      "93967": true,
      "93970": true,
      "93980": true
    },
    "VERACRUZ": {
      "91690": true,
      "91693": true,
      "91694": true,
      "91696": true,
      "91697": true,
      "91698": true,
      "91699": true,
      "91700": true,
      "91708": true,
      "91709": true,
      "91710": true,
      "91712": true,
      "91713": true,
      "91714": true,
      "91715": true,
      "91716": true,
      "91717": true,
      "91718": true,
      "91720": true,
      "91726": true,
      "91727": true,
      "91728": true,
      "91729": true,
      "91730": true,
      "91739": true,
      "91740": true,
      "91749": true,
      "91750": true,
      "91755": true,
      "91756": true,
      "91757": true,
      "91758": true,
      "91759": true,
      "91760": true,
      "91769": true,
      "91770": true,
      "91777": true,
      "91778": true,
      "91779": true,
      "91780": true,
      "91788": true,
      "91789": true,
      "91790": true,
      "91799": true,
      "91800": true,
      "91807": true,
      "91808": true,
      "91809": true,
      "91810": true,
      "91817": true,
      "91820": true,
      "91826": true,
      "91829": true,
      "91840": true,
      "91841": true,
      "91850": true,
      "91855": true,
      "91859": true,
      "91860": true,
      "91870": true,
      "91880": true,
      "91890": true,
      "91891": true,
      "91897": true,
      "91898": true,
      "91899": true,
      "91900": true,
      "91910": true,
      "91916": true,
      "91918": true,
      "91919": true,
      "91920": true,
      "91928": true,
      "91930": true,
      "91936": true,
      "91938": true,
      "91940": true,
      "91947": true,
      "91948": true,
      "91960": true,
      "91963": true,
      "91965": true,
      "91966": true,
      "91968": true,
      "91969": true
    },
    "VILLA ALDAMA": {
      "91340": true,
      "91341": true,
      "91345": true,
      "91346": true
    },
    "XALAPA": {
      "91000": true,
      "91010": true,
      "91013": true,
      "91014": true,
      "91015": true,
      "91016": true,
      "91017": true,
      "91018": true,
      "91020": true,
      "91023": true,
      "91024": true,
      "91025": true,
      "91026": true,
      "91027": true,
      "91028": true,
      "91030": true,
      "91033": true,
      "91037": true,
      "91040": true,
      "91045": true,
      "91046": true,
      "91047": true,
      "91048": true,
      "91049": true,
      "91050": true,
      "91053": true,
      "91054": true,
      "91055": true,
      "91056": true,
      "91057": true,
      "91060": true,
      "91063": true,
      "91064": true,
      "91065": true,
      "91066": true,
      "91067": true,
      "91069": true,
      "91070": true,
      "91073": true,
      "91075": true,
      "91080": true,
      "91083": true,
      "91084": true,
      "91090": true,
      "91094": true,
      "91095": true,
      "91096": true,
      "91097": true,
      "91098": true,
      "91100": true,
      "91103": true,
      "91104": true,
      "91105": true,
      "91106": true,
      "91107": true,
      "91110": true,
      "91113": true,
      "91114": true,
      "91119": true,
      "91120": true,
      "91123": true,
      "91129": true,
      "91130": true,
      "91133": true,
      "91140": true,
      "91143": true,
      "91150": true,
      "91152": true,
      "91153": true,
      "91154": true,
      "91155": true,
      "91156": true,
      "91157": true,
      "91158": true,
      "91160": true,
      "91163": true,
      "91164": true,
      "91165": true,
      "91166": true,
      "91170": true,
      "91173": true,
      "91174": true,
      "91179": true,
      "91180": true,
      "91183": true,
      "91184": true,
      "91185": true,
      "91186": true,
      "91190": true,
      "91193": true,
      "91194": true,
      "91195": true,
      "91196": true,
      "91197": true,
      "91198": true,
      "91200": true,
      "91203": true,
      "91204": true,
      "91205": true,
      "91207": true,
      "91210": true,
      "91213": true,
      "91214": true,
      "91215": true,
      "91216": true,
      "91217": true,
      "91220": true,
      "91225": true,
      "91226": true,
      "91227": true
    },
    "XICO": {
      "91240": true,
      "91241": true,
      "91244": true,
      "91245": true,
      "91247": true,
      "91248": true,
      "91249": true
    },
    "YECUATLA": {
      "93900": true,
      "93904": true,
      "93907": true,
      "93908": true,
      "93910": true,
      "93915": true,
      "93918": true,
      "93930": true,
      "93936": true,
      "93940": true
    },
    "ZARAGOZA": {
      "96320": true,
      "96323": true,
      "96324": true
    },
    "ZENTLA": {
      "94220": true,
      "94222": true,
      "94223": true,
      "94224": true,
      "94225": true,
      "94226": true,
      "94227": true,
      "94228": true
    },
    "ZOZOCOLCO DE HIDALGO": {
      "93000": true,
      "93003": true,
      "93004": true,
      "93005": true,
      "93010": true,
      "93015": true,
      "93020": true,
      "93030": true
    }
  },
  "YUCATÁN": {
    "HALACHO": {
      "97830": true,
      "97835": true,
      "97836": true,
      "97837": true
    },
    "MAXCANU": {
      "97800": true,
      "97803": true,
      "97804": true,
      "97807": true
    },
    "MÉRIDA": {
      "97000": true,
      "97003": true,
      "97050": true,
      "97059": true,
      "97060": true,
      "97069": true,
      "97070": true,
      "97080": true,
      "97088": true,
      "97089": true,
      "97098": true,
      "97099": true,
      "97100": true,
      "97107": true,
      "97108": true,
      "97109": true,
      "97110": true,
      "97113": true,
      "97114": true,
      "97115": true,
      "97116": true,
      "97117": true,
      "97118": true,
      "97119": true,
      "97120": true,
      "97125": true,
      "97127": true,
      "97128": true,
      "97129": true,
      "97130": true,
      "97133": true,
      "97134": true,
      "97135": true,
      "97136": true,
      "97137": true,
      "97138": true,
      "97139": true,
      "97140": true,
      "97142": true,
      "97143": true,
      "97144": true,
      "97145": true,
      "97146": true,
      "97147": true,
      "97148": true,
      "97149": true,
      "97150": true,
      "97155": true,
      "97156": true,
      "97157": true,
      "97158": true,
      "97159": true,
      "97160": true,
      "97165": true,
      "97166": true,
      "97167": true,
      "97168": true,
      "97169": true,
      "97170": true,
      "97173": true,
      "97174": true,
      "97175": true,
      "97176": true,
      "97177": true,
      "97178": true,
      "97179": true,
      "97180": true,
      "97189": true,
      "97190": true,
      "97195": true,
      "97196": true,
      "97198": true,
      "97199": true,
      "97203": true,
      "97204": true,
      "97205": true,
      "97206": true,
      "97207": true,
      "97208": true,
      "97209": true,
      "97210": true,
      "97215": true,
      "97217": true,
      "97218": true,
      "97219": true,
      "97220": true,
      "97225": true,
      "97226": true,
      "97227": true,
      "97229": true,
      "97230": true,
      "97237": true,
      "97238": true,
      "97239": true,
      "97240": true,
      "97245": true,
      "97246": true,
      "97247": true,
      "97249": true,
      "97250": true,
      "97255": true,
      "97256": true,
      "97260": true,
      "97267": true,
      "97268": true,
      "97269": true,
      "97270": true,
      "97277": true,
      "97278": true,
      "97279": true,
      "97280": true,
      "97284": true,
      "97285": true,
      "97286": true,
      "97287": true,
      "97288": true,
      "97289": true,
      "97290": true,
      "97295": true,
      "97296": true,
      "97297": true,
      "97298": true,
      "97299": true
    }
  },
  "ZACATECAS": {
    "APOZOL": {
      "99940": true,
      "99943": true,
      "99949": true,
      "99950": true,
      "99955": true,
      "99957": true
    },
    "APULCO": {
      "99920": true,
      "99921": true,
      "99930": true,
      "99933": true,
      "99934": true,
      "99935": true,
      "99937": true
    },
    "CALERA": {
      "98500": true,
      "98502": true,
      "98503": true,
      "98504": true,
      "98505": true,
      "98506": true,
      "98507": true,
      "98508": true,
      "98510": true,
      "98513": true,
      "98514": true,
      "98515": true,
      "98516": true,
      "98517": true,
      "98519": true,
      "98520": true,
      "98523": true
    },
    "CANITAS DE FELIPE PESCADOR": {
      "98480": true,
      "98490": true,
      "98492": true,
      "98494": true,
      "98496": true
    },
    "CONCEPCION DEL ORO": {
      "98200": true,
      "98203": true,
      "98204": true,
      "98205": true,
      "98209": true,
      "98212": true
    },
    "CUAUHTÉMOC": {
      "98680": true,
      "98684": true,
      "98689": true,
      "98690": true,
      "98692": true,
      "98693": true,
      "98694": true,
      "98695": true,
      "98696": true,
      "98697": true,
      "98698": true
    },
    "FRESNILLO": {
      "99000": true,
      "99010": true,
      "99011": true,
      "99013": true,
      "99014": true,
      "99020": true,
      "99030": true,
      "99034": true,
      "99036": true,
      "99039": true,
      "99040": true,
      "99049": true,
      "99050": true,
      "99054": true,
      "99055": true,
      "99056": true,
      "99060": true,
      "99070": true,
      "99080": true,
      "99084": true,
      "99089": true,
      "99090": true,
      "99094": true,
      "99095": true,
      "99099": true,
      "99150": true,
      "99154": true,
      "99158": true,
      "99170": true,
      "99176": true,
      "99185": true,
      "99188": true,
      "99189": true,
      "99192": true,
      "99194": true
    },
    "GENARO CODINA": {
      "98660": true,
      "98663": true,
      "98664": true,
      "98666": true,
      "98667": true,
      "98673": true,
      "98677": true
    },
    "GENERAL ENRIQUE ESTRADA": {
      "98560": true,
      "98561": true,
      "98580": true,
      "98584": true
    },
    "GENERAL PANFILO NATERA": {
      "98730": true,
      "98740": true,
      "98750": true,
      "98760": true
    },
    "GUADALUPE": {
      "98600": true,
      "98604": true,
      "98605": true,
      "98606": true,
      "98607": true,
      "98608": true,
      "98609": true,
      "98610": true,
      "98612": true,
      "98613": true,
      "98614": true,
      "98615": true,
      "98616": true,
      "98617": true,
      "98618": true,
      "98619": true,
      "98620": true,
      "98621": true,
      "98630": true,
      "98631": true,
      "98635": true,
      "98636": true,
      "98650": true,
      "98652": true,
      "98653": true,
      "98655": true,
      "98658": true,
      "98659": true
    },
    "JALPA": {
      "99600": true,
      "99602": true,
      "99603": true,
      "99605": true,
      "99606": true,
      "99607": true,
      "99608": true,
      "99609": true,
      "99615": true,
      "99616": true,
      "99618": true,
      "99620": true,
      "99622": true,
      "99623": true,
      "99624": true,
      "99625": true,
      "99626": true
    },
    "JEREZ": {
      "99300": true,
      "99310": true,
      "99311": true,
      "99312": true,
      "99313": true,
      "99314": true,
      "99315": true,
      "99316": true,
      "99320": true,
      "99322": true,
      "99323": true,
      "99330": true,
      "99340": true,
      "99342": true,
      "99343": true,
      "99344": true,
      "99350": true,
      "99352": true,
      "99353": true,
      "99360": true,
      "99362": true,
      "99363": true,
      "99370": true,
      "99379": true,
      "99380": true,
      "99382": true,
      "99390": true,
      "99392": true,
      "99393": true,
      "99443": true,
      "99444": true,
      "99447": true,
      "99454": true,
      "99455": true,
      "99456": true,
      "99457": true,
      "99458": true,
      "99460": true,
      "99466": true,
      "99467": true,
      "99468": true,
      "99469": true,
      "99476": true
    },
    "JUAN ALDAMA": {
      "98300": true,
      "98303": true,
      "98304": true,
      "98306": true,
      "98307": true,
      "98310": true,
      "98311": true,
      "98317": true,
      "98318": true,
      "98320": true
    },
    "JUCHIPILA": {
      "99960": true,
      "99964": true,
      "99969": true,
      "99970": true,
      "99973": true,
      "99974": true,
      "99979": true
    },
    "LORETO": {
      "98800": true,
      "98804": true,
      "98807": true,
      "98810": true,
      "98812": true,
      "98813": true,
      "98815": true,
      "98816": true,
      "98817": true,
      "98818": true,
      "98820": true,
      "98824": true,
      "98825": true,
      "98827": true,
      "98830": true,
      "98832": true,
      "98833": true,
      "98834": true,
      "98835": true,
      "98836": true,
      "98837": true,
      "98838": true,
      "98839": true
    },
    "LUIS MOYA": {
      "98770": true,
      "98772": true,
      "98773": true,
      "98775": true,
      "98776": true,
      "98785": true,
      "98790": true,
      "98794": true,
      "98795": true
    },
    "MIGUEL AUZA": {
      "98330": true,
      "98336": true,
      "98340": true,
      "98343": true,
      "98344": true
    },
    "MORELOS": {
      "98100": true,
      "98113": true
    },
    "NOCHISTLAN DE MEJIA": {
      "99900": true,
      "99902": true,
      "99904": true,
      "99905": true,
      "99906": true,
      "99907": true,
      "99908": true,
      "99909": true,
      "99910": true,
      "99911": true,
      "99912": true,
      "99913": true,
      "99914": true,
      "99915": true,
      "99916": true,
      "99917": true,
      "99918": true,
      "99919": true
    },
    "NORIA DE ANGELES": {
      "98880": true,
      "98884": true,
      "98885": true,
      "98887": true,
      "98888": true,
      "98890": true,
      "98893": true,
      "98894": true
    },
    "OJOCALIENTE": {
      "98700": true,
      "98704": true,
      "98706": true,
      "98707": true,
      "98710": true,
      "98712": true,
      "98713": true,
      "98714": true,
      "98715": true,
      "98716": true,
      "98717": true,
      "98718": true,
      "98720": true,
      "98723": true,
      "98724": true,
      "98725": true,
      "98726": true,
      "98727": true
    },
    "PANUCO": {
      "98540": true,
      "98541": true,
      "98545": true,
      "98546": true,
      "98547": true,
      "98548": true,
      "98550": true,
      "98553": true,
      "98555": true
    },
    "PINOS": {
      "98920": true,
      "98921": true,
      "98923": true,
      "98924": true,
      "98925": true,
      "98951": true,
      "98959": true,
      "98960": true,
      "98961": true,
      "98962": true,
      "98965": true,
      "98969": true,
      "98974": true
    },
    "RIO GRANDE": {
      "98400": true,
      "98401": true,
      "98403": true,
      "98404": true,
      "98405": true,
      "98406": true,
      "98416": true,
      "98417": true,
      "98419": true,
      "98420": true,
      "98422": true,
      "98423": true,
      "98424": true,
      "98425": true,
      "98426": true,
      "98429": true
    },
    "SAIN ALTO": {
      "99130": true,
      "99132": true,
      "99138": true,
      "99140": true,
      "99143": true,
      "99144": true
    },
    "SOMBRERETE": {
      "99100": true,
      "99102": true,
      "99103": true,
      "99104": true,
      "99106": true,
      "99109": true,
      "99110": true,
      "99118": true,
      "99120": true,
      "99127": true
    },
    "SUSTICACAN": {
      "99480": true,
      "99483": true,
      "99484": true
    },
    "TABASCO": {
      "99630": true,
      "99635": true,
      "99640": true,
      "99644": true,
      "99650": true,
      "99654": true,
      "99655": true
    },
    "TLALTENANGO DE SANCHEZ ROMAN": {
      "99700": true,
      "99703": true,
      "99704": true,
      "99705": true,
      "99707": true,
      "99709": true,
      "99713": true
    },
    "TRANCOSO": {
      "98640": true,
      "98644": true,
      "98645": true,
      "98647": true,
      "98648": true
    },
    "VALPARAISO": {
      "99200": true,
      "99201": true,
      "99202": true,
      "99203": true,
      "99207": true,
      "99215": true,
      "99220": true,
      "99225": true,
      "99227": true,
      "99230": true,
      "99231": true,
      "99237": true,
      "99245": true,
      "99250": true,
      "99252": true,
      "99253": true,
      "99254": true,
      "99255": true,
      "99256": true,
      "99257": true,
      "99258": true,
      "99259": true
    },
    "VETAGRANDE": {
      "98140": true,
      "98150": true,
      "98153": true
    },
    "VILLA DE COS": {
      "98430": true,
      "98432": true,
      "98436": true,
      "98463": true,
      "98471": true,
      "98473": true,
      "98474": true
    },
    "VILLA GARCIA": {
      "98900": true,
      "98904": true,
      "98905": true,
      "98907": true,
      "98910": true,
      "98913": true,
      "98914": true,
      "98918": true,
      "98919": true
    },
    "VILLA GONZALEZ ORTEGA": {
      "98840": true,
      "98844": true,
      "98846": true,
      "98850": true,
      "98870": true,
      "98873": true
    },
    "VILLA HIDALGO": {
      "98980": true,
      "98982": true,
      "98983": true,
      "98984": true,
      "98985": true,
      "98986": true,
      "98987": true,
      "98988": true,
      "98990": true,
      "98994": true,
      "98995": true
    },
    "VILLANUEVA": {
      "99500": true,
      "99504": true,
      "99505": true,
      "99520": true,
      "99530": true,
      "99540": true,
      "99542": true,
      "99543": true,
      "99544": true,
      "99545": true,
      "99546": true,
      "99547": true,
      "99550": true
    },
    "ZACATECAS": {
      "98000": true,
      "98010": true,
      "98015": true,
      "98017": true,
      "98018": true,
      "98019": true,
      "98020": true,
      "98023": true,
      "98024": true,
      "98040": true,
      "98045": true,
      "98046": true,
      "98047": true,
      "98050": true,
      "98053": true,
      "98054": true,
      "98056": true,
      "98057": true,
      "98060": true,
      "98064": true,
      "98065": true,
      "98066": true,
      "98067": true,
      "98068": true,
      "98070": true,
      "98077": true,
      "98078": true,
      "98079": true,
      "98080": true,
      "98083": true,
      "98084": true,
      "98085": true,
      "98086": true,
      "98087": true,
      "98088": true,
      "98089": true,
      "98090": true,
      "98097": true,
      "98098": true,
      "98099": true,
      "98160": true,
      "98163": true,
      "98170": true,
      "98173": true,
      "98176": true,
      "98177": true,
      "98183": true,
      "98185": true
    }
  }
},
  startFields: function () {
    try {
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();

      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onProvinceChange);
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onCityChange);
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
      html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onCityChange();
      return;
    }

    html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
    _CUSTOM_COD_FORM_PROVINCES.onCityChange();
  },
  onCityChange: function () {
    var provValue = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
  }
};


function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }
  } catch (e) {
    console.log(e);
  }
  _CUSTOM_COD_FORM_PROVINCES.startFields();
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }

    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    }

    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }

    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_ZIP_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province_country_field";
      item.backendFields.elementType = "select";

      var options = [];

      Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).forEach(key => {
        options.push({
          label: key,
          value: key
        })
      })


      item.backendFields.options = options;
    } else if (item.type == "city") {
      item.type = "city_country_field";
      item.backendFields.name = "city";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_CITY_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_CITY_LABEL) {
        _COD_FORM_CITY_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_CITY_LABEL
      }];
      item.backendFields.options = options;
    } else if (item.type == "zip_code") {
      item.type = "zip_country_field";
      item.backendFields.name = "zip_code";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_ZIP_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_ZIP_LABEL) {
        _COD_FORM_ZIP_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_ZIP_LABEL
      }];
      item.backendFields.options = options;
    }
  });

  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return true;
}